import { isLoggedInUser, signin } from '../common/auth';
import { adobeDataLayerTrack } from '../common/analytics';
import { cookie } from '../common/cookie';
import { debounce } from '../common/debounce';
import { $el, appShadowRoot } from '../common/elements';
import { log } from '../common/log';
import { notice } from '../common/notice';
import { o } from '../common/observable';
import { lang, render } from '../common/page';
// eslint-disable-next-line import/no-cycle
import { profile, profileLightweight, updateProfile } from '../common/profile';
import { request } from '../common/request';
import { ensureViewsLoaded, views } from '../common/views';
import {
  getInitialSupportTab,
  getViewsRequiredForTab,
  isLoggedOutRedeemIntent,
  tabNeedsExperienceLeagueProfile,
  tabNeedsOrgAccessBeforePaint,
  tabUsesOrgPicker,
  tabUsesSidebarSetup,
} from './utils/support-tab-resources';
import { close, modal } from './utils/modal';
import { productsList } from './utils/support-product-list';
import { toBase64, isOnlyNumber, compareVersions, deleteCookie, removeClass, addClass } from './utils/support';
import { groupProductsByFamily } from './utils/support';
import { createSupportInsightsManager, isInsightsSupportedForProduct } from './utils/support-insights';
import { createRecommendationModalManager } from './utils/recommendation-modal';
import { createSupportWidgetExperiment } from './utils/support-widget-experiment';
import SupportRedeemCode from './utils/support-redeem-code';
import {
  CaseListFilters,
  ClientId,
  CoveoOrg,
  CoveoSearchHubCaseAssist,
  CoveoSearchHubHomePage,
  CoveoToken,
  HasCommerce,
  HasECC,
  HasWorkfront,
  JWT,
  PremiumRedeemResumeUrl,
  PreferPortal,
  ReleaseRegions,
  SelectedOrg,
  SelectedProduct,
  SupportCaseSubmit,
  SupportOrgToken,
  SupportTab,
  SupportVisit,
} from '../common/keys';
import {
  statusSite as adobeStatusUrl,
  commerceAccess as commerceAccessUrl,
  commerceOrg as commerceOrgUrl,
  commerceOrgAccess as commerceOrgAccessUrl,
  coveoCaseAssist as coveoCaseAssistUrl,
  developerBoostProductsUrl,
  eccOrg as eccOrgUrl,
  eventHistory as eventHistoryUrl,
  exlMiloCase as exlMiloCaseUrl,
  exlMiloCaseAction as exlMiloCaseActionUrl,
  exlMiloCaseAttachments as exlMiloCaseAttachmentsUrl,
  exlMiloCaseCommentAddition as exlMiloCaseCommentAdditionUrl,
  exlMiloCaseCommentList as exlMiloCaseCommentListUrl,
  exlMiloCaseList as exlMiloCaseListUrl,
  exlMiloCaseUpdate as exlMiloCaseUpdateUrl,
  exlMiloIssueReason as exlMiloIssueReasonUrl,
  exlMiloProductMetadata as exlMiloProductMetadataUrl,
  miloCase as miloCaseUrl,
  miloCaseAction as miloCaseActionUrl,
  miloCaseAttachments as miloCaseAttachmentsUrl,
  miloCaseCommentAddition as miloCaseCommentAdditionUrl,
  miloCaseCommentList as miloCaseCommentListUrl,
  miloCaseDownloadAttachment as miloCaseDownloadAttachmentUrl,
  miloCaseList as miloCaseListUrl,
  miloCaseUpdate as miloCaseUpdateUrl,
  miloEntitlementSync as miloEntitlementSyncURL,
  miloIssueReason as miloIssueReasonUrl,
  miloProductMetadata as miloProductMetadataUrl,
  miloProductMetadataV2 as miloProductMetadataV2Url,
  modulePreferences as modulePreferencesUrl,
  orgSession,
  requestSession,
  statusMessage as statusMessageUrl,
  snaplogic as snaplogicUrl,
  suscribeStatus as suscribeStatusUrl,
  ticketStatus as ticketStatusUrl,
  watcherMembers as watcherMembersUrl,
  workfrontCaseAttachmentsDownload as workfrontCaseAttachmentsDownloadUrl,
  workfrontCaseClose as workfrontCaseCloseUrl,
  workfrontCaseCommentList as workfrontCaseCommentListUrl,
  workfrontCaseCreate as workfrontCaseCreateUrl,
  workfrontCaseCreateComment as workfrontCaseCreateCommentUrl,
  workfrontCaseDetail as workfrontCaseDetailUrl,
  workfrontCaseEscalate as workfrontCaseEscalateUrl,
  workfrontCaseList as workfrontCaseListUrl,
  workfrontFieldsList as workfrontFieldsListUrl,
  workfrontProductAccessAuth as workfrontProductAccessAuthUrl,
  zeonAiAgent as zeonAiAgentUrl,
  zeonAiAgentFeedback as zeonAiAgentFeedbackUrl,
  zeonCasePrepare as zeonCasePrepareUrl,
  whatsappNotifEligibility as whatsappNotifEligibilityUrl,
  workfrontCaseCreate

} from '../common/urls';
import { queryString } from './utils/querystring';
import { isRedeemCodeDeepLink, portalPageMapping } from './utils/portal-page-mapping';
import { isProfileInReleaseRegion } from './utils/release-region';
import { supportActivities } from './utils/support-activities';
import {getLabelV2} from '../common/labelV2.js'
import {
  AFFECTED_URL_REGEX,
  ALLOWED_FILE_SIZE,
  AMCFIELDS,
  CLOSE_CASE_REASON_CODES,
  COMMERCE_ADD_CUSTOM_LOGRATE_SETTING,
  COMMERCE_ADDITIONAL_FIELD_LABEL,
  COMMERCE_CREATE_READ_ONLY_USER,
  COMMERCE_CREATE_READ_ONLY_USER_DATABASE,
  COMMERCE_CREATE_READ_ONLY_USER_SFTP,
  COMMERCE_DATABASE_SNAPSHOT_RETRIEVAL,
  COMMERCE_DISABLING_EMAIL,
  COMMERCE_DISK_STORAGE_INCREASE_REQUEST,
  COMMERCE_DOMAIN_UPDATE,
  COMMERCE_DOMAIN_UPDATE_MIGRATION,
  COMMERCE_INFRA_CHANGE,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_9,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_7,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_6,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_5,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_4,
  COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME,
  COMMERCE_STAGE_ENVIRONMENT_NAME,
  COMMERCE_PRIVATE_LINK_SETUP,
  COMMERCE_SEND_GRID_DOMAIN_AUTHENTICATION,
  COMMERCE_SERVICE_RESTART,
  COMMERCE_SPLIT_ARCHITECTURE,
  COMMERCE_SSH_LOGS,
  COMMERCE_TEMPORARY_CLOUD_UPSIZE,
  COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT,
  COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_CUSTOM,
  COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_NEXT,
  COMMERCE_TEMPORARY_CLOUD_UPSIZE_SCALED,
  COMMERCEFIELDS,
  COMMON_FIELDS,
  COMMUNITY_LANG_MAPPING as communityLangMapping,
  COVEO_LANG_MAPPING as coveoLangMapping,
  resolveStatusMessageLocale,
  DEVELOPERSESSIONFIELDS1 as developerSessionFields1,
  DEVELOPERSESSIONFIELDS2 as developerSessionFields2,
  EMAIL_PATTERN,
  ENVIRONMENT_FIELD,
  ESCALATE_CASE_REASON_CODES,
  HELPX_LANG_MAPPING as helpxLangMapping,
  EXL_LANG_MAPPING as exlLangMapping,
  IMAGE_ALLOWED as imageAllowed,
  LOCALES as locales,
  MENTORSESSIONFIELDS as mentorSessionFields,
  MENTORSESSIONPRODUCTS as mentorSessionProducts,
  MENTORSESSIONTOPICS as mentorSessionTopics,
  MILO_LOCALES as miloLocales,
  MILO_CASE_CREATE_OBJECT,
  MILO_FIELDS_DATA as miloFieldsData,
  OPEN_STATUS_WORKFRONT as openStatusWorkfront,
  communityProductMapping as communityProductMapping,
  PHONE_NUMBER_FORMATS as phoneNumberFormat,
  PHONE_NUMBER_REGEX,
  PROJECT_URL_REGEX,
  REOPEN_CASE_REASON_CODES,
  SERVICES_VERSION,
  SUCCESSCARDS,
  SUPPORTCONTACTCARDS as contactCards,
  SUPPORT_TICKET_UI_STATUS as supportTicketUIStatus,
  TABS as SUPPORT_TABS,
  TIMEZONEOPTIONS as timezoneOptions,
  URL_PATTERN_HTTP,
  URL_PATTERN_WWW,
  PRIORITY_OPTIONS,
  TIMEZONE_OPTIONS,
  DESCRIPTION_FIELDS,
  priorityKeys,
  workfrontPriorityKeys,
  impactKeys,
  peopleForSmokeTesting,
  COUNTRY_CALLING_CODES,
  E164_PHONE_REGEX,
  ENABLE_PHONE_NOTIFICATION_OPT_IN,
} from './utils/support-constants';
import { getFormattedDate, getFormattedDateForStatus } from './utils/support-date';
import libphonenumber from 'google-libphonenumber';
import { removeImageLoader, showHideLoader } from './utils/support-loader';
import { getSafeHtml } from './utils/support-safe-html';
import { convertFileToBase64 } from './utils/support-image-convertor';
import { getProductList } from './utils/support-products';
import { uploadMiloCaseAttachments, uploadWorkfrontCaseAttachments } from './utils/support-upload-case-attachment';
import { paginate as pagination } from './utils/support-pagination';
import { instantiateTagsInput } from './utils/support-tag-input';
import { sortCaseData } from './utils/support-case-sort';
import { relicApiFail, relicApiSuccess, relicCaseCreation, relicCaseCreationResult, relicSetView } from './utils/relic';
import { getWorkfrontConfiguration } from './utils/support-workfront-configuration';
import { getSelectedOrg, isWorkFront, isCommerce, isECC } from './utils/support-org-util';
import { labels, getLabel } from '../common/labels';
import { keys as headerKeys, values as headerValues } from '../common/headers';
import { csrf } from '../common/csrf';
import { currentEnv } from '../common/environments';
import { ArrowLeftIcon } from '@spectrum-web-components/icons-workflow';
import { getImpactScopeLabel } from './utils/support-impact-scope';

const isStageEnvironment = currentEnv?.env !== 'PROD';

const RELIC_CASE_CREATION_AVAILABILITY_TRACKING = {
  title: 'Case Creation Availability',
};

const RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING = {
  title: 'Support Page Availability',
};

const id = 'support';

let viewCaseFilterList = [];
let typeOfProduct = '';

let isImsCommerce = false

let newMetaData = [];
let commerceProjectURL={} ;
let COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1;

console.log('Version 2.1.0');

// support() can run more than once per session (the hash router re-invokes it on
// every 'home'/'support' route change), but the portal-preference decision below
// should only ever be made once on the user's first landing in this boot.
let hasCheckedPortalPreferenceOnce = false;

export async function support() {
  // Portal preference lives client-side only, keyed per user so a shared
  // device/browser profile doesn't leak one person's toggle choice to another.
  const toggleStatusKey = (email) => `${PreferPortal}_${email}`;

  async function getPortalPreference() {
    const profileData = await adobeIMS.getProfile();
    const storedToggleStatus = localStorage.getItem(toggleStatusKey(profileData.email));
    return storedToggleStatus === null ? null : storedToggleStatus === 'true';
  }

  async function updatePortalPreference(preferNewPortal) {
    const profileData = await adobeIMS.getProfile();
    localStorage.setItem(toggleStatusKey(profileData.email), String(preferNewPortal));
    return true;
  }

  // Kick this off immediately, in parallel with isLoggedInUser() and the rest of
  // boot below, instead of waiting on `authenticated` first — shaves the wait
  // for the new-portal redirect decision down to just this call.
  const portalPreferencePromise = getPortalPreference().catch(() => null);

  let orgPickerRendered = true
  let eccOrgsFetched = true
  let commerceOrgsFetched = true
  let workfrontOrgsRendered = true
  let profileAPIFetched = true
  let pageLoadErrorMessage = ''

  function setPageLoadErrorMessage(message) {
    if (!message) {
      return;
    }
    pageLoadErrorMessage = pageLoadErrorMessage
      ? `${pageLoadErrorMessage}; ${message}`
      : String(message);
  }

  let lurl = new URL(`${location.href}`);

  const authenticated = await isLoggedInUser();
  const supportTabs = Object.values(SUPPORT_TABS);
  const initialTabAtBoot = getInitialSupportTab(supportTabs);
  const loggedOutRedeem = isLoggedOutRedeemIntent(supportTabs, authenticated);
  const needsFullProfile = tabNeedsExperienceLeagueProfile(initialTabAtBoot);
  let userprofile = null;
  let profileFullLoadPromise = null;

  let loggedOutRedeemSignInActive = false;

  async function startLoggedOutRedeemSignIn() {
    loggedOutRedeemSignInActive = true;
    sessionStorage.setItem(PremiumRedeemResumeUrl, window.location.href);
    $el.app?.removeAttribute('style');
    const contentEl =
      appShadowRoot?.querySelector('[data-id="content-wrapper"]');
    if (contentEl) {
      contentEl.innerHTML =
        '<div class="spectrum-Body spectrum-Body--sizeM" style="padding: 2rem; text-align: center;">Logging in…</div>';
    }
    try {
      await window.imsLoaded;
      signin();
    } catch (err) {
      log(`Redeem sign-in failed: ${err?.message || err}`, { type: 'error' });
    }
  }

  if (loggedOutRedeem) {
    void labels();
    void startLoggedOutRedeemSignIn();
  } else {
    [userprofile] = await Promise.all([
      authenticated
        ? (needsFullProfile ? profile() : profileLightweight())
        : Promise.resolve(null),
      labels(),
    ]);
  }
  if (authenticated && !needsFullProfile) {
    profileFullLoadPromise = profile();
  }
  if (authenticated && !userprofile) {
    setPageLoadErrorMessage('IMS profile returned null');
  }
  profileAPIFetched = !authenticated || !!userprofile;
  let organizations = [];
  const orgPickerCounter = 1;
  let productOrg = '';
  let orgAccessChecksPromise = null;
  let entitlementsPromise = null;
  const supportEntitlementsPromises = new Map();
  let ticketStatusData;
  let majorTicketData;
  const clientTimezoneArea = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let selectedOrgObj = {};
  let caseAttachments = [];
  let caseAttachmentsFiles = [];
  let selectedOrg = { id: '', name: '' };
  let showNotification = false;
  let issueReasonRequired = false;
  let browserTimezoneAppliedFromDescription = false;
  let timezoneSelectionIsUserOverride = false;

  const supportRoot = $el.support;

  // Initialize Support Insights Manager
  const supportInsightsManager = createSupportInsightsManager(appShadowRoot);

  // Initialize Recommendation Modal Manager
  const recommendationModalManager = createRecommendationModalManager(appShadowRoot);
  if (!loggedOutRedeem) {
    recommendationModalManager.inject();
    recommendationModalManager.initClickDelegation();
  }
  let enableReviewbtn = true;
  const $lel = {
    activeTabs: supportRoot?.querySelectorAll('a.active') ?? [],
    formSubject: supportRoot?.querySelector('form input[name="subject"]'),
    horizontalLine: appShadowRoot.querySelector('#horizontal-line'),
    orgPicker: supportRoot?.querySelector(`#support-sidebar-orgpicker-${orgPickerCounter}`),
    orgPickerWrap: supportRoot?.querySelector('.support-sidebar-orgpicker-wrap'),
    pickerLoader: supportRoot?.querySelector('#support-picker-loader'),
    progressBar: supportRoot?.querySelector('.progress-bar'),
    searchResults: supportRoot?.querySelector('#support-search-comp'),
    statBar: appShadowRoot.querySelector('#status-bar'),
    sidebarEnabled: supportRoot?.querySelector('.spectrum-SideNav-item'),
    systemStatus: appShadowRoot.querySelector('#systemStatus'),
    tabsContent:
      supportRoot?.querySelector('[data-id="content-wrapper"]')
      ?? appShadowRoot.querySelector('[data-id="content-wrapper"]'),
    tabs: appShadowRoot.querySelectorAll('a.support_tab_button'),
    tabsTooltip: supportRoot?.querySelectorAll('.tabs-tooltip') ?? [],
    topErrorMessage: supportRoot?.querySelector('.support_msg_sec'),
    topErrorMessageButton: supportRoot?.querySelector('.support-learn-more'),
    ticketStatusUL: appShadowRoot.querySelector('#ticketStatusUL'),
    statustPickerLoader: appShadowRoot.querySelector('#status-picker-loader'),
    sidebarSurveyStatus: appShadowRoot.querySelector('#sidebar-available-survey-btn'),
  };
  const getCurrentSupportTab = () => new URL(window.location.href).searchParams.get('support-tab')
    || sessionStorage.getItem(SupportTab)
    || SUPPORT_TABS.HOME;

  document.cookie = "QSI_CT=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  window._qsie = window._qsie || [];
  const updateToggleVisibility = () => {
    const toggleCard = appShadowRoot.querySelector('#toggleContainer')?.closest('.toggle-card');
    if (toggleCard) {
      // const selectedSupportOrg = getSelectedOrg();
      // const userAccess = peopleForSmokeTesting.some(person => person.email === userprofile?.email);
      const isOnHomeTab = getCurrentSupportTab() === SUPPORT_TABS.HOME;
      const shouldShowToggle = isOnHomeTab;
      toggleCard.classList.toggle('is-hidden', !shouldShowToggle);
    }
  };

  async function getOpenTicketAiChatPreference() {
    try {
      const profileData = await adobeIMS.getProfile();
      const res = await request(modulePreferencesUrl, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
        },
        params: {
          auth_id: profileData.userId,
          userId: profileData.authId,
          moduleName: 'caseCreation',
          preferenceKey: 'aiChat',
        },
        method: 'GET',
      });
      const data = await res.json();

      return data?.data?.preferenceValue ?? false;
    } catch (error) {
      log(`error in fetch open ticket AI chat preference: ${error}`);

      return false;
    }
  }

  async function updateOpenTicketAiChatPreference(useAiChat) {
    try {
      const profileData = await adobeIMS.getProfile();
      const res = await request(modulePreferencesUrl, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
        },
        params: {
          auth_id: profileData.userId,
        },
        method: 'PUT',
        body: JSON.stringify({
          userId: profileData.authId,
          moduleName: 'caseCreation',
          preferenceKey: 'aiChat',
          preferenceValue: useAiChat,
        }),
      });

      return await res.json();
    } catch (error) {
      log(`error updating open ticket AI chat preference: ${error}`);

      return null;
    }
  }

  const toggleContainer = appShadowRoot.querySelector('#toggleContainer');
  if (toggleContainer) {
    window.addEventListener('pageshow', (event) => {
      portalPageMapping({ toggleContainer, persisted: event.persisted });
      // BFCache restores the previous DOM snapshot after back/forward, so `is-active` can
      // stay true even though navigation state no longer matches. Clear it on restore.
      if (event.persisted) {
        toggleContainer.classList.remove('is-active');
      }
    });

    if (!hasCheckedPortalPreferenceOnce) {
      hasCheckedPortalPreferenceOnce = true;
      portalPreferencePromise.then(async (preferNewPortal) => {
        // Logged-out users have no saved preference to read — keep the toggle off.
        if (!authenticated) {
          toggleContainer.classList.remove('is-active');
          return;
        }

        //const isRollbackActive = (import.meta.env.VITE_IS_ROLLBACK_ACTIVE || '').toLowerCase() === 'true';
        //const releaseRegions = import.meta.env.VITE_RELEASE_REGIONS || localStorage.getItem(ReleaseRegions) || 'APAC';

        // No saved preference and rollback is off: send the user to the new portal,
        // but only if their IMS profile's country falls within the release regions.
        // if (preferNewPortal === null && !isRollbackActive) {
        //   const inRegion = await isProfileInReleaseRegion(releaseRegions);
        //   if (inRegion) {
        //     portalPageMapping({ toggleContainer, persisted: true });
        //   }
        //   return;
        // }

        // Preserve existing behavior for all other preference/rollback combinations.
        toggleContainer.classList.toggle('is-active', preferNewPortal);
        if(preferNewPortal && !isRedeemCodeDeepLink()) {
          window.location.href = modernSupportV2Href(getCurrentSupportTab());
        }
        
        // if (preferNewPortal && getCurrentSupportTab() === SUPPORT_TABS.HOME) {
        //   if(isRollbackActive) {
        //     window.location.href = modernSupportV2Href(getCurrentSupportTab());
        //   } else {
        //     portalPageMapping({ toggleContainer });
        //   }
        //  // 
        // }
      });
    }
  }
  const routeMap = {
    [SUPPORT_TABS.HOME]: "/", 
    [SUPPORT_TABS.OPEN_TICKET]: "/open-ticket",
    [SUPPORT_TABS.MY_CASES]: "/my-cases",
  };
  const modernSupportV2Href = (tab = SUPPORT_TABS.HOME) => {
    const current_org = getSelectedOrg();
    let orgQuery = '';
    const pathSuffix = routeMap[tab] || '';
    if (authenticated) {
      orgQuery = current_org?.id ? `?org-id=${current_org.id}` : '';
    }
    return new URL(`/support/v2/${lang}${pathSuffix}${orgQuery}`, window.location.origin).href;
  };

  if (toggleContainer && toggleContainer.dataset.listenerAttached !== 'true') {
    toggleContainer.addEventListener('click', async () => {
      if (getCurrentSupportTab() !== SUPPORT_TABS.HOME) {
        return;
      }

      // Logged-out users have no profile/email to key a saved preference by —
      // just send them to the new portal's home page without touching localStorage.
      if (!authenticated) {
        toggleContainer.classList.remove('is-active');
        window.location.href = modernSupportV2Href(SUPPORT_TABS.HOME);
        return;
      }

      toggleContainer.classList.toggle('is-active');
      const preferNewPortal = toggleContainer.classList.contains('is-active');
      const destinationDomain = modernSupportV2Href(getCurrentSupportTab());
      try {
        const companyEntitlements = await getEntitlementsString();
        const companysupportEntitlements = await getSupportEntitlements();
        const newHomepageTitle = getLabelV2('Return to the previous experience');
        adobeDataLayerTrack({
          event: 'linkClicked',
          eventType: 'web.webInteraction.linkclicks',
          supportPortalType: 'legacy support portal',
          companyLoginDetails: {
            companyLoginName: selectedOrg.name,
            companyLoginID: selectedOrg.id,
            companyEntitlements,
            companysupportEntitlements: companysupportEntitlements ? 'Ultimate' : 'Expert',
          },
          link: {
            linkTitle: `${newHomepageTitle} ${preferNewPortal ? 'On' : 'Off'}`,
            linkLocation: 'sideNav:legacy:newUiSwitcher',
            linkType: 'toggle',
            destinationDomain,
          },
        });
        const profileData = await adobeIMS.getProfile();
        if(profileData.authId && profileData.userId){
          await updatePortalPreference(preferNewPortal);
        }
        window.location.href = modernSupportV2Href(getCurrentSupportTab());
      } catch (error) {
        log(`error toggling portal preference: ${JSON.stringify(error)}`);
        window.location.href = modernSupportV2Href(getCurrentSupportTab());
      }
    });
    toggleContainer.dataset.listenerAttached = 'true';
  }
  updateToggleVisibility();
  portalPageMapping({ toggleContainer });

  let products = [];
  console.log('lang', lang);
  console.log('Lang exlLangMapping[lang]', exlLangMapping[lang]);
  
  if ($lel.topErrorMessageButton) {
    $lel.topErrorMessageButton.href = `https://experienceleague.adobe.com/${exlLangMapping[lang]}/docs/customer-one/using/home`;
    console.log('lang $lel.topErrorMessageButton.href', $lel.topErrorMessageButton.href);
    console.log('lang $lel.topErrorMessageButton', $lel.topErrorMessageButton);
    
  }

  appShadowRoot.querySelectorAll('a.support_tab_button[data-id="redeem-code"]').forEach((idx) => {
    idx.parentElement.classList.add('is-hidden');
  });

  appShadowRoot.querySelectorAll('a.support_tab_button[data-id="redeem-code"]').forEach((idx) => {
    idx.parentElement.classList.add('is-hidden');
  });

  let orgSwitchInFlight = false;
  let sideBarTicketStatusRunId = 0;
  let openTicketSubmitAbortController = null;
  let auraEmbed = null;

  function setOrgPickerSwitching(switching) {
    orgSwitchInFlight = switching;
    if (!$lel.pickerLoader || !$lel.orgPicker) {
      return;
    }
    if (switching) {
      sideBarTicketStatusRunId += 1;
      openTicketSubmitAbortController?.abort();
      $lel.orgPicker.classList.add('is-hidden');
      $lel.pickerLoader.classList.remove('is-hidden');
      appShadowRoot.querySelector('.adobe-exl-pickerOptions.is-open')?.classList.remove('is-open');
      const productDropdown = appShadowRoot.querySelector('#product-btn-dropdown-container');
      if (productDropdown) {
        productDropdown.innerHTML = '<span class="loader btn-loader"></span>';
        const productFamily = appShadowRoot.querySelector('#product-family-btn-container');
        if (productFamily) {
          productFamily.innerHTML = '';
        }
      }
    } else {
      $lel.pickerLoader.classList.add('is-hidden');
      $lel.orgPicker.classList.remove('is-hidden');
    }
  }

  function hidePickerLoader() {
    if (orgSwitchInFlight) {
      return;
    }
    if ($lel.pickerLoader && !$lel.pickerLoader.classList.contains('is-hidden')) {
      $lel.pickerLoader.classList.add('is-hidden');
    }
  }

  async function getEntitlements() {
    if (!entitlementsPromise) {
      // entitlementsPromise = getUserProfile().then((result) => result?.data?.entitlements);
      entitlementsPromise = []
    }
    return entitlementsPromise;
  }

  async function getEntitlementsString() {
    const entitlements = await getEntitlements();
    return (Array.isArray(entitlements) ? entitlements : []).join(',');
  }

  async function checkForWorkfrontAccess() {
    const result = [];
    let workfrontAccessStart = 0;
    if (authenticated) {
      try {
        if ($lel.pickerLoader.classList.contains('is-hidden')) {
          $lel.pickerLoader.classList.remove('is-hidden');
        }
        const requestHeaders = {};
        requestHeaders['x-api-key'] = ClientId;
        const token = window.adobeIMS.getAccessToken().token || '';
        requestHeaders.Authorization = `Bearer ${token}`;
        const searchParams = {
          contactRengaId: userprofile.email,
        };

        workfrontAccessStart = performance.now();
        const res = await request(workfrontProductAccessAuthUrl, {
          headers: { ...requestHeaders },
          params: { ...searchParams },
          key: 'workfront-access',
        });
        const workfrontAccessDuration = Number((performance.now() - workfrontAccessStart));
        const data = await res.json();

        if (res.ok && data.status === 200 && data.message === 'Authentication Success') {
          relicApiSuccess({
            endpoint: workfrontProductAccessAuthUrl,
            duration: workfrontAccessDuration,
            ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
          });
          if (Array.isArray(data.data)) {
            for (const org of data.data) {
              if (org.Account && org.Account.Name) {
                let workfrontOrg = {};
                let organizationName = `${org.Account.Name} (Workfront)`;
                if (org.Account.Dynamics_Transition__c) {
                  organizationName = `${org.Account.Name} (ReadOnly)`;
                }
                workfrontOrg = {
                  orgId: org.Account.Id,
                  orgName: organizationName,
                  orgType: 'Enterprise',
                  type: 'WORKFRONT',
                  contactId: org.Id,
                };
                result.push(workfrontOrg);
              } else {
                console.warn('Account.Name is not present, skipping this organization.');
              }
            }

            workfrontOrgsRendered = true;
            sessionStorage.setItem(HasWorkfront, JSON.stringify(result));
          }
          hidePickerLoader();

          return result;
        }
        relicApiFail({ 
          status: data.status,
          endpoint: workfrontProductAccessAuthUrl,
          duration: workfrontAccessDuration,
          ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
        });
        sessionStorage.removeItem(HasWorkfront);
        hidePickerLoader();
        log(`Failed to retrieve access for workfront: ${data.error}`);
        workfrontOrgsRendered = true;
        setPageLoadErrorMessage(data?.error || data?.message || `Workfront access check failed (${data?.status || res.status})`);

        return result;
      } catch (err) {
        const workfrontAccessDuration = workfrontAccessStart
          ? Number((performance.now() - workfrontAccessStart) )
          : 0;
        relicApiFail({
          err: err.status,
          endpoint: workfrontProductAccessAuthUrl,
          duration: workfrontAccessDuration,
          ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
        });
        hidePickerLoader();
        log(`Failed to retrieve access for workfront: ${err.message}`);
        setPageLoadErrorMessage(err?.message || String(err || 'Workfront access check failed'));

        return result;
      }
    } else {
      hidePickerLoader();

      return result;
    }
  }

  async function checkCommerceAccess() {
    const result = [];
    try {
      if ($lel.pickerLoader.classList.contains('is-hidden')) {
        $lel.pickerLoader.classList.remove('is-hidden');
      }

      let res = '';
      let amcData = '';
      const imsProfile = JSON.parse(sessionStorage.getItem('profile'));

      const imsOrgs = imsProfile.orgs;
      imsOrgs.push({ userId: imsProfile.authId });

      let abc = ''
      for (let org of imsOrgs){
        abc += org.userId + ','
      }
      console.log('abc', abc);
      
      let profileData = await adobeIMS.getProfile();
        const commerceAccessStart = performance.now();
        res = await request(commerceAccessUrl, {
          credentials: 'include',
          headers: {
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            [headerKeys.accept]: headerValues.json,
          },
          params: {
            customerIds: abc,
            auth_id: profileData.userId
          },
          method: 'GET',
        });
        const commerceAccessDuration = Number((performance.now() - commerceAccessStart) );
        amcData = await res.json();
        if (amcData.success) {
          if (res.ok) {
            relicApiSuccess({
              endpoint: commerceAccessUrl,
              duration: commerceAccessDuration,
              ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
            });
          } else {
            relicApiFail({
              status:amcData.status,
              endpoint: commerceAccessUrl,
              duration: commerceAccessDuration,
              ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
            });
          }
        }
      // }

      const allAmcOrg = [];
      if (amcData.success) {
        if (!amcData.orgs.primary.length && !amcData.orgs.shared.length) {
          sessionStorage.removeItem(HasCommerce);
          hidePickerLoader();
          log('No Commerce Orgs Found');
          commerceOrgsFetched = true;

          return result;
        }
        if (Array.isArray(amcData.orgs.primary) && amcData.orgs.primary.length) {
          allAmcOrg.push(...amcData.orgs.primary);
        }
        if (Array.isArray(amcData.orgs.shared) && amcData.orgs.shared.length) {
          allAmcOrg.push(...amcData.orgs.shared);
        }

        let profileData = await adobeIMS.getProfile();

        let allOrgIds = ''
        if (allAmcOrg && allAmcOrg.length) {
          for (const org of allAmcOrg) {
            allOrgIds += org.id + ','
          }
          console.log('allOrgIds', allOrgIds);
          const orgRes = await request(commerceOrgAccessUrl, {
              credentials: 'include',
              headers: {
                Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
                [headerKeys.accept]: headerValues.json,
              },
              params: {
                organization_Id: allOrgIds,
                email_id: userprofile.email,
                date: new Date(),
                auth_id: profileData.userId
              },
              method: 'GET',
            });
            const amcOrgData = await orgRes.json();
            console.log('amcOrgData', amcOrgData.data);
            if(amcOrgData && amcOrgData.success){
              for (let orgData of amcOrgData.data){
                console.log('orgData', orgData);
                const filteredArray = orgData.contacts.filter((item) => item.email.includes(userprofile.email));

                const commonIds = filteredArray.filter((commerceObj) =>
                  imsOrgs.some((imsObj) => imsObj.userId === commerceObj.contactRengaId),
                );

                // Define the order of types
                const typeOrder = ['type1', 'type3', 'type2', 'type2e'];

                // Custom comparison function
                const compareTypes = (a, b) => typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);

                commonIds.sort(compareTypes);

                const amcUserOrgDetail = commonIds[0];

                let roleArray = [];
                if (Array.isArray(amcUserOrgDetail.roles) && amcUserOrgDetail.roles.length) {
                  roleArray = amcUserOrgDetail.roles.map((role) => role.attributes).flat();
                }
                let commerceOrg = {};
                commerceOrg = {
                  orgId: orgData.id,
                  orgName: orgData.name + ' (Commerce)',
                  orgType: 'Enterprise',
                  type: 'COMMERCE',
                  userId: userprofile.authId,
                  rengaId: amcUserOrgDetail.contactRengaId,
                  rengaIdType: amcUserOrgDetail.type,
                  roles: roleArray,
                };
                result.push(commerceOrg);
              }
            } else{
              result = []
            }
            console.log('result orgData', result);
            
          
          // for (const org of allAmcOrg) {
          //   const commerceOrgStart = performance.now();
          //   console.log('before commerceOrgUrl', commerceOrgUrl);
            
          //   let newCommerceOrgUrl = commerceOrgUrl.replace('#ORG_ID#', org.id)
          //   console.log('after commerceOrgUrl', commerceOrgUrl);
          //   const orgRes = await request(newCommerceOrgUrl, {
          //     credentials: 'include',
          //     headers: {
          //       Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          //       [headerKeys.accept]: headerValues.json,
          //     },
          //     params: {
          //       id: org.id,
          //       date: new Date(),
          //       auth_id: profileData.userId
          //     },
          //     method: 'GET',
          //   });
          //   const amcOrgData = await orgRes.json();
          //   const commerceOrgDuration = Number((performance.now() - commerceOrgStart) );

          //   if (amcOrgData.success) {
          //     relicApiSuccess({
          //       endpoint: commerceOrgUrl,
          //       duration: commerceOrgDuration,
          //       ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
          //     });
          //     if (Array.isArray(amcOrgData.contacts) && amcOrgData.contacts.length) {
          //       const filteredArray = amcOrgData.contacts.filter((item) => item.email.includes(userprofile.email));

          //       const commonIds = filteredArray.filter((commerceObj) =>
          //         imsOrgs.some((imsObj) => imsObj.userId === commerceObj.contactRengaId),
          //       );

          //       // Define the order of types
          //       const typeOrder = ['type1', 'type3', 'type2', 'type2e'];

          //       // Custom comparison function
          //       const compareTypes = (a, b) => typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);

          //       commonIds.sort(compareTypes);

          //       const amcUserOrgDetail = commonIds[0];

          //       let roleArray = [];
          //       if (Array.isArray(amcUserOrgDetail.roles) && amcUserOrgDetail.roles.length) {
          //         roleArray = amcUserOrgDetail.roles.map((role) => role.attributes).flat();
          //       }
          //       let commerceOrg = {};
          //       commerceOrg = {
          //         orgId: org.id,
          //         orgName: org.name + ' (Commerce)',
          //         orgType: 'Enterprise',
          //         type: 'COMMERCE',
          //         userId: userprofile.authId,
          //         rengaId: amcUserOrgDetail.contactRengaId,
          //         rengaIdType: amcUserOrgDetail.type,
          //         roles: roleArray,
          //       };
          //       result.push(commerceOrg);
          //     } else {
          //       sessionStorage.removeItem(HasCommerce);
          //       hidePickerLoader();
          //       log('Failed to retrieve access for commerce:');
          //       commerceOrgsFetched = true;

          //       return result;
          //     }
          //   } else {
          //     relicApiFail({
          //       status:amcData.status,
          //       endpoint: commerceOrgUrl,
          //       duration: commerceOrgDuration,
          //       ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
          //     });
          //   }
          // }
          sessionStorage.setItem(HasCommerce, JSON.stringify(result));
          hidePickerLoader();

          return result;
        }
        sessionStorage.removeItem(HasCommerce);
        hidePickerLoader();
        log('No Commerce Orgs Found');
        commerceOrgsFetched = true;


        return result;
      }
      sessionStorage.removeItem(HasCommerce);
      hidePickerLoader();
      log('Failed to retrieve access for commerce:');

      return result;
    } catch (error) {
      hidePickerLoader();
      console.error(`Failed to retrieve access for Commerce: ${error}`);
      console.error(`Failed to retrieve access for Commerce: ${error.message}`);

      return result;
    }
  }

  async function checkECCAccess() {
    let result = [];
    let eccAccessStart = 0;
    try {
      if ($lel.pickerLoader.classList.contains('is-hidden')) {
        $lel.pickerLoader.classList.remove('is-hidden');
      }


      let userDetails = await adobeIMS.getProfile();
      const raw = `{"EMAILID": "${userDetails.email}"}`;

      // log(eccOrgUrl);
      // log(raw);
      eccAccessStart = performance.now();
      const res = await request(eccOrgUrl, {
        credentials: 'include',
        headers: {
          Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
          'content-type': 'application/json',
        },
        params:{
          auth_id: userDetails.userId
        },
        body: raw,
        method: 'POST'
      });
      let eccData = await res.json();
      const eccAccessDuration = Number((performance.now() - eccAccessStart) );

      log("eccData", eccData)

      if (eccData.status === 200) {
        relicApiSuccess({
          endpoint: eccOrgUrl,
          duration: eccAccessDuration,
          ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
        });
        if (eccData.result.length) {


          for (let org of eccData.result) {

            let eccOrg = {};
            eccOrg = {
              orgId: org.orgNo,
              orgName: org.orgName1 + ' (ALM)',
              orgType: 'Enterprise',
              type: 'ECC',
              userId: org.contacts[0].rengaid,
              rengaId: '',
              rengaIdType: '',
              roles: ['support']
            };
            result.push(eccOrg);
          }


          sessionStorage.setItem(HasECC, JSON.stringify(result));
          hidePickerLoader();
          eccOrgsFetched = true
          
          return result;

        } else {
          sessionStorage.removeItem(HasECC);
          hidePickerLoader();
          log('No ECC Orgs Found');
          eccOrgsFetched = true
          
          return result;
        }
      } else {
        relicApiFail({
          status:eccData.status,
          endpoint: eccOrgUrl,
          duration: eccAccessDuration,
          ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
        });
        eccOrgsFetched = true
        setPageLoadErrorMessage(eccData?.message || eccData?.error || `ECC access check failed (${eccData?.status || res.status})`);
        sessionStorage.removeItem(HasECC);
        hidePickerLoader();
        log('Failed to retrieve access for ECC:');

        return result;
      }
    } catch (error) {
      const eccAccessDuration = eccAccessStart
        ? Number((performance.now() - eccAccessStart) )
        : 0;
      relicApiFail({
        status:error.status,
        endpoint: eccOrgUrl,
        duration: eccAccessDuration,
        ...RELIC_SUPPORT_PAGE_AVAILABILITY_TRACKING,
      });
      hidePickerLoader();
      log(`Failed to retrieve access for ECC: ${error.message}`);
      setPageLoadErrorMessage(error?.message || String(error || 'ECC access check failed'));

      return result;
    }
  }

  viewCaseFilterList = [
    { id: 1, label: getLabelV2('My cases (Open)') },
    { id: 2, label: getLabelV2('My cases (Closed)') },
    { id: 3, label: getLabelV2('My cases (All)') },
    { id: 4, label: getLabelV2("My organization's cases (Open)") },
    { id: 5, label: getLabelV2("My organization's cases (Closed)") },
    { id: 6, label: getLabelV2("My organization's cases (All)") },
  ];

  function mergeOrganizationsFromProfileAndSession() {
    organizations = userprofile.orgs ? userprofile.orgs : [];
    if (organizations.length) {
      organizations = organizations.map((org) => {
        org.type = 'MILO';

        return org;
      });
    }
    const hasWorkfrontOrg = sessionStorage.getItem(HasWorkfront);
    if (hasWorkfrontOrg !== null) {
      const workfrontOrgs = JSON.parse(hasWorkfrontOrg);
      organizations = [...organizations, ...workfrontOrgs];
    }
    const hasCommerceOrg = sessionStorage.getItem(HasCommerce);
    if (hasCommerceOrg !== null) {
      const commerceOrgs = JSON.parse(hasCommerceOrg);
      organizations = [...organizations, ...commerceOrgs];
    }

    const hasECCOrg = sessionStorage.getItem(HasECC);
    if (hasECCOrg !== null) {
      const eccOrgs = JSON.parse(hasECCOrg);
      organizations = [...organizations, ...eccOrgs];
    }
  }

  if (authenticated) {
    mergeOrganizationsFromProfileAndSession();
    orgAccessChecksPromise = Promise.all([
      checkForWorkfrontAccess(),
      checkCommerceAccess(),
      checkECCAccess(),
    ]);
    if (tabNeedsOrgAccessBeforePaint(initialTabAtBoot)) {
      await orgAccessChecksPromise;
      mergeOrganizationsFromProfileAndSession();
    } else {
      orgAccessChecksPromise.then(() => {
        mergeOrganizationsFromProfileAndSession();
      });
    }
    if (profileFullLoadPromise) {
      profileFullLoadPromise = profileFullLoadPromise.then((full) => {
        if (full) {
          userprofile = full;
          mergeOrganizationsFromProfileAndSession();
        }
        return full;
      });
    }
  }

  if (lurl.searchParams.get('org-id')) {
    selectedOrgObj = organizations.find((org) => org.orgId === lurl.searchParams.get('org-id'));
    deleteCookie(SelectedOrg);
    if(selectedOrgObj){
      cookie(
        'set',
        SelectedOrg,
        JSON.stringify({
          id: lurl.searchParams.get('org-id'),
          name: selectedOrgObj.orgName,
          type: selectedOrgObj.type,
          orgType: selectedOrgObj.orgType,
          userId: selectedOrgObj.userId,
          contactId: selectedOrgObj.contactId ? selectedOrgObj.contactId : null,
          rengaId: selectedOrgObj?.rengaId ? selectedOrgObj?.rengaId : null,
          rengaIdType: selectedOrgObj?.rengaIdType ? selectedOrgObj?.rengaIdType : null,
        }),
      );
    }
  }

  /**
   * `verifyRole()` is invoked from both `helperSideNav()` and `supportProcess()` during init (and similar
   * pairs elsewhere), causing repeated `switchProfile` for the same org. Share one in-flight call per
   * userId and debounce failure UI so alerts / signIn do not fire twice in a row.
   */
  const switchProfileInFlightByUserId = new Map();
  let lastImsSwitchProfileFailureNotifyAt = 0;
  const IMS_SWITCH_PROFILE_FAILURE_DEBOUNCE_MS = 5000;

  function notifyImsSwitchProfileFailureOnce(logMessage) {
    const now = Date.now();
    if (now - lastImsSwitchProfileFailureNotifyAt < IMS_SWITCH_PROFILE_FAILURE_DEBOUNCE_MS) {
      return;
    }
    lastImsSwitchProfileFailureNotifyAt = now;
    log(logMessage, { type: 'error' });
    alert('Your session has timed out. You will be redirected to the login page.');
    adobeIMS.signIn();
  }

  const changeAccessToken = async (org) => {
    const { userId } = org;
    if (!userId) {
      log('Adobe IMS switchProfile skipped: missing userId', { type: 'error' });
      return false;
    }

    let inFlight = switchProfileInFlightByUserId.get(userId);
    if (inFlight) {
      return inFlight;
    }

    inFlight = (async () => {
      try {
        const newProfile = await window.adobeIMS.switchProfile(userId);
        const tokenStr = newProfile?.tokenInfo?.token;
        if (!tokenStr) {
          log('Adobe IMS switchProfile returned no token', { type: 'error' });
          return false;
        }
        sessionStorage.setItem(SupportOrgToken, `Bearer ${tokenStr}`);
        return true;
      } catch (e) {
        notifyImsSwitchProfileFailureOnce(`Adobe IMS switchProfile failed: ${e?.message ?? e}`);
        return false;
      }
    })();

    switchProfileInFlightByUserId.set(userId, inFlight);
    inFlight.finally(() => {
      switchProfileInFlightByUserId.delete(userId);
    });

    return inFlight;
  };

  /**
   * check if the day when survey generated is less than 15 days
   */
  async function checkSurveyDate(surveyDate) {
    surveyDate = new Date(surveyDate);
    const nowDate = new Date();
    const dateDifference = new Date(nowDate.getTime() - surveyDate.getTime());
    if (dateDifference < 1296000000) {
      return true;
    }
    return false;
  }

  /**
   * show survey notification for Workfront Orgs if a survey is available and not filled
   */
  async function showSurveyNotification() {
    let workfrontCaseListStart = 0;
    try {
      const sidebarSurveyBanner = appShadowRoot.getElementById('sidebar-survey');
      showNotification = false;
      if (isWorkFront()) {
        workfrontCaseListStart = performance.now();
        const res = await request(workfrontCaseListUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            accountId: getSelectedOrg().id,
            contactRengaId: userprofile.email,
          },
          key: 'workfrontCaseList',
        });
        const data = await res.json();
        const workfrontCaseListDuration = Number((performance.now() - workfrontCaseListStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: workfrontCaseListUrl,
            duration: workfrontCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (Array.isArray(data.data)) {
            for (const caseData of data.data) {
              if (
                caseData.Survey_URL__c &&
                (caseData.Survey_Status__c === 'Success' || caseData.Survey_Status__c === 'SurveyStarted')
              ) {
                if (await checkSurveyDate(caseData.LastModifiedDate)) {
                  showNotification = true;
                }
              }
            }
          }
        } else {
          relicApiFail({
            status:data.status,
            endpoint: workfrontCaseListUrl,
            duration: workfrontCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }
        if (showNotification) {
          sidebarSurveyBanner.classList.remove('is-hidden');
        } else if (!sidebarSurveyBanner.classList.contains('is-hidden')) {
          sidebarSurveyBanner.classList.add('is-hidden');
        }
      }
    } catch (error) {
      const workfrontCaseListDuration = workfrontCaseListStart
        ? Number((performance.now() - workfrontCaseListStart) )
        : 0;
      relicApiFail({
        status:error.status,
        endpoint: workfrontCaseListUrl,
        duration: workfrontCaseListDuration,
        ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
      });
      console.error('Error in showSurvey notification', error);
    }
  }

  $lel.sidebarSurveyStatus.addEventListener('click', () => {
    const caseSort = {
      key: 'caseDate',
      order: 'descending',
    };
    const filterObj = {
      caseSort,
      viewCase: { id: 6, label: "My organization's cases (All)" },
    };
    sessionStorage.setItem(CaseListFilters, JSON.stringify(filterObj));
    const url = new URL(window.location);
    url.searchParams.set('support-tab', 'my-cases');
    window.location.href = url.href;
  });

  let onlyPSA = false;
  /**
   * This function CHECKS if the user has appropriate role to log a case
   * returns boolean
   */
  async function verifyRole() {
    let result = false;
    const sidebarSurveyBanner = appShadowRoot.getElementById('sidebar-survey');
    const current_org = getSelectedOrg();
    console.log('current_org', current_org);
    
    let orgSelected = organizations[0];
    if(current_org?.id){
      orgSelected = organizations.find((org) => org.orgId === current_org?.id);
    }
    const hasWorkfrontOrg = sessionStorage.getItem(HasWorkfront);
    const hasCommerceOrg = sessionStorage.getItem(HasCommerce);
    if (organizations.length || hasWorkfrontOrg !== null || hasCommerceOrg !== null) {
      if (isWorkFront()) {
        result = true;
        showSurveyNotification();
      } else if (isCommerce()) {
        if (orgSelected) {
          const roles = orgSelected.roles ? (orgSelected.roles.length > 0 ? orgSelected.roles : []) : [];
          const allowedRoles = ['support', 'owner'];
          const hasEligibleCommerceRole = roles.some((role) => allowedRoles.includes(role.toLowerCase()));
          /* One switchProfile per org — multiple IMS roles matched the same org (e.g. support + owner) */
          if (hasEligibleCommerceRole && (await changeAccessToken(orgSelected))) {
            result = true;
          }
        }
      } else if (isECC()) {
        if (orgSelected) {
          const roles = orgSelected.roles ? orgSelected.roles.length > 0 ? orgSelected.roles : [] : [];
          const allowedRoles = ['support', 'owner'];
          const hasEligibleEccRole = roles.some((role) => allowedRoles.includes(role.toLowerCase()));
          if (hasEligibleEccRole && (await changeAccessToken(orgSelected))) {
            result = true;
          }
        }
      } else if (current_org && current_org.type === 'MILO') {
        if (!sidebarSurveyBanner.classList.contains('is-hidden')) {
          sidebarSurveyBanner.classList.add('is-hidden');
        }
        console.log('orgSelected', orgSelected);

        if (orgSelected) {
          const roles = orgSelected.roles ? (orgSelected.roles.length > 0 ? orgSelected.roles : []) : [];
          const allowedRoles = ['support_admin', 'org_admin', 'product_support_admin'];
          const lowerCaseRoles = roles.map(role => role.toLowerCase());

          onlyPSA =
            lowerCaseRoles.includes('product_support_admin') &&
            !lowerCaseRoles.includes('support_admin') &&
            !lowerCaseRoles.includes('org_admin');
          const hasEligibleMiloRole = roles.some((role) => allowedRoles.includes(role.toLowerCase()));
          if (hasEligibleMiloRole && (await changeAccessToken(orgSelected))) {
            result = true;
          }
        }
      }
    }

    return result;
  }
  /**
   *api to get all tickets information
   */
  async function getTicketStatus(productID) {
    const currentDate = new Date(Date.now() - 86400000);
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    try {
      const clientRegion = sessionStorage?.getItem('region');
      const apiParams = {
        api_key: 'StatusAdobeIOClient',
        productIds: productID,
        // from: formattedDate,
      };
      // if (clientRegion) {
      //   apiParams.regionIds = clientRegion;
      // }
      const res = await request(ticketStatusUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getTokenFromStorage()?.token || ''}`,
        },
        params: apiParams,
      });

      return await res.json();
    } catch (error) {
      log('Failed to retrieve status for side nav bar');
      console.error('Error in getTicketStatus', error);

      return { error: 'something went wrong in status api' };
    }
  }

  function normalizeImpactMessagePayload(res) {
    if (!res || res.error_code) return null;
    if (Array.isArray(res)) return res[0] ?? null;
    if (res.incidentMessages || res.maintenanceMessages) return res;
    return null;
  }

  function extractImpactTextMessage(payload, messageType, messageToken) {
    if (!payload || !messageToken) return '';
    const messages =
      messageType === 'incident' ? payload.incidentMessages : payload.maintenanceMessages;
    return messages?.[messageToken]?.textMessage ?? '';
  }

  async function fetchImpactMessagePayload(messageToken, locale) {
    const impactMessageUrl = `${statusMessageUrl}/${locale}`;
    const res = await request(impactMessageUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.adobeIMS.getTokenFromStorage()?.token || ''}`,
      },
      params: {
        api_key: 'StatusAdobeIOClient',
        messageToken,
      },
    });
    return res.json();
  }

  async function getImpactMessage(messageToken, messageType) {
    const primaryLocale = resolveStatusMessageLocale(lang);
    let payload = normalizeImpactMessagePayload(
      await fetchImpactMessagePayload(messageToken, primaryLocale),
    );
    let text = extractImpactTextMessage(payload, messageType, messageToken);
    const englishLocale = coveoLangMapping.en;
    if (!text && primaryLocale !== englishLocale) {
      payload = normalizeImpactMessagePayload(
        await fetchImpactMessagePayload(messageToken, englishLocale),
      );
      text = extractImpactTextMessage(payload, messageType, messageToken);
    }
    return text;
  }

  function initZeonChatCallbackFn() {
    log('zeon chat successfully initialized');
  }

  function initZeonChatErrorCallbackFn() {
    log('error in initializing zeon chat');
  }

  async function initWebcallCallbackFn() {
    log('webcall successfully initialized');
  }

  function initWebcallErrorCallbackFn() {
    log('error in initializing webcall');
  }

  function oncloseCallbackDialogFn() {
    log('webcall dialog closed');
  }
  /**
   * Initializes the zeon chat bot
   */
  async function initZeonChat() {
    try {
      if (authenticated) {
        const profileData = await window.adobeIMS.getProfile();
        const orgDetail = getSelectedOrg();
        let accessToken = sessionStorage.getItem(SupportOrgToken);
        accessToken = accessToken.replace('Bearer ', '');
        const orgId = orgDetail?.id || profileData.ownerOrg;
        const initialData = {
          appid: 'experience_league',
          appType: 'web',
          env: 'prod',
          mapped_locale: locales.get(lang).toLocaleLowerCase().replace('-', '_'),
          orgId,
          surface_locale: locales.get(lang).toLocaleLowerCase().replace('-', '_'),
          type: 'ExperienceLeague',
          supportPortalType: 'legacy support portal',
          imsAccessToken: accessToken,
          imsUserProfile: {
            account_type: profileData.account_type,
            displayName: profileData.displayName,
            roles: profileData.role,
            last_name: profileData.last_name,
            userId: profileData.userId,
            authId: profileData.userId,
            emailVerified: profileData.emailVerified,
            countryCode: profileData.countryCode,
            name: profileData.displayName,
            first_name: profileData.first_name,
            email: profileData.email,
          },
          callbacks: {
            initCallback: initZeonChatCallbackFn,
            initErrorCallback: initZeonChatErrorCallbackFn,
          },
        };
        if (orgId) {
          // eslint-disable-next-line no-undef
          await customerInteractionClientSdk.init(initialData);
        } else {
          log('failed to initialize zeon chat as organization ID is not available');
        }
      }
    } catch (e) {
      log(`error in initializing zeon chat: ${e}`);
    }
  }

  /**
 * Initializes the webcall (request a callback)
 */
  async function initWebcall(page, caseDetails) {

    let ultimateHomeCallbackImage = appShadowRoot?.querySelector('#ultimate-banner-image');
    let ultimateHomeCallbackDiv = appShadowRoot?.querySelector('#ultimate-callback-div');
    let ultimateHomeCallbackDiv1 = appShadowRoot?.querySelector('#ultimate-callback-div-1');

    let supportHomeCards = appShadowRoot?.querySelector('#support-home-cards');
    let supportHomeCallbackCards = appShadowRoot?.querySelector('#support-home-callback-cards');
    try {
      if (authenticated) {
        let orgDetail = await getSelectedOrg();
        let profileData = await adobeIMS.getProfile();

        let escalatioUserId = orgDetail.userId;

        if(isCommerce()){
          if(orgDetail?.rengaId){
            escalatioUserId = orgDetail?.rengaId ? orgDetail?.rengaId : ''
          }
        }
        
        let accessToken = await adobeIMS.getAccessToken()?.token || '';
        const initialData = {
          appid: 'helpx',
          appType: 'web',
          allowScheduledCallback: false,
          allowImmediateCallback: true,
          mapped_locale: 'en_us',
          surface_locale: 'en_us',
          userConsent: true,
          host_surface_domain: window.location.hostname,
          host_surface_name: page,
          env: 'prod',
          orgId: orgDetail.id,
          type: 'ExperienceLeague',
          imsAccessToken: accessToken,
          imsUserProfile: {
            'email': profileData.email,
            'name': profileData.displayName,
            'first_name': profileData.first_name,
            'last_name': profileData.last_name,
            'userId': escalatioUserId,
            'emailVerified': profileData.emailVerified,
            'countryCode': profileData.countryCode
          },
          callbacks: {
            'initCallback': initWebcallCallbackFn(page),
            'initErrorCallback': initWebcallErrorCallbackFn(page)
          },
          entitlements : await getEntitlements(),
        };
        if (page === 'EXL-Case Detail') {
          initialData.caseId = caseDetails.caseId;
          initialData.caseTitle = caseDetails.caseTitle;
          initialData.productCode = caseDetails.productCode;
        }

        // eslint-disable-next-line no-undef
        await ZeonCallbackClient.init(initialData, 'callback-container');
        if (page === 'EXL-Home') {
          if (ultimateHomeCallbackDiv?.classList.contains('is-hidden')) {
            ultimateHomeCallbackDiv.classList.remove('is-hidden');
          }
          if (supportHomeCallbackCards?.classList.contains('is-hidden')) {
            supportHomeCallbackCards.classList.remove('is-hidden');
          }
          supportHomeCards.classList.add('is-hidden');
          ultimateHomeCallbackImage.classList.add('is-hidden');
        }
        if (page === 'EXL-Case Detail') {
          let caseDetailRequestCallbackBtn = appShadowRoot?.querySelector('#request-callback-btn');
          if (caseDetailRequestCallbackBtn) {
            if (caseDetailRequestCallbackBtn?.classList.contains('is-hidden')) {
              caseDetailRequestCallbackBtn.classList.remove('is-hidden');
            }
          }
        }
      }
    } catch (e) {
      log(`error in initializing webcall: ${e}`);
      if (page === 'EXL-Home') {
        if (ultimateHomeCallbackImage?.classList.contains('is-hidden')) {
          ultimateHomeCallbackImage.classList.remove('is-hidden');
        }
        ultimateHomeCallbackDiv.classList.add('is-hidden');
        if (supportHomeCards?.classList.contains('is-hidden')) {
          supportHomeCards.classList.remove('is-hidden');
        }
        supportHomeCallbackCards.classList.add('is-hidden');
      }

      if (page === 'EXL-Case Detail') {
        let caseDetailRequestCallbackBtn = appShadowRoot?.querySelector('#request-callback-btn');
        if (caseDetailRequestCallbackBtn) {
          caseDetailRequestCallbackBtn.classList.add('is-hidden');
        }
      }
    }

  }


  // unhide zeon btn when modal is closed
  appShadowRoot.querySelector('.modal-close').addEventListener('click', () => {
    let zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
    if (zeonChatBtn?.classList.contains('is-hidden')) {
    }
  });
  /**
   *show number of open and closed major and maintenance tickets in sidebar
   */
  async function sideBarTicketStatus() {
    const runId = ++sideBarTicketStatusRunId;
    const isStale = () => runId !== sideBarTicketStatusRunId;

    $lel.ticketStatusUL.innerHTML = '';
    $lel.horizontalLine.classList.remove('is-hidden');
    $lel.statBar.classList.remove('is-hidden');
    $lel.systemStatus.textContent = `${getLabelV2('Your System Status')}`;
    $lel.statustPickerLoader.classList.remove('is-hidden');
    const productResult = await getProductList(productOrg, null, onlyPSA);
    if (isStale()) {
      return;
    }
    $lel.statustPickerLoader.classList.add('is-hidden');
    const productsArray = productResult.productList;
    console.log('productsArray', productsArray);
    
    const productIdArray = [];
    let statusLabel;
    for (const product of productsList) {
      for (const apiProduct of productsArray) {

        if (apiProduct.id === product.productCode) {
          console.log('productsArray product.productCode', product.productCode);
          
          if (product.productId) {
            productIdArray.push(product.productId);
          }
        }
      }
    }
    function getSideBarStatus(events, pluralLabel, singularLabel, iconClass, ticketId, productId, productName) {
      let link = '';
      if (events > 0) {
        if (events > 1) {
          statusLabel = getLabelV2(pluralLabel);
          link = adobeStatusUrl;
        } else {
          statusLabel = `${getLabelV2(singularLabel)} ${getLabelV2('in')} ${productName}`;
          link = `${eventHistoryUrl + productId}/${ticketId}`;
        }
        $lel.ticketStatusUL.innerHTML += `
        <a class ='has-text-black' href=${link} target="_blank">
          <li class="system-status-SideNav-item is-flex is-align-items-flex-start">
            <i class="event-icon ${iconClass}"></i>
            <span class="sidebar-label">${events} ${getLabelV2(statusLabel)}</span>
          </li>
        </a>`;
      }
    }

    if (productIdArray.length) {
      ticketStatusData = await getTicketStatus(productIdArray.toString());
      if (isStale()) {
        return;
      }
      if (ticketStatusData.error) {
        $lel.horizontalLine.classList.add('is-hidden');
        $lel.statBar.classList.add('is-hidden');
      }
      if (Object.keys(ticketStatusData).length === 0) {
        $lel.ticketStatusUL.innerHTML += `<li class="system-status-SideNav-item is-flex is-align-items-flex-start">
            <i class="event-icon available"></i>
            <span class="sidebar-label">${getLabelV2('All Adobe Products and Services are available')}</span>
          </li>`;
      } else {
        majorTicketData = ticketStatusData.incidents ? ticketStatusData.incidents : [];
        const maintenanceTicketData = ticketStatusData.maintenances ? ticketStatusData.maintenances : [];
        let openMajor = 0;
        let openMajorProductId;
        let openMajorTicketId;
        let openMajorTicketName;

        let openMinor = 0;
        let openMinorProductId;
        let openMinorTicketId;
        let openMinorTicketName;

        let openPotential = 0;
        let openPotentialProductId;
        let openPotentialTicketId;
        let openPotentialProductName;

        let openMaintenance = 0;
        let openMaintenanceProductId;
        let openMaintenanceTicketId;
        let openMaintenanceProductName;

        if (majorTicketData.length > 0) {
          majorTicketData.forEach((val) => {
            val.products.forEach((product) => {
              if (productIdArray.includes(Number(product.id)) && product.status !== 'Closed') {
                if (product.severity === 'Major') {
                  openMajor += 1;
                  openMajorTicketId = val.id;
                  openMajorTicketName = product.name;
                  openMajorProductId = product.id;
                } else if (product.severity === 'Minor') {
                  openMinor += 1;
                  openMinorTicketId = val.id;
                  openMinorTicketName = product.name;
                  openMinorProductId = product.id;
                } else if (product.severity === 'Potential') {
                  openPotential += 1;
                  openPotentialTicketId = val.id;
                  openPotentialProductName = product.name;
                  openPotentialProductId = product.id;
                }
              }
            });
          });
        }

        if (maintenanceTicketData.length > 0) {
          maintenanceTicketData.forEach((val) => {
            if (val.status === 'Started') {
              openMaintenance += 1;
              openMaintenanceTicketId = val.id;
              openMaintenanceProductName = val.products[0].name;
              openMaintenanceProductId = val.products[0].id;
            }
          });
        }

        getSideBarStatus(
          openMajor,
          'Major issues in progress',
          'Major issue in progress',
          'major',
          openMajorTicketId,
          openMajorProductId,
          openMajorTicketName,
        );
        getSideBarStatus(
          openMinor,
          'Minor issues in progress',
          'Minor issue in progress',
          'minor',
          openMinorTicketId,
          openMinorProductId,
          openMinorTicketName,
        );
        getSideBarStatus(
          openPotential,
          'Potential issues in progress',
          'Potential issue in progress',
          'potential',
          openPotentialTicketId,
          openPotentialProductId,
          openPotentialProductName,
        );
        getSideBarStatus(
          openMaintenance,
          'Maintenances in progress',
          'Maintenance in progress',
          'maintenance-open',
          openMaintenanceTicketId,
          openMaintenanceProductId,
          openMaintenanceProductName,
        );
        if (!openMajor && !openMinor && !openPotential && !openMaintenance) {
          $lel.ticketStatusUL.innerHTML += `<li class="system-status-SideNav-item is-flex is-align-items-flex-start">
            <i class="event-icon available"></i>
            <span class="sidebar-label">${getLabelV2('All Adobe Products and Services are available')}</span>
          </li>`;
        }
      }
    } else {
      $lel.horizontalLine.classList.add('is-hidden');
      $lel.statBar.classList.add('is-hidden');
    }

    if ($lel.ticketStatusUL && !$lel.ticketStatusUL.__supportFormSystemStatusClickBound) {
      $lel.ticketStatusUL.__supportFormSystemStatusClickBound = true;
      $lel.ticketStatusUL.addEventListener('click', async(e) => {
        const anchor = e.target.closest && e.target.closest('a.has-text-black');
        if (!anchor || !$lel.ticketStatusUL.contains(anchor)) return;
        const span = anchor.querySelector('span');
        const companyEntitlements = await getEntitlementsString();
        const companysupportEntitlements = await getSupportEntitlements();
        // adobeDataLayerTrack({
        //   event: 'supportFormSystemStatusClick',
        //   supportForm: {
        //     companyName: selectedOrg.name ? selectedOrg.name : '',
        //     url: anchor.href,
        //     title: span ? span.innerText : ''
        //   },
        // });
        adobeDataLayerTrack({
          event: 'linkClicked',
          eventType: 'web.webInteraction.linkclicks',
          companyLoginDetails: {
            companyLoginName: selectedOrg.name,
            companyLoginID: selectedOrg.id,
            companyEntitlements,
            companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
          },
          link: {
            linkTitle: span ? span.innerText : '',
            linkLocation: `status.adobe.com:left`,
            linkType: 'link',
            destinationDomain: anchor.href,
          },
        });
      });
    }
  }

  async function getUltimateContact() {
    try {
      const userDetails = await window.adobeIMS.getProfile();
      let profileData = await adobeIMS.getProfile();
      let orgID = userDetails.ownerOrg;
      if (orgID.includes('@AdobeOrg')) {
        orgID = orgID.replaceAll('@AdobeOrg', '');
      }

      if (orgID.includes('%40AdobeOrg')) {
        orgID = orgID.replaceAll('%40AdobeOrg', '');
      }

      const res = await request(snaplogicUrl, {
        credentials: 'include',
        headers: {
          Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
        },
        params: {
          OrgID: orgID,
          auth_id: profileData.userId
        },
        method: 'GET',
      });
      const data = await res.json();

      return data.data;
    } catch (error) {
      log(`error in fetch ultimate contacts: ${error}`);

      return [];
    }
  }

  async function getSupportEntitlements() {
    let source = 'IMS';
    if (isECC()) {
      source = 'ECC';
    }
    if (isCommerce()) {
      source = 'AMC';
    }

    const cacheKey = `${getSelectedOrg().id}:${source}`;
    if (supportEntitlementsPromises.has(cacheKey)) {
      return supportEntitlementsPromises.get(cacheKey);
    }

    const promise = (async () => {
    let showUltimate = false;
    let entitlementStart = 0;

    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': ClientId,
        Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
      },
      params: {
        identifier: getSelectedOrg().id,
        source
      },
    };
    try {
      if (isCommerce()) {
        showUltimate = false;
      } else {

        entitlementStart = performance.now();
        const res = await request(miloEntitlementSyncURL, options);
        let data = await res.json();
        const entitlementDuration = Number((performance.now() - entitlementStart) );

        if (res.ok) {
          relicApiSuccess({
            endpoint: miloEntitlementSyncURL,
            duration: entitlementDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        } else {
          relicApiFail({
            status:data.status,
            endpoint: miloEntitlementSyncURL,
            duration: entitlementDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }

        if (data && data.orgs && data.orgs.length) {
          for (const productEntitlement of data.orgs[0].product_entitlements || []) {
            for (const item of productEntitlement.entitlement?.support_entitlements || []) {
              if (item.code === 'support_plan_level' && item.value === 'Ultimate') {
                showUltimate = true;
              }
            }
          }
        } else {
          console.log('User not entitled to Ultimate support: ');
        }
      }

      return showUltimate;
    } catch (error) {
      const entitlementDuration = entitlementStart
        ? Number((performance.now() - entitlementStart) )
        : 0;
      relicApiFail({
        status:error.status,
        endpoint: miloEntitlementSyncURL,
        duration: entitlementDuration,
        ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
      });
      log(`There was an error in entitlements API: ${error.message}`);

      return {};
    }
    })();

    supportEntitlementsPromises.set(cacheKey, promise);
    return promise;
  }

  async function successHomeCards(supportCards) {
    const suppportUltimateCard = appShadowRoot.getElementById('support-home-person-cards');
    let cardsHTML = '';
    if (supportCards && supportCards.length) {
      supportCards.forEach((row) => {
        contactCards.roles.forEach((role) => {
          let email = role?.split(' ')[0] + ' Email';
          if (row[role] && row[role] !== '' && row[role] !== 'undefined') {
            cardsHTML += `<div class="column is-4">
            <div class="card-ultimate">
              <div class="card-content">
                  <div class="mb-4 media-card-ultimate">
                    <div class="media-content">
                        <p class="subtitle pb-3 mb-4 card-titles has-text-grey  " data-cs-mask> ${contactCards.roleNames[
                role
              ]?.name.toUpperCase()}
                        </p>
                        <p class="title has-text-weight-bold  ultimate-card-name is-4 is-size-5" data-cs-mask>${row[role]}</p>
                    </div>
                  </div>
                  <div class="has-text-darkgray is-size-6 ">
                    <p class=" is-size-6  card-description" data-cs-mask> ${contactCards.roleNames?.[role]?.roleDescription}</p>

                    </p>
                    <a href="mailto:${row[email]}" target="_blank">
                    <button data-id="signin"
                          class=" spectrum-Button spectrum-Button--sizeM">
                          <span class="spectrum-Button-label">Contact</span>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>`;
          } else {
            suppportUltimateCard.innerHTML = cardsHTML;
          }
        });
      });
      suppportUltimateCard.innerHTML = cardsHTML;
    } else {
      suppportUltimateCard.innerHTML = cardsHTML;
    }
  }

  async function showUltimateHomePage(showUltimate) {
    const $llel = {
      premiumHomeLearnMore: appShadowRoot.querySelector('#premium-home-learn-more'),
      ultimateHomePage: appShadowRoot.getElementById('support-ultimate-home'),
      supportPage: appShadowRoot.querySelector('#support-home'),
      ultimateInnerButton: appShadowRoot.getElementById('ultimate-inner-circle-anchor-views'),
    };
    if (showUltimate) {
      if ($llel.supportPage?.classList.contains('active')) {
        $llel.supportPage?.classList.replace('active', 'is-hidden');
      } else {
        $llel.supportPage?.classList.add('is-hidden');
      }
      if ($llel.ultimateHomePage?.classList.contains('is-hidden')) {
        $llel.ultimateHomePage?.classList.replace('is-hidden', 'active');
      } else {
        $llel.ultimateHomePage?.classList.add('active');
      }



      if (appShadowRoot.getElementById('support-home-person-cards')) {
        const supportCards = await getUltimateContact();
        await successHomeCards(supportCards);
      }
    } else {
      if (!$llel.ultimateInnerButton.parentElement?.classList.contains('is-hidden')) {
        $llel.ultimateInnerButton.parentElement?.classList.add('is-hidden');
      }
      if ($llel.ultimateHomePage?.classList.contains('active')) {
        $llel.ultimateHomePage?.classList.replace('active', 'is-hidden');
      } else {
        $llel.ultimateHomePage?.classList.add('is-hidden');
      }

    }
  }

  function detectDevice() {
    const is_Mobile = window.matchMedia;
    if (is_Mobile) {
      const match_Mobile = is_Mobile('(pointer:coarse)');

      return match_Mobile.matches;
    }

    return false;
  }

  /**
   * process left sidebar for authenticated and authorized user
   */
  async function helperSideNav(hasUserRole) {
    const $llel = {
      premiumHomeLearnMore: appShadowRoot.querySelector('#premium-home-learn-more'),
      ultimateHomePage: appShadowRoot.getElementById('support-ultimate-home'),
      supportPage: appShadowRoot.querySelector('#support-home'),
      ultimateInnerButton: appShadowRoot.getElementById('ultimate-inner-circle-anchor-views'),
    };

    if (hasUserRole === undefined) {
      hasUserRole = await verifyRole();
    }
    if (hasUserRole && authenticated) {
      $lel.topErrorMessage.classList.add('is-hidden');
      $lel.tabsTooltip.forEach((idx) => {
        idx.classList.add('is-hidden');
      });
      appShadowRoot.querySelectorAll('a.support_tab_button[data-id="my-cases"]').forEach((idx) => {
        idx.classList.remove('disable-btn');
      });
      await initZeonChat();
      sideBarTicketStatus();
      const data = await getSupportEntitlements();
      if (data) {
        await showUltimateHomePage(data);
      }

      const mobileDevice = detectDevice();
      if (mobileDevice && data) {
        if ($llel.ultimateHomePage.classList.contains('active')) {
          let mobileView = '';
          mobileView += `<div class="card mobile-view-card">
                          <div class="card-content mobile-card-content">
                              <p> It looks like you are an Ultimate Support customer. 
                              Please use the new Ultimate Support App or use the website on a desktop device.</p>
                            <div class="mobile-content is-flex is-justify-content-space-evenly" >
                              <div><a href="https://apps.apple.com/us/app/ultimate-success/id6479165510" target="_blank" class="card-footer-item">
                              <div> <img src="/assets/img/support/app-store.png"></div>
                              </a></div>
                              <div class="is-flex" >
                                <a href="#" target="" class="card-footer-item is-flex-direction-column" >
                              <div> <img src="/assets/img/support/playstore.png"></div>
                                 <span> Android coming soon </span> </a>
                            </div>
                            </div>
                          </div>
                          
                        </div>`;
          $llel.ultimateHomePage.innerHTML = mobileView;
        }
      }

      appShadowRoot.querySelectorAll('a.support_tab_button[data-id="open-ticket"]').forEach((idx) => {
        idx.classList.remove('disable-btn');
      });
      const currentOrg = getSelectedOrg();
      if (currentOrg.name.includes('ReadOnly')) {
        appShadowRoot.querySelectorAll('a.support_tab_button[data-id="open-ticket"]').forEach((idx) => {
          idx.classList.add('disable-btn');
        });
      }
    } else {
      if (authenticated) {
        $lel.topErrorMessageButton.href = `https://experienceleague.adobe.com/${exlLangMapping[lang]}/docs/customer-one/using/home`;
        $lel.topErrorMessage.classList.remove('is-hidden');
      }

      $lel.tabsTooltip.forEach((idx) => {
        idx.classList.remove('is-hidden');
      });
      appShadowRoot.querySelectorAll('a.support_tab_button[data-id="my-cases"]').forEach((idx) => {
        idx.classList.add('disable-btn');
      });
      appShadowRoot.querySelectorAll('a.support_tab_button[data-id="open-ticket"]').forEach((idx) => {
        idx.classList.add('disable-btn');
      });
      if (appShadowRoot.querySelectorAll('.adbMsgClientWrapper').length) {
        // eslint-disable-next-line no-undef
        await customerInteractionClientSdk.destroy();
      }
    }
  }

  /**
   * get organization list
   */
  async function prepareOrgList() {
    let orgHTML = '';
    selectedOrg = { id: '', name: '' };
    let currentOrg = getSelectedOrg();
    if (organizations.length) {
      $lel.orgPicker.classList.remove('is-hidden');
      $lel.orgPicker.classList.add('org-device');
      if (currentOrg === null) {
        selectedOrg.id = organizations[0].orgId;
        selectedOrg.name = organizations[0].orgName;
        selectedOrg.type = organizations[0].type;
        selectedOrg.contactId = organizations[0].contactId ? organizations[0].contactId : null;
        selectedOrg.rengaId = organizations[0]?.rengaId ? organizations[0]?.rengaId : null;
        selectedOrg.rengaIdType = organizations[0]?.rengaIdType ? organizations[0]?.rengaIdType : null;
      } else {
        const foundOrg = organizations.find((org) => org.orgId === currentOrg.id);
        if (foundOrg) {
          selectedOrg.id = foundOrg.orgId;
          selectedOrg.name = foundOrg.orgName;
          selectedOrg.type = foundOrg.type;
          selectedOrg.userId = foundOrg.userId;
          selectedOrg.contactId = foundOrg.contactId ? foundOrg.contactId : null;
          selectedOrg.rengaId = foundOrg?.rengaId ? foundOrg?.rengaId : null;
          selectedOrg.rengaIdType = foundOrg?.rengaIdType ? foundOrg?.rengaIdType : null;
        } else {
          currentOrg = organizations[0].orgId;
          selectedOrg.id = organizations[0].orgId;
          selectedOrg.name = organizations[0].orgName;
          selectedOrg.type = organizations[0].type;
          selectedOrg.userId = organizations[0].userId;
          selectedOrg.contactId = organizations[0].contactId ? organizations[0].contactId : null;
          selectedOrg.rengaId = organizations[0]?.rengaId ? organizations[0]?.rengaId : null;
          selectedOrg.rengaIdType = organizations[0]?.rengaIdType ? organizations[0]?.rengaIdType : null;
        }
      }
      for (const org of organizations) {
        orgHTML += views.get('support-orglist-item')({ selected: selectedOrg.name === org.orgName, ...org });
      }
      deleteCookie(SelectedOrg);
      cookie('set', SelectedOrg, JSON.stringify(selectedOrg));
      const orgPickerLabel = $lel.orgPicker?.querySelector('.adobe-exl-pickerSelectedOption');
      if (orgPickerLabel) {
        orgPickerLabel.innerText = selectedOrg.name;
      }
      Array.from($lel.orgPicker.querySelectorAll('.supportSidebarOrgPickerListWrap')).forEach((p) => {
        p.innerHTML = orgHTML;
      });
    }
    log('Prepared Org List');
    orgPickerRendered = true;
  }

  // initZeonChat();

  /**
   * Support home
   */
  async function processSupportHome(supportProcess = null) {
    const $llel = {
      articlesCards: $el.support.querySelector('#support-cards-comp'),
      cardSignInBTN: $el.support.querySelectorAll('.support-home-signincardbtn'),
      cardSignInCTA: $el.support.querySelectorAll('.support-home-signincardCta'),
      homeCards: $el.support.querySelector('#support-home-cards'),
      homeHereToHelp: $el.support.querySelector('#support-home-heretohelp'),
      signIn: $el.support.querySelectorAll('[data-id="signin"]'),
      signInMessage: $el.support.querySelector('#support-home-signinmessage'),
      premiumHomeLearnMore: appShadowRoot.querySelector('#premium-home-learn-more'),
    };
    $llel.premiumHomeLearnMore.href = `${$llel.premiumHomeLearnMore.href}?lang=${lang}`;

    o.dispatch(
      SupportVisit,
      authenticated
        ? ((userprofile.interactions.filter((i) => i.event === SupportVisit)[0] || {}).timestamps || []).length
        : Number(localStorage.getItem(SupportVisit) || 0),
    ); // eslint-disable-line no-use-before-define

    console.log('qwerty authenticated 1853', authenticated);
    
    if (authenticated) {
      const contentWrapper = appShadowRoot.querySelector('div.contentWrapper[data-id="content-wrapper"]');
      const loaderSpan = document.createElement('span');
      loaderSpan.classList.add('loader', 'btn-loader-support', 'is-hidden');
      contentWrapper.appendChild(loaderSpan);
      appShadowRoot.querySelector('#support-home').classList.add('is-hidden');
      showHideLoader(loaderSpan, true);
      $llel.signInMessage.classList.add('is-hidden');
      $llel.homeHereToHelp.classList.add('is-hidden');
      $llel.cardSignInBTN.forEach((idx) => {
        idx.classList.add('is-hidden');
      });

      let openFormOptions = {
        host_surface_name: 'EXL-Home',
        supportPortalType: 'legacy support portal',
        oncloseCallbackDialogFn
      };
      let homeRequestCallbackBtn = appShadowRoot?.querySelector('#home-request-callback-btn');
      if (homeRequestCallbackBtn) {
        homeRequestCallbackBtn.addEventListener('click', async () => {
          // eslint-disable-next-line no-undef
          await ZeonCallbackClient.openForm(openFormOptions);
        });
      }
      let ultimateHomeRequestCallbackBtn = appShadowRoot?.querySelector('#ultimate-home-request-callback-btn');
      if (ultimateHomeRequestCallbackBtn) {
        ultimateHomeRequestCallbackBtn.addEventListener('click', async () => {
          // eslint-disable-next-line no-undef
          await ZeonCallbackClient.openForm(openFormOptions);
        });
      }
      const homeLearnMoreBtn = appShadowRoot?.querySelector('.support-needed-content a');
      if(homeLearnMoreBtn){
        homeLearnMoreBtn.addEventListener('click', async () => {
          console.log("asd");
          
          const companyEntitlements = await getEntitlementsString();
          adobeDataLayerTrack({
            "event": "linkClicked",
            "eventType": "web.webInteraction.linkclicks",
            "companyLoginDetails": {
              "companyLoginName": selectedOrg.name,
              "companyLoginID": selectedOrg.id,
              "companyEntitlements": companyEntitlements
            },
            "link": {
            "linkTitle": "Learn more",
            "linkLocation": "home:Learn more",
            "linkType": "button",
            "destinationDomain":"https://experienceleague.adobe.com/en/docs/support-resources/data-sheets/overview",
            },
          });
        });
      }
      $llel.homeCards.classList.add('is-hidden');
      const hasUserRole = await verifyRole();
      showHideLoader(loaderSpan, false);
      if (hasUserRole) {
        let data = await getSupportEntitlements();
        if (data) {
          await showUltimateHomePage(data);
        } else {
          console.log('Not entitled to Ultimate support');
          appShadowRoot.querySelector('#support-home').classList.remove('is-hidden');
        }
        $llel.homeCards.classList.remove('is-hidden');
        await initWebcall('EXL-Home', {});
         // Deep link from other portals: ?request-callback=true
        const requestCallbackDeepLink = new URL(location.href).searchParams.get('request-callback');
        if (requestCallbackDeepLink === 'true' || requestCallbackDeepLink === '1') {
          queryString('request-callback', '');
          try {
            // eslint-disable-next-line no-undef
            await ZeonCallbackClient.openForm(openFormOptions);
          } catch (e) {
            log(`request-callback URL param: openForm failed: ${e}`);
          }
        }
        $llel.cardSignInCTA.forEach((idx) => {
          idx.classList.remove('is-hidden');
          idx.addEventListener('click', async () => {
            const companyEntitlements = await getEntitlementsString();
            if (idx.getAttribute('data-id') === 'GetStarted') {
              if (supportProcess !== null) {
                adobeDataLayerTrack({
                 "event": "linkClicked",
                 "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                            "companyLoginName": selectedOrg.name,
                            "companyLoginID": selectedOrg.id,
                            "companyEntitlements": companyEntitlements
                       },
                 "link": {
                  "linkTitle": "Get Started",
                  "linkLocation": "home:openCase",
                  "linkType": "button",
                 },
                });
                supportProcess(SUPPORT_TABS.OPEN_TICKET);
              }
            } else if (idx.getAttribute('data-id') === 'GetNow') {
              adobeDataLayerTrack({
                 "event": "linkClicked",
                 "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                            "companyLoginName": selectedOrg.name,
                            "companyLoginID": selectedOrg.id,
                            "companyEntitlements": companyEntitlements
                       },
                 "link": {
                  "linkTitle": "Go Now",
                  "linkLocation": "home:manageCases",
                  "linkType": "button",
                 },
                });
              if (supportProcess !== null) {
                supportProcess(SUPPORT_TABS.MY_CASES);
              }
            } else if (idx.getAttribute('data-id') === 'ultimatePage') {
              if (supportProcess !== null) {
                supportProcess(SUPPORT_TABS.ULTIMATE_SUCCESS_INNER_CIRCLE);
              }
            }
          });
        });
      } else {
        appShadowRoot.querySelector('#support-home').classList.remove('is-hidden');
      }
    } else {
      $llel.signIn.forEach((i) => i.addEventListener('click', signin, false));
    }

    // Top support articles
    Coveo.SearchEndpoint.configureCloudV2Endpoint(CoveoOrg, sessionStorage.getItem(CoveoToken));

    const myRequestModifier = function (requestObj) {
      requestObj.requestData.fieldsToInclude = [
        'source',
        'sourcetype',
        'rating',
        'date',
        'outlookformacuri',
        'outlookuri',
        'connectortype',
        'urihash',
        'collection',
        'author',
        'language',
        'objecttype',
        'permanentid',
        'type',
        'product',
      ];

      return requestObj;
    };

    Coveo.SearchEndpoint.endpoints.default.setRequestModifier(myRequestModifier);
    const coveoRecommendationsRoot = appShadowRoot.querySelector('#top-articals-wrapper #top-articals');

    Coveo.initRecommendation(
      coveoRecommendationsRoot,
      undefined,
      {},
      {
        Analytics: {
          searchHub: CoveoSearchHubHomePage,
        },
        SearchInterface: {
          resultsPerPage: 4,
          excerptLength: 120,
        },
        Recommendation: {
          hideIfNoResults: true,
        },
      },
    );
    appShadowRoot?.getElementById('top-articals-wrapper')?.parentElement?.classList.add('is-hidden');

    function toggleVideo(videoId) {
      const video = appShadowRoot.getElementById(videoId);
      const playButton = appShadowRoot.querySelector(`img[data-video="${videoId}"]`);

      if (video.paused) {
        video.play();
        playButton.style.display = 'none';
      } else {
        video.pause();
        playButton.style.display = 'block';
      }

      video.onended = function () {
        playButton.style.display = 'block';
      };
    }

    appShadowRoot.querySelectorAll('video').forEach((video) => {
      video.addEventListener('click', function () {
        const playButton = appShadowRoot.querySelector(`img[data-video="${this.id}"]`);
        if (!this.paused) {
          this.pause();
          playButton.style.display = 'block';
        }
      });
    });

    const videoPlayLinkTitles = {
      videoElement: {linkTitle: 'Ultimate Success Overview', linkLocation: 'ultimateSuccessOverview'},
      videoElement1: {linkTitle: 'Ultimate Success Add-Ons', linkLocation: 'ultimateSuccessAddOns'},
      videoElement2: {linkTitle: 'Contacting Assigned Resources', linkLocation: 'contactingAssignedResources'},
      videoElement3: {linkTitle: 'Support Channels', linkLocation: 'supportChannels'},
    };
    appShadowRoot.querySelectorAll('.play_button_ultimate, .play_button_ultimate_cards').forEach((playButton) => {
      playButton.addEventListener('click', async function () {
        const videoId = this.getAttribute('data-video');
        const companyEntitlements = await getEntitlementsString();
        adobeDataLayerTrack({
          "event": "linkClicked",
          "eventType": "web.webInteraction.linkclicks",
          "companyLoginDetails": {
            "companyLoginName": selectedOrg.name,
            "companyLoginID": selectedOrg.id,
            "companyEntitlements": companyEntitlements
          },
          "link": {
            "linkTitle": videoPlayLinkTitles[videoId].linkTitle,
            "linkLocation": videoPlayLinkTitles[videoId].linkLocation,
            "linkType": "video",
          },
        });
        toggleVideo(videoId);
        
      });
    });

    let allChecksPass = false;
    if(orgPickerRendered && eccOrgsFetched && commerceOrgsFetched && workfrontOrgsRendered && profileAPIFetched){
      allChecksPass = true;
    }
    let abc = {
      orgPickerRendered,
      eccOrgsFetched,
      commerceOrgsFetched,
      workfrontOrgsRendered,
      profileAPIFetched,
      pageLoaded : true,
      allChecksPass
    };
    console.log('abc', abc);
    
    newrelic.addPageAction('PAGE_LOADED', {
      orgPickerRendered,
      eccOrgsFetched,
      commerceOrgsFetched,
      workfrontOrgsRendered,
      profileAPIFetched,
      pageLoaded : true,
      allChecksPass,
      ...(!allChecksPass && pageLoadErrorMessage ? { errorMessage: pageLoadErrorMessage } : {}),
    });
  }

  function debounceWatcher(func, delayTime) {
    let debounceTimer;

    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delayTime);
    };
  }

  async function findWatchersMembers(inputSelector, modalSelector, userListSelector, onWatcherAdded) {
    const input = appShadowRoot.querySelector(inputSelector);
    const userListModal = appShadowRoot.querySelector(modalSelector);
    const tagsInputWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
    let errorMessage = '';

    appShadowRoot.addEventListener('click', event => {
      if (!userListModal?.contains(event.target) && !input?.contains(event.target)) {
        if (!userListModal.classList?.contains('is-hidden')) {
          userListModal.classList.add('is-hidden');
        }
      }
    });

    input.addEventListener('input', () => {
      const userList = appShadowRoot.querySelector(userListSelector);
      userList.innerHTML = '';

      if (input.value.trim().length < 3 || input.value.length === 0) {
        userListModal.classList.add('is-hidden');
      } else if (input.value.trim().length > 2) {
        let loadingLiItem = appShadowRoot.querySelector('.loadingUserList');
        if (!loadingLiItem) {
          loadingLiItem = document.createElement('li');
          if (modalSelector === '.edituserListModal') {
            loadingLiItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-3', 'pt-5', 'pl-3', 'loadingUserList');
          }
          loadingLiItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-4', 'pt-2', 'loadingUserList');
          loadingLiItem.textContent = 'Loading ...';
          userList.appendChild(loadingLiItem);
          userListModal.classList.remove('is-hidden');
        } else {
          loadingLiItem.classList.remove('is-hidden');
        }
      }
    });

    input.addEventListener('keyup', debounceWatcher(async event => {
      let inputValue = input.value.trim();

      if (inputValue.length < 3) {
        userListModal.classList.add('is-hidden');
        if (inputValue.length > 0) {
          errorMessage = getLabelV2('Type at least 3 characters.');
          notice(errorMessage, true, 3000, 'negative', 0, true);
        }

        return;
      }
      let userList = appShadowRoot.querySelector(userListSelector);
      if (!userList) {
        userList = document.createElement('ul');
        userList.id = userListSelector.substring(1); // Remove the leading '#' if present
        document.body.appendChild(userList);
      }
      userList.innerHTML = '';
      let loadingLiItem = appShadowRoot.querySelector('.loadingUserList');
      if (!loadingLiItem) {
        loadingLiItem = document.createElement('li');
        if (modalSelector === '.edituserListModal') {
          loadingLiItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-3', 'pt-5', 'pl-3', 'loadingUserList');
        } else {
          loadingLiItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-4', 'pt-2', 'loadingUserList');
        }
        loadingLiItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-4', 'pt-2', 'loadingUserList');
        loadingLiItem.textContent = 'Loading ...';
        userList.appendChild(loadingLiItem);
        userListModal.classList.remove('is-hidden');
      } else {
        loadingLiItem.classList.remove('is-hidden');
      }

      let current_org = getSelectedOrg();
      const searchMembersOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': ClientId,
          Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
        }
      };

      const watcherEndpoint = watcherMembersUrl
        .replace('#ORG_ID', current_org.id)
        .replace('#searchquery', inputValue);
      let watcherStart = 0;
      try {
        watcherStart = performance.now();
        const result = await request(watcherEndpoint, searchMembersOptions);
        const watcherDuration = Number((performance.now() - watcherStart) );
        const res = await result.json();
        loadingLiItem.classList.add('is-hidden');

        if (result.ok && result.status === 200) {
          relicApiSuccess({
            endpoint: watcherEndpoint,
            duration: watcherDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        } else {
          relicApiFail({
            status:result.status,
            endpoint: watcherEndpoint,
            duration: watcherDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }

        if (result.ok && result.status === 200 && res.length) {
          userListModal.classList.remove('is-hidden');
          userList.innerHTML = '';

          res.forEach(member => {
            if (member.firstName && member.lastName && member.email) {
              const listItem = document.createElement('li');
              listItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'p-4', 'watcher-drop');
              listItem.innerHTML = `
                <div class="mr-5"><img class="is-rounded" src="https://www.gravatar.com/avatar?d=mp&s=40" alt="User Avatar" /></div>
                <div class="user-info-wrapper is-flex is-flex-direction-column" data-cs-mask>
                  <span class="name has-text-weight-bold">${member.firstName} ${member.lastName}</span>
                  <span class="email">${member.email}</span>
                </div>
              `;
              userList.appendChild(listItem);

              listItem.addEventListener('click', async () => {
                if (tagsInputWrapper) {

                  const emailExists = Array.from(tagsInputWrapper.querySelectorAll('.tag')).some(tag =>
                    tag.textContent.trim() === member.email
                  );
                  if (!emailExists) {
                    const newTag = document.createElement('span');
                    newTag.classList.add('tag', 'radius-5', 'is-size-7', 'mr-1');
                    newTag.textContent = member.email;
                    tagsInputWrapper.insertBefore(newTag, input);
                    input.value = '';
                    userListModal.classList.add('is-hidden');
                    if (typeof onWatcherAdded === 'function') {
                      await onWatcherAdded();
                    }
                  } else {
                    errorMessage = getLabelV2('This email has already been added.');
                    notice(errorMessage, true, 3000, 'negative', 0, true);
                  }
                }
              });
            }
          });
        } else {
          if (userListModal.classList.contains('is-hidden')) {
            userListModal.classList.remove('is-hidden');
          }
          userList.innerHTML = '';
          const listItem = document.createElement('li');
          if (modalSelector === '.edituserListModal') {
            listItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-3', 'pt-5', 'pl-3');
          } else {
            listItem.classList.add('wrapper-li', 'is-flex', 'is-align-items-center', 'pb-4', 'pt-2');
          }
          listItem.textContent = 'No suggestions';
          userList.appendChild(listItem);
        }
      } catch (error) {
        const watcherDuration = watcherStart
          ? Number((performance.now() - watcherStart) )
          : 0;
        relicApiFail({
          status:error.status,
          endpoint: watcherEndpoint,
          duration: watcherDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        console.error('Error fetching watchers members:', error);
      }
    }, 1000));
  }

  let trackOpenTicketAiChatDuration = null;
  let isOpenTicketAiChatActive = () => false;
  window.addEventListener('pagehide', () => {
    if (
      getCurrentSupportTab() === SUPPORT_TABS.OPEN_TICKET &&
      isOpenTicketAiChatActive() &&
      trackOpenTicketAiChatDuration
    ) {
      void trackOpenTicketAiChatDuration();
    }
  });

  // Cancels the previous Open Ticket submit handler when the form re-inits (e.g. org change).

  /**
   * Support Open Ticket
   * NOTE: The widget experiment is only provided when getSelectedOrg().type === COMMERCE
   */
  async function supportOpenTicket(supportProcess = null, widgetExperiment = null) {
    openTicketSubmitAbortController?.abort();
    openTicketSubmitAbortController = new AbortController();
    const { signal: openTicketSubmitSignal } = openTicketSubmitAbortController;

    const $llel = {
      articalProduct: $el.support.querySelector('#artical-product'),
      articleListComponent: $el.support.querySelector('#support-list-comp'),
      additionalHelpSection: $el.support.querySelector('#support-openticket-additionalhelp'),
      additionalMiloHelpSection: $el.support.querySelector('#support-openticket-additionalMilohelp'),
      adminConsoleLink: appShadowRoot.querySelector('#admin-support-link'),
      askQuestionBtn: $el.support.querySelector('#support-open-ask-question'),
      // articlesSection: $el.support.querySelector('#support-openticket-relatedarticles'),
      articlesSectionList: $el.support.querySelector('#support-openticket-relatedarticleslist'),
      articlesListHeading: $el.support.querySelector('#support-openticket-relatedarticles-heading'),
      casePriorityError: $el.support.querySelector('#support-openticket-p1errormessage'),
      casePriorityMessage: $el.support.querySelector('#support-openticket-p4message'),
      caseLoaderBlock: $el.support.querySelector('#case-loader-div'),
      commonTopicsSection: $el.support.querySelector('#support-openticket-commontopics'),
      formCaseTitle: $el.support.querySelector('#support-openticket-casetitle'),
      formSubmitBtn: $el.support.querySelector('#support-open-ticket-submitBtn'),
      form: $el.support.querySelector('#support-open-ticket-form'),
      formCaseTitleInput: $el.support.querySelector('#support-openticket-casetitle-input'),
      formSwat: $el.support.querySelector('#support-openticket-swat'),
      formSwatTable: $el.support.querySelector('#support-openticket-swat-table'),
      formSwatHead: $el.support.querySelector('#support-openticket-swat-head'),
      formSwatBody: $el.support.querySelector('#support-openticket-swat-body'),
      formSwatEmpty: $el.support.querySelector('#support-openticket-swat-empty'),
      formDropzone: $el.support.querySelector('#support-openticket-dropzone'),
      formAddAttachment: $el.support.querySelector('#support-openticket-addAttachment'),
      formUploadAttachment: $el.support.querySelector('#support-openticket-dropzone'),
      formUploadAttachmentInput: $el.support.querySelector('#support-openticket-dropzone-input'),
      formUploadAttachmentImagesWrap: $el.support.querySelector('.support-openticket-dropzone-imageswrapper'),
      formUploadAttachmentWrapSec: $el.support.querySelector('#support-openticket-dropzone .upload-image-sec'),
      formCaseDescription: $el.support.querySelector('#support-openticket-casedescription'),
      formCaseDescriptionInput: $el.support.querySelector('#support-openticket-casedescription-input'),
      formCasePriority: $el.support.querySelector('#support-openticket-selectpriority'),
      formCaseImpact: $el.support.querySelector('#support-openticket-selectimpact'),
      formFieldsSection: $el.support.querySelector('#fieldSection'),
      loaderMore: appShadowRoot.querySelector('#support-openticket-loadmore'),
      loaderMoreSec: appShadowRoot.querySelector('#loadMore-sec'),
      // needSection: $el.support.querySelector('#support-openticket-needsection'),
      // premiumLearnMore: $el.support.querySelector('#premium-learn-more'),
      productPicker: $el.support.querySelector('#support-openticket-selectproduct'),
      issuePicker: $el.support.querySelector('#support-openticket-selectIssue'),
      relatedArticlesList: appShadowRoot.querySelector('#support-openticket-relatedarticleslist'),
      ticketAtatusArea: appShadowRoot.querySelector('#ticket-status-area'),
      ticketTip: appShadowRoot.querySelector('#ticketTip'),
      workfrontContactDetails: appShadowRoot.querySelector('#workfront-contact-details'),
      showIssueList: appShadowRoot.querySelector('#issue-reason-dropdown'),
      showTicketDes: appShadowRoot.querySelector('#ticket-description'),
      // addAttachment: appShadowRoot.querySelector('#attachment-case'),
      // addAttachmentBtn: appShadowRoot.querySelector('#attachment-case-btn'),
      openTicketError: appShadowRoot.querySelector('#open-ticket-commerce-error-sec'),
      productBtnContainer: appShadowRoot.querySelector('#product-btn-container'),
      productBtnDropdownContainer: appShadowRoot.querySelector('#product-btn-dropdown-container'),
      productFamilyBtnContainer: appShadowRoot.querySelector('#product-family-btn-container'),
      nextStep0: appShadowRoot.querySelector('#next-step-0'),
      previousStep: appShadowRoot.querySelector('#previous-step'),
      nextStep: appShadowRoot.querySelector('#next-step'),
      allStep: appShadowRoot.querySelector('.all-step'),
      allStepHeader: appShadowRoot.querySelector('.all-step-header'),
      step2Header: appShadowRoot.querySelector('#step-2-header'),
      selectedProductNameDiv: appShadowRoot.querySelector('.selected-product-name'),
      submitFormButton:appShadowRoot.querySelector('#submit-button'),
      submitMessage:appShadowRoot.querySelector('#submit-message'),
      submitMessageMkto:appShadowRoot.querySelector('#mkto-submit-message')
    };
    
    let hasEnvironmentField = false;
    let hasImpactField = false;
    let newDescriptionObject = {};
    let newDescriptionEnvObject = {};
    let openTicketContactMode = 'classic';
    let auraInitializedProductCode = '';

    function getRadioSuggestionEntries() {
      const entries = [];
      const wrappers = appShadowRoot.querySelectorAll('.radio-suggestion-wrapper');
      wrappers.forEach((wrapper) => {
        const key = wrapper.getAttribute('data-suggestion-key');
        if (!key) return;
        const labelEl = wrapper.querySelector('label.field-labels, label.spectrum-FieldLabel');
        const label = labelEl ? labelEl.textContent.replace(/\s*\*$/, '').trim() : key;
        entries.push({ key, label });
      });
      return entries;
    }
    let issueReasonMetaData = [];
    let hasIssueReason = false;
    let hasCommerceProjectUrl = false;
    let hasCommerceProjectUrlArray = [];
    let commerceStageEnvironmentName = '';
    let hasVisitedStep5 = false;
    // Ensure title input changes (from the light DOM) revalidate the Next button
    if ($llel.formCaseTitleInput) {
      $llel.formCaseTitleInput.addEventListener('input', (e) => {
        const v = (e.target.value || '').trim();
        miloCaseCreateObject.title = v;
        if (v && miloCaseCreateObject.description && (
          !('value' in commerceProjectURL) ||
          commerceProjectURL.value.trim() !== ''
        )) {
          removeClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = false;
        } else {
          addClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = true;
        }
        try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
      });
    }
    
    const currentOrg = getSelectedOrg();
    if (currentOrg.name.includes('ReadOnly')) {
      const url = new URL(window.location);
      url.searchParams.set('support-tab', 'home');
      window.location.href = url.href;

      return;
    }
    let productSelectionCount = 0;
    if (isCommerce()) {
      if (getSelectedOrg().rengaIdType === 'type2e') {
        $llel.openTicketError.querySelector('p span').innerHTML = `
        <p>We are currently experiencing an issue regarding case attachment uploads and downloads within Experience League.</p>
        <ul>
          <li>To provide us with an attachment, please respond to one of the system generated case emails with the attachments to ensure they are available to our support teams.</li>
          <li>Please request an attachment be provided by email if you are experiencing errors downloading attachments from a case in Experience League.</li>
        </ul>`;
        // $llel.openTicketError.querySelector('p span').innerText = getLabelV2('We are currently experiencing an issue with case attachment uploads within Experience League. To ensure your attachments are received by our support teams, please respond to one of the system-generated case emails with the necessary attachments.');
        if ($llel.openTicketError.classList.contains('is-hidden')) {
          $llel.openTicketError.classList.remove('is-hidden');
        }
        // if (!$llel.addAttachmentBtn.classList.contains('is-hidden')) {
        //   $llel.addAttachmentBtn.classList.add('is-hidden');
      }
      // }
    }

    // localize common trouble shooting topics links
    const commonTopicLinks = appShadowRoot.querySelector('#support-openticket-commontopics').querySelectorAll('a');
    commonTopicLinks.forEach((link) => {
      link.href = `${link.href}?lang=${lang}`;
    });
    commonTopicLinks[0].href = `https://experienceleague.adobe.com/?lang=${lang}#home`;
    commonTopicLinks[1].href = `${commonTopicLinks[1].href}&profile.language=${lang}`;
    commonTopicLinks[8].href = `https://experienceleague.adobe.com/docs/audience-manager/user-guide/features/addressable-audiences.html?lang=${lang
      }#low-match-rates`;
    commonTopicLinks[10].href = `https://helpx.adobe.com/${helpxLangMapping[lang]}/enterprise/using/licensing.html`;
    commonTopicLinks[11].href = `https://helpx.adobe.com/${helpxLangMapping[lang]}/enterprise/using/applications.html`;
    commonTopicLinks[12].href = `https://helpx.adobe.com/${helpxLangMapping[lang]}/enterprise/using/admin-console.html`;
    commonTopicLinks[13].href = `https://helpx.adobe.com/${helpxLangMapping[lang]}/enterprise/using/users.html`;
    commonTopicLinks[14].href = `https://helpx.adobe.com/${helpxLangMapping[lang]}/enterprise/using/identity.html`;

    // $llel.formCaseDescriptionInput.placeholder = '';

    /**
     *show open major ticket details in open ticket page
     */
    async function getTicketDetailsforOpenTicketSection(productId, productType, productOfferingId) {
      const offset = new Date().getTimezoneOffset();
      const clientTimezone = offset * -1;
      let clientTimezoneAbbreviation;
      if (!isWorkFront()) {
        for (const timedata of timezoneOptions) {
          if (clientTimezone === timedata.UTC_OFFSET) {
            clientTimezoneAbbreviation = timedata.abbreviation;
            appShadowRoot.querySelector('#support-product-timeZone .adobe-exl-pickerSelectedOption').innerText =
              timedata.label;
            break;
          }
        }
      }
      
      $llel._openTicketStatusAbort?.abort();
      $llel.ticketAtatusArea.innerHTML = '';
      $llel.ticketTip.classList.add('is-hidden');
      ticketStatusData = await getTicketStatus(productId);
      let showTip = 0;
      
      async function collectVisibleTicketViews(overallTicketData) {
        const views = [];
        const incidentItems = (overallTicketData?.incidents || []).map((val) => ({ val, type: 'incident' }));
        const maintenanceItems = (overallTicketData?.maintenances || []).map((val) => ({
          val,
          type: 'maintenance',
        }));
        const ticketQueue = [...incidentItems, ...maintenanceItems];
        if (!ticketQueue.length) {
          return views;
        }
        for (const { val, type } of ticketQueue) {
          let productName;
          const ticketId = val.id;
          const cloudName = [];
          let regionList = [];
          let showStatus = false;
          let startDate;
          let updateDate;
          let showTicketStatus = false;
          let ticketHistoryDate;
          let ticketSeverity;
          let impactScope;
          const serviceImpact = [];
          let tokenMessage;
          let impactDescription;
          let eventType;
          let eventStatus;
          let eventEnvironment = [];
          let newServiceImpact = '';
          const newFlow = true;
          let shouldShowEnvironment = true;
          let CFSURL = '';
          if (val.region) {
            val.region.forEach((regions) => {
              regionList.push(regions.name);
            });
          }
          const userRegion = sessionStorage?.getItem('region');
          (val.environment || []).forEach((environment) => {
            if (userRegion) {
              environment?.serviceRegions?.forEach((serviceRegions) => {
                if (sessionStorage?.getItem('region') === serviceRegions) {
                  eventEnvironment.push(environment.name);
                }
              });
            } else {
              eventEnvironment.push(environment.name);
            }
          });
          if (val.services) {
            val.services.forEach((service) => {
              serviceImpact.push(service.name);
            });
          }
          val.products.forEach((product) => {
            if (String(product.id) === String(productId)) {
              eventType = product.severity;
              if (product.history[0].messageType === 'CFS') {
                CFSURL = product.history[0].cfsURL;
              }
              const service = product.id;
                if (type === 'incident') {
                  eventStatus = product.status;
                  startDate = getFormattedDateForStatus(`${product.startedOn}.000Z`, clientTimezoneArea);
                  updateDate = getFormattedDateForStatus(`${product.endedOn}.000Z`, clientTimezoneArea);
                  ticketHistoryDate = `${product.history[0]?.messageTime}.000Z`;
                } else if (type === 'maintenance') {
                  eventStatus = val.status;
                  startDate = getFormattedDateForStatus(`${val.startedOn}.000Z`, clientTimezoneArea);
                  updateDate = getFormattedDateForStatus(`${val.completedOn}.000Z`, clientTimezoneArea);
                  ticketHistoryDate = newFlow ? `${product.history[0]?.messageTime}.000Z` : `${val.completedOn}.000Z`;
                }
                impactScope = product.history[0].customerImpact;
                tokenMessage = product.history[0]?.messageToken;
                if (productType === 'productOfferings') {
                  if (service === productOfferingId) {
                    showTicketStatus = true;
                  }
                } else if (productType === 'product') {
                  showTicketStatus = true;
                }
                if (eventStatus === 'Closed' || eventStatus === 'Completed') {
                  showTicketStatus = false;
                }
              if (showTicketStatus) {
                productName = product.name;
                showStatus = true;
                ticketSeverity = product.severity;
                if (newFlow) {
                  const offering = [...val.offering];
                  const enviroment = [...(val.environment || [])];
                  const ImpactedRegions = [...product.history[0]?.locationImpact?.serviceRegions || []];
                  const impactedEnvironments = [...product.history[0]?.locationImpact?.serviceEnvironments || []];
                  const impactedEnvironmentsString = impactedEnvironments
                    .map((environmentID) => {
                      return enviroment.find((environment) => { return environmentID === environment.id });
                    })
                    .filter(Boolean);
                  const newRegionList = val.region?.filter((region) => { return ImpactedRegions.includes(region.id); });
                  regionList = newRegionList?.map((region) => {
                    return region.name;
                  });
                  const newEventEnvironment = new Set(
                    impactedEnvironmentsString.map((environment) => { return environment.name; }),
                  );
                  const locationImpactEnvironments = Array.from(newEventEnvironment);
                  if (locationImpactEnvironments.length) {
                    eventEnvironment = locationImpactEnvironments;
                  }
                  const productOfferings = [...product.history[0]?.serviceImpact?.productOfferings || []];
                  const productServices = [...product.history[0]?.serviceImpact?.productServices || []];
                  const services = [...val.services];
                  const productOfferingsData = productOfferings.map((offeringId) => {
                    const offeringData = offering.find((offering) => { return offeringId === offering.id });
                    return { ...offeringData };
                  });
                  const productOfferingService = productOfferingsData.map((offeringData) => {
                    const serviceData = offeringData.productServices
                      .map((serviceId) => services.find((service) => serviceId === service.id))
                      .filter(Boolean);
                    serviceData.sort((a, b) => { return a.name.localeCompare(b.name); });
                    return { ...offeringData, serviceData };
                  });
                  productOfferingService.sort((a, b) => { return a.name.localeCompare(b.name); });

                  let remainingServiceImpact = []
                  if(productOfferingsData.length > 0) {
                    const remainingServiceImpactID = productServices.filter((serviceId) => { return !productOfferingService.some((offering) => { return offering.serviceData.some((serviceData) => { return serviceData.id === serviceId }); }); });
                    remainingServiceImpact = remainingServiceImpactID?.map((serviceId) => { return services?.find((service) => serviceId === service.id); });
                  }
                  else {
                    remainingServiceImpact = productServices?.map((serviceId) => { return services?.find((service) => serviceId === service.id); });
                  }
                  const remainingServiceImpactString = remainingServiceImpact.map((service) => { return service.name; }).join(', ');
                  newServiceImpact = productOfferingService.reduce((acc, curr, index) => {
                    const serviceName = curr.name;
                    const serviceInString = curr.serviceData.map((offering) => { return offering.name; }).join(', ');
                    const string = `${serviceName}: (${serviceInString})`;
                    if (index === productOfferingService.length - 1) {
                      acc += string;
                    } else {
                      acc += string + ', ';
                    }
                    return acc;
                  }, '')
                  const result = newServiceImpact.length > 0 ? newServiceImpact + (remainingServiceImpactString.length > 0 ? `, ${remainingServiceImpactString}` : '') : remainingServiceImpactString;
                  newServiceImpact = result;
                  shouldShowEnvironment = product.history[0].showEnvironment ?? true;
                }
              }
            }
          });
          if (showTicketStatus) {
            impactDescription = await getImpactMessage(tokenMessage, type);
            if (impactDescription?.includes('CFS_URL')) {
              impactDescription = impactDescription.replace('{CFS_URL}', CFSURL);
            }
          }
          val.clouds.forEach((cloud) => {
            cloudName.push(cloud.name);
          });
          if (showStatus) {
            let impactedServices;
            let moreButtonClass;
            let ticketClass;
            let borderClass;
            let iconClass;
            let showSubscribe;
            let severityClass;
            let environmentClass;
            let environmentImpacted;
            if (serviceImpact.toString().length > 333) {
              impactedServices = `${serviceImpact.toString().substring(0, 333)}...`;
              moreButtonClass = 'more-btn';
            } else {
              impactedServices = serviceImpact.toString();
              moreButtonClass = 'is-hidden more-btn';
            }

            if (eventEnvironment.toString().length > 333) {
              environmentImpacted = `${eventEnvironment.toString().substring(0, 333)}...`;
              moreButtonClass = 'more-btn';
            } else {
              environmentImpacted = eventEnvironment.toString();
              moreButtonClass = 'is-hidden more-btn';
            }
            if (newFlow) {
              impactedServices = newServiceImpact;
              environmentImpacted = eventEnvironment.join(', ');
            }

            if (type === 'incident') {
              if (eventType === 'Major') {
                ticketClass = 'red-background';
                borderClass = 'border-red';
                iconClass = 'major';
              } else if (eventType === 'Minor') {
                ticketClass = 'orange-background';
                borderClass = 'border-orange';
                iconClass = 'minor';
              } else if (eventType === 'Potential') {
                ticketClass = 'grey-background';
                borderClass = 'border-grey';
                iconClass = 'potential';
              } else if (eventType === 'Trivial') {
                ticketClass = 'green-background';
                borderClass = 'border-green';
                iconClass = 'closed-incident';
              }
              if (eventStatus === 'Closed') {
                ticketClass = 'green-background';
                borderClass = 'border-green';
                showSubscribe = 'hidden';
              }
            } else if (type === 'maintenance') {
              severityClass = 'is-hidden';
              if (eventStatus === 'Completed') {
                environmentClass = 'is-hidden';
                ticketClass = 'green-background';
                borderClass = 'border-green';
                showSubscribe = 'hidden';
                iconClass = 'maintenance-open';
              } else {
                ticketClass = 'blue-background';
                borderClass = 'border-blue';
                iconClass = 'maintenance-open';
              }
            }

            let dropdownDotClass = 'is-grey';
            if (type === 'incident') {
              if (eventStatus === 'Closed' || borderClass === 'border-green') {
                dropdownDotClass = 'is-green';
              } else if (borderClass === 'border-red') {
                dropdownDotClass = 'is-red';
              } else if (borderClass === 'border-orange') {
                dropdownDotClass = 'is-orange';
              } else if (borderClass === 'border-grey') {
                dropdownDotClass = 'is-grey';
              }
            } else if (type === 'maintenance') {
              dropdownDotClass = eventStatus === 'Completed' ? 'is-green' : 'is-blue';
            }

            const dropdownTitle =
              type === 'incident' ? getLabelV2(ticketSeverity) : getLabelV2(eventStatus);
            const pickerMetaLine =
              type === 'maintenance'
                ? `${getLabelV2('Maintenance')}: #${ticketId}`
                : `${getLabelV2('Issue')}: #${ticketId}`;
            const ticketKindLabel = type === 'maintenance' ? getLabelV2('Maintenance') : getLabelV2('Issue');

            views.push({
              type,
              ticketId,
              productName,
              eventStatus,
              eventType,
              cloudName: cloudName.slice(),
              regionList: regionList?.length > 0 ? regionList.slice() : [],
              startDate,
              updateDate,
              ticketHistoryDate,
              ticketSeverity,
              impactScope,
              serviceImpact: serviceImpact.slice(),
              impactedServices,
              moreButtonClass,
              environmentImpacted,
              environmentClass,
              severityClass,
              impactDescription,
              borderClass,
              iconClass,
              ticketClass,
              showSubscribe,
              eventEnvironment: eventEnvironment.slice(),
              dropdownDotClass,
              dropdownTitle,
              pickerMetaLine,
              ticketKindLabel,
              newFlow,
              shouldShowEnvironment,
            });
          }
        }
        return views;
      }

      function buildOpenTicketStatusMessageHtml(view) {
        return `
              <div class='event-history-btn'>
                <sp-button class="">${getLabelV2('Event History')}</sp-button>
              </div>
              <div class="row">
                <div class="col-md-9">
                  <div class="solution-content">
                  <div>${getFormattedDateForStatus(view.ticketHistoryDate, clientTimezoneArea)} (${clientTimezoneAbbreviation})</div>
                    <div class='${view.severityClass || ''}'>
                      <b>${getLabelV2('Impact Severity')}: </b>
                      ${getLabelV2(view.ticketSeverity)}
                    </div>
                    <div>
                      <b>${getLabelV2('Impact Scope')}: </b>
                        ${view.newFlow ? getImpactScopeLabel(view.impactScope, { severity: view.ticketSeverity, type: view.type }) : getLabelV2(`${view.impactScope} of the customers are impacted`)}
                    </div>
                    <div class="banner-services">
                      <div class="pointor"  title="${view.impactedServices.toString()}">
                        <b>${getLabelV2('Services Impacted')}: </b>
                        ${view.impactedServices}
                      </div>
                      ${view.shouldShowEnvironment ? `
                        <div class="pointor ${view.environmentClass || ''}" title="${view.eventEnvironment.toString()}">
                          <b>${getLabelV2('Environments Impacted')}: </b>
                          ${view.environmentImpacted}
                        </div>
                      ` : ''}
                        <div>
                          <b>${getLabelV2('Impact Update')}: </b>
                          <span>
                            ${view.impactDescription}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="is-flex is-flex-direction-row-reverse ">
                <sp-button class="${view.moreButtonClass}">More</sp-button>
                </div>
                `;
      }

      function buildOpenTicketStatusLeadHtml(view) {
        const cloudStr = view.cloudName.toString();
        return `
              <div class="icon-id is-flex is-align-items-center	is-flex-grow-1">
                <div class="status-icon ">
                  <i class="event-icon alert-icon ${view.iconClass}"></i>
                </div>
                <div class="ticket-id">
                  <p class="has-text-weight-bold m-0">${view.productName}</p>
                  <p class="m-0"><span class="has-text-weight-bold">${view.ticketKindLabel}: </span>#${view.ticketId}</p>
                  <p><span class="has-text-weight-bold">${getLabelV2(
                    'Started/Ended',
                  )}: </span>${view.startDate} - ${view.eventStatus} (${clientTimezoneAbbreviation})</p>
                 </div>
              </div>
              <div class="ticket-details is-flex is-flex-direction-column is-flex-grow-2">
                <p  class="m-0 is-flex overflow-hidden"><span class="has-text-weight-bold ">${getLabelV2(
          'Regions',
        )}: </span>${view.regionList?.length > 0 ? view.regionList.toString() : '-'}</p>
                <p><span class="has-text-weight-bold">${getLabelV2(
          'Impact update',
        )}: </span>${view.impactDescription}</p>
              </div>`;
      }

      function buildOpenTicketStatusPickerHtml(views, selectedIndex) {
        if (views.length <= 1) {
          return '';
        }
        return `<div class="ticket-status-picker is-relative">
                 <button type="button" class="ticket-status-picker-trigger" aria-expanded="false" aria-haspopup="listbox">
                   <span class="ticket-status-picker-label">+${views.length - 1} more</span>
                   <span class="ticket-status-picker-chevron" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M5.7376e-07 0.996796C0.000632933 0.799481 0.059624 0.606763 0.169548 0.442903C0.279472 0.279043 0.435416 0.151364 0.617747 0.0759408C0.800079 0.000517257 1.00065 -0.0192802 1.19421 0.0190408C1.38777 0.0573618 1.56566 0.152088 1.7055 0.291296L4.9945 3.5773L8.2835 0.291296C8.47095 0.117708 8.71773 0.0224475 8.9732 0.0250656C9.22867 0.0276837 9.47345 0.127981 9.6573 0.305375C9.84116 0.482768 9.95014 0.723803 9.9619 0.979014C9.97365 1.23423 9.88727 1.48426 9.7205 1.6778L9.696 1.7023L5.7 5.6943C5.51253 5.88131 5.25855 5.98633 4.99375 5.98633C4.72895 5.98633 4.47497 5.88131 4.2875 5.6943L0.293001 1.7028C0.200011 1.61026 0.126248 1.50024 0.0759622 1.37907C0.025676 1.2579 -0.00014034 1.12798 5.7376e-07 0.996796Z" fill="#222222"/></svg></span>
                 </button>
                 <div class="ticket-status-picker-menu is-hidden" role="listbox">
                   ${views
                     .map(
                       (v, i) => `
                     <button type="button" role="option" class="ticket-status-picker-item${
                       i === selectedIndex ? ' is-selected' : ''
                     }" data-ticket-picker-index="${i}" aria-selected="${i === selectedIndex}">
                       <span class="ticket-status-dot ${v.dropdownDotClass}"></span>
                       <span class="ticket-status-picker-item-body">
                         <span class="has-text-weight-bold ticket-status-picker-title">${v.dropdownTitle}</span>
                         <span class="ticket-status-picker-meta">${v.pickerMetaLine}</span>
                       </span>
                       <span class="ticket-status-picker-check${
                         i === selectedIndex ? '' : ' is-hidden'
                       }" aria-hidden="true">&#10003;</span>
                     </button>`,
                     )
                     .join('')}
                 </div>
               </div>`;
      }

      function mountOpenTicketStatusSwitcher(allViews, signal) {
        const area = $llel.ticketAtatusArea;
        const borderWrap = area.querySelector('[data-open-ticket-border-wrap]');
        const leadSlot = area.querySelector('[data-open-ticket-lead-slot]');
        const pickerSlot = area.querySelector('[data-open-ticket-picker-slot]');
        const subscribeBtn = area.querySelector('[data-open-ticket-subscribe]');
        const expandWrap = area.querySelector('[data-open-ticket-expand-wrap]');
        const messageSlot = area.querySelector('[data-open-ticket-message-slot]');
        if (!borderWrap || !leadSlot || !pickerSlot || !subscribeBtn || !expandWrap || !messageSlot) {
          return;
        }
        let selectedIndex = 0;
        const closePicker = () => {
          const trig = area.querySelector('.ticket-status-picker-trigger');
          const menu = area.querySelector('.ticket-status-picker-menu');
          if (trig) {
            trig.setAttribute('aria-expanded', 'false');
          }
          menu?.classList.add('is-hidden');
        };
        const updatePickerSelection = (idx) => {
          area.querySelectorAll('.ticket-status-picker-item').forEach((btn, i) => {
            btn.classList.toggle('is-selected', i === idx);
            btn.setAttribute('aria-selected', String(i === idx));
            const check = btn.querySelector('.ticket-status-picker-check');
            check?.classList.toggle('is-hidden', i !== idx);
          });
        };
        const paint = (idx) => {
          selectedIndex = idx;
          const v = allViews[idx];
          borderWrap.className = `ticket-status-bar is-flex ${v.borderClass}`;
          leadSlot.innerHTML = buildOpenTicketStatusLeadHtml(v);
          subscribeBtn.className = `subscribe-btn ${v.showSubscribe || ''}`;
          subscribeBtn.dataset.openTicketStatusId = String(v.ticketId);
          expandWrap.className = `icon-div ticket-status-expand-icon is-flex is-justify-content-center is-align-items-center`;
          expandWrap.classList.remove('active');
          messageSlot.innerHTML = buildOpenTicketStatusMessageHtml(v);
          messageSlot.classList.add('is-hidden');
          updatePickerSelection(idx);
          closePicker();
        };

        pickerSlot.innerHTML = buildOpenTicketStatusPickerHtml(allViews, 0);
        paint(0);

        $llel.ticketAtatusArea.addEventListener(
          'click',
          function openTicketStatusAreaClick(ev) {
            const root = ev.currentTarget;
            const pickerItem = ev.target.closest('.ticket-status-picker-item');
            if (pickerItem && root.contains(pickerItem)) {
              const next = Number.parseInt(pickerItem.getAttribute('data-ticket-picker-index'), 10);
              if (!Number.isNaN(next) && allViews[next]) {
                paint(next);
              }
              ev.stopPropagation();
              return;
            }
            const trigger = ev.target.closest('.ticket-status-picker-trigger');
            if (trigger && root.contains(trigger)) {
              const menu = root.querySelector('.ticket-status-picker-menu');
              const expanded = trigger.getAttribute('aria-expanded') === 'true';
              trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
              menu?.classList.toggle('is-hidden', expanded);
              ev.stopPropagation();
              return;
            }
            if (ev.target.closest('.ticket-open-status-close')) {
              $llel.ticketTip.classList.add('is-hidden');
              root.innerHTML = '';
              $llel._openTicketStatusAbort?.abort();
              return;
            }
            const sub = ev.target.closest('[data-open-ticket-subscribe]');
            if (sub && root.contains(sub) && sub.dataset.openTicketStatusId) {
              window.open(`${suscribeStatusUrl + sub.dataset.openTicketStatusId}/${productId}`, 'subscribeLink');
              void (async () => {
                const companyEntitlements = await getEntitlementsString();
                const companysupportEntitlements = await getSupportEntitlements();
                adobeDataLayerTrack({
                  event: 'linkClicked',
                  eventType: 'web.webInteraction.linkclicks',
                  companyLoginDetails: {
                    companyLoginName: selectedOrg.name,
                    companyLoginID: selectedOrg.id,
                    companyEntitlements,
                    companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
                  },
                  link: {
                    linkTitle: 'View',
                    linkLocation: `status.adobe.com:top`,
                    linkType: 'link',
                    destinationDomain: `${suscribeStatusUrl + sub.dataset.openTicketStatusId}/${productId}`,
                  },
                });
              })();
              return;
            }
            if (ev.target.closest('.more-btn') && root.contains(ev.target.closest('.more-btn'))) {
              window.open(adobeStatusUrl, 'adobeStatus');
              return;
            }
            if (ev.target.closest('.event-history-btn') && root.contains(ev.target.closest('.event-history-btn'))) {
              const v = allViews[selectedIndex];
              const destinationUrl = `${eventHistoryUrl + productId}/${v.ticketId}`;
              void (async () => {
                const companyEntitlements = await getEntitlementsString();
                const companysupportEntitlements = await getSupportEntitlements();
                adobeDataLayerTrack({
                  event: 'linkClicked',
                  eventType: 'web.webInteraction.linkclicks',
                  companyLoginDetails: {
                    companyLoginName: selectedOrg.name,
                    companyLoginID: selectedOrg.id,
                    companyEntitlements,
                    companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
                  },
                  link: {
                    linkTitle: 'Event History',
                    linkLocation: 'status.adobe.com:eventHistory',
                    linkType: 'link',
                    destinationDomain: destinationUrl,
                  },
                });
              })();
              window.open(destinationUrl, 'eventHistoryLink');
              return;
            }
            const expandIcon = ev.target.closest('.ticket-status-expand-icon');
            if (expandIcon && root.contains(expandIcon)) {
              const willExpand = !expandIcon.classList.contains('active');
              expandIcon.classList.toggle('active');
              const msg = root.querySelector('[data-open-ticket-message-slot]');
              msg?.classList.toggle('is-hidden');
              void (async () => {
                const companyEntitlements = await getEntitlementsString();
                const companysupportEntitlements = await getSupportEntitlements();
                adobeDataLayerTrack({
                  event: 'linkClicked',
                  eventType: 'web.webInteraction.linkclicks',
                  companyLoginDetails: {
                    companyLoginName: selectedOrg.name,
                    companyLoginID: selectedOrg.id,
                    companyEntitlements,
                    companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
                  },
                  link: {
                    linkTitle: willExpand ? 'expand' : 'collapse',
                    linkLocation: 'status.adobe.com:top',
                    linkType: 'link',
                  },
                });
              })();
            }
          },
          { signal },
        );

        function openTicketStatusShadowCapture(ev) {
          const menu = $llel.ticketAtatusArea.querySelector('.ticket-status-picker-menu');
          const picker = $llel.ticketAtatusArea.querySelector('.ticket-status-picker');
          if (!menu || menu.classList.contains('is-hidden') || !picker) {
            return;
          }
          const t = ev.composedPath()[0];
          if (picker.contains(t)) {
            return;
          }
          closePicker();
        }
        appShadowRoot.addEventListener('click', openTicketStatusShadowCapture, { capture: true, signal });
      }

      const allTicketViews = await collectVisibleTicketViews(ticketStatusData);
      showTip = allTicketViews.length;

      if (allTicketViews.length > 0) {
        $llel._openTicketStatusAbort = new AbortController();
        $llel.ticketAtatusArea.innerHTML = `
          <div class="ticket-open-status-switcher ticket-status-unified">
            <div class="ticket-status-bar is-flex" data-open-ticket-border-wrap>
              <div data-open-ticket-lead-slot class="ticket-status-lead is-flex is-flex-grow-1"></div>
              <div class="ticket-action is-flex is-justify-content-center is-align-items-center ">
                <sp-button class="subscribe-btn" data-open-ticket-subscribe data-open-ticket-status-id="">${getLabelV2(
                  'View',
                )} <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M13.3333 6.88889V12.4444H0.888889V0.888889H7.33333C7.39227 0.888889 7.44879 0.865476 7.49047 0.823801C7.53214 0.782127 7.55556 0.725604 7.55556 0.666667V0.222222C7.55556 0.163285 7.53214 0.106762 7.49047 0.0650874C7.44879 0.0234127 7.39227 0 7.33333 0H0.444444C0.32657 0 0.213524 0.0468252 0.130175 0.130175C0.0468252 0.213524 0 0.32657 0 0.444444V12.8889C0 13.0068 0.0468252 13.1198 0.130175 13.2032C0.213524 13.2865 0.32657 13.3333 0.444444 13.3333H13.7778C13.8957 13.3333 14.0087 13.2865 14.092 13.2032C14.1754 13.1198 14.2222 13.0068 14.2222 12.8889V6.88889C14.2222 6.82995 14.1988 6.77343 14.1571 6.73175C14.1155 6.69008 14.0589 6.66667 14 6.66667H13.5556C13.4966 6.66667 13.4401 6.69008 13.3984 6.73175C13.3567 6.77343 13.3333 6.82995 13.3333 6.88889Z" fill="#147AF3"/><path d="M9.57333 0.379111L11.0796 1.88578L6.83689 6.12844C6.79523 6.17012 6.77183 6.22663 6.77183 6.28556C6.77183 6.34448 6.79523 6.40099 6.83689 6.44267L7.77778 7.38533C7.81945 7.42699 7.87596 7.4504 7.93489 7.4504C7.99381 7.4504 8.05033 7.42699 8.092 7.38533L12.3347 3.14267L13.8409 4.64889C13.8718 4.68064 13.9116 4.7024 13.955 4.71138C13.9984 4.72036 14.0436 4.71614 14.0846 4.69927C14.1256 4.6824 14.1606 4.65365 14.1851 4.61671C14.2097 4.57977 14.2226 4.53634 14.2222 4.492V0H9.73022C9.68634 9.69486e-05 9.64347 0.0131825 9.60702 0.0376072C9.57057 0.0620319 9.54216 0.0967022 9.52538 0.137248C9.5086 0.177793 9.5042 0.222398 9.51273 0.26544C9.52127 0.308483 9.54235 0.348035 9.57333 0.379111Z" fill="#147AF3"/></svg> </sp-button>
                <div data-open-ticket-picker-slot></div>
                <div data-open-ticket-expand-wrap class="icon-div ticket-status-expand-icon is-flex is-justify-content-center is-align-items-center"></div>
              </div>
              <div class="close-action is-flex is-justify-content-center is-align-items-center ">
                <div class="icon-div ticket-open-status-close is-flex is-justify-content-center is-align-items-center">
                  <img src="/assets/img/support/whitepaper-cross.png" loading="lazy" alt="Close" />
                </div>
              </div>
            </div>
            <div data-open-ticket-message-slot class="status-message is-hidden"></div>
          </div>`;
        mountOpenTicketStatusSwitcher(allTicketViews, $llel._openTicketStatusAbort.signal);
      }

      if (showTip > 0) {
        $llel.ticketTip.classList.remove('is-hidden');
      } else {
        $llel.ticketTip.classList.add('is-hidden');
        $llel.ticketAtatusArea.innerHTML = '';
      }
    }

    // $llel.premiumLearnMore.href = `${$llel.premiumLearnMore.href}?lang=${lang}`;

    let isFormStart = false;
    let selectedNewProductName = '';
    let selectedNewProductCode = '';
    let selectedNewLicenseId = ''
    let addedNewProductCode = ''
    let addedNewProductName = ''
    let stepCount = 0;
    let maxVisitedStep = 0;
    const completedSteps = new Set();

    let aiApiObject = {
      product: '',
      userInput: '',
      locale:lang
    };
    /** Bumped to ignore in-flight GenAI responses when description or product context changes. */
    let zeonGenAiRequestGeneration = 0;
    /** Latest requestId from getZeonAiAgent success response; used for support insights analytics. */
    let zeonAiAgentRequestId = '';

    function syncAiApiObjectProductForGenAi() {
      const pendingUncommittedProductSwitch =
        addedNewProductCode !== '' &&
        selectedNewProductCode !== '' &&
        selectedNewProductCode !== addedNewProductCode;
      // On the product-selection step, honor the highlighted product. On later steps, keep the
      // last committed product until Next so a description blur during product browsing does not
      // send the wrong product to GenAI.
      const useCommittedProduct =
        pendingUncommittedProductSwitch && stepCount > 0;
      if (useCommittedProduct) {
        aiApiObject.product = addedNewProductName;
        aiApiObject.productCode = addedNewProductCode;
      } else {
        aiApiObject.product = selectedNewProductName;
        aiApiObject.productCode = selectedNewProductCode;
      }
    }

    function invalidateInFlightGenAiRequests() {
      zeonGenAiRequestGeneration += 1;
      zeonAiAgentRequestId = '';
    }

    function scheduleOpenTicketAuraProductRefresh() {
      if (openTicketContactMode !== 'ai' || !selectedNewProductCode) {
        return;
      }
      if (
        auraEmbed &&
        auraInitializedProductCode !== '' &&
        auraInitializedProductCode === selectedNewProductCode
      ) {
        return;
      }
      void applyOpenTicketAiMode();
    }

    function onOpenTicketProductHighlightChanged() {
      syncAiApiObjectProductForGenAi();
      if (
        addedNewProductCode !== '' &&
        selectedNewProductCode !== '' &&
        selectedNewProductCode !== addedNewProductCode
      ) {
        invalidateInFlightGenAiRequests();
      }
      scheduleOpenTicketAuraProductRefresh();
    }

    
    const productResult = await getProductList(productOrg, null, onlyPSA);
    products = productResult.productList;
    productOrg = productResult.orgId;
    if (!isWorkFront() && !isCommerce()) {
      products.unshift({
        id: 'admin_console',
        label: 'Admin Console',
        type: 'ADMINISTRATION'
      });
    }

    console.log('products', products);
    

    let newProductList = groupProductsByFamily(products);
    let unsortedProductList = structuredClone(products);
    console.log('newProductList', newProductList);
    
    const sortProducts = (data) => {
      return data
        .sort((a, b) => {
          const nameA = (a.familyName || a.label || "").toLowerCase();
          const nameB = (b.familyName || b.label || "").toLowerCase();
          return nameA.localeCompare(nameB);
        })
        .map((item) => {
          if (item.products && item.products.length > 1) {
            item.products = item.products.sort((a, b) =>
              (a.label || "").toLowerCase().localeCompare((b.label || "").toLowerCase())
            );
          }

          return item;
        });
    };

    // Usage
    newProductList = sortProducts(newProductList);
    console.log('sorted newProductList',newProductList);


    let buttonHtml = ''
      
    for (let product of newProductList){
      if(product?.products?.length){

            
            buttonHtml += `<button class="product-dropdown-btn product-btn-common spectrum-ActionButton spectrum-ActionButton--sizeM spectrum-ActionButton--staticBlack hoverbox"
            id=""  data-family = "${product.familyName || ''}"  
            class="spectrum-Menu-item" role="option" aria-selected="true" tabindex="0" >
              <span class="">${product.familyName}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#464646" d="m12 15l-4.243-4.242l1.415-1.414L12 12.172l2.828-2.828l1.415 1.414L12 15.001Z"/></svg>
            </button>`
        }
        // if(product?.products?.length == 1){

        //   buttonHtml += `<button class="product-btn product-btn-common spectrum-ActionButton spectrum-ActionButton--sizeM spectrum-ActionButton--staticBlack hoverbox"
        //     id=""
        //     data-id="${product?.products[0].id || ''}" data-label="${product?.products[0].label || ''}" data-licenseId="${product?.products[0]?.licenseId || ''}"
        //     class="spectrum-Menu-item" role="option" aria-selected="true" tabindex="0" >
        //     <span class="">${product?.products[0].label}</span>
        //     </button>`
        // }

        if(product?.id){

          buttonHtml += `<button class="product-btn product-btn-common spectrum-ActionButton spectrum-ActionButton--sizeM spectrum-ActionButton--staticBlack hoverbox"
            id=""
            data-id="${product?.id || ''}" data-label="${product?.label || ''}" data-licenseId="${product?.licenseId || ''}"
            class="spectrum-Menu-item" role="option" aria-selected="true" tabindex="0" >
            <span class="">${product?.label}</span>
          </button>`
        }
    }

    $llel.productBtnDropdownContainer.innerHTML = buttonHtml

    function resolveProductMetadataV2ItemRequired(apiItem) {
      if (!apiItem || typeof apiItem !== 'object') return true;
      if (apiItem.optional === true || apiItem.isOptional === true) return false;
      if (apiItem.nullable === true || apiItem.isNullable === true) return false;
      if (apiItem.required === false || apiItem.mandatory === false || apiItem.isMandatory === false) return false;
      if (apiItem.required === true || apiItem.mandatory === true || apiItem.isMandatory === true) return true;
      if (apiItem.nullable === false) return true;
      const isReq = apiItem.isRequired;
      if (isReq === 'Y' || isReq === 'y' || isReq === 'true' || isReq === true) return true;
      if (isReq === 'N' || isReq === 'n' || isReq === 'false' || isReq === false) return false;
      const level = apiItem.requirementLevel ?? apiItem.fieldRequirement ?? apiItem.requirement;
      if (typeof level === 'string') {
        if (/optional/i.test(level)) return false;
        if (/required|mandatory/i.test(level)) return true;
      }
      // No explicit optional/required from API: treat as required (step 2 must collect mandatory metadata).
      return true;
    }

    function isStep2MetadataValueRequired(metaEntry) {
      if (!metaEntry) return false;
      const name = metaEntry.displayName;
      if (name === 'Project URL' || name === 'Project ID') return false;
      if (Object.prototype.hasOwnProperty.call(metaEntry, 'required')) {
        return metaEntry.required === true;
      }
      // Picker / legacy rows without `required`: assume required unless URL fields above.
      return true;
    }

    function isStep2MetaEntryValueMissing(metaEntry) {
      if (!isStep2MetadataValueRequired(metaEntry)) return false;
      const v = metaEntry.value;
      return v == null || String(v).trim() === '';
    }

    function isMiloCriticalPrioritySelected() {
      return miloCaseCreateObject.priorityCode === '1';
    }

    /** P1 / Critical: Business Impact description is required before Review & Submit can be enabled. */
    function isMiloCriticalBusinessImpactComplete() {
      if (!isMiloCriticalPrioritySelected()) return true;
      const impactDescInput = appShadowRoot.getElementById('support-product-impact-desc-input');
      return !!(impactDescInput && (impactDescInput.value || '').trim().length > 0);
    }

    function miloStep3ImpactRequirementMet(impactDescFilled) {
      if (!miloCaseCreateObject.priorityCode) return false;
      if (miloCaseCreateObject.priorityCode === '1') {
        return !!impactDescFilled;
      }
      return !hasImpactField || (hasImpactField && (miloCaseCreateObject.impactCode || impactDescFilled));
    }

    function parseProfilePhoneNumber(profile) {
      const rawPhone = (profile?.phoneNumber || profile?.phone || '').trim();
      if (!rawPhone) return null;
      const PhoneNumberUtil = libphonenumber.PhoneNumberUtil || libphonenumber.default?.PhoneNumberUtil;
      if (!PhoneNumberUtil) return null;
      const phoneUtil = PhoneNumberUtil.getInstance();

      let normalized = rawPhone.replace(/[^\d+]/g, '');
      if (normalized.startsWith('00')) {
        normalized = `+${normalized.slice(2)}`;
      } else if (!normalized.startsWith('+')) {
        normalized = `+${normalized}`;
      }

      try {
        const [defaultRegion] = phoneUtil.getSupportedRegions();
        const parsed = phoneUtil.parse(normalized, defaultRegion);
        const iso2 = phoneUtil.getRegionCodeForNumber(parsed);
        const nationalNumber = parsed.getNationalNumber();
        if (!iso2 || iso2 === '001' || !nationalNumber) return null;
        return {
          iso2,
          nationalNumber: String(nationalNumber),
        };
      } catch (e) {
        return null;
      }
    }

    function updateOpenTicketPhone() {
      const phoneInput = appShadowRoot?.querySelector('#support-openticket-phone-input');
      if (!phoneInput) return;

      if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
        miloCaseCreateObject.optInCountryCode = '';
        miloCaseCreateObject.smsOptIn = false;
        miloCaseCreateObject.whatsappOptIn = false;
        miloCaseCreateObject.phone = phoneInput.value.trim().replace(/[^\d+]/g, '');
        return;
      }

      const countrySelect = appShadowRoot?.querySelector('#support-openticket-phone-country-select');
      if (!countrySelect) return;
      const country = COUNTRY_CALLING_CODES.find((c) => c.iso2 === countrySelect.value);
      const localDigits = phoneInput.value.trim().replace(/\D/g, '');
      miloCaseCreateObject.optInCountryCode = countrySelect.value || '';
      miloCaseCreateObject.phone = country && localDigits ? `+${country.dialCode}${localDigits}` : '';
    }

    // Digits plus common phone formatting characters only (spaces, dashes, parens, dots, +).
    const OPEN_TICKET_PHONE_ALLOWED_CHARS = /^[0-9\s\-().+]*$/;

    function isOpenTicketStep4PhoneValid() {
      const phoneInput = appShadowRoot?.querySelector('#support-openticket-phone-input');
      if (!phoneInput) return true;

      if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
        const pValue = phoneInput.value.trim().replace(/[^\d+]/g, '');
        if (!pValue.length) return false;
        miloCaseCreateObject.phone = pValue;
        return PHONE_NUMBER_REGEX.test(pValue);
      }

      updateOpenTicketPhone();
      const countrySelect = appShadowRoot?.querySelector('#support-openticket-phone-country-select');
      if (!countrySelect || !phoneInput) return true;

      const rawValue = phoneInput.value.trim();
      const localDigits = rawValue.replace(/\D/g, '');
      if (!countrySelect.value || !localDigits) return false;

      // Reject letters/special characters that are not valid phone formatting.
      if (!OPEN_TICKET_PHONE_ALLOWED_CHARS.test(rawValue)) return false;
      if (!E164_PHONE_REGEX.test(miloCaseCreateObject.phone)) return false;

      try {
        const PhoneNumberUtil = libphonenumber.PhoneNumberUtil || libphonenumber.default?.PhoneNumberUtil;
        if (!PhoneNumberUtil) return false;
        const phoneUtil = PhoneNumberUtil.getInstance();
        const parsed = phoneUtil.parse(localDigits, countrySelect.value);
        return phoneUtil.isValidNumberForRegion(parsed, countrySelect.value);
      } catch (e) {
        return false;
      }
    }

    async function checkOpenTicketNotificationEligibility() {
      if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
        miloCaseCreateObject.smsOptIn = false;
        miloCaseCreateObject.whatsappOptIn = false;
        return;
      }

      const smsWrap = appShadowRoot?.querySelector('#support-openticket-sms-opt-in-wrap');
      const waWrap = appShadowRoot?.querySelector('#support-openticket-whatsapp-opt-in-wrap');
      const smsCheckbox = appShadowRoot?.querySelector('#support-openticket-sms-opt-in');
      const waCheckbox = appShadowRoot?.querySelector('#support-openticket-whatsapp-opt-in');
      const hideOptIns = () => {
        miloCaseCreateObject.smsOptIn = false;
        miloCaseCreateObject.whatsappOptIn = false;
        if (smsCheckbox) smsCheckbox.checked = false;
        if (waCheckbox) waCheckbox.checked = false;
        if (smsWrap) addClass(smsWrap, 'is-hidden');
        if (waWrap) addClass(waWrap, 'is-hidden');
      };

      updateOpenTicketPhone();
      if (!isOpenTicketStep4PhoneValid() || !getSelectedOrg()?.id) {
        hideOptIns();
        return;
      }
      try {
        const org = getSelectedOrg();
        const isUltimate = await getSupportEntitlements();
        const profile = await window.adobeIMS.getProfile();
        console.log(profile);
        
        const res = await request(whatsappNotifEligibilityUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': ClientId,
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          body: JSON.stringify({
            countryCode: miloCaseCreateObject.optInCountryCode,
            phoneNumber: miloCaseCreateObject.phone,
            level: isUltimate ? 'Ultimate' : 'Expert',
            customerName: profile?.displayName || userprofile?.email || '',
            customerEmail: userprofile?.email || profile?.email || '',
            orgId: org.id,
            rengaId: org.rengaId || org.userId || '',
          }),
        });
        const data = await res.json();
        if (!res.ok || data?.status !== 'success' || (!data?.data?.sms && !data?.data?.whatsapp)) {
          hideOptIns();
          return;
        }
        if (smsWrap) {
          if (data.data.sms) removeClass(smsWrap, 'is-hidden');
          else { addClass(smsWrap, 'is-hidden'); if (smsCheckbox) smsCheckbox.checked = false; miloCaseCreateObject.smsOptIn = false; }
        }
        if (waWrap) {
          if (data.data.whatsapp) removeClass(waWrap, 'is-hidden');
          else { addClass(waWrap, 'is-hidden'); if (waCheckbox) waCheckbox.checked = false; miloCaseCreateObject.whatsappOptIn = false; }
        }
      } catch (e) {
        hideOptIns();
      }
    }

    /** Copy Commerce infra / nested field values from visible DOM into commercePlatformFieldsData2–5 before step-2 validation.
     *  Fixes Next staying disabled until a second edit when `input`/`paste` did not run the same path as `keyup`, or model lagged the DOM. */
    function hydrateCommercePlatformFieldsFromStep2Dom() {
      const rootStep = appShadowRoot?.querySelector('#step-2');
      if (!rootStep) return;
      const buckets = [
        ['commerce-additional-field2', commercePlatformFieldsData2],
        ['commerce-additional-field3', commercePlatformFieldsData3],
        ['commerce-additional-field4', commercePlatformFieldsData4],
        ['commerce-additional-field5', commercePlatformFieldsData5]
      ];
      for (const [rootId, arr] of buckets) {
        if (!arr?.length) continue;
        const addRoot = rootStep.querySelector(`#${rootId}`);
        if (!addRoot) continue;
        for (const meta of arr) {
          if (!meta?.id) continue;
          const wrap = addRoot.querySelector(`#${meta.id}`);
          if (!wrap) continue;
          const pickerBtn = wrap.querySelector('.adobe-exl-picker');
          if (pickerBtn) {
            const sv = (pickerBtn.getAttribute('selected-value') || '').trim();
            const lab = pickerBtn.querySelector('.spectrum-Picker-label');
            if (!sv || lab?.classList.contains('is-placeholder')) {
              delete meta.value;
            } else {
              meta.value = (lab.textContent || '').trim();
            }
            continue;
          }
          const inp = wrap.querySelector('input, textarea');
          if (!inp || inp.disabled) continue;
          const raw = (inp.value || '').trim();
          const typ = (inp.type || '').toLowerCase();
          if (!raw) {
            delete meta.value;
            continue;
          }
          if (typ === 'datetime-local') {
            const d = new Date(`${raw}:00Z`);
            if (Number.isNaN(d.getTime())) delete meta.value;
            else meta.value = d.toUTCString();
          } else if (typ === 'date') {
            meta.value = raw;
          } else {
            meta.value = raw;
          }
        }
      }
    }

    function handleNextPreviousBtn(checkEnableReviewBtn = false){
      const swatInput = appShadowRoot.querySelector('#swat-input-field');
      if (swatInput && !swatInput.__listenerAttached) {
        swatInput.__listenerAttached = true;
        swatInput.addEventListener('click', (e) => {
          loadSwatData(e.target.value);
        });
      }
      addClass($llel.nextStep, 'disabled');
      $llel.nextStep.disabled = true;
      // if (stepCount === 0){
      
      if(addedNewProductCode !== selectedNewProductCode){
        invalidateInFlightGenAiRequests();

        const readyToHelpEl = appShadowRoot.querySelector('.ready-to-help');
        const lookingIntoItEl = appShadowRoot.querySelector('.looking-into-it');
        const coveoResultsWrap = appShadowRoot.querySelector('.coveo-results');
        const aiAgentResponseContainer = appShadowRoot.querySelector('#ai-agent-response-container');
        let afterFeedbackDiv = appShadowRoot.querySelector('#feedback-after-submit');
        let feedbackDiv = appShadowRoot.querySelector('#feedback-before-submit');

        appShadowRoot.querySelector('#env-description-fields').innerHTML = '';
        appShadowRoot.querySelector('#issue-reson-field').innerHTML = '';
        appShadowRoot.querySelector('#metadata-fields').innerHTML = '';
        appShadowRoot.querySelector('#description-fields').innerHTML = '';
        appShadowRoot.querySelector('#project-url-field').innerHTML = '';
        appShadowRoot.querySelector('#render-additinal-fields').innerHTML = '';
        appShadowRoot.getElementById('commerce-additional-field2').innerHTML = '';
        appShadowRoot.getElementById('commerce-additional-field3').innerHTML = '';
        appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
        appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
        appShadowRoot.getElementById('ims-commerce-additional-field').innerHTML = '';
        appShadowRoot.getElementById('commerce-stage-environment-field').innerHTML = '';
        commerceStageEnvironmentName = '';


        if (readyToHelpEl) removeClass(readyToHelpEl, 'is-hidden');
        if (lookingIntoItEl) addClass(lookingIntoItEl, 'is-hidden');
        if (coveoResultsWrap) addClass(coveoResultsWrap, 'is-hidden');
        if (aiAgentResponseContainer) addClass(aiAgentResponseContainer, 'is-hidden');
        if (afterFeedbackDiv) addClass(afterFeedbackDiv, 'is-hidden');
        if (feedbackDiv) addClass(feedbackDiv, 'is-hidden');
        if($llel.casePriorityMessage) addClass($llel.casePriorityMessage, 'is-hidden');
        if($llel.casePriorityError) addClass($llel.casePriorityError, 'is-hidden');
        hasEnvironmentField = false;
        newDescriptionObject = {};
        newDescriptionEnvObject = {};
        issueReasonMetaData = [];
        hasIssueReason = false;
        hasCommerceProjectUrl = false;
        hasCommerceProjectUrlArray = [];
        hasVisitedStep5 = false;
        completedSteps.clear();
        maxVisitedStep = 0;
        renderAllFields();
        miloCaseCreateObject.title = '';
        miloCaseCreateObject.description = '';
        miloCaseCreateObject.priorityCode = '';
        miloCaseCreateObject.impactCode = '';
        impactCodeFromApiFailed = false;
        miloCaseCreateObject.timezone = '';
        browserTimezoneAppliedFromDescription = false;
        timezoneSelectionIsUserOverride = false;
        miloCaseCreateObject.phone = '';
        miloCaseCreateObject.optInCountryCode = '';
        miloCaseCreateObject.smsOptIn = false;
        miloCaseCreateObject.whatsappOptIn = false;
        miloCaseCreateObject.issueReasonCode=''
        newMetaData = [];
        commerceProjectURL.value='';
        
        // Clear Project URL input field in DOM
        const projectUrl = appShadowRoot?.getElementById('commerce-project-url');
        if (projectUrl) {
          const projectUrlInput = projectUrl.getElementsByTagName('input');
          if (projectUrlInput && projectUrlInput[0]) {
            projectUrlInput[0].value = '';
          }
        }
        
        // Clear Project ID input field in DOM
        const projectId = appShadowRoot?.getElementById('commerce-project-id');
        if (projectId) {
          const projectIdInput = projectId.getElementsByTagName('input');
          if (projectIdInput && projectIdInput[0]) {
            projectIdInput[0].value = '';
          }
        }
        let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
        if(isWorkFront()){
          analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
        }
        adobeDataLayerTrack({
          event: 'Form-Product selection',
          supportForm: {
            formStep: "Form Product Selection",
            formType: 'support',
            productSelection: selectedNewProductName,
            productSelectionOrder: productSelectionCount.toString(),
            caseTitle:'',
            caseDescription:'',
            step:'',
            companyName: selectedOrg.name ? selectedOrg.name : '',
            useCasePriority: analyticCasePriority,
          },
        });
      }
      addedNewProductCode = selectedNewProductCode;
      addedNewProductName = selectedNewProductName;
      syncAiApiObjectProductForGenAi();
      scheduleOpenTicketAuraProductRefresh();
      appShadowRoot.querySelectorAll('.step-container').forEach((el) => {
        addClass(el, 'is-hidden');
      });
      if (openTicketContactMode !== 'ai') {
        removeClass(appShadowRoot.querySelector(`#step-${stepCount}`), 'is-hidden');
      }
      $llel.selectedProductNameDiv.innerHTML = selectedNewProductName
      const impactField = appShadowRoot.getElementById('support-product-impact');
      const impactDescriptionField = appShadowRoot.getElementById('step-3-fields-impact');

      let impactFieldParentEl = null;
      if(impactField){
          impactFieldParentEl = impactField.parentElement; 
      }
      if(stepCount > 0){
        maxVisitedStep = Math.max(maxVisitedStep, stepCount);
        [1, 2, 3, 4, 5].forEach((stepNum) => {
          const stepHeader = appShadowRoot.querySelector(`#step-${stepNum}-header`);
          if (stepHeader) {
            removeClass(stepHeader, 'disabled');
            removeClass(stepHeader, 'enabled');
            removeClass(stepHeader, 'visited');
            removeClass(stepHeader, 'reached');
            if (stepNum === stepCount) {
              if (completedSteps.has(stepNum)) {
                addClass(stepHeader, 'visited');
              } else {
                addClass(stepHeader, 'enabled');
              }
            } else if (completedSteps.has(stepNum)) {
              addClass(stepHeader, 'visited');
            } else if (stepNum <= maxVisitedStep) {
              addClass(stepHeader, 'reached');
            } else {
              addClass(stepHeader, 'disabled');
            }
          }
        });
        addClass($llel.nextStep0, 'is-hidden');
        removeClass($llel.nextStep, 'is-hidden');
        removeClass($llel.previousStep, 'is-hidden');
        if (openTicketContactMode !== 'ai') {
          removeClass($llel.allStep, 'is-hidden');
          removeClass($llel.allStepHeader, 'is-hidden');
        }
      }

      if(stepCount === 0){
        removeClass($llel.nextStep0, 'is-hidden');
        addClass($llel.nextStep, 'is-hidden');
        addClass($llel.previousStep, 'is-hidden');
        if (openTicketContactMode !== 'ai') {
          addClass($llel.allStep, 'is-hidden');
          addClass($llel.allStepHeader, 'is-hidden');
        }
        // Hide "Return to Review Summary" button on product selection page
        // const returnButton = appShadowRoot.querySelector(`.return-to-review-btn`);
        // if (returnButton) {
        //   returnButton.style.display = 'none';
        // }
      }

      if(stepCount === 1){
        const projectUrlInput = appShadowRoot?.querySelector('#commerce-project-url input');
        const pValue = projectUrlInput?.value?.trim() || '';

        const isProjectUrlValid =
          !('value' in commerceProjectURL) ||
          (pValue !== '' && PROJECT_URL_REGEX.test(pValue));
            
        let errorEl = appShadowRoot.querySelector('#project-url-error');

        const step1Container = appShadowRoot.querySelector('#step-1');
        const requiredSuggestionFieldsInStep = step1Container
          ? step1Container.querySelectorAll('.radio-suggestion-wrapper:not(.is-hidden)[data-suggestion-required="true"] .suggestion-field-required')
          : [];
        const allRequiredSuggestionsFilled = requiredSuggestionFieldsInStep.length === 0 || Array.from(requiredSuggestionFieldsInStep).every((el) => (el.value || '').trim().length > 0);

        const requiredRadioContainersInStep = step1Container
          ? step1Container.querySelectorAll('[data-field-type="radio"][data-radio-required="true"]')
          : [];
        const allRequiredRadiosSelected = Array.from(requiredRadioContainersInStep).every((container) => container.querySelector('input[type="radio"]:checked'));

        if(miloCaseCreateObject.title && miloCaseCreateObject.description && isProjectUrlValid && allRequiredSuggestionsFilled && allRequiredRadiosSelected){
          removeClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = false;
          if(errorEl){
              errorEl.innerText = '';
          }
          if(!checkEnableReviewBtn){
            enableReviewbtn = isMiloCriticalBusinessImpactComplete();
          }
        }else {
          addClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = true;
          enableReviewbtn=false;
          if ('value' in commerceProjectURL && pValue !== '' && !PROJECT_URL_REGEX.test(pValue)) {

            if (!errorEl) {
              errorEl = document.createElement('div');
              errorEl.id = 'project-url-error';
              errorEl.className = 'spectrum-Form-errorText';
              errorEl.innerText = 'Enter valid Project URL';
              errorEl.style.cssText = 'color:red'

              projectUrlInput.parentElement.appendChild(errorEl);
            }
          }
        }

      }

      if(isWorkFront()){
        if(stepCount === 2){
          if(workfrontCaseCreateObject.Case_Product__c && workfrontCaseCreateObject.Environment__c && workfrontCaseCreateObject.Product_Area__c){
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              if(workfrontCaseCreateObject.Priority){
                enableReviewbtn = true;
              }
            }
          }
          else{
            addClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = true; 
            enableReviewbtn = false;
          }
        }
        if(stepCount === 3){
          if (impactFieldParentEl) {
            addClass(impactFieldParentEl,'showIfOnlyP1');
            addClass(impactDescriptionField,'showIfOnlyP1');
          }
          
          if(workfrontCaseCreateObject.Priority){
            
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              if(workfrontCaseCreateObject.Customer_Region__c){
                enableReviewbtn = true;
              }
            }
          }
          else{
            addClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = true; 
            enableReviewbtn = false;
          }
        }
        if(stepCount === 4){
          if(workfrontCaseCreateObject.Customer_Region__c){
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              enableReviewbtn = true;
            }
          }
          else{
            addClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = true; 
            enableReviewbtn = false;
          }
          if(selectedNewProductCode.toLowerCase().startsWith('mkto_') || selectedNewProductCode.toLowerCase().includes('dx_genstudio_support') || selectedNewProductCode.toLowerCase().startsWith('amm_')){
            removeClass($llel.showTicketDes,'is-hidden');
          }
        }
        if(stepCount === 5){
          // appShadowRoot.querySelector(`.return-to-review-btn`).style.display = 'none';
          appShadowRoot.querySelector('#step-1-review').querySelector('.review-fields').innerHTML =
          `
            <div class="review-detail-label">${getLabelV2('Title')}:</div>
            <div class="review-detail-value" data-cs-mask>${miloCaseCreateObject.title}</div>
            
            <div class="review-detail-label">${getLabelV2('Description')}:</div>
            <div class="review-detail-value" data-cs-mask>${miloCaseCreateObject.description}</div>
            <div class="review-detail-label">${getLabelV2('Is this issue reproducible')}:</div>
            <div class="review-detail-value">${(newDescriptionObject['stepsToReproduce'] === 'yes' ? 'Yes' : newDescriptionObject['stepsToReproduce'] === 'no' ? 'No' : newDescriptionObject['stepsToReproduce'] || '')}</div>
          `

          if(newDescriptionObject['Steps to Reproduce'] || newDescriptionObject['steps-to-reproduceSuggestion']){
            const stepsToReproduceValue = newDescriptionObject['Steps to Reproduce'] || newDescriptionObject['steps-to-reproduceSuggestion'] || '';
            appShadowRoot.querySelector('#step-1-review').querySelector('.review-fields').innerHTML +=
            `
              <div class="review-detail-label">${getLabelV2('Steps to Reproduce')}:</div>
              <div class="review-detail-value" data-cs-mask>${stepsToReproduceValue}</div>
            `
          }

          appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML =
            `        
            <div class="review-detail-label">${getLabelV2('Case Product')}:</div>
            <div class="review-detail-value" data-cs-mask>${workfrontCaseCreateObject.Case_Product__c}</div>    
            <div class="review-detail-label">${getLabelV2('Product Area')}:</div>
            <div class="review-detail-value" data-cs-mask>${workfrontCaseCreateObject.Product_Area__c}</div>    
            <div class="review-detail-label">${getLabelV2('Environment')}:</div>
            <div class="review-detail-value" data-cs-mask>${workfrontCaseCreateObject.Environment__c}</div>    
          `;
          appShadowRoot.querySelector('#step-3-review').querySelector('.review-fields').innerHTML =
            `        
            <div class="review-detail-label">${getLabelV2('Priority')}:</div>
            <div class="review-detail-value">${workfrontCaseCreateObject.Priority}</div>    
          `;
          appShadowRoot.querySelector('#step-4-review').querySelector('.review-fields').innerHTML =
            `        
            <div class="review-detail-label">${getLabelV2('Customer Region')}:</div>
            <div class="review-detail-value">${workfrontCaseCreateObject.Customer_Region__c}</div>    
          `;

          addClass($llel.nextStep, 'is-hidden');
          removeClass($llel.submitFormButton, 'is-hidden');
          removeClass($llel.submitMessage, 'is-hidden');
          if(selectedNewProductCode.toLowerCase().startsWith('mkto_') || selectedNewProductCode.toLowerCase().includes('dx_genstudio_support') || selectedNewProductCode.toLowerCase().startsWith('amm_')){
            removeClass($llel.submitMessageMkto, 'is-hidden');
          }
        } else{
          removeClass($llel.nextStep, 'is-hidden');
          addClass($llel.submitFormButton, 'is-hidden');
          addClass($llel.submitMessage, 'is-hidden');
          addClass($llel.submitMessageMkto, 'is-hidden');

        }

      } else{

      
        if(stepCount === 2){
          let validStep2 = true
          let hasEnvironmentValue = false
          
          // Validate Project URL directly from input field (similar to Step 1 validation)
          const projectUrlInput = appShadowRoot?.querySelector('#commerce-project-url input');
          if(projectUrlInput){
            const pValue = projectUrlInput.value?.trim() || '';
            // Check if Project URL is valid: either empty (if not required) or matches the regex pattern
            const isProjectUrlValid =
              !('value' in commerceProjectURL) ||
              pValue === '' ||
              PROJECT_URL_REGEX.test(pValue);
            
            if(!isProjectUrlValid){
              validStep2 = false;
            }
          }

          // Validate Affected URL directly from input field (invalid or empty when required fails step)
          const affectedUrlInputStep2 = appShadowRoot?.querySelector('#commerce-affected-url input');
          console.log('affectedUrlInputStep2', affectedUrlInputStep2);
          
          if(affectedUrlInputStep2){
            const avValue = affectedUrlInputStep2.value?.trim() || '';
            if(!avValue.length || !AFFECTED_URL_REGEX.test(avValue)){
              validStep2 = false;
            }
          }
          
          // Check if Environment field exists in newMetaData and has a value
          if(newMetaData.length){
            for (let newMeta of newMetaData){
              // Check if this is the Environment field
              if(newMeta?.displayName?.toLowerCase() === 'environment'){
                if(newMeta?.value){
                  hasEnvironmentValue = true;
                }
              }
              
              // Skip Project URL and Project ID from "must have value" check
              if(newMeta?.displayName === 'Project URL' || newMeta?.displayName === 'Project ID'){
                continue;
              }
              
              if (isStep2MetaEntryValueMissing(newMeta)) {
                validStep2 = false;
              }
            }
          }
          
          // If Environment field is not in newMetaData, check newDescriptionEnvObject
          // (This handles the case when Environment is rendered as a separate field)
          if(!hasEnvironmentValue){
            if(newDescriptionEnvObject?.environment){
              hasEnvironmentValue = true;
            }
          }
          
          // Environment field is required - Next button should be disabled if it doesn't have a value
          if(!hasEnvironmentValue){
            validStep2 = false;
          }

          // Step 2: require visible suggestion textareas (e.g. Environment "Yes" with suggestionRequired: true)
          const step2Container = appShadowRoot.querySelector('#step-2');
          const requiredSuggestionInStep2 = step2Container
            ? step2Container.querySelectorAll('.radio-suggestion-wrapper:not(.is-hidden)[data-suggestion-required="true"] .suggestion-field-required')
            : [];
          const allRequiredSuggestionsFilledStep2 = requiredSuggestionInStep2.length === 0 ||
            Array.from(requiredSuggestionInStep2).every((el) => (el.value || '').trim().length > 0);
          if (!allRequiredSuggestionsFilledStep2) {
            validStep2 = false;
          }

          const requiredRadioContainersStep2 = step2Container
            ? step2Container.querySelectorAll('[data-field-type="radio"][data-radio-required="true"]')
            : [];
          const allRequiredRadiosSelectedStep2 = requiredRadioContainersStep2.length === 0
            || Array.from(requiredRadioContainersStep2).every((container) => container.querySelector('input[type="radio"]:checked'));
          if (!allRequiredRadiosSelectedStep2) {
            validStep2 = false;
          }

          // Issue reason lives in #issue-reson-field (outside commerce-additional-field*). Model + DOM must agree with renderAllFields keyup path.
          if (hasIssueReason) {
            if (!miloCaseCreateObject.issueReasonCode) {
              validStep2 = false;
            }
            const irBtn = step2Container?.querySelector('#issue-reson-field .adobe-exl-picker');
            if (irBtn && !irBtn.closest('.is-hidden')) {
              const irSv = (irBtn.getAttribute('selected-value') || '').trim();
              const irLab = irBtn.querySelector('.spectrum-Picker-label');
              if (!irSv || irLab?.classList.contains('is-placeholder')) {
                validStep2 = false;
              }
            }
          }

          hydrateCommercePlatformFieldsFromStep2Dom();

          // Commerce additional step-2 fields (picker-based, e.g. Infra Change) live in commercePlatformFieldsData2–5,
          // not in newMetaData, so they must be checked here — same rules as the Next-button click validator.
          if (validStep2 && commercePlatformFieldsData2?.length) {
            for (let metadata of commercePlatformFieldsData2) {
              if (!metadata?.value || String(metadata.value).trim() === '') {
                validStep2 = false;
                break;
              }
            }
          }

          if (validStep2 && commercePlatformFieldsData3?.length) {
            const upgradeSpecialIds = [
              'support-commerce-platform-upgrade-rabbit-required',
              'support-commerce-platform-upgrade-redis-required',
              'support-commerce-platform-upgrade-maria-required',
              'support-commerce-platform-upgrade-open-required'
            ];
            const hasUpgradeVersionGroup = commercePlatformFieldsData3.some(
              (f) => f.id === 'support-commerce-platform-upgrade-rabbit-required'
            );
            if (hasUpgradeVersionGroup) {
              const specialFields = commercePlatformFieldsData3.filter((f) =>
                upgradeSpecialIds.includes(f.id)
              );
              const anyUpgradeFieldFilled = specialFields.some(
                (f) => f?.value && String(f.value).trim().length > 0
              );
              if (!anyUpgradeFieldFilled) {
                validStep2 = false;
              }
            } else {
              for (let metadata of commercePlatformFieldsData3) {
                if (!metadata?.value || String(metadata.value).trim() === '') {
                  validStep2 = false;
                  break;
                }
              }
            }
          }

          if (validStep2 && commercePlatformFieldsData4?.length) {
            for (let metadata of commercePlatformFieldsData4) {
              if (!metadata?.value || String(metadata.value).trim() === '') {
                validStep2 = false;
                break;
              }
            }
          }

          if (validStep2 && commercePlatformFieldsData5?.length) {
            for (let metadata of commercePlatformFieldsData5) {
              if (!metadata?.value || String(metadata.value).trim() === '') {
                validStep2 = false;
                break;
              }
            }
          }

          // Commerce additional Spectrum pickers: require both `selected-value` (set in prepareFormPicker on pick)
          // and no `is-placeholder` on the label. Covers every infra follow-up dropdown under field2–5 (Service Restart,
          // Cloud resize, domain migration, storage type, user type, split architecture autoscaling, etc.).
          if (step2Container) {
            const commerceAdditionalRootIds = [
              'commerce-additional-field2',
              'commerce-additional-field3',
              'commerce-additional-field4',
              'commerce-additional-field5'
            ];
            for (const rootId of commerceAdditionalRootIds) {
              const root = step2Container.querySelector(`#${rootId}`);
              if (!root) continue;
              const commercePickers = root.querySelectorAll('.spectrumpicker-outer-box .adobe-exl-picker');
              commercePickers.forEach((btn) => {
                const sv = (btn.getAttribute('selected-value') || '').trim();
                const label = btn.querySelector('.spectrum-Picker-label');
                if (!sv || label?.classList.contains('is-placeholder')) {
                  validStep2 = false;
                }
              });
            }
          }

          // Text / datetime fields in commerce field4–5 (e.g. Cloud resize Default vs Scaled) must match the DOM.
          // After switching architecture or branch, model arrays are reset but stale closure bugs or missed syncs
          // could otherwise leave Next enabled while visible inputs are empty.
          if (step2Container) {
            [
              'commerce-stage-environment-field',
              'commerce-additional-field2',
              'commerce-additional-field3',
              'commerce-additional-field4',
              'commerce-additional-field5'
            ].forEach((rootId) => {
              const root = step2Container.querySelector(`#${rootId}`);
              if (!root) return;
              root
                .querySelectorAll(
                  'input.field-input, textarea.field-textarea, input[type="datetime-local"], input[type="date"]'
                )
                .forEach((el) => {
                  if (el.disabled) return;
                  if (el.closest('.is-hidden')) return;
                  const t = (el.type || '').toLowerCase();
                  if (t === 'checkbox' || t === 'radio') return;
                  if (!(el.value || '').trim()) {
                    validStep2 = false;
                  }
                });
            });
          }

          if(validStep2){
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              let step3Valid = false;
              let step4Valid = false;
              if (miloCaseCreateObject.priorityCode!=='1' && impactField) {
                if (impactFieldParentEl) {
                  addClass(impactFieldParentEl,'showIfOnlyP1');
                  addClass(impactDescriptionField,'showIfOnlyP1');
                }
              }
              
              const impactDescInputForStep3 = appShadowRoot.getElementById('support-product-impact-desc-input');
              const impactDescFilledStep3 = impactDescInputForStep3 && (impactDescInputForStep3.value || '').trim().length > 0;
              if (miloStep3ImpactRequirementMet(impactDescFilledStep3)) {
                step3Valid = true;
              }
              if (
                Number.isInteger(miloCaseCreateObject.timezone) &&
                miloCaseCreateObject.phone &&
                isOpenTicketStep4PhoneValid()
              ) {
                step4Valid = true;
              }
              enableReviewbtn = !!(step3Valid && step4Valid);
            }
          } else{
            addClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = true;
            enableReviewbtn=false;
          }
        }

        if(stepCount === 3){
          const impactField = appShadowRoot.getElementById('support-product-impact');
          const impactDescriptionField = appShadowRoot.getElementById('step-3-fields-impact');
          if (miloCaseCreateObject.priorityCode!=='1' && impactField) {
            const parentElement = impactField.parentElement;
            if (parentElement) addClass(parentElement, 'showIfOnlyP1');
          }
          const impactDescInputStep3 = appShadowRoot.getElementById('support-product-impact-desc-input');
          if (impactDescInputStep3 && !impactDescInputStep3._impactDescListenerAttached) {
            impactDescInputStep3._impactDescListenerAttached = true;
            impactDescInputStep3.addEventListener('input', () => { try { handleNextPreviousBtn(); } catch (e) { /* ignore */ } });
            impactDescInputStep3.addEventListener('keyup', () => { try { handleNextPreviousBtn(); } catch (e) { /* ignore */ } });
            impactDescInputStep3.addEventListener('blur', async () => {
              const impactDescInput = appShadowRoot.getElementById('support-product-impact-desc-input');
              const businessImpactText = impactDescInput ? impactDescInput.value : '';            
              const recentChangesVal = newDescriptionObject.environmentChanges;
              const recentChanges = recentChangesVal === 'yes' ? 'true' : recentChangesVal === 'no' ? 'false' : '';
              const recentChangesDescription = newDescriptionObject['env-description-fieldSuggestion'] || '';
              
              const companyEntitlements = await getEntitlementsString();
              const companysupportEntitlements = await getSupportEntitlements();

              adobeDataLayerTrack({
                event: 'businessImpactEntered',
                eventType: 'web.webInteraction.supportform-businessImpact',
                companyLoginDetails: {
                  companyLoginName: selectedOrg.name,
                  companyLoginID: selectedOrg.id,
                  companyEntitlements,
                  companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
                },
                supportForm: {
                  formStep: '',
                  formType: 'support',
                  productSelection: selectedNewProductName,
                  productSelectionOrder: productSelectionCount.toString(),
                  caseTitle: miloCaseCreateObject.title || '',
                  caseDescription: miloCaseCreateObject.description,
                  step: stepCount.toString(),
                  companyName: selectedOrg.name ? selectedOrg.name : '',
                  useCasePriority: analyticCasePriority,
                  recentChanges,
                  recentChangesDescription,
                  businessImpactEntry: businessImpactText,
                },
              });
            });
          }
          const impactDescFilledStep3Main = impactDescInputStep3 && (impactDescInputStep3.value || '').trim().length > 0;
          if (miloStep3ImpactRequirementMet(impactDescFilledStep3Main)) {
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              if (
                Number.isInteger(miloCaseCreateObject.timezone) &&
                miloCaseCreateObject.phone &&
                isOpenTicketStep4PhoneValid()
              ) {
                enableReviewbtn = isMiloCriticalBusinessImpactComplete();
              } else {
                enableReviewbtn = false;
              }
            }

          }
          if($llel.nextStep.disabled){
            enableReviewbtn=false;
          }
        }
            

        if(stepCount === 4){
          // if(caseAttachmentsFiles.length === 0){
          //   renderDemoAttachmentCards();
          // }

          const phoneInputStep4 = appShadowRoot?.querySelector('#support-openticket-phone-input');
          if (
            phoneInputStep4 &&
            Number.isInteger(miloCaseCreateObject.timezone) &&
            miloCaseCreateObject.phone &&
            isOpenTicketStep4PhoneValid()
          ) {
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
            if(!checkEnableReviewBtn){
              enableReviewbtn = isMiloCriticalBusinessImpactComplete();
            }
          }
          if($llel.nextStep.disabled){
            enableReviewbtn=false;
          }
          if (!isMiloCriticalBusinessImpactComplete()) {
            enableReviewbtn = false;
          }
          if (!isOpenTicketStep4PhoneValid()) {
            enableReviewbtn = false;
          }
          if(selectedNewProductCode.toLowerCase().startsWith('mkto_') || selectedNewProductCode.toLowerCase().includes('dx_genstudio_support') || selectedNewProductCode.toLowerCase().startsWith('amm_')){
            removeClass($llel.showTicketDes,'is-hidden');
          }
        }
        if (stepCount >= 1 && stepCount <= 4 && maxVisitedStep >= 5) {
          const step5Header = appShadowRoot.querySelector('#step-5-header');
          if (step5Header) {
            removeClass(step5Header, 'reached');
            removeClass(step5Header, 'disabled');
            const reviewAllowed = enableReviewbtn && isOpenTicketStep4PhoneValid();
            if (reviewAllowed) {
              addClass(step5Header, 'reached');
            } else {
              addClass(step5Header, 'disabled');
            }
          }
        }
        if(stepCount === 5){
          // appShadowRoot.querySelector(`.return-to-review-btn`).style.display = 'none';
          hasVisitedStep5 = true;
          const tags = appShadowRoot.querySelector('.tags-input-wrapper');
          const emailTags = tags.querySelectorAll('.tag');
          let formCaseCCEmailList = '';
          emailTags.forEach(tag => {
            const email = tag.textContent.trim();
            if (email.length ) {
              formCaseCCEmailList += email + ',';
            } else if (email.length) {
              console.warn(`${email} is not a valid email address.`);
            }
          });

          miloCaseCreateObject.ccEmailList = formCaseCCEmailList.length ? formCaseCCEmailList.slice(0, -1).split(',') : [];

          
          appShadowRoot.querySelector('#step-1-review').querySelector('.review-fields').innerHTML = ''
          appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML = ''
          appShadowRoot.querySelector('#step-3-review').querySelector('.review-fields').innerHTML = ''
          appShadowRoot.querySelector('#step-4-review').querySelector('.review-fields').innerHTML = ''



          appShadowRoot.querySelector('#step-1-review').querySelector('.review-fields').innerHTML =
          `
            <div class="review-detail-label">${getLabelV2('Title')}:</div>
            <div class="review-detail-value" data-cs-mask>${miloCaseCreateObject.title}</div>
            
            <div class="review-detail-label">${getLabelV2('Description')}:</div>
            <div class="review-detail-value" data-cs-mask>${miloCaseCreateObject.description}</div>
            <div class="review-detail-label">${getLabelV2('Is this issue reproducible')}:</div>
            <div class="review-detail-value">${(newDescriptionObject['stepsToReproduce'] === 'yes' ? 'Yes' : newDescriptionObject['stepsToReproduce'] === 'no' ? 'No' : newDescriptionObject['stepsToReproduce'] || '')}</div>
          `

          if(newDescriptionObject['Steps to Reproduce'] || newDescriptionObject['steps-to-reproduceSuggestion']){
            const stepsToReproduceValue = newDescriptionObject['Steps to Reproduce'] || newDescriptionObject['steps-to-reproduceSuggestion'] || '';
            appShadowRoot.querySelector('#step-1-review').querySelector('.review-fields').innerHTML +=
            `
              <div class="review-detail-label">${getLabelV2('Steps to Reproduce')}:</div>
              <div class="review-detail-value" data-cs-mask>${stepsToReproduceValue}</div>
            `
          }

          let issueReasonLabel = '';

          if (issueReasonMetaData && issueReasonMetaData.length) {
            for (const option of issueReasonMetaData[0].options) {
              if (miloCaseCreateObject.issueReasonCode == option.value) {
                issueReasonLabel = option.label;
              }
            }
            const issueReasonDisplay =
              (issueReasonLabel && String(issueReasonLabel).trim()) ||
              (miloCaseCreateObject.issueReasonCode != null &&
              miloCaseCreateObject.issueReasonCode !== '' &&
              String(miloCaseCreateObject.issueReasonCode).trim());
            if (issueReasonDisplay) {
              appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML =
                `
            <div class="review-detail-label">${getLabelV2('Issue Reason')}:</div>
            <div class="review-detail-value">${issueReasonDisplay}</div>
            `;
            }
          }

          for (let field of newMetaData){
            if(field.value){
              appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
              `
              <div class="review-detail-label">${getLabelV2(field.displayName)}:</div>
              <div class="review-detail-value" data-cs-mask>${field.value}</div>
              `
            }
          }
          if(DESCRIPTION_FIELDS[selectedNewProductCode]?.length){

            for (let description of DESCRIPTION_FIELDS[selectedNewProductCode]){
              if(newDescriptionObject[description.label]){
                appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
                `
                <div class="review-detail-label">${getLabelV2(description.label)}:</div>
                <div class="review-detail-value" data-cs-mask>${newDescriptionObject[description.label]}</div>
                `
              }
            }
          }
          if(!hasEnvironmentField){
            appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
              `
                <div class="review-detail-label">${getLabelV2('Have there been any recent changes to the environment')}:</div>
                <div class="review-detail-value" data-cs-mask>${newDescriptionEnvObject.environment}</div>
              `
          }
          getRadioSuggestionEntries().forEach((entry) => {
            if (newDescriptionObject[entry.key]) {
              if (entry.key === 'steps-to-reproduceSuggestion') return;
              appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML +=
                `
                <div class="review-detail-label">${getLabelV2(entry.label)}:</div>
                <div class="review-detail-value" data-cs-mask>${newDescriptionObject[entry.key]}</div>
                `;
            }
          });
          if(commercePlatformFieldsData2?.length){
            for (let field of commercePlatformFieldsData2){
              if(field.value){
                appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
                `
                  <div class="review-detail-label">${getLabelV2(field.label)}:</div>
                  <div class="review-detail-value" data-cs-mask>${field.value}</div>
                `
              }
            }
          }
          if (commerceStageEnvironmentName.trim()) {
            appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML +=
              `
                <div class="review-detail-label">${getLabelV2('Stage Environment Name')}:</div>
                <div class="review-detail-value" data-cs-mask>${commerceStageEnvironmentName.trim()}</div>
              `;
          }
          console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
          
          if(commercePlatformFieldsData3?.length){
            for (let field of commercePlatformFieldsData3){
              let fieldLabel = field.label
              if(field.value){
                if(field.label === 'Redis/Valkey (Required Version)'){
                  console.log('field.value', field.value);
                  console.log('field.value number', Number(field.value));
                  if(Number(field.value) === 8){
                    fieldLabel = 'Valkey (Required Version)'
                  } else{
                    fieldLabel = 'Redis (Required Version)'
                  }
                  
                }
                appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
                `
                  <div class="review-detail-label">${getLabelV2(fieldLabel)}:</div>
                  <div class="review-detail-value" data-cs-mask>${field.value}</div>
                `
              }
            }
          }
          if(commercePlatformFieldsData4?.length){
            for (let field of commercePlatformFieldsData4){
              if(field.value){
                appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
                `
                  <div class="review-detail-label">${getLabelV2(field.label)}:</div>
                  <div class="review-detail-value" data-cs-mask>${field.value}</div>
                `
              }
            }
          }
          if(commercePlatformFieldsData5?.length){
            for (let field of commercePlatformFieldsData5){
              if(field.value){
                appShadowRoot.querySelector('#step-2-review').querySelector('.review-fields').innerHTML  +=
                `
                  <div class="review-detail-label">${getLabelV2(field.label)}:</div>
                  <div class="review-detail-value" data-cs-mask>${field.value}</div>
                `
              }
            }
          }
          
          // ${miloCaseCreateObject.priorityCode === '1' && impactKeys[miloCaseCreateObject.impactCode] != null ?`
          //   <div class="review-detail-label">Business Impact Code:</div>
          //   <div class="review-detail-value">${impactKeys[miloCaseCreateObject.impactCode]}</div>    
          //   `:''
          // }
          appShadowRoot.querySelector('#step-3-review').querySelector('.review-fields').innerHTML =
          `    
            <div class="review-detail-label">${getLabelV2('Priority')}:</div>
            <div class="review-detail-value">${priorityKeys[miloCaseCreateObject.priorityCode]}</div>    
            
            ${appShadowRoot.getElementById('support-product-impact-desc-input').value ?`
            ${hasImpactField ?`
              <div class="review-detail-label">${getLabelV2('Business Impact')}:</div>
              <div class="review-detail-value" data-cs-mask>${appShadowRoot.getElementById('support-product-impact-desc-input').value}</div>    
              `:''
            }`  : ''}
          `

          let timezoneLabel = ''
          for (let timezone of timezoneOptions){
            if(miloCaseCreateObject.timezone == timezone.value){
              timezoneLabel = timezone.label
            }
          }

          appShadowRoot.querySelector('#step-4-review').querySelector('.review-fields').innerHTML =
          `        
            <div class="review-detail-label">${getLabelV2('Timezone')}:</div>
            <div class="review-detail-value">${timezoneLabel}</div>    
            ${ENABLE_PHONE_NOTIFICATION_OPT_IN ? `
            <div class="review-detail-label">${getLabelV2('Country Code')}:</div>
            <div class="review-detail-value">${miloCaseCreateObject.optInCountryCode || ''}</div>` : ''}
            <div class="review-detail-label">${getLabelV2('Phone Number')}:</div>
            <div class="review-detail-value" data-cs-mask>${miloCaseCreateObject.phone}</div>
            ${ENABLE_PHONE_NOTIFICATION_OPT_IN ? `
            ${appShadowRoot.querySelector('#support-openticket-sms-opt-in-wrap:not(.is-hidden)') ? `
            <div class="review-detail-label">${getLabelV2('SMS opt-in')}:</div>
            <div class="review-detail-value">${miloCaseCreateObject.smsOptIn ? getLabelV2('Yes') : getLabelV2('No')}</div>` : ''}
            ${appShadowRoot.querySelector('#support-openticket-whatsapp-opt-in-wrap:not(.is-hidden)') ? `
            <div class="review-detail-label">${getLabelV2('WhatsApp opt-in')}:</div>
            <div class="review-detail-value">${miloCaseCreateObject.whatsappOptIn ? getLabelV2('Yes') : getLabelV2('No')}</div>` : ''}
            `: ''}
            ${formCaseCCEmailList.trim() ? `
            <div class="review-detail-label">${getLabelV2('Watchers Email')}:</div>
            <div class="review-detail-value" data-cs-mask>${formCaseCCEmailList.replace(/,$/, '').replace(/,/g, ', ')}</div>    
            ` : ''}
            ${caseAttachmentsFiles.length > 0 ? `
            <div class="review-detail-label">${getLabelV2('Attached Files')}:</div>
            <div class="review-detail-value">
              ${caseAttachmentsFiles.map(file => `<div style="margin-bottom: 5px;">• ${file.name}</div>`).join('')}
            </div>` : ''}
          `


          addClass($llel.nextStep, 'is-hidden');
          removeClass($llel.submitFormButton, 'is-hidden');
          removeClass($llel.submitMessage, 'is-hidden');
          if(selectedNewProductCode.toLowerCase().startsWith('mkto_') || selectedNewProductCode.toLowerCase().includes('dx_genstudio_support') || selectedNewProductCode.toLowerCase().startsWith('amm_')){
            removeClass($llel.submitMessageMkto, 'is-hidden');
          }
        } else{
          removeClass($llel.nextStep, 'is-hidden');
          addClass($llel.submitFormButton, 'is-hidden');
          addClass($llel.submitMessage, 'is-hidden');
          addClass($llel.submitMessageMkto, 'is-hidden');
        }
      }

      

    }



    let globalLoaderDismissed = false;
    /** True while getZeonAiAgent (recommended docs) request is in flight; used to keep global loader visible until recommended docs API returns */
    let recommendedDocsLoadInProgress = false;
    let recommendationColumnGlobalOverlayUsed = false;
    function showGlobalLoader(forRecommendationsFlow = false) {
      const productIdForInsights = selectedProduct || miloCaseCreateObject?.productCode || selectedNewProductCode || '';
      if (!forRecommendationsFlow && !isInsightsSupportedForProduct(productIdForInsights)) return;
      globalLoaderDismissed = false;
      const wrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
      const globalReadyToHelp = appShadowRoot.querySelector('#global-ready-to-help');
      const globalLookingIntoIt = appShadowRoot.querySelector('#global-looking-into-it');
      if (!wrapper || !globalReadyToHelp || !globalLookingIntoIt) return;
      wrapper.classList.add('show-global-loader');
      addClass(globalReadyToHelp, 'is-hidden');
      removeClass(globalLookingIntoIt, 'is-hidden');
    }

    function dismissGlobalLoader() {
      if (globalLoaderDismissed) return;
      globalLoaderDismissed = true;
      const wrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
      const globalLoaderHelper = appShadowRoot.querySelector('#global-loader-helper');
      if (wrapper) wrapper.classList.remove('show-global-loader');
      if (globalLoaderHelper) addClass(globalLoaderHelper, 'is-hidden');
    }

    function resetGlobalLoaderState() {
      recommendationColumnGlobalOverlayUsed = false;
      invalidateInFlightGenAiRequests();
      const productIdForInsights = selectedNewProductCode || miloCaseCreateObject?.productCode || selectedProduct || '';
      if (!isInsightsSupportedForProduct(productIdForInsights)) {
        dismissGlobalLoader();
        return;
      }
      globalLoaderDismissed = false;
      recommendedDocsLoadInProgress = false;
      const wrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
      const globalLoaderHelper = appShadowRoot.querySelector('#global-loader-helper');
      const globalReadyToHelp = appShadowRoot.querySelector('#global-ready-to-help');
      const globalLookingIntoIt = appShadowRoot.querySelector('#global-looking-into-it');
      if (wrapper) wrapper.classList.add('show-global-loader');
      if (globalLoaderHelper) removeClass(globalLoaderHelper, 'is-hidden');
      if (globalReadyToHelp) removeClass(globalReadyToHelp, 'is-hidden');
      if (globalLookingIntoIt) addClass(globalLookingIntoIt, 'is-hidden');
    }

    async function handleFields(){
      let formCaseTitleInput =  appShadowRoot.querySelector('#support-openticket-casetitle-input');
      let formCaseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');

      if(selectedNewProductCode !== 'WORKFRONT'){
        renderFieldsPicker('step-4-timezone-fields', TIMEZONE_OPTIONS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
      }

      // let readyToHelp = appShadowRoot.querySelector('.ready-to-help');
      // removeClass(readyToHelp, 'is-hidden')
      // let aiAgentResponseContainer = appShadowRoot.querySelector('#ai-agent-response-container');
      // addClass(aiAgentResponseContainer, 'is-hidden')
      
      formCaseTitleInput.addEventListener(
        'keyup',
        debounceTitle(function () {
          const event = this;
          
          const inputValue = event.value.trim();
          miloCaseCreateObject.title = inputValue;
          if (inputValue.length > 0) {
            miloCaseCreateObject.title = inputValue;
          } else {
            $llel.articleListComponent.removeAttribute('title');
            addClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = true;
          }
          caseAssistArticlesPerPage = 5;
          // setCaseAssistView();

          if(miloCaseCreateObject.title && miloCaseCreateObject.description && (
            !('value' in commerceProjectURL) ||
            commerceProjectURL.value.trim() !== ''
          )){
            removeClass($llel.nextStep, 'disabled');
            $llel.nextStep.disabled = false;
          }

          try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }

        }, 1000),
      );

      formCaseTitleInput.addEventListener('blur', function () {
        const event = this;
        const inputValue = event.value.trim();
        if (inputValue.length) {
          // form-start data tracker
          let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
          if(isWorkFront()){
            analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
          }
          adobeDataLayerTrack({
            event: 'form-start',
            supportForm: {
              formStep: 'Form Case Title Entered',
              formType: 'support',
              productSelection:selectedNewProductName,
              productSelectionOrder:productSelectionCount.toString(),
              caseTitle:inputValue,
              caseDescription:miloCaseCreateObject.description,
              step:stepCount.toString(),
              companyName: selectedOrg.name ? selectedOrg.name : '',
              useCasePriority: analyticCasePriority,
            },
          });
          isFormStart = true;
        }
      });

      // Also listen for input events on the shadow-root title input so clearing
      // the field immediately recalculates the Next button state.
      formCaseTitleInput.addEventListener('input', (e) => {
        const v = (e.target.value || '').trim();
        miloCaseCreateObject.title = v;
        if (v && miloCaseCreateObject.description && (
          !('value' in commerceProjectURL) ||
          commerceProjectURL.value.trim() !== ''
        )) {
          removeClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = false;
        } else {
          addClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = true;
        }
        try { handleNextPreviousBtn(); } catch (err) { /* ignore */ }
      });

      formCaseDescriptionInput.addEventListener('keyup', async (event) => {
        
        const selectedValue = event.target.value;
        formCaseDescriptionInput.setAttribute('selected-value', selectedValue);
        aiApiObject.userInput = selectedValue;
        syncAiApiObjectProductForGenAi();
        miloCaseCreateObject.description = selectedValue;
        const offset = new Date().getTimezoneOffset();
        const clientTimezone = offset * -1;
        if (!isWorkFront() && !timezoneSelectionIsUserOverride && !browserTimezoneAppliedFromDescription) {
          for (const timedata of timezoneOptions) {
            if (clientTimezone === timedata.UTC_OFFSET) {
              const tzPickerSelected = appShadowRoot.querySelector(
                '#support-product-timeZone .adobe-exl-pickerSelectedOption',
              );
              if (tzPickerSelected) {
                tzPickerSelected.innerText = timedata.label;
              }
              miloCaseCreateObject.timezone = timedata.value;
              browserTimezoneAppliedFromDescription = true;
              break;
            }
          }
        }
        $llel.formFieldsSection.classList.remove('is-hidden');
        $llel.additionalHelpSection.classList.remove('is-hidden');
        
        if (!isCommerce() && !isWorkFront()) {
          await findWatchersMembers(
            '.tags-input-wrapper input',
            '.saveuserListModal',
            '.saveuserListMembers',
            trackSupportFormWatcherAdded,
          );
        }
        if (selectedValue.length > 5000) {
          miloCaseCreateObject.description = '';
          notice(`${getLabelV2('Case Description should be less than 5000 characters. Current Length: ')}${selectedValue.length}`, true, void 0, 'negative', 1);
        }
        
        if(miloCaseCreateObject.title && miloCaseCreateObject.description && (
            !('value' in commerceProjectURL) ||
            commerceProjectURL.value.trim() !== ''
          )
        ){
          removeClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = false;
        } else {
          addClass($llel.nextStep, 'disabled');
          $llel.nextStep.disabled = true;
        }
        try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
      });

      formCaseDescriptionInput.addEventListener('blur', async (event) => {
        const CONTROL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g;
        const raw = event.target.value;
        const sanitized = raw.replace(CONTROL_CHARS, '');
        if (sanitized !== raw) {
          formCaseDescriptionInput.value = sanitized;
          miloCaseCreateObject.description = sanitized;
        }
        const trimmedValue = sanitized.trim();
        const inputValue = trimmedValue.slice(0, 200);
        let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
        if(isWorkFront()){
          analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
        }
        adobeDataLayerTrack({ 
          event: 'support-form-description',
          supportForm: {
            formStep: 'Form Case Description Entered',
            formType: 'support',
            productSelection:selectedNewProductName,
            productSelectionOrder:productSelectionCount.toString(),
            caseTitle:miloCaseCreateObject.title,
            caseDescription:inputValue,
            step:stepCount.toString(),
            companyName: selectedOrg.name ? selectedOrg.name : '',
            useCasePriority: analyticCasePriority,
          },
        });    
        if (trimmedValue.length) {
          syncAiApiObjectProductForGenAi();
          aiApiObject.userInput = formCaseDescriptionInput.value;
          getZeonAiAgent(aiApiObject);
        }

        if (trimmedValue.length > 0) {
          const titleContainer = formCaseTitleInput?.closest('#support-openticket-casetitle') || formCaseTitleInput?.parentElement;
          const sublabelEl = titleContainer?.querySelector('.field-sub-labels');
          const titleFieldConfig = COMMON_FIELDS.find(f => f.textAreaId === 'support-openticket-casetitle-input');
          const originalPlaceholder = titleFieldConfig ? getLabelV2(titleFieldConfig.placeholder) : (formCaseTitleInput?.placeholder ?? '');
          const originalSublabel = titleFieldConfig ? getLabelV2(titleFieldConfig.sublabel) : '';
          try {
            formCaseTitleInput.value = '';
            formCaseTitleInput.placeholder = getLabelV2('Generating...') || 'Generating...';
            const result = await getCasePrepareTitle(trimmedValue);
            if ((formCaseDescriptionInput?.value || '').trim() !== trimmedValue) {
              return;
            }
            if (result) {
              const validImpact = result.impact_code != null && result.impact_code !== '' && result.impact_code !== 'failed';
              if (validImpact) {
                impactCodeFromApiFailed = false;
                miloCaseCreateObject.impactCode = result.impact_code;
              } else {
                impactCodeFromApiFailed = true;
                const priorityCode = miloCaseCreateObject.priorityCode || '';
                if (priorityCode === '1' || priorityCode === '2') {
                  miloCaseCreateObject.impactCode = 1;
                } else if (priorityCode === '3') {
                  miloCaseCreateObject.impactCode = 2;
                } else {
                  miloCaseCreateObject.impactCode = 3;
                }
              }
              if(result.case_title){
                formCaseTitleInput.value = result.case_title;
                miloCaseCreateObject.title = result.case_title;
                formCaseTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
              } else{
                formCaseTitleInput.value = miloCaseCreateObject.description.length > 100 ? miloCaseCreateObject.description.slice(0, 20) : miloCaseCreateObject.description;;
                miloCaseCreateObject.title = miloCaseCreateObject.description;
                formCaseTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
              }
              try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            } else {
              if ((formCaseDescriptionInput?.value || '').trim() !== trimmedValue) {
                return;
              }
              formCaseTitleInput.value = miloCaseCreateObject.description.length > 100 ? miloCaseCreateObject.description.slice(0, 100) : miloCaseCreateObject.description;;
              miloCaseCreateObject.title = miloCaseCreateObject.description;
              formCaseTitleInput.dispatchEvent(new Event('input', { bubbles: true }));
            }

          } catch (err) {
            console.error('[CasePrepare] Title auto-populate failed', err);
          } finally {
            if (formCaseTitleInput) formCaseTitleInput.placeholder = originalPlaceholder;
            if (sublabelEl) sublabelEl.textContent = originalSublabel;
          }
        }
        
      });

      if (formCaseDescriptionInput) {
        const DESCRIPTION_MAX_LENGTH = 5000;
        const descriptionCharCountEl = appShadowRoot.querySelector('#description-char-count');
        const recommendationCounters = appShadowRoot.querySelectorAll('.recommendation-char-counter');
        const updateDescriptionCharCount = () => {
          if (!descriptionCharCountEl) return;
          const len = (formCaseDescriptionInput.value || '').length;
          const remaining = Math.max(0, 50 - len);
          descriptionCharCountEl.textContent = `${remaining} ${getLabelV2('characters remaining')}`;
          const used = 50 - remaining;
          recommendationCounters.forEach((el) => {
            el.textContent = String(used);
          });
        };
        formCaseDescriptionInput.addEventListener('input', (e) => {
          if (e.target.value.length > DESCRIPTION_MAX_LENGTH) {
            e.target.value = e.target.value.slice(0, DESCRIPTION_MAX_LENGTH);
          }
          updateDescriptionCharCount();
        });
        updateDescriptionCharCount();
      }

          // Add "Return to Review Summary" buttons to steps 1-4 (initially hidden)
      // for (let i = 1; i < 5; i++) {
        // const stepContainer = appShadowRoot.querySelector(`#new-open-ticket`);
        // if (stepContainer) {
        //   // Create the button (initially hidden)

        //   const returnButton = document.createElement('button');
        //   returnButton.innerHTML = `
        //   Return to Review Summary
        //   <svg
        //     xmlns="http://www.w3.org/2000/svg"
        //     width="16"
        //     height="16"
        //     viewBox="0 0 36 36"
        //     fill="currentColor"
        //     aria-hidden="true"
        //   >
        //     <path
        //       d="M14.2 28.8c-.6-.6-.6-1.6 0-2.2l7.6-7.6H6a1.5 1.5 0 1 1 0-3h15.8l-7.6-7.6c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l10 10c.6.6.6 1.6 0 2.2l-10 10c-.6.6-1.6.6-2.2 0z"
        //     />
        //   </svg>
        //   `;
        //   returnButton.className =  "return-to-review-btn";
        //   returnButton.style.cssText = 'margin-top: 10px; margin-bottom: 10px; display: none';
        //   // returnButton.dataset.stepNumber = i;
          
        //   // Insert the button at the top of the step
        //   stepContainer.insertBefore(returnButton, stepContainer.firstElementChild);
          
        //   // Add click event listener
        //   returnButton.addEventListener('click', () => {

        //     if($llel.nextStep.disabled){
        //       notice(getLabelV2('Fill missing fields'), true, void 0, 'negative', 0);
        //     }else if(!$llel.nextStep.disabled && !enableReviewbtn){
        //       notice(getLabelV2('Fill missing fields'), true, void 0, 'negative', 0);
        //     }else{
        //       stepCount = 5;
        //       returnButton.style.display = 'none'
        //       handleNextPreviousBtn();
        //     }
        //     // if($llel.nextStep.classList.contains('disabled') && !enableReviewbtn){
        //     // }
        //   });
        // }
      // }

      if (selectedNewProductCode !== 'WORKFRONT') {
        if (isCommerce()) {
          // eslint-disable-next-line no-use-before-define
          await getCommerceIssueReasonField(selectedNewProductCode);
        } else {
          // eslint-disable-next-line no-use-before-define
          await getIssueReasonField(selectedNewProductCode);
        }
      }
      if(selectedNewProductCode === 'WORKFRONT'){

        getWorkFrontFormFields(selectedNewProductCode)

      } else{

        if(isCommerce()){

          renderFieldsPicker('description-fields', DESCRIPTION_FIELDS[selectedNewProductCode], 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          renderFieldsPicker('step-3-fields', PRIORITY_OPTIONS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          // renderFieldsPicker('step-4-timezone-fields', TIMEZONE_OPTIONS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          if(selectedNewProductCode !== 'admin_console'){
            getCommerceProductMetadata();
          }
        } else{
          renderFieldsPicker('description-fields', DESCRIPTION_FIELDS[selectedNewProductCode], 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          renderFieldsPicker('step-3-fields', PRIORITY_OPTIONS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          // renderFieldsPicker('step-4-timezone-fields', TIMEZONE_OPTIONS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          if(selectedNewProductCode !== 'admin_console'){
            getProductMetadataV2();
          }
          
        }
      }
      


      const countryOptionsHtml = COUNTRY_CALLING_CODES.map(
        (c) => `<option value="${c.iso2}">${c.name} (+${c.dialCode})</option>`,
      ).join('');

      const phoneFieldHtml = ENABLE_PHONE_NOTIFICATION_OPT_IN
        ? `<div id="support-openticket-phoneNumber" class="is-margin-bottom-big">
            <label class="spectrum-FieldLabel spectrum-Form-itemLabel set-index is-inline-block has-text-weight-bold is-margin-bottom-small is-size-5-tablet set-index">${getLabelV2(
          'Phone number',
        )} <sup>*</sup></label>
            <div style="display:flex;flex-wrap:wrap;gap:1rem">
              <div style="flex:1;min-width:200px">
                <select id="support-openticket-phone-country-select" class="support-form-title spectrum-Textfield-input w-100 border radius-5 is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6">
                  <option value="">${getLabelV2('Select country code')}</option>
                  ${countryOptionsHtml}
                </select>
                <p class="spectrum-HelpText is-margin-top-xsmall">${getLabelV2('Select country calling code')}</p>
              </div>
              <div style="flex:2;min-width:200px">
                <input placeholder="${getLabelV2(
          'e.g. 2015550123',
        )}" type="tel" inputmode="numeric" id="support-openticket-phone-input" maxlength="15" class="support-form-title spectrum-Textfield-input w-100 border radius-5 is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6" data-cs-mask />
                <p class="spectrum-HelpText is-margin-top-xsmall">${getLabelV2('Enter number without country code')}</p>
              </div>
            </div>
            <div id="support-openticket-notification-opt-ins" class="is-margin-top-medium">
              <div id="support-openticket-sms-opt-in-wrap" class="spectrum-Form-item is-margin-bottom-small is-hidden">
                <label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;">
                  <input type="checkbox" id="support-openticket-sms-opt-in" style="margin-top:0.25rem;width:20px" />
                  <span>
                    <span class="has-text-weight-bold is-size-6">${getLabelV2('SMS opt-in')}</span>
                    <p class="spectrum-HelpText is-margin-top-xsmall">${getLabelV2('Receive case updates via SMS.')}</p>
                  </span>
                </label>
              </div>
              <div id="support-openticket-whatsapp-opt-in-wrap" class="spectrum-Form-item is-hidden">
                <label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;">
                  <input type="checkbox" id="support-openticket-whatsapp-opt-in" style="margin-top:0.25rem;width:20px" />
                  <span>
                    <span class="has-text-weight-bold is-size-6">${getLabelV2('WhatsApp opt-in')}</span>
                    <p class="spectrum-HelpText is-margin-top-xsmall">${getLabelV2('Receive case updates via WhatsApp.')}</p>
                  </span>
                </label>
              </div>
            </div>
          </div>`
        : `<div id="support-openticket-phoneNumber" class=" is-margin-bottom-big">
            <label class="spectrum-FieldLabel spectrum-Form-itemLabel set-index is-inline-block has-text-weight-bold is-margin-bottom-small is-size-5-tablet set-index">${getLabelV2(
          'Phone number',
        )} <sup>*</sup></label>
            <input placeholder="${getLabelV2(
          'e.g. +12015550123',
        )}" type="tel" id="support-openticket-phone-input" maxlength="20" class="support-form-title  spectrum-Textfield-input w-100 border radius-5 is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6" data-cs-mask />
          </div>`;

      appShadowRoot.querySelector('#step-4-fields').innerHTML = `<div class="spectrum-Form-item is-margin-bottom-big w-100 is-inline-block">
          ${phoneFieldHtml}
        </div>

        <div class="spectrum-Form-item w-100 is-inline-block">
          <label class="spectrum-FieldLabel spectrum-Form-itemLabel is-inline-block has-text-weight-bold is-margin-bottom-small is-size-5 spectrum-FieldLabel spectrum-Form-itemLabel" style="display: flex; justify-content: space-between;">
            ${getLabelV2('Add up to 10 watchers, people you add will receive email updates about this case.')}
          </label>
          <textarea class=" has-background-white radius-5 border" id="tag-input1" data-value="" placeholder="${getLabelV2("Enter name or email")}" data-cs-mask></textarea>
        </div>
        <div class="userlistModal saveuserListModal is-hidden"> 
            <ul id="userListMembers" class="saveuserListMembers" data-cs-mask></ul>
        </div>`;
          
          instantiateTagsInput('tag-input1');
          await findWatchersMembers(
            '.tags-input-wrapper input',
            '.saveuserListModal',
            '.saveuserListMembers',
            trackSupportFormWatcherAdded,
          );

        const watchersTooltipWrapper = appShadowRoot.querySelector('.watchers-tooltip');
        if (watchersTooltipWrapper) {
          watchersTooltipWrapper.addEventListener('mouseenter', function() {
            this.querySelector('.info-tooltip-text').style.visibility = 'visible';
            this.querySelector('.info-tooltip-text').style.opacity = '1';
          });
          watchersTooltipWrapper.addEventListener('mouseleave', function() {
            this.querySelector('.info-tooltip-text').style.visibility = 'hidden';
            this.querySelector('.info-tooltip-text').style.opacity = '0';
          });
        }

        const ImpactWatchersTooltipWrapper = appShadowRoot.querySelector('.impact-watchers-tooltip');
        if (ImpactWatchersTooltipWrapper) {
          ImpactWatchersTooltipWrapper.addEventListener('mouseenter', function() {
            this.querySelector('.info-tooltip-text').style.visibility = 'visible';
            this.querySelector('.info-tooltip-text').style.opacity = '1';
          });
          ImpactWatchersTooltipWrapper.addEventListener('mouseleave', function() {
            this.querySelector('.info-tooltip-text').style.visibility = 'hidden';
            this.querySelector('.info-tooltip-text').style.opacity = '0';
          });
        }

        const countrySelect = appShadowRoot.querySelector('#support-openticket-phone-country-select');
        const phoneNumberInput = appShadowRoot.querySelector('#support-openticket-phone-input');
        if (ENABLE_PHONE_NOTIFICATION_OPT_IN) {
          const smsOptInCheckbox = appShadowRoot.querySelector('#support-openticket-sms-opt-in');
          const whatsappOptInCheckbox = appShadowRoot.querySelector('#support-openticket-whatsapp-opt-in');
          smsOptInCheckbox?.addEventListener('change', () => {
            miloCaseCreateObject.smsOptIn = !!smsOptInCheckbox.checked;
          });
          whatsappOptInCheckbox?.addEventListener('change', () => {
            miloCaseCreateObject.whatsappOptIn = !!whatsappOptInCheckbox.checked;
          });
        } else {
          miloCaseCreateObject.smsOptIn = false;
          miloCaseCreateObject.whatsappOptIn = false;
          miloCaseCreateObject.optInCountryCode = '';
        }
        if (phoneNumberInput) {
          try {
            const profile = await window.adobeIMS.getProfile();
            if (ENABLE_PHONE_NOTIFICATION_OPT_IN) {
              const parsed = parseProfilePhoneNumber(profile);
              if (parsed && countrySelect) {
                countrySelect.value = parsed.iso2;
                phoneNumberInput.value = parsed.nationalNumber;
                formatPhoneNumber(phoneNumberFormat[lang]);
                updateOpenTicketPhone();
                if (
                  Number.isInteger(miloCaseCreateObject.timezone) &&
                  miloCaseCreateObject.phone &&
                  isOpenTicketStep4PhoneValid()
                ) {
                  removeClass($llel.nextStep, 'disabled');
                  $llel.nextStep.disabled = false;
                }
                checkOpenTicketNotificationEligibility();
                try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
              }
            } else {
              const userPhone = (profile?.phoneNumber || profile?.phone || '').trim();
              if (userPhone) {
                phoneNumberInput.value = userPhone;
                miloCaseCreateObject.phone = userPhone.replace(/[^\d+]/g, '');
                formatPhoneNumber(phoneNumberFormat[lang]);
                if (
                  Number.isInteger(miloCaseCreateObject.timezone) &&
                  miloCaseCreateObject.phone &&
                  isOpenTicketStep4PhoneValid()
                ) {
                  removeClass($llel.nextStep, 'disabled');
                  $llel.nextStep.disabled = false;
                }
                try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
              }
            }
          } catch (e) { /* ignore */ }
          if (ENABLE_PHONE_NOTIFICATION_OPT_IN) {
            countrySelect?.addEventListener('change', () => {
              updateOpenTicketPhone();
              if (
                Number.isInteger(miloCaseCreateObject.timezone) &&
                miloCaseCreateObject.phone &&
                isOpenTicketStep4PhoneValid()
              ) {
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              } else {
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true;
              }
              try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
              checkOpenTicketNotificationEligibility();
            });
          }
          phoneNumberInput.addEventListener('keyup', () => {
            const rawPhoneValue = phoneNumberInput.value.trim();
            // Only auto-format when the value has no invalid characters; otherwise leave
            // it intact so validation can reject letters/special characters.
            if (OPEN_TICKET_PHONE_ALLOWED_CHARS.test(rawPhoneValue)) {
              formatPhoneNumber(phoneNumberFormat[lang]);
            }
            updateOpenTicketPhone();
            if (
              Number.isInteger(miloCaseCreateObject.timezone) &&
              miloCaseCreateObject.phone &&
              isOpenTicketStep4PhoneValid()
            ) {
              removeClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = false;
            } else {
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          });
          phoneNumberInput.addEventListener('blur', async() => {
            updateOpenTicketPhone();
            const rawPhoneValue = phoneNumberInput.value.trim();
            const pValue = ENABLE_PHONE_NOTIFICATION_OPT_IN
              ? rawPhoneValue.replace(/\D/g, '')
              : rawPhoneValue.replace(/[^\d+]/g, '');

            if (ENABLE_PHONE_NOTIFICATION_OPT_IN && !countrySelect?.value) {
              notice(getLabelV2('Select country code'), true, void 0, 'negative', 0);
            }
            if (!pValue.length || !OPEN_TICKET_PHONE_ALLOWED_CHARS.test(rawPhoneValue) || !isOpenTicketStep4PhoneValid()) {
              notice(getLabelV2('Enter valid phone number'), true, void 0, 'negative', 0);
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            } else if (
              Number.isInteger(miloCaseCreateObject.timezone) &&
              miloCaseCreateObject.phone &&
              isOpenTicketStep4PhoneValid()
            ) {
              removeClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = false;
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            await checkOpenTicketNotificationEligibility();
            const companyEntitlements = await getEntitlementsString();
            const companysupportEntitlements = await getSupportEntitlements();
            const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
            const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
            const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
            const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';
            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
            if (isWorkFront()) {
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
            }
            adobeDataLayerTrack({
              event: 'supportFormPhoneNumberEntered',
              eventType: 'web.webinteraction.supportform-phoneNumberEntered',
              companyLoginDetails: {
                companyLoginName: selectedOrg.name,
                companyLoginID: selectedOrg.id,
                companyEntitlements,
                companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
              },
              supportForm: {
                formStep: 'Form Complete',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle: miloCaseCreateObject.title || '',
                caseDescription: miloCaseCreateObject.description,
                step: stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCasePriority,
                hasAttachment,
                watchersAdded,
              },
            });
          });
        }
    }
    

    function renderAllFields(){
      renderFieldsPicker('step-1-fields', COMMON_FIELDS, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
      addClass(appShadowRoot.querySelector('#support-openticket-casetitle'),'is-hidden');
      handleFields();
      
    }
    appShadowRoot.querySelectorAll('.product-btn-common').forEach((el,index) => {
        el.addEventListener('click', (event) => {
          console.log('product-btn-common clicked');
          productSelectionCount = index+1;
          $llel.productFamilyBtnContainer.innerHTML = '';
          selectedNewProductName = event.currentTarget.innerText;
          selectedNewProductCode =event.currentTarget.dataset.id;
          selectedNewLicenseId =event.currentTarget.dataset.licenseid;
          // listItem.getAttribute('data-licenseId');
          miloCaseCreateObject.licenseId = selectedNewLicenseId;
          miloCaseCreateObject.productCode = selectedNewProductCode;
          // Do not clear metadata/description here: only commit-on-Next (handleNextPreviousBtn) should
          // reset those containers. Otherwise highlighting another product then re-selecting the same
          // committed product wipes step-2 API fields without re-fetch (added === selected skips reset).
          // appShadowRoot.getElementById('metadata-fields').innerHTML = '';
          // appShadowRoot.getElementById('description-fields').innerHTML = '';
          addClass(appShadowRoot.getElementById('ai-agent-response-container'), 'is-hidden')
          addClass(appShadowRoot.querySelector('.recomend-container .looking-into-it'), 'is-hidden')
          addClass(appShadowRoot.querySelector('#support-openticket-relatedarticles'), 'is-hidden')
          addClass(appShadowRoot.querySelector('#support-openticket-noresult'), 'is-hidden')
          removeClass(appShadowRoot.querySelector('.recomend-container .ready-to-help'), 'is-hidden')
          supportInsightsManager.reset();
          const insightsWrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
          insightsWrapper?.classList.remove('has-insights', 'insights-supported', 'insights-not-supported', 'recommendations-loaded');
          supportInsightsManager.initForProduct(selectedNewProductCode || '');
          // Reset support-insights-section to show ready-to-help and hide looking-into-it
          removeClass(appShadowRoot.querySelector('.support-insights-section .ready-to-help'), 'is-hidden');
          addClass(appShadowRoot.querySelector('.support-insights-section .looking-into-it'), 'is-hidden');
          resetGlobalLoaderState();
          addClass($llel.nextStep0, 'disabled');

 
          
          appShadowRoot.querySelectorAll('.product-btn-common').forEach((element) => {
            removeClass(element, 'product-dropdown-btn-selected');
            removeClass(element, 'product-btn-selected');
          })
          
          if(event.currentTarget.classList.contains('product-dropdown-btn')){
            addClass(event.currentTarget, 'product-dropdown-btn-selected');
          }
          
          if(event.currentTarget.classList.contains('product-btn')){
            selectedNewProductName = event.currentTarget.innerText;
            selectedNewProductCode =event.currentTarget.dataset.id;
            selectedNewLicenseId =event.currentTarget.dataset.licenseid;
            // listItem.getAttribute('data-licenseId');
            miloCaseCreateObject.licenseId = selectedNewLicenseId;
            miloCaseCreateObject.productCode = selectedNewProductCode;
            $llel.nextStep0.disabled = false;
            removeClass($llel.nextStep0, 'disabled');
            addClass(event.currentTarget, 'product-btn-selected');
            setOpenTicketAdminConsolePresentation(selectedNewProductCode === 'admin_console');
            onOpenTicketProductHighlightChanged();
          }

        });
    })


    appShadowRoot.querySelectorAll('.product-dropdown-btn').forEach((el) => {
      el.addEventListener('click', (event) => {
        addClass($llel.nextStep0, 'disabled');
        $llel.nextStep0.disabled = true;
        $llel.productFamilyBtnContainer.innerHTML = '';
        let familyProductButtonHtml = '';
        for (let product of newProductList){   
          if(product.familyName === event.currentTarget.dataset.family){
            for (let newproduct of product?.products){
              familyProductButtonHtml += `<button class="product-btn product-btn-common spectrum-ActionButton spectrum-ActionButton--sizeM spectrum-ActionButton--staticBlack hoverbox"
                id=""
                data-id="${newproduct?.id || ''}" data-label="${newproduct?.label || ''}" data-licenseId="${newproduct?.licenseId || ''}"
                class="spectrum-Menu-item" role="option" aria-selected="true" tabindex="0" >
                <span class="">${newproduct?.label}</span>
              </button>`
            }
          }
        }
        $llel.productFamilyBtnContainer.innerHTML = familyProductButtonHtml

        appShadowRoot.querySelectorAll('.product-btn-common').forEach((el) => {
          
          el.addEventListener('click', (event) => {
            appShadowRoot.querySelectorAll('.product-btn-common').forEach((element) => {
              removeClass(element, 'product-btn-selected');
            })
          
            if(event.currentTarget.classList.contains('product-btn')){
              selectedNewProductName = event.currentTarget.innerText;
              selectedNewProductCode =event.currentTarget.dataset.id;
              selectedNewLicenseId =event.currentTarget.dataset.licenseid;
              
              // listItem.getAttribute('data-licenseId');
              miloCaseCreateObject.productCode = selectedNewProductCode;
              miloCaseCreateObject.licenseId = selectedNewLicenseId;
              addClass(appShadowRoot.getElementById('ai-agent-response-container'), 'is-hidden')
              addClass(appShadowRoot.querySelector('.recomend-container .looking-into-it'), 'is-hidden')
              addClass(appShadowRoot.querySelector('#support-openticket-relatedarticles'), 'is-hidden')
              addClass(appShadowRoot.querySelector('#support-openticket-noresult'), 'is-hidden')
              removeClass(appShadowRoot.querySelector('.recomend-container .ready-to-help'), 'is-hidden')
              supportInsightsManager.reset();
              const insightsWrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
              insightsWrapper?.classList.remove('has-insights', 'insights-supported', 'insights-not-supported', 'recommendations-loaded');
              supportInsightsManager.initForProduct(selectedNewProductCode || '');
              // Reset support-insights-section to show ready-to-help and hide looking-into-it
              removeClass(appShadowRoot.querySelector('.support-insights-section .ready-to-help'), 'is-hidden');
              addClass(appShadowRoot.querySelector('.support-insights-section .looking-into-it'), 'is-hidden');
              resetGlobalLoaderState();

              $llel.nextStep0.disabled = false;
              removeClass($llel.nextStep0, 'disabled');
              addClass(event.currentTarget, 'product-btn-selected');
              setOpenTicketAdminConsolePresentation(selectedNewProductCode === 'admin_console');
              onOpenTicketProductHighlightChanged();
            }
          });
        })
      
      })

    })

    if(!selectedNewProductCode){
      $llel.nextStep0.disabled = true;
    }

    function setOpenTicketAdminConsolePresentation(isAdminConsole) {
      const step2Header = appShadowRoot?.querySelector('#step-2-header');
      if (isAdminConsole) {
        if (step2Header) {
          addClass(step2Header, 'is-hidden');
        }
        const step2Review = appShadowRoot?.querySelector('#step-2-review');
        if (step2Review) {
          addClass(step2Review, 'is-hidden');
        }
        const subLabels = appShadowRoot?.querySelector('#support-openticket-casedescription .field-sub-labels');
        if (subLabels) {
          addClass(subLabels, 'is-hidden');
        }
        const charRemaining = appShadowRoot?.querySelector('.char-remaining');
        if (charRemaining) {
          addClass(charRemaining, 'is-hidden');
        }
        appShadowRoot?.querySelectorAll('.recommendation-char-counter-span')?.forEach((el) => {
          addClass(el, 'is-hidden');
        });
        const step3Label = appShadowRoot?.querySelector('#step-3-review .step-label');
        if (step3Label) {
          step3Label.innerHTML = getLabelV2('2. Priority & Business Impact');
        }
        const step4Label = appShadowRoot?.querySelector('#step-4-review .step-label');
        if (step4Label) {
          step4Label.innerHTML = getLabelV2('3. Contact Information & Watchers List');
        }
      } else {
        if (step2Header) {
          removeClass(step2Header, 'is-hidden');
        }
        const step2Review = appShadowRoot?.querySelector('#step-2-review');
        if (step2Review) {
          removeClass(step2Review, 'is-hidden');
        }
        const subLabels = appShadowRoot?.querySelector('#support-openticket-casedescription .field-sub-labels');
        if (subLabels) {
          removeClass(subLabels, 'is-hidden');
        }
        const charRemaining = appShadowRoot?.querySelector('.char-remaining');
        if (charRemaining) {
          removeClass(charRemaining, 'is-hidden');
        }
        appShadowRoot?.querySelectorAll('.recommendation-char-counter-span')?.forEach((el) => {
          removeClass(el, 'is-hidden');
        });
        const step3Label = appShadowRoot?.querySelector('#step-3-review .step-label');
        if (step3Label) {
          step3Label.innerHTML = getLabelV2('3. Priority & Business Impact');
        }
        const step4Label = appShadowRoot?.querySelector('#step-4-review .step-label');
        if (step4Label) {
          step4Label.innerHTML = getLabelV2('4. Contact Information & Watchers List');
        }
      }
    }

    // function showReturnButtonForStep() {
    //   const returnButton = appShadowRoot.querySelector(`.return-to-review-btn`);
    //   if (returnButton) {
    //     // Hide button on step 0 (Product selection page) even if hasVisitedStep5 is true
    //     if (stepCount === 0) {
    //       returnButton.style.display = 'none';
    //     } else if (hasVisitedStep5) {
    //       returnButton.style.display = 'block';
    //     } else {
    //       returnButton.style.display = 'none';
    //     }
    //   }
    // }

    $llel.nextStep0.addEventListener('click', async (event) => {
      stepCount++;
      window.scrollTo(0, 0);
      const isWorkFrontOrg = isWorkFront();
      const shouldCheckAiChatPreference = !isWorkFrontOrg && openTicketContactMode !== 'ai' && !!selectedNewProductCode;
      handleNextPreviousBtn(true);
      setOpenTicketAdminConsolePresentation(selectedNewProductCode === 'admin_console');
      if (shouldCheckAiChatPreference) {
        showOpenTicketModeSwitchLoader();
      }
      if(isWorkFrontOrg){
        addClass( appShadowRoot.querySelector('#new-header-container') , 'is-hidden');
      } else{
        removeClass( appShadowRoot.querySelector('#new-header-container') , 'is-hidden');
        if (shouldCheckAiChatPreference) {
          try {
            const prefersAiChat = await getOpenTicketAiChatPreference();
            if (prefersAiChat) {
              await prepareOpenTicketAiMicrophoneAccess();
              await applyOpenTicketAiMode();
            }
          } finally {
            hideOpenTicketModeSwitchLoader();
          }
        }
      }
      updateOpenTicketBreadcrumb();
      for (const product of productsList) {
        if (product.productCode === selectedNewProductCode) {
          getTicketDetailsforOpenTicketSection(product.productId, product.type, product.id);
        }
      }
    })
    $llel.previousStep.addEventListener('click', (event) => {
      if(stepCount > 0){
         if (selectedNewProductCode === 'admin_console' && stepCount === 3) {
          stepCount -= 2; 
        }else{
          stepCount = stepCount - 1;
        }
        if (stepCount === 0) {
          addClass( appShadowRoot.querySelector('#new-header-container') , 'is-hidden');
          appShadowRoot?.querySelector(`.ticket-open-status-switcher`)?.remove();
        }
      }
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
      if(isWorkFront()){
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
      }
      adobeDataLayerTrack({
        event: 'supportFormStepBack',
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection:selectedNewProductName,
          productSelectionOrder:productSelectionCount.toString(),
          caseTitle:miloCaseCreateObject.description,
          caseDescription:miloCaseCreateObject.description,
          step:stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
        },
      });

      window.scrollTo(0, 0);
      // showReturnButtonForStep();
      handleNextPreviousBtn(true);
    })
    $llel.nextStep.addEventListener('click', (event) => {
      console.log('clicked next step');
      completedSteps.add(stepCount);

      if(stepCount === 2){

      
          
          let errorMessage = '';
          if (commercePlatformFieldsData2.length) {
            for (let metadata of commercePlatformFieldsData2) {
              if (!metadata?.value?.length) {
                errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
              }
            }
          }

          if (commercePlatformFieldsData3.length) {
            const specialIds = [
              'support-commerce-platform-upgrade-rabbit-required',
              'support-commerce-platform-upgrade-redis-required',
              'support-commerce-platform-upgrade-maria-required',
              'support-commerce-platform-upgrade-open-required'
            ];

            const hasRabbit = commercePlatformFieldsData3.some(
              f => f.id === 'support-commerce-platform-upgrade-rabbit-required'
            );

            if (hasRabbit) {
              // Only check the special group
              const specialFields = commercePlatformFieldsData3.filter(f =>
                specialIds.includes(f.id)
              );

              const anyValuePresent = specialFields.some(
                f => f?.value && f.value.length
              );

              if (!anyValuePresent) {
                errorMessage = getLabelV2(
                  `Enter valid ${specialFields.map(f => f.label).join(' / ')}`
                );
              }

              // const scheduledAt = commercePlatformFieldsData3.find(
              //   f => f.id === 'support-commerce-platform-upgrade-scheduled-at'
              // );

              // if (!scheduledAt?.value?.length) {
              //   errorMessage = getLabelV2(`Enter valid ${scheduledAt?.label || 'Scheduled At'}`);
              // }
            } else {
              // Normal validation for all fields if rabbit isn't present
              for (let metadata of commercePlatformFieldsData3) {
                if (metadata.id === 'support-commerce-platform-add-storage-size') {
                  if (!isOnlyNumber(metadata.value)) {
                    errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
                  } else if (Number(metadata.value) < 10) {
                    errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
                  }
                }

                const nowDateTime = new Date();


                if (metadata.id === 'support-commerce-platform-disable-email-disable-date') {
                  if (nowDateTime > new Date(metadata.value)) {
                    errorMessage = getLabelV2(`${metadata.label} cannot be earlier than present date and time`);
                  }
                }


                if (metadata.id === 'support-commerce-platform-disable-email-renable-date') {
                  let disableDate;
                  for (let metadata1 of commercePlatformFieldsData3) {
                    if (metadata1.id === 'support-commerce-platform-disable-email-disable-date') {
                      disableDate = metadata1.value;
                    }
                  }
                  if (new Date(disableDate) > new Date(metadata.value)) {
                    errorMessage = getLabelV2(`${metadata.label} cannot be earlier than disable date`);
                  }
                }

                if (metadata.id === 'support-commerce-platform-database-snapshot-retrieval') {
                  if (nowDateTime < new Date(metadata.value)) {
                    errorMessage = getLabelV2(`${metadata.label} should be past date and time`);
                  }
                }
                if (!metadata?.value?.length) {
                  errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
                }
              }
            }


          }

          if (commercePlatformFieldsData4.length) {
            for (let metadata of commercePlatformFieldsData4) {
              const nowDateTime = new Date();
              if (metadata.id === 'support-commerce-platform-upgrade-scheduled-at') {
                if (nowDateTime > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than present date and time`);
                }
              }
              if (metadata.id === 'support-commerce-platform-update-domain-prefered-time') {
                if (nowDateTime > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than present date and time`);
                }
              }

              if (metadata.id === 'support-commerce-platform-up-size-from-date') {
                if (nowDateTime > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than present date and time`);
                }
              }
              if (metadata.id === 'support-commerce-platform-up-size-to-date') {
                let toDate;
                for (let metadata1 of commercePlatformFieldsData4) {
                  if (metadata1.id === 'support-commerce-platform-up-size-from-date') {
                    toDate = metadata1.value;
                  }
                }
                if (toDate > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than from date`);
                }
              }
              if (!metadata?.value?.length) {
                errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
              }
            }
          }
          if (commercePlatformFieldsData5.length) {
            for (let metadata of commercePlatformFieldsData5) {
              const nowDateTime = new Date();

              if (metadata.id === 'support-commerce-platform-up-size-from-date') {
                if (nowDateTime > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than present date and time`);
                }
              }
              if (metadata.id === 'support-commerce-platform-up-size-to-date') {
                let toDate;
                for (let metadata1 of commercePlatformFieldsData5) {
                  if (metadata1.id === 'support-commerce-platform-up-size-from-date') {
                    toDate = metadata1.value;
                  }
                }
                if (toDate > new Date(metadata.value)) {
                  errorMessage = getLabelV2(`${metadata.label} cannot be earlier than from date`);
                }
              }
              if (!metadata?.value?.length) {
                errorMessage = getLabelV2(`Enter valid ${metadata.label}`);
              }
            }
          }
       
          if(errorMessage){
            notice(errorMessage, true, 3000, 'negative', 0, true);
            return;
          }
        }
      if (selectedNewProductCode === 'admin_console' && (stepCount === 1 || stepCount === 2)) {
        stepCount = stepCount === 1 ? 3 : stepCount + 1;
        const impactDescriptionField = appShadowRoot.getElementById('step-3-fields-impact');
        if (miloCaseCreateObject.priorityCode!=='1' && impactDescriptionField) {
          addClass(impactDescriptionField, 'showIfOnlyP1');
        }
      }else{
        stepCount++;
      }
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
      if(isWorkFront()){
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
      }
      adobeDataLayerTrack({
        event: 'supportFormStepNext',
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection:selectedNewProductName,
          productSelectionOrder:productSelectionCount.toString(),
          caseTitle:miloCaseCreateObject.description,
          caseDescription:miloCaseCreateObject.description,
          step:stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
        },
      });
      window.scrollTo(0, 0);
      // showReturnButtonForStep();
      handleNextPreviousBtn();
    })

    // Step header tabs: navigate to step when clicking a visited or current step
    $llel.allStepHeader?.addEventListener('click', (e) => {
      const tab = e.target.closest('.step-header-tab');
      if (!tab || tab.classList.contains('disabled')) return;
      let stepNum = parseInt(tab.getAttribute('data-step'), 10);
      if (selectedNewProductCode === 'admin_console' && stepNum === 2) stepNum = 3;
      if (!Number.isNaN(stepNum) && stepNum >= 1 && stepNum <= 5 && stepNum <= maxVisitedStep) {
        stepCount = stepNum;
        window.scrollTo(0, 0);
        // showReturnButtonForStep();
        handleNextPreviousBtn(true);
      }
    })
    $llel.allStepHeader?.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const tab = e.target.closest('.step-header-tab');
      if (!tab || tab.classList.contains('disabled')) return;
      e.preventDefault();
      let stepNum = parseInt(tab.getAttribute('data-step'), 10);
      if (selectedNewProductCode === 'admin_console' && stepNum === 2) stepNum = 3;
      if (!Number.isNaN(stepNum) && stepNum >= 1 && stepNum <= 5 && stepNum <= maxVisitedStep) {
        stepCount = stepNum;
        window.scrollTo(0, 0);
        // showReturnButtonForStep();
        handleNextPreviousBtn(true);
      }
    })

    for (let i = 1; i < 5; i++) {
      appShadowRoot.querySelector(`#step-${i}-review`)?.querySelector('.step-edit')?.addEventListener('click', async() => {
          removeClass($llel.nextStep, 'is-hidden');
          addClass($llel.submitFormButton, 'is-hidden');
          addClass($llel.submitMessage, 'is-hidden');
          addClass($llel.submitMessageMkto, 'is-hidden');
          
          // showReturnButtonForStep();
          stepCount = selectedNewProductCode === 'admin_console' && i === 2 ? 3 : i;
          handleNextPreviousBtn();
          const companyEntitlements = await getEntitlementsString();
          let currentFormName = getCurrentFormName();
          const companysupportEntitlements = await getSupportEntitlements();
          adobeDataLayerTrack({
            event: 'linkClicked',
            eventType: 'web.webInteraction.linkclicks',
            companyLoginDetails: {
              companyLoginName: selectedOrg.name,
              companyLoginID: selectedOrg.id,
              companyEntitlements,
              companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
            },
            link: {
              linkTitle: 'Edit this section',
              linkLocation: currentFormName,
              linkType: "link",
            },
          });
      });
    }

    if (selectedOrg.type === 'MILO' && !products.length) {
      if ($llel.adminConsoleLink && $llel.adminConsoleLink.classList.contains('is-hidden')) {
        $llel.adminConsoleLink.classList.remove('is-hidden');
      }
    } else if ($llel.adminConsoleLink && !$llel.adminConsoleLink.classList.contains('is-hidden')) {
      $llel.adminConsoleLink.classList.add('is-hidden');
    }
    (function (win, key) {
      win[key] =
        win[key] ||
        function () {
          (win[key].q = win[key].q || []).push(arguments);
        };
      win[key].t = Date.now();
    })(window, 'coveoua');
    if (window.coveoua) {
      window.coveoua('init', sessionStorage.getItem(CoveoToken));
    } else {
      log('window.coveoua is undefined');
    }

    function coveoAnalyticsOpenCase() {
      window.coveoua('svc:setAction', 'ticket_create_start');
      window.coveoua('send', 'event', 'svc', 'flowStart', {
        searchHub: CoveoSearchHubCaseAssist,
      });
    }

    function coveoAnalyticsSubmitCase(caseTitle, caseDescription, caseId) {
      window.coveoua('svc:setAction', 'ticket_create');
      window.coveoua('svc:setTicket', {
        subject: caseTitle,
        description: caseDescription,
        id: caseId,
      });
      window.coveoua('send', 'event', 'svc', 'click', {
        searchHub: CoveoSearchHubCaseAssist,
      });
    }

    coveoAnalyticsOpenCase();
    caseAttachments = [];
    caseAttachmentsFiles = [];
    const workfrontCaseCreateObject = {
      contactId: getSelectedOrg().contactId,
    };

    const miloCaseCreateObject = MILO_CASE_CREATE_OBJECT;
    miloCaseCreateObject.contactRengaId = getSelectedOrg().userId; // userprofile.userId;
    miloCaseCreateObject.orgId = getSelectedOrg().id;
    miloCaseCreateObject.language = miloLocales.get(lang);
    miloCaseCreateObject.email = userprofile.email;

    async function trackSupportFormWatcherAdded() {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
      if (isWorkFront()) {
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
      }
      const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';
      const companyEntitlements = await getEntitlementsString();

      adobeDataLayerTrack({
        event: 'watchersAdded',
        eventType: 'web.webInteraction.supportform-watchersAdded',
        companyLoginDetails: {
          companyLoginName: selectedOrg.name,
          companyLoginID: selectedOrg.id,
          companyEntitlements,
        },
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle: miloCaseCreateObject.title || '',
          caseDescription: miloCaseCreateObject.description,
          step: stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          hasAttachment,
          watchersAdded: 'true',
        },
      });
    }

    let selectedProduct;
    let selectedProductName = '';
    let caseAssistArticlesPerPage = 5;
    let workFrontFormFields;
    let mileAdditionalFieldsData = [];
    let commercePlatformFieldsData2 = [];
    let commercePlatformFieldsData3 = [];
    let commercePlatformFieldsData4 = [];
    let commercePlatformFieldsData5 = [];
    let impactCodeFromApiFailed = false;

    const submitButton = appShadowRoot.querySelector('#submit-button');
    if (!submitButton) {
      return;
    }

    submitButton.addEventListener('click', async (event) => {
      let caseCreationApiMs = 0;
      let caseCreationApiFlowStart = 0;
      const getCaseCreationRelicTitle = () => {
        if (selectedNewProductCode === 'WORKFRONT') return 'workfront';
        if (isCommerce()) return 'commerce';
        if (isECC()) return 'ECC';
        return 'IMS';
      };
      const getCaseCreationEndpoint = () => {
        if (selectedNewProductCode === 'WORKFRONT') {
          return workfrontCaseCreateUrl;
        }
        if (isCommerce()) {
          return exlMiloCaseUrl;
        }
        return miloCaseUrl;
      };
      const emitCaseCreationRelic = (caseStatus, flowEndTime, errorMessage) => {
        const end = typeof flowEndTime === 'number' ? flowEndTime : performance.now();
        relicCaseCreation({
          title: getCaseCreationRelicTitle(),
          totalDuration: end - caseCreationApiFlowStart,
          caseCreation: caseCreationApiMs,
          caseStatus,
          duration: caseCreationApiMs,
          endpoint: getCaseCreationEndpoint(),
          payload: miloCaseCreateObject,
          ...(caseStatus === 'FAIL' && errorMessage ? { errorMessage } : {}),
        });
      };

      if (isCommerce()) {
        newMetaData = newMetaData.map((field) => {
          if (
            field.displayName === 'Environment'
            && commerceStageEnvironmentName.trim()
            && ['STAGE', 'STAGING'].includes(String(field.value || '').trim().toUpperCase())
          ) {
            return { ...field, value: commerceStageEnvironmentName.trim() };
          }
          return field;
        });
      }
      miloCaseCreateObject.productMetadata = newMetaData;
      let caseDescription = appShadowRoot.querySelector('#support-openticket-casedescription-input').value;
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
      if(isWorkFront()){
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
      }
      adobeDataLayerTrack({
        event: 'supportFormSubmit',
        supportForm: {
          formStep: 'Form Submit',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle:miloCaseCreateObject.title,
          caseDescription:caseDescription,
          step:stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
        }
      });
      miloCaseCreateObject.description = caseDescription;
      miloCaseCreateObject.description += `\n\n\n-------------------------------------\n`;
      const stepsToReproduceText = newDescriptionObject['Steps to Reproduce'] || newDescriptionObject['steps-to-reproduceSuggestion'] || '';
      if(stepsToReproduceText.length){
        miloCaseCreateObject.description += `${getLabelV2('Is this issue reproducible')}?: Yes \n ${getLabelV2('Steps to Reproduce')}: ${stepsToReproduceText}\n`;
      }else{
        miloCaseCreateObject.description += `${getLabelV2('Is this issue reproducible')}?: No\n`;
      }

      if(DESCRIPTION_FIELDS[selectedNewProductCode]?.length){
        DESCRIPTION_FIELDS[selectedNewProductCode]?.forEach((element)=>{
          let value = newDescriptionObject[element.label]
          if(!newDescriptionObject[element.label]){
            value = 'N/A';
          }
          miloCaseCreateObject.description += `${getLabelV2(element.label)}:  ${value}\n`;
        })
      }
      const excludedProducts = ['WORKFRONT', 'admin_console'];  
      if (!excludedProducts.includes(selectedNewProductCode)) {
        if (!hasEnvironmentField) {
          miloCaseCreateObject.description += `Have there been any recent changes to the environment?:  ${newDescriptionEnvObject.environment}\n`;
        }
      }
      getRadioSuggestionEntries().forEach((entry) => {
        if (newDescriptionObject[entry.key] && entry.key !== 'steps-to-reproduceSuggestion') {
          miloCaseCreateObject.description += `${getLabelV2(entry.label)}:  ${newDescriptionObject[entry.key]}\n`;
        }
      });

      if(hasImpactField){
        miloCaseCreateObject.description += `${getLabelV2('Business Impact Description')}: ${appShadowRoot.getElementById('support-product-impact-desc-input').value}\n`;
      }
      
      miloCaseCreateObject.description += `-------------------------------------`;
      
      let submitBtn = appShadowRoot.querySelector('#submit-button')
      let btnLoader = appShadowRoot.querySelector('#submit-button').querySelector('.btn-loader');

      removeClass(btnLoader, 'is-hidden');
      addClass(btnLoader, 'disabled');
      submitBtn.disabled = true;
      
      // Create and show overlay to disable entire screen
      let submitOverlay = appShadowRoot.querySelector('#submit-overlay');
      if (!submitOverlay) {
        submitOverlay = document.createElement('div');
        submitOverlay.id = 'submit-overlay';
        submitOverlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 999999; pointer-events: all; display: flex; align-items: center; justify-content: center;';
        
        // Add loading indicator
        const loadingIndicator = document.createElement('div');
        loadingIndicator.style.cssText = 'background: white; padding: 20px 40px; border-radius: 8px; display: flex; flex-direction: column; align-items: center; gap: 15px;';
        loadingIndicator.innerHTML = `
          <div class="loader btn-loader" style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #0265DC; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          <div style="color: #333; font-size: 16px; font-weight: 500;">${getLabelV2('Submitting your case...')}</div>
        `;
        submitOverlay.appendChild(loadingIndicator);
        
        // Add spin animation if not already in stylesheet
        if (!document.querySelector('#submit-overlay-spin-style')) {
          const style = document.createElement('style');
          style.id = 'submit-overlay-spin-style';
          style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
          document.head.appendChild(style);
        }
        
        appShadowRoot.appendChild(submitOverlay);
      } else {
        submitOverlay.style.display = 'flex';
      }
      if (miloCaseCreateObject.productCode === 'admin_console') {
        miloCaseCreateObject.typeCode = 1;
        miloCaseCreateObject.productCode = '';
      }
      updateOpenTicketPhone();
      let caseCreationResponse;

      
      if(selectedNewProductCode === 'WORKFRONT'){
        caseCreationApiFlowStart = performance.now();
        caseCreationResponse = await createWorkfrontSupportCase({
          ...workfrontCaseCreateObject,
          title: miloCaseCreateObject.title,
          description: miloCaseCreateObject.description,
        });
        caseCreationApiMs = performance.now() - caseCreationApiFlowStart;
      } else if(isCommerce()){

          let commercePlatformDetailsText = `\n\n\n-------------------------------------\n${getLabelV2('INFRA CHANGE SUMMARY')}\n-------------------------------------\n`;


          if (newMetaData.length > 0) {
            newMetaData.forEach(field => {
              if (field.displayName === 'Project ID') {
                commercePlatformDetailsText += `${getLabelV2(COMMERCE_ADDITIONAL_FIELD_LABEL[field.displayName])}: ${field.value || 'N/A'}\n`;
              }
            });
            newMetaData.forEach(field => {
              if (field.displayName === 'Environment') {
                commercePlatformDetailsText += `${getLabelV2(COMMERCE_ADDITIONAL_FIELD_LABEL[field.displayName])}: ${field.value || 'N/A'}\n`;
              }
            });
          }

          if (commercePlatformFieldsData2.length > 0) {
            commercePlatformFieldsData2.forEach(field => {
              let fieldLabel = field.label;
              let fieldValue = field.value;
              if (COMMERCE_ADDITIONAL_FIELD_LABEL[field.label]) {
                fieldLabel = getLabelV2(COMMERCE_ADDITIONAL_FIELD_LABEL[field.label]);
              }
              if (field.value === 'Email Credit Reset') {
                fieldValue = getLabelV2('Email Credit exceeded, please retest.');
              }
              if (field.value === 'Split Architecture') {
                fieldValue = ' ';
              }
              if (field.value === 'Sendgrid Domain Authentication (Pro)') {
                fieldValue = ' ';
              }
              if (field.value === 'Infrastructure services upgrade') {
                fieldValue = getLabelV2('Service Upgrade Request');
              }
              commercePlatformDetailsText += `${fieldLabel}: ${fieldValue || 'N/A'}\n`;
              if (field.value === 'Split Architecture') {
                commercePlatformDetailsText += 'Enable Split Architecture \n';
                commercePlatformDetailsText += 'Unified Sizing: M-288.\n';
              }
              if (field.value === 'Add Custom Logrotate Settings') {
                commercePlatformDetailsText += 'Please change log rotation configuration\n';
              }
              if (field.value === 'PrivateLink Setup') {
                commercePlatformDetailsText += 'Please Setup private link\n';
              }
              if (field.value === 'Sendgrid Domain Authentication (Pro)') {
                commercePlatformDetailsText += 'Please setup the sendgrid domain\n';
              }
              if (field.value === 'Service Restart') {
                commercePlatformDetailsText += 'Please Restart the service\n';
              }
            });
          }

          if (commercePlatformFieldsData3.length > 0) {
            commercePlatformFieldsData3.forEach(field => {
              let fieldLabel = field.label;
              if(field.label === 'Redis/Valkey (Required Version)'){
                console.log('field.value', field.value);
                console.log('field.value number', Number(field.value));
                if(Number(field.value) === 8){
                  fieldLabel = 'Valkey (Required Version)'
                } else{
                  fieldLabel = 'Redis (Required Version)'
                }    
              }
              if (COMMERCE_ADDITIONAL_FIELD_LABEL[field.label]) {
                fieldLabel = COMMERCE_ADDITIONAL_FIELD_LABEL[field.label];
              }
              commercePlatformDetailsText += `${getLabelV2(fieldLabel)}: ${field.value || 'N/A'}\n`;
            });
          }

          if (commercePlatformFieldsData4.length > 0) {
            commercePlatformFieldsData4.forEach(field => {
              let fieldLabel = field.label;
              if (COMMERCE_ADDITIONAL_FIELD_LABEL[field.label]) {
                fieldLabel = COMMERCE_ADDITIONAL_FIELD_LABEL[field.label];
              }
              commercePlatformDetailsText += `${getLabelV2(fieldLabel)}: ${field.value || 'N/A'}\n`;
            });
          }

          if (commercePlatformFieldsData5.length > 0) {
            commercePlatformFieldsData5.forEach(field => {
              let fieldLabel = field.label;
              if (COMMERCE_ADDITIONAL_FIELD_LABEL[field.label]) {
                fieldLabel = COMMERCE_ADDITIONAL_FIELD_LABEL[field.label];
              }
              commercePlatformDetailsText += `${getLabelV2(fieldLabel)}: ${field.value || 'N/A'}\n`
            });
          }


          if (commercePlatformFieldsData2.length) {
            miloCaseCreateObject.description = miloCaseCreateObject.description + '\n' + commercePlatformDetailsText;
          }
        caseCreationApiFlowStart = performance.now();
        caseCreationResponse = await createCommerceMiloSupportCase(miloCaseCreateObject);
        caseCreationApiMs = performance.now() - caseCreationApiFlowStart;
      }else{
        caseCreationApiFlowStart = performance.now();
        caseCreationResponse = await createMiloSupportCase(miloCaseCreateObject);
        caseCreationApiMs = performance.now() - caseCreationApiFlowStart;
      }



      
      if (caseCreationResponse.status === true) {
        const idx = userprofile.interactions.map((i) => i.event).indexOf(SupportCaseSubmit);
        let count = 0;

        if (idx === -1) {
          userprofile.interactions.push({
            event: SupportCaseSubmit,
            origin: 'learning',
            timestamps: [new Date().toISOString()],
          });
          count = 1;
        } else {
          count = userprofile.interactions[idx].timestamps.push(new Date().toISOString());
        }

        await updateProfile('interactions', userprofile.interactions, true);
        o.dispatch(SupportCaseSubmit, count); // eslint-disable-line no-use-before-define
        let caseId;
        if (selectedNewProductCode === 'WORKFRONT') {
          
          caseId = caseCreationResponse.data.id;
          
          if (caseAttachmentsFiles.length > 0) {
            await uploadWorkfrontCaseAttachments(caseId, caseAttachmentsFiles, userprofile);
          }
          submitOverlay = appShadowRoot.querySelector('#submit-overlay');
          if(submitOverlay) {
            submitOverlay.style.display = 'none';
          }

          goToCaseDetailPage(caseId, btnLoader);
        } else {
          caseId = caseCreationResponse.data.caseId;
          if (caseAttachmentsFiles.length > 0) {
            await uploadMiloCaseAttachments(caseId, caseAttachmentsFiles);
          }
          submitOverlay = appShadowRoot.querySelector('#submit-overlay');
          if(submitOverlay) {
            submitOverlay.style.display = 'none';
          }
          goToCaseDetailPage(caseId, btnLoader);
        }
        const caseCreationPassFlowEnd = performance.now();
        emitCaseCreationRelic('PASS', caseCreationPassFlowEnd);
        submitOverlay = appShadowRoot.querySelector('#submit-overlay');
        if(submitOverlay) {
          submitOverlay.style.display = 'none';
        }
        goToCaseDetailPage(caseId, btnLoader);


        // supportProcess(SUPPORT_TABS.OPEN_TICKET);
        window.scrollTo(0, 0);
        notice(caseCreationResponse.msg, true, 3e3, 'positive', 0, true);

        // Track experiment conversion on successful case creation
        widgetExperiment?.trackConversion();

        let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
        if(isWorkFront()){
          analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
        }
        adobeDataLayerTrack({
          event: 'supportFormSuccess',
          supportForm: {
            formStep: 'Form Complete',
            formType: 'support',
            productSelection: selectedNewProductName,
            productSelectionOrder: productSelectionCount.toString(),
            caseTitle:miloCaseCreateObject.title,
            caseDescription:caseDescription,
            step:stepCount.toString(),
            companyName: selectedOrg.name ? selectedOrg.name : '',
            useCasePriority: analyticCasePriority,
            caseId:caseId
          }
        });
      } else {
          const caseCreationFailFlowEnd = performance.now();
          emitCaseCreationRelic(
            'FAIL',
            caseCreationFailFlowEnd,
            `${caseCreationResponse.msg}`,
          );
          submitOverlay = appShadowRoot.querySelector('#submit-overlay');
          if(submitOverlay) {
            submitOverlay.style.display = 'none';
          }

          addClass(btnLoader, 'is-hidden');
          removeClass(btnLoader, 'disabled');
          submitBtn.disabled = false;
        notice(caseCreationResponse.msg, true, 3e3, 'negative', 0, true);
        let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
        if(isWorkFront()){
          analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
        }

        adobeDataLayerTrack({
          event: 'supportFormError',
          supportForm: {
            formStep: '',
            formType: 'support',
            productSelection: selectedNewProductName,
            productSelectionOrder: productSelectionCount.toString(),
            caseTitle:miloCaseCreateObject.title,
            caseDescription:caseDescription,
            step:stepCount.toString(),
            companyName: selectedOrg.name ? selectedOrg.name : '',
            useCasePriority: analyticCasePriority,
            errorMessage:caseCreationResponse.statusCode + '-' + caseCreationResponse.apiMessage
          }
        });
      }
    }, { signal: openTicketSubmitSignal })

    // Fetched templates live under public/assets/views/ — may lag src/html; ensure overlay exists.
    function ensureOpenTicketModeSwitchOverlayMounted() {
      if (appShadowRoot.querySelector('#support-open-ticket-mode-switch-overlay')) {
        return;
      }
      const header = appShadowRoot.querySelector('#new-header-container');
      if (!header) {
        return;
      }
      header.insertAdjacentHTML(
        'afterend',
        '<div id="support-open-ticket-mode-switch-overlay" class="support-open-ticket-mode-switch-overlay is-hidden" aria-hidden="true">' +
          '<div id="support-open-ticket-mode-switch-dialog" class="support-open-ticket-mode-switch-dialog" role="dialog" aria-modal="true" aria-labelledby="support-open-ticket-mode-switch-title" tabindex="-1">' +
          '<div class="support-open-ticket-mode-switch-dialog__icon" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">' +
          '<path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#e68619" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />' +
          '</svg>' +
          '</div>' +
          '<h2 id="support-open-ticket-mode-switch-title" class="support-open-ticket-mode-switch-dialog__title"></h2>' +
          '<p id="support-open-ticket-mode-switch-body" class="support-open-ticket-mode-switch-dialog__body"></p>' +
          '<div class="support-open-ticket-mode-switch-dialog__actions">' +
          '<button type="button" id="support-open-ticket-mode-switch-confirm" class="support-open-ticket-mode-switch-dialog__confirm spectrum-Button spectrum-Button--sizeL"></button>' +
          `<button type="button" id="support-open-ticket-mode-switch-dismiss" class="support-open-ticket-mode-switch-dialog__dismiss spectrum-Button spectrum-Button--sizeL">${getLabelV2('Keep working')}</button>` +
          '</div>' +
          '</div>' +
          '</div>',
      );
    }

    ensureOpenTicketModeSwitchOverlayMounted();

    const aiCurrentHost = window.location.hostname;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = aiCurrentHost === 'experienceleague.adobe.com' ? 'https://di5qpove02emu.cloudfront.net/aura.css' : 'https://dtbjd0dloyr4e.cloudfront.net/aura.css';
    appShadowRoot.appendChild(link);

    let openTicketModeSwitchLastFocus = null;
    let openTicketPendingMode = null;

    function openTicketModeSwitchOnKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeOpenTicketModeSwitchModal(true);
      }
    }

    function closeOpenTicketModeSwitchModal(restoreFocus) {
      const overlay = appShadowRoot.querySelector('#support-open-ticket-mode-switch-overlay');
      if (!overlay || overlay.classList.contains('is-hidden')) {
        return;
      }
      addClass(overlay, 'is-hidden');
      overlay.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', openTicketModeSwitchOnKeydown, true);
      openTicketPendingMode = null;
      if (restoreFocus && openTicketModeSwitchLastFocus && typeof openTicketModeSwitchLastFocus.focus === 'function') {
        openTicketModeSwitchLastFocus.focus();
      }
      openTicketModeSwitchLastFocus = null;
    }

    function openOpenTicketModeSwitchModal(targetMode) {
      ensureOpenTicketModeSwitchOverlayMounted();
      const overlay = appShadowRoot.querySelector('#support-open-ticket-mode-switch-overlay');
      const titleEl = appShadowRoot.querySelector('#support-open-ticket-mode-switch-title');
      const bodyEl = appShadowRoot.querySelector('#support-open-ticket-mode-switch-body');
      const confirmBtn = appShadowRoot.querySelector('#support-open-ticket-mode-switch-confirm');
      if (!overlay || !titleEl || !bodyEl || !confirmBtn) {
        return;
      }

      openTicketModeSwitchLastFocus = appShadowRoot.activeElement;
      openTicketPendingMode = targetMode;
      
      if (targetMode === 'classic') {
        titleEl.textContent = getLabelV2('Switch to Classic Form?');
        bodyEl.textContent =
        getLabelV2("Your current progress won't carry over. Any cases or actions you've already completed will remain intact.");
        confirmBtn.textContent = getLabelV2('Switch to Classic Form');
      } else {
        titleEl.textContent = getLabelV2('Switch to AI Chat?');
        bodyEl.textContent =
        getLabelV2("Your current progress won't carry over. Any cases or actions you've already completed will remain intact.");
        confirmBtn.textContent = getLabelV2('Switch to AI Chat');
      }

      removeClass(overlay, 'is-hidden');
      overlay.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', openTicketModeSwitchOnKeydown, true);
      confirmBtn.focus();
    }

    let onOpenTicketAuraSessionVisibilityCheck = null;

    function teardownOpenTicketAuraSessionWatch() {
      if (!onOpenTicketAuraSessionVisibilityCheck) {
        return;
      }
      document.removeEventListener('visibilitychange', onOpenTicketAuraSessionVisibilityCheck);
      onOpenTicketAuraSessionVisibilityCheck = null;
    }

    function setupOpenTicketAuraSessionWatch() {
      if (onOpenTicketAuraSessionVisibilityCheck) {
        return;
      }
      onOpenTicketAuraSessionVisibilityCheck = () => {
        if (document.visibilityState !== 'visible' || openTicketContactMode !== 'ai') {
          return;
        }
        void validateOpenTicketAiSession().then((valid) => {
          if (!valid) {
            handleOpenTicketAuraSessionExpired(
              'Open ticket AI chat: session expired while tab was in background',
            );
          }
        });
      };
      document.addEventListener('visibilitychange', onOpenTicketAuraSessionVisibilityCheck);
    }

    async function validateOpenTicketAiSession() {
      try {
        await window.imsLoaded;
        if (!window.adobeIMS?.isSignedInUser?.()) {
          return false;
        }
        const accessToken =
          window.adobeIMS.getAccessToken()?.token ||
          window.adobeIMS.getTokenFromStorage()?.token ||
          '';
        return accessToken.length > 0;
      } catch (err) {
        console.error('validateOpenTicketAiSession failed', err);
        return false;
      }
    }

    function resetOpenTicketAuraEmbed() {
      auraInitializedProductCode = '';
      if (auraEmbed?.unmount) {
        try {
          auraEmbed.unmount();
        } catch (e) {
          console.error('Aura unmount error:', e);
        }
      }
      auraEmbed = null;
      const aiChatContainer = appShadowRoot.querySelector('#ai-chat-container');
      if (aiChatContainer) {
        aiChatContainer.innerHTML = '';
      }
    }

    function handleOpenTicketAuraSessionExpired(logMessage) {
      teardownOpenTicketAuraSessionWatch();
      resetOpenTicketAuraEmbed();
      applyOpenTicketClassicMode();
      notifyImsSwitchProfileFailureOnce(
        logMessage || 'Open ticket AI chat: session is no longer valid',
      );
    }

    function updateOpenTicketBreadcrumb() {
      const crumbEl = appShadowRoot.querySelector('.support-new-header__crumb-current');
      if (!crumbEl) {
        return;
      }
      crumbEl.textContent = openTicketContactMode === 'ai'
        ? getLabelV2('Chat with Us')
        : getLabelV2('Open Ticket');
    }

    function syncOpenTicketModeButtonState() {
      const classicBtn = appShadowRoot.querySelector('#support-open-ticket-mode-classic');
      const aiBtn = appShadowRoot.querySelector('#support-open-ticket-mode-ai');
      const isClassic = openTicketContactMode === 'classic';
      classicBtn?.setAttribute('aria-pressed', isClassic ? 'true' : 'false');
      aiBtn?.setAttribute('aria-pressed', isClassic ? 'false' : 'true');
    }

    function showOpenTicketModeSwitchLoader() {
      hideOpenTicketModeSwitchLoader();
      const newOpenTicketContainer = appShadowRoot.querySelector('#new-open-ticket');
      if (!newOpenTicketContainer) {
        return;
      }
      if (getComputedStyle(newOpenTicketContainer).position === 'static') {
        newOpenTicketContainer.style.position = 'relative';
      }
      const overlay = document.createElement('div');
      overlay.id = 'open-ticket-mode-loader-overlay';
      overlay.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; min-height: 100%; background: rgba(255, 255, 255, 0.95); z-index: 999999; pointer-events: all; display: flex; align-items: center; justify-content: center;';
      overlay.innerHTML = '<div class="loader btn-loader" style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #0265DC; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
      if (!document.querySelector('#submit-overlay-spin-style')) {
        const style = document.createElement('style');
        style.id = 'submit-overlay-spin-style';
        style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
        document.head.appendChild(style);
      }
      newOpenTicketContainer.appendChild(overlay);
    }

    function hideOpenTicketModeSwitchLoader() {
      appShadowRoot.querySelector('#open-ticket-mode-loader-overlay')?.remove();
    }

    async function prepareOpenTicketAiMicrophoneAccess() {
      if (!navigator.mediaDevices?.getUserMedia) {
        return;
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        console.warn('Microphone permission was not granted for AI chat speech input.', error);
      }
    }

    function applyOpenTicketClassicMode() {
      teardownOpenTicketAuraSessionWatch();
      openTicketContactMode = 'classic';
      const classicBtn = appShadowRoot.querySelector('#support-open-ticket-mode-classic');
      const aiBtn = appShadowRoot.querySelector('#support-open-ticket-mode-ai');
      addClass(classicBtn, 'selected');
      removeClass(aiBtn, 'selected');
      classicBtn?.setAttribute('aria-pressed', 'true');
      aiBtn?.setAttribute('aria-pressed', 'false');
      addClass(appShadowRoot.querySelector('#ai-chat-container'), 'is-hidden');
      updateOpenTicketBreadcrumb();
      try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
    }
    function getCurrentFormName() {
      let headerElement;
      switch (stepCount) {
        case 1:
          headerElement = appShadowRoot.querySelector("#step-1-header .step-header-label");
          break;
        case 2:
          headerElement = appShadowRoot.querySelector("#step-2-header .step-header-label");
          break;
        case 3:
          headerElement = appShadowRoot.querySelector("#step-3-header .step-header-label");
          break;
        case 4:
        headerElement = appShadowRoot.querySelector("#step-4-header .step-header-label");
        break;
        case 5:
          headerElement = appShadowRoot.querySelector("#step-5-header .step-header-label");
          break;
        default:
          return null;
      }
      
      return headerElement ? headerElement.textContent.trim() : null;
    }
    function getaiChatMessageNumber(aiChatHistory) {
      if (aiChatHistory.length) {
        const firstChat = aiChatHistory[0];
        
        if (firstChat.messages && Array.isArray(firstChat.messages)) {
          return firstChat.messages.filter(msg => msg.sender === 'bot').length;
        }
      }
      return 0; // Return 0 if history is empty or structure is missing
    }
    async function trackAiChatDurationEvent() {
      if (openTicketContactMode !== 'ai') {
        return;
      }
      openTicketContactMode = 'classic';
      const companyEntitlements = await getEntitlementsString();
      const aiChatHistory = window.Aura?.getChatHistory?.() || [];
      const aiChatMessageNumber = getaiChatMessageNumber(aiChatHistory);
      const chatCreatedAt = aiChatHistory?.[0]?.createdAt;
      const aiChatDuration = chatCreatedAt ? Math.round((Date.now() - chatCreatedAt) / 1000) : 0;
      adobeDataLayerTrack({
        "event": "chat_ended",
        "eventType": "web.webInteraction.chatEnded",
        "companyLoginDetails": {
          "companyLoginName": selectedOrg.name,
          "companyLoginID": selectedOrg.id,
          "companyEntitlements": companyEntitlements,
        },
        "link": {
          "linkTitle": "chat duration",
          "linkLocation": "ai chat box",
          "linkType": "button",
          "destinationDomain":window.location.href
        },
        "supportAiChat":{
          productSelection:selectedNewProductName
        },
        "aiChat":{
          "aiChatId":aiChatHistory?.[0]?.userSessionId,
          "aiChatMessageNumber":aiChatMessageNumber,
          "aiChatDuration": aiChatDuration,
        },
      });
    }
    trackOpenTicketAiChatDuration = trackAiChatDurationEvent;
    isOpenTicketAiChatActive = () => openTicketContactMode === 'ai';
    async function applyOpenTicketAiMode() {
      if (!(await validateOpenTicketAiSession())) {
        handleOpenTicketAuraSessionExpired('Open ticket AI chat: session is no longer valid');
        return;
      }

      openTicketContactMode = 'ai';
      removeClass(appShadowRoot.querySelector('#ai-chat-container'), 'is-hidden');
      const classicBtn = appShadowRoot.querySelector('#support-open-ticket-mode-classic');
      const aiBtn = appShadowRoot.querySelector('#support-open-ticket-mode-ai');
      removeClass(classicBtn, 'selected');
      addClass(aiBtn, 'selected');
      classicBtn?.setAttribute('aria-pressed', 'false');
      aiBtn?.setAttribute('aria-pressed', 'true');
      updateOpenTicketBreadcrumb();
      addClass(appShadowRoot.querySelector('.all-step'), 'is-hidden');
      addClass(appShadowRoot.querySelector('.all-step-header'), 'is-hidden');

      const aiChatContainer = appShadowRoot.querySelector('#ai-chat-container');
      if (
        auraEmbed &&
        auraInitializedProductCode !== '' &&
        auraInitializedProductCode === selectedNewProductCode &&
        selectedNewProductCode
      ) {
        window.Aura.openChat({});
        window.Aura.setPanelVisible(true);
        setupOpenTicketAuraSessionWatch();
        return;
      }

      let profileData;
      try {
        profileData = await adobeIMS.getProfile();
        if (!profileData?.userId) {
          handleOpenTicketAuraSessionExpired('Open ticket AI chat: unable to load user profile');
          return;
        }
      } catch (err) {
        console.error('Open ticket AI chat: getProfile failed', err);
        handleOpenTicketAuraSessionExpired('Open ticket AI chat: getProfile failed for stale session');
        return;
      }

      if (!(await validateOpenTicketAiSession())) {
        handleOpenTicketAuraSessionExpired('Open ticket AI chat: session expired during AI chat init');
        return;
      }

      if (
        auraEmbed &&
        auraInitializedProductCode !== '' &&
        auraInitializedProductCode === selectedNewProductCode
      ) {
        window.Aura.openChat({});
        window.Aura.setPanelVisible(true);
        setupOpenTicketAuraSessionWatch();
        return;
      }

      if (!selectedNewProductCode) {
        return;
      }

      let selectedProductFamily = '';
      for (let product of unsortedProductList) {
        if (product.id === selectedNewProductCode) {
          if (product?.familyName) {
            selectedProductFamily = product?.familyName;
          } else {
            selectedProductFamily = product.label;
          }
        }
      }
      console.log('product selectedProductFamily', selectedProductFamily);

      resetOpenTicketAuraEmbed();

      const imsAccessToken =
        window.adobeIMS.getAccessToken()?.token ||
        window.adobeIMS.getTokenFromStorage()?.token ||
        '';
      if (!imsAccessToken) {
        handleOpenTicketAuraSessionExpired('Open ticket AI chat: missing IMS access token');
        return;
      }

      let orgData = await getSelectedOrg();
      let orgDetail = await getSelectedOrg();

      let auraUserId = orgData.userId;
      if(isCommerce()){
        if(orgDetail?.rengaId){
          auraUserId = orgData?.rengaId ? orgData?.rengaId : '';
        }
      }

      auraEmbed = window.Aura.init(
        {
          imsAccessToken,
          orgId: getSelectedOrg().id,
          productCode: selectedNewProductCode,
          productFamily: selectedProductFamily,
          productName: selectedNewProductName,
          licenseId: selectedNewLicenseId,
          surface_locale: locales.get(lang),
          mapped_locale: miloLocales.get(lang),
          host_surface_domain: location.hostname,
          host_surface_name: 'Experience League',
          imsUserProfile: {
            email: profileData.email,
            first_name: profileData.first_name,
            last_name: profileData.last_name,
            language: 'English',
            userId: auraUserId,
          },
          auraClient: {
            initAura: () => {},
            initErrorAura: (msg) => {
              console.error('Aura init error:', msg);
              void validateOpenTicketAiSession().then((valid) => {
                if (!valid) {
                  handleOpenTicketAuraSessionExpired(
                    typeof msg === 'string' ? msg : 'Open ticket AI chat: Aura init failed for stale session',
                  );
                  return;
                }
                notice(
                  getLabelV2('Unable to start AI chat. Please try again.') ||
                    'Unable to start AI chat. Please try again.',
                  true,
                  5000,
                  'negative',
                  0,
                  true,
                );
              });
            },
          },
        },
        aiChatContainer
      );
      window.Aura.openChat({});
      window.Aura.setPanelVisible(true);
      auraInitializedProductCode = selectedNewProductCode;
      setupOpenTicketAuraSessionWatch();
    }

    appShadowRoot.querySelector('#support-open-ticket-mode-classic').addEventListener('click', async(event) => {
      const classicBtn = appShadowRoot.querySelector('#support-open-ticket-mode-classic');
      if (classicBtn.classList.contains('selected')) {
        return;
      }
      // event.preventDefault();
      openOpenTicketModeSwitchModal('classic');
      let currentFormName = getCurrentFormName();
      const companyEntitlements = await getEntitlementsString();
      let aiChatHistory = window.Aura.getChatHistory();
      let aiChatMessageNumber = getaiChatMessageNumber(aiChatHistory);
      adobeDataLayerTrack({
        "event": "linkClicked",
        "eventType": "web.webInteraction.linkclicks",
        "companyLoginDetails": {
          "companyLoginName": selectedOrg.name,
          "companyLoginID": selectedOrg.id,
          "companyEntitlements": companyEntitlements,
        },
        "link": {
          "linkTitle": "Classic form toggled",
          "linkLocation": `ai chat box`,
          "linkType": "button",
          "destinationDomain":window.location.href
        },
        "supportAiChat":{
          productSelection:selectedNewProductName
        },
        "aiChat":{
          "aiChatId":aiChatHistory?.[0]?.userSessionId,
          "aiChatMessageNumber":aiChatMessageNumber,
        },
      });
    });

    appShadowRoot.querySelector('#support-open-ticket-mode-ai').addEventListener('click', async (event) => {   
      const aiBtn = appShadowRoot.querySelector('#support-open-ticket-mode-ai');
      if (aiBtn.classList.contains('selected')) {
        return;
      }
      console.log('line 5472');
      
      // event.preventDefault();
      openOpenTicketModeSwitchModal('ai');
      let currentFormName = getCurrentFormName();
      let aiChatHistory = window.Aura.getChatHistory();
      let aiChatMessageNumber = getaiChatMessageNumber(aiChatHistory);
      const companyEntitlements = await getEntitlementsString();
      adobeDataLayerTrack({
        "event": "linkClicked",
        "eventType": "web.webInteraction.linkclicks",
        "companyLoginDetails": {
          "companyLoginName": selectedOrg.name,
          "companyLoginID": selectedOrg.id,
          "companyEntitlements": companyEntitlements,
        },
        "link": {
          "linkTitle": "Chat with ai beta toggled",
          "linkLocation": `Open Ticket - ${currentFormName}`,
          "linkType": "button",
          "destinationDomain":window.location.href
        },
        "supportAiChat":{
          productSelection:selectedNewProductName
        },
        "aiChat":{
         "aiChatId":aiChatHistory?.[0]?.userSessionId,
          "aiChatMessageNumber":aiChatMessageNumber,
        },
      });
    });

    syncOpenTicketModeButtonState();
    applyOpenTicketClassicMode();

    const modeSwitchOverlay = appShadowRoot.querySelector('#support-open-ticket-mode-switch-overlay');
    modeSwitchOverlay?.addEventListener('click', (e) => {
      if (e.target === modeSwitchOverlay) {
        closeOpenTicketModeSwitchModal(true);
      }
    });
    appShadowRoot.querySelector('#support-open-ticket-mode-switch-dismiss')?.addEventListener('click', async() => {
      const mode = openTicketPendingMode;
      closeOpenTicketModeSwitchModal(true);
      const companyEntitlements = await getEntitlementsString();
      let aiChatHistory = window.Aura.getChatHistory();
      let aiChatMessageNumber = getaiChatMessageNumber(aiChatHistory);
      let currentFormName = getCurrentFormName();
      let linkLocation = '';
      if (mode === 'classic') {
        linkLocation = 'ai chat box';
      } else if (mode === 'ai') {
        linkLocation = `Open Ticket - ${currentFormName}`;
      }
      adobeDataLayerTrack({
        "event": "linkClicked",
        "eventType": "web.webInteraction.linkclicks",
        "companyLoginDetails": {
          "companyLoginName": selectedOrg.name,
          "companyLoginID": selectedOrg.id,
          "companyEntitlements": companyEntitlements,
        },
        "link": {
          "linkTitle": "Keep working",
          "linkLocation": linkLocation,
          "linkType": "button",
          "destinationDomain":window.location.href
        },
        "supportAiChat":{
          productSelection:selectedNewProductName
        },
        "aiChat":{
          "aiChatId":aiChatHistory?.[0]?.userSessionId,
          "aiChatMessageNumber":aiChatMessageNumber,
        },
      });
    });
    appShadowRoot.querySelector('#support-open-ticket-mode-switch-confirm')?.addEventListener('click', async () => {
      const mode = openTicketPendingMode;
      closeOpenTicketModeSwitchModal(false);
      const companyEntitlements = await getEntitlementsString();
      let aiChatHistory = window.Aura.getChatHistory();
      let aiChatMessageNumber = getaiChatMessageNumber(aiChatHistory);
      if (mode === 'classic') {
        if (isOpenTicketAiChatActive()) {
          await trackAiChatDurationEvent();
        }
        removeClass(appShadowRoot.querySelector('#ticket-status-area'), 'is-hidden');
        applyOpenTicketClassicMode();
        void updateOpenTicketAiChatPreference(false);
        adobeDataLayerTrack({
          "event": "linkClicked",
          "eventType": "web.webInteraction.linkclicks",
          "companyLoginDetails": {
            "companyLoginName": selectedOrg.name,
            "companyLoginID": selectedOrg.id,
            "companyEntitlements": companyEntitlements,
          },
          "link": {
            "linkTitle": "Switch to classic form",
            "linkLocation": "ai chat box",
            "linkType": "button",
          "destinationDomain":window.location.href
          },
          "supportAiChat":{
            productSelection:selectedNewProductName
          },
          "aiChat":{
            "aiChatId":aiChatHistory?.[0]?.userSessionId,
            "aiChatMessageNumber":aiChatMessageNumber,
          },
        });
      } else if (mode === 'ai') {
        let currentFormName  = getCurrentFormName();
        addClass(appShadowRoot.querySelector('#ticket-status-area'), 'is-hidden');
        await prepareOpenTicketAiMicrophoneAccess();
        await applyOpenTicketAiMode();
        void updateOpenTicketAiChatPreference(true);
        adobeDataLayerTrack({
          "event": "linkClicked",
          "eventType": "web.webInteraction.linkclicks",
          "companyLoginDetails": {
            "companyLoginName": selectedOrg.name,
            "companyLoginID": selectedOrg.id,
            "companyEntitlements": companyEntitlements,
          },
          "link": {
            "linkTitle": "Switch to ai form",
            "linkLocation": `Open Ticket - ${currentFormName}`,
            "linkType": "button",
            "destinationDomain":window.location.href
          },
          "supportAiChat":{
            productSelection:selectedNewProductName
          },
          "aiChat":{
            "aiChatId":aiChatHistory?.[0]?.userSessionId,
            "aiChatMessageNumber":aiChatMessageNumber,
          },
        });
      }
    });
    function coveoAnalyticsSuggestionClick(data) {
      window.coveoua('svc:setAction', 'suggestion_click', {
        suggestionId: data.suggestionId,
        responseId: data.responseId,
        suggestion: {
          documentUri: data.documentUri,
          documentUriHash: data.documentUriHash,
          documentUrl: data.documentUri,
          documentTitle: data.documentTitle,
          documentPosition: +data.documentPosition,
        },
      });
      window.coveoua('svc:setTicket', {
        subject: miloCaseCreateObject.title,
        description: miloCaseCreateObject.description,
      });
      window.coveoua('send', 'event', 'svc', 'documentOpen', {
        searchHub: CoveoSearchHubCaseAssist,
      });
    }


    // Prepare Product List
    let productListHTML = '';
    if (!isWorkFront() && !isCommerce()) {
      products.unshift({
        id: 'admin_console',
        label: 'Admin Console',
        type: 'ADMINISTRATION'
      });
    }
    
    for (const product of products) {
      productListHTML += views.get('support-products-item')(product);
    }
    $llel.productPicker.innerHTML = productListHTML;

    function debounceTitle(func, delayTitle) {
      let debounceTimer;

      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delayTitle);
      };
    }

    async function getCoveoCaseAssistArticles(perPage) {
      try {
        const contextProduct = (selectedNewProductName.match(/^[^-]+/) || [])[0].trim() || selectedNewProductName;
        const caseDetails = {
          fields: {
            subject: {
              value: '',
            },
            description: {
              value: '',
            },
          },
          context: {
            product: contextProduct,
          },
          searchHub: "Experience League Learning Hub",
          locale: coveoLangMapping[lang],
          numberOfResults: perPage
        };
        if (miloCaseCreateObject.title) {
          caseDetails.fields.subject.value = miloCaseCreateObject.title;
        }

        let formCaseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
        if (formCaseDescriptionInput.value) {
          caseDetails.fields.description.value = formCaseDescriptionInput.value;
        }
        const lcoveoCaseAssistUrl = new URL(coveoCaseAssistUrl);
        let coveo_token = import.meta.env.VITE_COVEO_TOKEN;
        const requestOption = {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: `Bearer ${coveo_token}`,
          },
          body: JSON.stringify(caseDetails),
        };

        const res = await request(lcoveoCaseAssistUrl.href, {
          ...requestOption,
        });
        const data = await res.json();

        if (res.ok) {
          return {
            items: data.results instanceof Array && data.results.length > 0 ? data.results : [],
            totalRecords: data.totalCount ? data.totalCount : 0,
            responseId: data.responseId ? data.responseId : '',
          };
        }

        return {
          items: [],
          totalRecords: 0,
          responseId: '',
        };
      } catch (e) {
        // addClass(appShadowRoot.querySelector('#support-openticket-relatedarticles'), 'is-hidden')
        // removeClass(appShadowRoot.querySelector('#support-openticket-noresult'), 'is-hidden')
        log('Failed to retrieve items for Case Assist');
        log(e.message, 'warn');
        console.error('error', e);
        

        return {
          items: [],
          totalRecords: 0,
          responseId: '',
        };
      }
    }


    async function setCaseAssistView() {
      const coveoSearch = appShadowRoot.querySelector('#support-openticket-relatedarticles');
      const noResultDiv = appShadowRoot.querySelector('#support-openticket-noresult');
      const feedbackDiv = appShadowRoot.querySelector('#feedback-before-submit');
      const readyToHelpEl = appShadowRoot.querySelector('.ready-to-help');
      const lookingIntoItEl = appShadowRoot.querySelector('.recomend-container .looking-into-it');
      const recomendContainerEl = appShadowRoot.querySelector('.recomend-container');
      const coveoResultsWrap = appShadowRoot.querySelector('.coveo-results');

      // Same UX as Gen AI path: "Generating recommendations" + animated dots, centered (see .coveo-loading-recommendations).
      addClass(noResultDiv, 'is-hidden');
      addClass(feedbackDiv, 'is-hidden');
      if (readyToHelpEl) addClass(readyToHelpEl, 'is-hidden');
      if (lookingIntoItEl) removeClass(lookingIntoItEl, 'is-hidden');
      if (recomendContainerEl) addClass(recomendContainerEl, 'coveo-loading-recommendations');
      if (coveoResultsWrap) addClass(coveoResultsWrap, 'is-hidden');
      // $llel.relatedArticlesList.innerHTML = '';

      const suggestionData = await getCoveoCaseAssistArticles(caseAssistArticlesPerPage);
      let listHtml = '';

      
      if (suggestionData.items.length) {
        suggestionData.items.forEach((item, indx) => {
          const type =
            item.fields && item.fields.contenttype && item.fields.contenttype.length ? item.fields.contenttype[0] : '';
          const solution =
            item.fields && item.fields.el_product && item.fields.el_product.length ? item.fields.el_product[0] : '';
          const suggestionId = item.fields && item.fields.permanentid ? item.fields.permanentid : '';
          const documentUriHash = item.fields && item.fields.urihash ? item.fields.urihash : '';

          listHtml += views.get('support-case-assit-view')({
            solution,
            type,
            title: item.title,
            clickUri: item.clickUri,
            documentUri: item.clickUri,
            documentUriHash,
            excerpt: item.excerpt,
            index: indx + 1,
            suggestionId,
            responseId: suggestionData.responseId,
          });
        });
        removeClass(coveoSearch, 'is-hidden')
        addClass(noResultDiv, 'is-hidden')

        if (caseAssistArticlesPerPage >= suggestionData.totalRecords) {
          if (!$llel.loaderMoreSec.classList.contains('is-hidden')) {
            $llel.loaderMoreSec.classList.add('is-hidden');
          }
        } else {
          $llel.loaderMoreSec.classList.remove('is-hidden');
        }
      } else {
        listHtml += views.get('support-case-assit-empty')();
        if (!$llel.loaderMoreSec.classList.contains('is-hidden')) {
          $llel.loaderMoreSec.classList.add('is-hidden');
        }
        
        addClass(coveoSearch, 'is-hidden')
        removeClass(noResultDiv, 'is-hidden')
        // addClass(appShadowRoot.querySelector('#support-openticket-relatedarticles'), 'is-hidden')
        // removeClass(appShadowRoot.querySelector('#support-openticket-noresult'), 'is-hidden')
      }
      $llel.relatedArticlesList.innerHTML = listHtml;

      if (lookingIntoItEl) addClass(lookingIntoItEl, 'is-hidden');
      if (recomendContainerEl) removeClass(recomendContainerEl, 'coveo-loading-recommendations');
      if (coveoResultsWrap) removeClass(coveoResultsWrap, 'is-hidden');

      $llel.relatedArticlesList.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          const requestObj = {};
          requestObj.suggestionId = link.getAttribute('data-suggestionId'); // @todo fix casing and utilize .dataset directly
          requestObj.responseId = link.getAttribute('data-responseId');
          requestObj.documentUri = link.getAttribute('data-documentUri');
          requestObj.documentPosition = link.getAttribute('data-documentPosition');
          requestObj.documentUriHash = link.getAttribute('data-documentUriHash');
          requestObj.documentTitle = link.innerHTML;

          coveoAnalyticsSuggestionClick(requestObj);
        });
      });

      let coveoArticlesContainer = appShadowRoot.querySelector('#support-openticket-relatedarticles');



        if(coveoArticlesContainer?.querySelectorAll('a').length){

          coveoArticlesContainer.querySelectorAll('a').forEach((element)=>{


            element.addEventListener('click', ()=>{
              let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
              if(isWorkFront()){
                analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
              }
              adobeDataLayerTrack({
                event: 'clickSupportLink',
                "supportForm": {
                  formStep: "",
                  formType: "support",
                  productSelection: selectedNewProductName,
                  productSelectionOrder: productSelectionCount.toString(),
                  caseTitle: miloCaseCreateObject.title,
                  caseDescription: miloCaseCreateObject.description,
                  step: stepCount.toString(),
                  companyName: selectedOrg.name || '',
                  useCasePriority: analyticCasePriority,
                  link:
                    {
                      title: element.innerText,
                      url: element.href
                    }
                },
              });
            })
            
          })
        }
      return suggestionData.length;
        
    }

    $llel.loaderMore.addEventListener('click', () => {
      log('support open case load more click');
      caseAssistArticlesPerPage += 5;
      if (caseAssistArticlesPerPage <= 40) {
        setCaseAssistView();
      } else if (!$llel.loaderMoreSec.classList.contains('is-hidden')) {
        $llel.loaderMoreSec.classList.add('is-hidden');
      }
    });
    function syncCommerceStageEnvironmentNameField(envLabel) {
      const container = appShadowRoot?.getElementById('commerce-stage-environment-field');
      if (!container) return;

      const showField = isCommerce()
        && String(miloCaseCreateObject.issueReasonCode) === '313'
        && ['STAGE', 'STAGING'].includes(String(envLabel || '').trim().toUpperCase());

      if (!showField) {
        container.innerHTML = '';
        commerceStageEnvironmentName = '';
        return;
      }

      renderFieldsPicker('commerce-stage-environment-field', COMMERCE_STAGE_ENVIRONMENT_NAME, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
      const input = appShadowRoot?.querySelector('#support-commerce-stage-environment-name input');
      if (!input || input.__stageEnvBound) return;
      input.__stageEnvBound = true;
      const sync = () => {
        commerceStageEnvironmentName = input.value.trim();
        try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
      };
      input.addEventListener('input', sync);
      input.addEventListener('keyup', sync);
    }

    function prepareFormPicker(arg, type) {
      const pickerMainEl = appShadowRoot.querySelector(`#${arg}`);
      const pickerElement = pickerMainEl.querySelector('.adobe-exl-picker');
      const pickerElementOptions = pickerMainEl.querySelector('.adobe-exl-pickerOptions');

      const chevronDown = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
        <defs>
          <style>
            .fill {
              fill: #464646;
            }
          </style>
        </defs>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z" />
      </svg>`;
      pickerElement.addEventListener('click', (event) => {
        log('Form picker clicked');
        event.stopPropagation();
        event.preventDefault();
        const pickerButton = pickerMainEl.querySelector('.spectrum-Picker');
        const allDropdown = appShadowRoot.querySelectorAll('.adobe-exl-pickerOptions');
        // Filter out the clicked element
        const dropdowns = Array.from(allDropdown).filter((el) => el !== pickerElementOptions);
        dropdowns.forEach((dropdown) => {
          // close extra drop down
          if (dropdown.classList.contains('is-open')) {
            dropdown.classList.remove('is-open');
          }
        });

        if (pickerElementOptions.classList.contains('is-open')) {
          pickerElementOptions.classList.remove('is-open');
          pickerButton.lastElementChild.outerHTML = chevronDown;
          log(`Form picker closed (#${arg})`);
        } else {
          pickerElementOptions.classList.add('is-open');
          pickerButton.lastElementChild.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
            <defs>
              <style>
                .fill {
                  fill: #464646;
                }
              </style>
            </defs>
            <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z" />
          </svg>`;
          log(`Form picker opend (#${arg})`);
        }
      });
      pickerElementOptions.querySelectorAll('li').forEach((listItem) => {
        listItem.addEventListener('click', async (event) => {
          log('Form picker option clicked');
          const selectedValue = listItem.getAttribute('data-id');
          const selectedLabel = listItem.getAttribute('data-label');
          const selectedLicenseId = listItem.getAttribute('data-licenseId');
          const pickerButton = pickerMainEl.querySelector('.spectrum-Picker');
          const pickerLabelEl = pickerButton?.querySelector('.spectrum-Picker-label');
          event.stopPropagation();
          // One label node: update text, clear placeholder, and persist selected-value together so step-2 checks
          // pass on the first option pick (avoids split updates via stale pickerTextElement vs pickerSpan refs).
          if (pickerLabelEl) {
            pickerLabelEl.textContent = selectedLabel || '';
            pickerLabelEl.classList.remove('is-placeholder');
          }
          if (pickerButton) {
            pickerButton.setAttribute('selected-value', selectedValue != null ? String(selectedValue) : '');
          }
          if (pickerButton?.lastElementChild) {
            pickerButton.lastElementChild.outerHTML = chevronDown;
          }

          const selectedElement = pickerElementOptions.querySelector('li.is-selected');
          if (selectedElement) {
            selectedElement.classList.remove('is-selected');
          }
          listItem.classList.add('is-selected');
          pickerElementOptions.classList.remove('is-open');

          if (type === 'support-product-priority' || type === 'support-product-impact') {
            if (selectedElement) {
              selectedElement.classList.remove('is-selected');
            }
            listItem.classList.add('is-selected');
          }

          workFrontFormFields?.forEach((field) => {
            if (type === field.id) {
              workfrontCaseCreateObject[field.id] = selectedValue;

            if(stepCount === 2){
              if(workfrontCaseCreateObject.Case_Product__c && workfrontCaseCreateObject.Environment__c && workfrontCaseCreateObject.Product_Area__c){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
              else{
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true; 
              }
            }
            if(stepCount === 3){
              if(workfrontCaseCreateObject.Priority){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
              else{
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true; 
              }
            }
            if(stepCount === 4){
              if(workfrontCaseCreateObject.Customer_Region__c){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
              else{
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true; 
              }
            }
              
            }
          });

          if (type === 'support-product-picker') {
            appShadowRoot.getElementById('metadata-fields').innerHTML = '';
            appShadowRoot.getElementById('description-fields').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field2').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field3').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
            appShadowRoot.getElementById('ims-commerce-additional-field').innerHTML = '';
            appShadowRoot.getElementById('commerce-stage-environment-field').innerHTML = '';
            commerceStageEnvironmentName = '';
            mileAdditionalFieldsData = [];
            newMetaData = [];
            miloCaseCreateObject.priorityCode = '';
            miloCaseCreateObject.impactCode = '';
            impactCodeFromApiFailed = false;
            miloCaseCreateObject.issueReasonCode = '';
            miloCaseCreateObject.ccEmailList = [];
            miloCaseCreateObject.phone = '';
            miloCaseCreateObject.optInCountryCode = '';
            miloCaseCreateObject.smsOptIn = false;
            miloCaseCreateObject.whatsappOptIn = false;
            miloCaseCreateObject.timezone = '';
            browserTimezoneAppliedFromDescription = false;
            timezoneSelectionIsUserOverride = false;
            selectedProduct = selectedValue;
            selectedProductName = selectedLabel;
            getWorkFrontFormFields(selectedValue); // eslint-disable-line no-use-before-define
            getCommerceField(selectedValue); // eslint-disable-line no-use-before-define
            miloCaseCreateObject.productCode = selectedValue;
            miloCaseCreateObject.licenseId = selectedLicenseId;
            $llel.formCaseTitleInput.placeholder = `${getLabelV2("What's going on in")} ${selectedLabel}?`;
            $llel.articalProduct.innerText = selectedLabel;
            $llel.formCaseTitle.classList.remove('is-hidden');
            // $llel.needSection.classList.add('is-hidden');
            $lel.progressBar.classList.remove('is-hidden');
            // $llel.articlesSection.classList.remove('is-hidden');
            $llel.commonTopicsSection.classList.add('is-hidden');
          try {
            loadSwatData(selectedValue);
          } catch (e) {
            // swallow errors for SWAT data fetch to not block form
          }
            if (selectedValue === 'WORKFRONT') {
              if ($llel.workfrontContactDetails.classList.contains('is-hidden')) {
                $llel.workfrontContactDetails.classList.remove('is-hidden');
              }
            } else if (!$llel.workfrontContactDetails.classList.contains('is-hidden')) {
              $llel.workfrontContactDetails.classList.add('is-hidden');
            }

            if (selectedValue !== 'WORKFRONT') {
              if (isCommerce()) {
                // eslint-disable-next-line no-use-before-define
                await getCommerceIssueReasonField(selectedValue);
              } else {
                // eslint-disable-next-line no-use-before-define
                await getIssueReasonField(selectedValue);
              }
            }
            await getEccField(); // eslint-disable-line no-use-before-define
            isImsCommerce = false
            if (selectedValue === 'dx_a_commerce_cloudsrvc_support' || selectedValue === 'dx_a_commerce_aco_support' || selectedValue === 'dx_a_commerce_cloudsrvc_ms_support'){
              isImsCommerce = true;
              getProductMetadataV2();
            } else{
              if (isCommerce()) {
                // eslint-disable-next-line no-use-before-define
                getCommerceProductMetadata();
              } else {
                // eslint-disable-next-line no-use-before-define
                getProductMetadata();
              }
            }

            caseAssistArticlesPerPage = 5;
            // setCaseAssistView();
            const selectedTicketProduct = appShadowRoot.querySelector('#selected-ticket-product').textContent;
            for (const product of productsList) {
              if (product.productCode === selectedNewProductCode) {
                getTicketDetailsforOpenTicketSection(product.productId, product.type, product.id);
              }
            }
            if (
              selectedValue.toLowerCase().startsWith('mkto_') ||
              selectedValue.toLowerCase().includes('dx_genstudio_support') ||
              selectedValue.toLowerCase().startsWith('amm_')
            ) {
              if ($llel.showIssueList.classList.contains('is-hidden')) {
                $llel.showIssueList.classList.remove('is-hidden');
              }
              if ($llel.showTicketDes.classList.contains('is-hidden')) {
                $llel.showTicketDes.classList.remove('is-hidden');
              }
              // if ($llel.addAttachment.classList.contains('is-flex')) {
              //   $llel.addAttachment.classList.remove('is-flex');
              // }
            } else {
              if (!$llel.showIssueList.classList.contains('is-hidden')) {
                $llel.showIssueList.classList.add('is-hidden');
              }
              if (!$llel.showTicketDes.classList.contains('is-hidden')) {
                $llel.showTicketDes.classList.add('is-hidden');
              }
              // if (!$llel.addAttachment.classList.contains('is-flex')) {
              //   $llel.addAttachment.classList.add('is-flex');
              // }
            }
          }
          
          
          if (type === 'support-product-impact') {
            miloCaseCreateObject.impactCode = selectedValue;
            // Update Next button state when Business Impact is selected
            // If we're on step 3 and priority is already selected, enable Next button immediately
            if(stepCount === 3){
              if(miloCaseCreateObject.priorityCode && (
                !hasImpactField || 
                (hasImpactField && miloCaseCreateObject.impactCode)
              )){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          } else if (type === 'support-product-environment') {
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Environment');
            newMetaData.push({
              displayName: 'Environment',
              code: selectedValue,
              value: selectedLabel,
            });
            syncCommerceStageEnvironmentNameField(selectedLabel);
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }

            if (commercePlatformFieldsData2[0]?.value) {
              if (commercePlatformFieldsData2[0]?.value === 'Infrastructure services upgrade' && selectedLabel === 'PRODUCTION') {
                renderFieldsPicker('commerce-additional-field4', COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
                COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME.forEach(field => {
                  commercePlatformFieldsData4.push({ // eslint-disable-line no-loop-func
                    label: field.label,
                    id: field.id
                  });
                });
                setupCommercePlatformUpgradeField({ idValue: 'support-commerce-platform-upgrade-scheduled-at', label: 'Enter valid Scheduled Time', fieldsType: 'commercePlatformFieldsData4' }); // eslint-disable-line no-use-before-define
              } else {
                appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
                commercePlatformFieldsData4 = [];
              }
            }
          } else if (type === 'commerce-support-product-environment' || type === 'support-product-v2-environment') {
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Environment');
            newMetaData.push({
              displayName: 'Environment',
              code: selectedValue,
              value: selectedLabel,
            });
            syncCommerceStageEnvironmentNameField(selectedLabel);
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          } else if (type === 'commerce-support-product-productVersion') {
            
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Product Version');
            miloCaseCreateObject.productMetadata.versionId = selectedValue;
            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            
            newMetaData.push({
              displayName: 'Product Version',
              code: selectedValue,
              value: selectedLabel,
            });


            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            console.log('commercePlatformFieldsData2', commercePlatformFieldsData2);

            let redis_valkey = appShadowRoot?.getElementById('support-commerce-platform-upgrade-redis-required');
 

if (commercePlatformFieldsData2.length && commercePlatformFieldsData2[0].value === 'Infrastructure services upgrade') {
              // if (compareVersions(selectedLabel, '2.4.8') >= 0) {
              //   redis_valkey.getElementsByTagName('label')[0].innerText = 'Valkey (Required Version)';
              //   COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1;
              //   for (let field of commercePlatformFieldsData3) {
              //     if (field.id === 'support-commerce-platform-upgrade-redis-required') {
              //       field.label = 'Valkey (Required Version)';
              //     }
              //   }
              // } else {
              //   redis_valkey.getElementsByTagName('label')[0].innerText = 'Redis (Required Version)';
              //   COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2;
              //   for (let field of commercePlatformFieldsData3) {
              //     if (field.id === 'support-commerce-platform-upgrade-redis-required') {
              //       field.label = 'Redis (Required Version)';
              //     }
              //   }
              // }
              let commerceFieldsArray = []
              console.log('newMeta.value', selectedLabel);
              if(selectedLabel === '2.4.4 and older (unsupported)'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_4
              } else if(selectedLabel === '2.4.5'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_5
              } else if(selectedLabel === '2.4.6'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_6
              } else if(selectedLabel === '2.4.7'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_7
              } else if(selectedLabel === '2.4.8'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8
              } else if(selectedLabel === '2.4.9'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_9
              } else if(selectedLabel === 'Alpha/Beta'){
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8
              } else{
                commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1
              }
                appShadowRoot.getElementById('commerce-additional-field3').innerHTML = ''; 
                commercePlatformFieldsData3 = []; 
                renderFieldsPicker('commerce-additional-field3', commerceFieldsArray, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
                commerceFieldsArray.forEach(field => {
                  commercePlatformFieldsData3.push({
                    label: field.label,
                    id: field.id
                  });
                });
            }

            miloCaseCreateObject.productMetadata.versionId = selectedValue;
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          } else if (type === 'support-issue-reason') {
            miloCaseCreateObject.issueReasonCode = selectedValue;
            if (isCommerce()) {
              if (String(selectedValue) === '313') {
                renderFieldsPicker('commerce-additional-field2', COMMERCE_INFRA_CHANGE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define

                commercePlatformFieldsData2 = [];
                commercePlatformFieldsData3 = [];
                commercePlatformFieldsData4 = [];
                commercePlatformFieldsData5 = [];
                COMMERCE_INFRA_CHANGE.forEach(field => {
                  commercePlatformFieldsData2.push({
                    label: field.label,
                    id: field.id
                  });
                });
                syncCommerceStageEnvironmentNameField(newMetaData.find((m) => m.displayName === 'Environment')?.value);
              } else {
                commercePlatformFieldsData2 = [];
                commercePlatformFieldsData3 = [];
                commercePlatformFieldsData4 = [];
                commercePlatformFieldsData5 = [];
                appShadowRoot.getElementById('commerce-additional-field2').innerHTML = '';
                appShadowRoot.getElementById('commerce-additional-field3').innerHTML = '';
                appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
                appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
                syncCommerceStageEnvironmentNameField('');
              }
            } else { 
              commercePlatformFieldsData2 = [];
              commercePlatformFieldsData3 = [];
              commercePlatformFieldsData4 = [];
              commercePlatformFieldsData5 = [];
              appShadowRoot.getElementById('commerce-additional-field2').innerHTML = '';
              appShadowRoot.getElementById('commerce-additional-field3').innerHTML = '';
              appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
              appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
              syncCommerceStageEnvironmentNameField('');
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          } else if(type === 'env-description-field'){  
            newDescriptionEnvObject.environment = selectedLabel;
            // Update Next button state when Environment field value changes
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          } else{            
            // add all metadata value in the metadata array for dropdown
            for (let newMeta of newMetaData){
              if(newMeta.id === type){
                newMeta.code = selectedValue;
                newMeta.value = selectedLabel;
                // delete newMeta.id
              }
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }

          }

          
          if (type === 'support-commerce-platform-infra-change') {
            appShadowRoot.getElementById('commerce-additional-field3').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
            commercePlatformFieldsData3 = [];
            commercePlatformFieldsData4 = [];
            commercePlatformFieldsData5 = [];
            if (selectedValue === '3') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_SPLIT_ARCHITECTURE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_SPLIT_ARCHITECTURE.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '4') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_SEND_GRID_DOMAIN_AUTHENTICATION, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_SEND_GRID_DOMAIN_AUTHENTICATION.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '5') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_PRIVATE_LINK_SETUP, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_PRIVATE_LINK_SETUP.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '6') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_ADD_CUSTOM_LOGRATE_SETTING, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_ADD_CUSTOM_LOGRATE_SETTING.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '7') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_DOMAIN_UPDATE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_DOMAIN_UPDATE.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '8') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_DISABLING_EMAIL, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_DISABLING_EMAIL.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '10') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_CREATE_READ_ONLY_USER, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_CREATE_READ_ONLY_USER.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '11') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_DISK_STORAGE_INCREASE_REQUEST, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_DISK_STORAGE_INCREASE_REQUEST.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '12') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_SSH_LOGS, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_SSH_LOGS.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '13') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_SERVICE_RESTART, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_SERVICE_RESTART.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '14') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_DATABASE_SNAPSHOT_RETRIEVAL, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              appShadowRoot.querySelector('#support-commerce-platform-database-snapshot-retrieval-anchor').innerText = getLabelV2('Refer Backup Retention Policy for the available Snapshot. In case the snap shot for the entered time period is not available, we will retrieve the closest available one.')
              COMMERCE_DATABASE_SNAPSHOT_RETRIEVAL.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '15') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_TEMPORARY_CLOUD_UPSIZE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_TEMPORARY_CLOUD_UPSIZE.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '16') {
              renderFieldsPicker('commerce-additional-field3', COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE.forEach(field => {
                commercePlatformFieldsData3.push({
                  label: field.label,
                  id: field.id
                });
                
              });
             for (let newMeta of newMetaData) {
                if (newMeta.displayName === 'Product Version') {
                  console.log('newMeta.value', newMeta.value);
                  // if(newMeta.value === '2.4.6'){
                  //   appShadowRoot.getElementById('commerce-additional-field3').innerHTML = ''; 
                  //   commercePlatformFieldsData3 = []; 
                  //   renderFieldsPicker('commerce-additional-field3', COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_3, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
                  //   COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_3.forEach(field => {
                  //     commercePlatformFieldsData3.push({
                  //       label: field.label,
                  //       id: field.id
                  //     });
                  //   });
                  // }
                  let commerceFieldsArray = []
                  if(newMeta.value === '2.4.4 and older (unsupported)'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_4
                  } else if(newMeta.value === '2.4.5'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_5
                  } else if(newMeta.value === '2.4.6'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_6
                  } else if(newMeta.value === '2.4.7'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_7
                  } else if(newMeta.value === '2.4.8'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8
                  } else if(newMeta.value === '2.4.9'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_9
                  } else if(newMeta.value === 'Alpha/Beta'){
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_2_4_8
                  } else{
                    commerceFieldsArray = COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_1
                  }
                  appShadowRoot.getElementById('commerce-additional-field3').innerHTML = ''; 
                  commercePlatformFieldsData3 = []; 
                  renderFieldsPicker('commerce-additional-field3', commerceFieldsArray, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
                  commerceFieldsArray.forEach(field => {
                    commercePlatformFieldsData3.push({
                      label: field.label,
                      id: field.id
                    });
                  });

                }
                if (newMeta.displayName === 'Environment') {
                  if (newMeta.value === 'PRODUCTION') {
                    renderFieldsPicker('commerce-additional-field4', COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
                    COMMERCE_INFRASTRUCTURE_SERVICE_UPGRADE_TIME.forEach(field => { // eslint-disable-line no-loop-func
                      commercePlatformFieldsData4.push({ // eslint-disable-line no-loop-func
                        label: field.label,
                        id: field.id
                      });
                    });
                    setupCommercePlatformUpgradeField({ idValue: 'support-commerce-platform-upgrade-scheduled-at', label: 'Enter valid Scheduled Time', fieldsType: 'commercePlatformFieldsData4' }); // eslint-disable-line no-use-before-define
                  } else {
                    appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
                    commercePlatformFieldsData4 = [];
                  }
                }
              }
            }
              
            for (let field of commercePlatformFieldsData2) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }

          if (type === 'support-commerce-platform-up-size-architecture') {
            commercePlatformFieldsData4 = [];
            commercePlatformFieldsData5 = [];
            appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
            if (selectedValue === '2') {
              renderFieldsPicker('commerce-additional-field4', COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT.forEach(field => {
                commercePlatformFieldsData4.push({
                  label: field.label,
                  id: field.id
                });
              });

            } else if (selectedValue === '1') {
              renderFieldsPicker('commerce-additional-field4', COMMERCE_TEMPORARY_CLOUD_UPSIZE_SCALED, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_TEMPORARY_CLOUD_UPSIZE_SCALED.forEach(field => {
                commercePlatformFieldsData4.push({
                  label: field.label,
                  id: field.id
                });
              });
            }
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
            if (type === 'support-commerce-platform-upgrade-rabbit-required-dropdown') {
            // commercePlatformFieldsData4 = [];
            // commercePlatformFieldsData5 = [];
            // appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            // appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';

            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            console.log('newMetaData', newMetaData);
          }
          if (type === 'support-commerce-platform-upgrade-redis-required-dropdown') {
            // commercePlatformFieldsData4 = [];
            // commercePlatformFieldsData5 = [];
            // appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            // appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';

            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            console.log('newMetaData', newMetaData);
          }
          if (type === 'support-commerce-platform-upgrade-maria-required-dropdown') {
            // commercePlatformFieldsData4 = [];
            // commercePlatformFieldsData5 = [];
            // appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            // appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';

            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            console.log('newMetaData', newMetaData);
          }
          if (type === 'support-commerce-platform-upgrade-open-required-dropdown') {
            // commercePlatformFieldsData4 = [];
            // commercePlatformFieldsData5 = [];
            // appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            // appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';

            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
            console.log('commercePlatformFieldsData3', commercePlatformFieldsData3);
            console.log('newMetaData', newMetaData);
          }
          if (type === 'support-commerce-platform-update-domain-migration') {
            commercePlatformFieldsData4 = [];
            commercePlatformFieldsData5 = [];
            appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
            if (selectedValue === '2') {
              renderFieldsPicker('commerce-additional-field4', COMMERCE_DOMAIN_UPDATE_MIGRATION, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_DOMAIN_UPDATE_MIGRATION.forEach(field => {
                commercePlatformFieldsData4.push({
                  label: field.label,
                  id: field.id
                });
              });

            }
          }
          if (type === 'support-commerce-platform-up-size-size') {
            commercePlatformFieldsData5 = [];
            appShadowRoot.getElementById('commerce-additional-field5').innerHTML = '';
            if (selectedValue === '2') {
              renderFieldsPicker('commerce-additional-field5', COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_NEXT, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_NEXT.forEach(field => {
                commercePlatformFieldsData5.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '1') {
              renderFieldsPicker('commerce-additional-field5', COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_CUSTOM, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_TEMPORARY_CLOUD_UPSIZE_DEFAULT_CUSTOM.forEach(field => {
                commercePlatformFieldsData5.push({
                  label: field.label,
                  id: field.id
                });
              });
            }
            for (let field of commercePlatformFieldsData4) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
          if (type === 'support-commerce-platform-user-creation-type') {
            commercePlatformFieldsData4 = [];
            commercePlatformFieldsData5 = [];
            appShadowRoot.getElementById('commerce-additional-field4').innerHTML = '';
            if (selectedValue === '2') {
              renderFieldsPicker('commerce-additional-field4', COMMERCE_CREATE_READ_ONLY_USER_DATABASE, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_CREATE_READ_ONLY_USER_DATABASE.forEach(field => {
                commercePlatformFieldsData4.push({
                  label: field.label,
                  id: field.id
                });
              });
            } else if (selectedValue === '1') {
              renderFieldsPicker('commerce-additional-field4', COMMERCE_CREATE_READ_ONLY_USER_SFTP, 'COMMERCE-ADDITONAL-PLATFORM_FIELDS'); // eslint-disable-line no-use-before-define
              COMMERCE_CREATE_READ_ONLY_USER_SFTP.forEach(field => {
                commercePlatformFieldsData4.push({
                  label: field.label,
                  id: field.id
                });
              });
            }
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }

          if (type === 'support-commerce-platform-up-size-size') {
            for (let field of commercePlatformFieldsData4) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
          if (type === 'support-commerce-platform-service-restart-service') {
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
          if (type === 'support-commerce-platform-update-domain-migration') {
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
          if (type === 'support-commerce-platform-add-storage-current') {
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }

          if (type === 'support-commerce-platform-user-creation-type') {
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }

          if (type === 'support-commerce-platform-split-architecture-auto-scaling') {
            for (let field of commercePlatformFieldsData3) {
              if (field.id === type) {
                field.value = selectedLabel;
              }
            }
          }
          if (type === 'support-product-timeZone') {
            const parsedTimezone = parseInt(selectedValue, 10);
            if (Number.isInteger(parsedTimezone)) {
              timezoneSelectionIsUserOverride = true;
            }
            miloCaseCreateObject.timezone = parsedTimezone;
            if (
              Number.isInteger(miloCaseCreateObject.timezone) &&
              miloCaseCreateObject.phone &&
              isOpenTicketStep4PhoneValid()
            ) {
              removeClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = false;
            } else {
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
            const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
            const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
            const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';
            const companyEntitlements = await getEntitlementsString();
            const companysupportEntitlements = await getSupportEntitlements();
            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
            if(isWorkFront()){
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
            }
            adobeDataLayerTrack({
              event: 'timezoneSelected',
              eventType: 'web.webInteraction.supportForm-timezoneSelected',
              companyLoginDetails: {
                companyLoginName: selectedOrg.name,
                companyLoginID: selectedOrg.id,
                companyEntitlements,
                companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
              },
              supportForm: {
                formStep: '',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle: miloCaseCreateObject.title || '',
                caseDescription: miloCaseCreateObject.description,
                step: stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCasePriority || '',
                timezone: selectedLabel,
                hasAttachment,
                watchersAdded
              },
            });
          }

          if (type === 'support-product-priority') {
            miloCaseCreateObject.priorityCode = selectedValue;
            const impactField = appShadowRoot.getElementById('support-product-impact');
            const impactDescriptionField = appShadowRoot.getElementById('step-3-fields-impact');
            if(selectedValue !== '1'){
              // P1: show both Business Impact dropdown and textarea
              if (impactDescriptionField) addClass(impactDescriptionField, 'showIfOnlyP1');
              if (impactField) {
                const parentElement = impactField.parentElement;
                if (parentElement) addClass(parentElement, 'showIfOnlyP1');
                if (impactDescriptionField) addClass(impactDescriptionField, 'showIfOnlyP1');
              }
              const impactDescInput = appShadowRoot.getElementById('support-product-impact-desc-input');
              if (impactDescInput) impactDescInput.value = '';
              hasImpactField = false;
            } else {
              // P2/P3/P4: hide only Business Impact textarea, hide dropdown
              if (impactField) {
                const parentElement = impactField.parentElement;
                if (parentElement) addClass(parentElement, 'showIfOnlyP1');
              }
              if (impactDescriptionField) removeClass(impactDescriptionField, 'showIfOnlyP1');
              hasImpactField = true;
            }
            // If getCasePrepareTitle returned failed/empty impact, always derive impact from current priority
            if (impactCodeFromApiFailed) {
              if (selectedValue === '1' || selectedValue === '2') {
                miloCaseCreateObject.impactCode = 1;
              } else if (selectedValue === '3') {
                miloCaseCreateObject.impactCode = 2;
              } else {
                miloCaseCreateObject.impactCode = 3;
              }
            }
            // Update Next button state when Priority is selected
            if(stepCount === 3){
              const impactDescInput = appShadowRoot.getElementById('support-product-impact-desc-input');
              const impactDescFilled = impactDescInput && (impactDescInput.value || '').trim().length > 0;
              const impactValid = miloStep3ImpactRequirementMet(impactDescFilled);
              if(miloCaseCreateObject.priorityCode && impactValid){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              } else {
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true;
              }
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
            if (isWorkFront()) {
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
            }
            const impactDescInput = appShadowRoot.getElementById('support-product-impact-desc-input');
            const businessImpactText = impactDescInput ? impactDescInput.value : '';            const recentChangesVal = newDescriptionObject.environmentChanges;
            const recentChanges = recentChangesVal === 'yes' ? 'true' : recentChangesVal === 'no' ? 'false' : '';
            const recentChangesDescription = newDescriptionObject['env-description-fieldSuggestion'] || '';
            const companyEntitlements = await getEntitlementsString();
            const companysupportEntitlements = await getSupportEntitlements();

            adobeDataLayerTrack({
              event: 'prioritySelection',
              eventType: 'web.webInteraction.supportform-prioritySelection',
              companyLoginDetails: {
                companyLoginName: selectedOrg.name,
                companyLoginID: selectedOrg.id,
                companyEntitlements,
                companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
              },
              supportForm: {
                formStep: '',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle: miloCaseCreateObject.title || '',
                caseDescription: miloCaseCreateObject.description,
                step: stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCasePriority,
                recentChanges,
                recentChangesDescription,
                businessImpactEntry:businessImpactText,
              },
            });
          }
          console.log("priority listItem.getAttribute('data-label')", listItem.getAttribute('data-label'));
            switch (listItem.getAttribute('data-label')) {
              case 'P1- Critical': {
                $llel.casePriorityError.classList.remove('is-hidden');
                $llel.casePriorityMessage?.classList.add('is-hidden');
                if (lang === 'ja') {
                  const p1PhoneSpan = $llel.casePriorityError?.querySelector('#p1-phonenumber');
                  if (p1PhoneSpan) {
                    p1PhoneSpan.textContent = '0120-410-404 (日本) 電話番号：';
                  }
                }
                // $llel.casePriorityMessage.classList.add('is-hidden');
                break;
              }
              case 'P4- Minor': {
                console.log('priority in p4minor');
                
                $llel.casePriorityError?.classList.add('is-hidden');
                $llel.casePriorityMessage?.classList.remove('is-hidden');
                $llel.askQuestionBtn = $el.support.querySelector('#support-open-ask-question');
                let communityLink = '';
                // let communityLink = `https://experienceleaguecommunities.adobe.com?lang=${communityLangMapping[lang]}`;
                let hasLink = false
                for (let product of communityProductMapping){
                  if(product.productCode === selectedNewProductCode){
                    communityLink = product.link + `?lang=${communityLangMapping[lang]}`;
                    hasLink = true;
                  }
                }
                if(!hasLink){
                  addClass($llel.casePriorityMessage, 'is-hidden');
                }
                $llel.askQuestionBtn.addEventListener('click', () => {
                  console.log('priority in click event');
                  const selectedTicketProduct = appShadowRoot.querySelector('#selected-ticket-product').textContent;
                  function setCookieWithOneHourLimit(name, value) {
                    const date = new Date();
                    date.setTime(date.getTime() + 600000); // 1 hour in milliseconds
                    const expires = `; expires=${date.toUTCString()}`;
                    const domain = '; domain=.adobe.com';
                    document.cookie = `${name}=${encodeURIComponent(value)}${expires}${domain}; path=/`;
                  }
                  window.open(communityLink, 'communityWindow');
                });
                break;
              }
              default: {
                $llel.casePriorityError.classList.add('is-hidden');
                $llel.casePriorityMessage.classList.add('is-hidden');
              }
            }

          pickerElementOptions.classList.remove('is-open');

          // Single source of truth for step-2 Next (includes Commerce additional fields 2–5, radios, URLs).
          // A previous partial check here ran after infra/sub-picker updates and could re-enable Next while
          // mandatory follow-up fields were still empty.
          if (stepCount === 2) {
            queueMicrotask(() => {
              try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            });
            if (isStep2FieldContainer(arg) && type !== 'support-product-picker') {
              const pickerContainer = appShadowRoot.getElementById(arg);
              const fieldTitle = getStep2FieldTitle(pickerContainer?.closest('.spectrum-Form-item') || pickerContainer);
              void trackSupportFormFieldInteracted(fieldTitle, selectedLabel || String(selectedValue ?? ''), 'yes');
            }
          }

          if(stepCount === 3){
            const impactDescForPicker = appShadowRoot.getElementById('support-product-impact-desc-input');
            const impactDescFilledPicker = impactDescForPicker && (impactDescForPicker.value || '').trim().length > 0;
            if (miloStep3ImpactRequirementMet(impactDescFilledPicker)) {
              removeClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = false;
            }
            if(isWorkFront()){
              if(workfrontCaseCreateObject.Priority){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
              else{
                addClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = true; 
              }
            }
          }
          
          if(stepCount === 4){
            if (
              Number.isInteger(miloCaseCreateObject.timezone) &&
              miloCaseCreateObject.phone &&
              isOpenTicketStep4PhoneValid()
            ) {
              removeClass($llel.submitFormButton, 'disabled');
              $llel.submitFormButton.disabled = false;
            }
          }


        });
      });
      log(`Form picker ready for (#${arg})`);
    }

    async function loadSwatData(productCode) {
      const productIdForInsights = selectedProduct || miloCaseCreateObject?.productCode || selectedNewProductCode || productCode || '';
      supportInsightsManager.initForProduct(productIdForInsights);
      if (!$llel.formSwat) {
        dismissGlobalLoader();
        return;
      }
      const insightsReadyToHelp = appShadowRoot.querySelector('.support-insights-section .ready-to-help');
      const insightsLookingIntoIt = appShadowRoot.querySelector('.support-insights-section .looking-into-it');
      if (!isInsightsSupportedForProduct(productIdForInsights)) {
        dismissGlobalLoader();
        removeClass(insightsReadyToHelp, 'is-hidden');
        addClass(insightsLookingIntoIt, 'is-hidden');
        return;
      }
      if ($llel.formSwatHead) $llel.formSwatHead.innerHTML = '';
      if ($llel.formSwatBody) $llel.formSwatBody.innerHTML = '';
      if ($llel.formSwatEmpty) $llel.formSwatEmpty.classList.add('is-hidden');
      // Keep hidden until data is available
      $llel.formSwat.classList.add('is-hidden');
      // Widths and wrapping handled in CSS
      const orgId = getSelectedOrg().id;
      let projectId = productCode;
      const environment = 'production';
      let rowsData;
      if(projectId){
        // Always show Support Insights section loader so it stays visible until this API returns (even if the other section finishes first)
        addClass(insightsReadyToHelp, 'is-hidden');
        removeClass(insightsLookingIntoIt, 'is-hidden');
        const useGlobalOverlay = !recommendationColumnGlobalOverlayUsed;
        if (useGlobalOverlay) {
          showGlobalLoader();
        }
        try {
          await loadSupportInsights(projectId);
        } finally {
          if (useGlobalOverlay) {
            dismissGlobalLoader();
            recommendationColumnGlobalOverlayUsed = true;
          }
          addClass(insightsLookingIntoIt, 'is-hidden');
          addClass(insightsReadyToHelp, 'is-hidden');
        }
      } else{
        console.warn('swat project ID not found');
        dismissGlobalLoader();
        removeClass(insightsReadyToHelp, 'is-hidden');
        addClass(insightsLookingIntoIt, 'is-hidden');
      }
    }

    async function trackSupportFormSupportInsightsRecommendedEvent(insightsCount) {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
      if (isWorkFront()) {
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
      }
      const caseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
      const caseDescription = (caseDescriptionInput?.value || miloCaseCreateObject.description || '')
        .trim()
        .slice(0, 200);
      const companyEntitlements = await getEntitlementsString();
      const companysupportEntitlements = await getSupportEntitlements();
      const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
      const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
      const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
      const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';

      adobeDataLayerTrack({
        event: 'supportFormSupportInsightsRecommended',
        eventType: 'web.webinteraction.supportform-supportInsightsRecommended',
        companyLoginDetails: {
          companyLoginName: selectedOrg.name,
          companyLoginID: selectedOrg.id,
          companyEntitlements,
          companysupportEntitlements: companysupportEntitlements ? 'Ultimate' : 'Expert',
        },
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle: miloCaseCreateObject.title || '',
          caseDescription,
          step: stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          hasAttachment,
          watchersAdded,
          aiRecommendationContentId: zeonAiAgentRequestId,
          supportInsightsRecommended: insightsCount,
        },
      });
    }

    async function loadSupportInsights(projectId='') {
      const orgId = getSelectedOrg()?.id || '';
      const email = userprofile.email
      const productId = selectedProduct || miloCaseCreateObject?.productCode || '';
      const descriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
      const description = descriptionInput?.value?.trim() || '';
      await supportInsightsManager.load({
        orgId,
        productId,
        description,
        projectId,
        environment: 'production',
        email,
        onInsightsRecommended: trackSupportFormSupportInsightsRecommendedEvent,
      });
    }
    
    function formatPhoneNumber(patterns) {
      let phoneNumber = appShadowRoot.getElementById('support-openticket-phone-input').value;
      // Remove non-digit characters for easier processing
      const pureDigits = phoneNumber.replace(/[^\d+]/g, '');
      for (const pattern of patterns) {
        const matches = pureDigits.match(pattern.match);
        if (matches) {
          phoneNumber = pattern.format(matches);
          break;
        }
      }
      appShadowRoot.getElementById('support-openticket-phone-input').value = phoneNumber;
    }

    prepareFormPicker('support-product-picker', 'support-product-picker');

    function setupCommercePlatformUpgradeField({ idValue, label, fieldsType }) {
      function commerceFieldsForType() {
        switch (fieldsType) {
          case 'commercePlatformFieldsData3':
            return commercePlatformFieldsData3;
          case 'commercePlatformFieldsData4':
            return commercePlatformFieldsData4;
          case 'commercePlatformFieldsData5':
            return commercePlatformFieldsData5;
          default:
            return [];
        }
      }

      const container = appShadowRoot?.getElementById(idValue);
      if (!container) return;

      
      const input = container.querySelector('input');
      if (!input || input.__supportFormStep2InputBound) return;
      input.__supportFormStep2InputBound = true;

      const scheduleCommerceStep2Revalidate = () => {
        queueMicrotask(() => {
          try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
        });
      };

      if (idValue === 'support-commerce-platform-add-storage-size') {
        input.min = 10;
      }

      if (input.type === 'date' || input.type === 'datetime-local') {

        const nowUTC = new Date();
        if (input.type === 'datetime-local') {

          const rounded = new Date(nowUTC.getTime() - (nowUTC.getSeconds() * 1000 + nowUTC.getMilliseconds()));
          const minISO = rounded.toISOString().slice(0, 16);
          if (idValue === 'support-commerce-platform-database-snapshot-retrieval') {
            input.max = minISO;
          } else {
            input.min = minISO;
          }
        }

        if (input.type === 'date') {

          const today = new Date();
          const yyyy = today.getUTCFullYear();
          const mm = String(today.getUTCMonth() + 1).padStart(2, '0');
          const dd = String(today.getUTCDate()).padStart(2, '0');
          const minDate = `${yyyy}-${mm}-${dd}`;

          // Set minimum date to today
          input.min = minDate;
        }

        input.addEventListener('change', () => {
          const fields = commerceFieldsForType();
          for (let field of fields) {
            if (field.id === idValue) {

              if (field.id === 'support-commerce-platform-upgrade-scheduled-at') {
                if (!input.value.trim()) {
                  delete field.value;
                  break;
                }
                const diffMs = new Date(input.value.trim() + ':00Z') - nowUTC;
                const diffHours = diffMs / (1000 * 60 * 60);
                if (diffHours > 48) {
                  field.value = new Date(input.value.trim() + ':00Z').toUTCString();
                } else {
                  notice('Selected date and time should be greater than 48 hours from the current UTC time', true, 3e3, 'negative', 0, true);
                  delete field.value;
                  break;
                }
              }
              if (input.type === 'datetime-local') {
                if (!input.value.trim()) {
                  delete field.value;
                  break;
                }
                field.value = new Date(input.value.trim() + ':00Z').toUTCString();
                if (field.id === 'support-commerce-platform-disable-email-disable-date') {
                  const container1 = appShadowRoot?.getElementById('support-commerce-platform-disable-email-renable-date');
                  if (!container1) return;
                  const input1 = container1.querySelector('input');
                  const nowUTC1 = new Date(field.value);
                  const rounded1 = new Date(nowUTC1.getTime() - (nowUTC1.getSeconds() * 1000 + nowUTC1.getMilliseconds()));
                  const minISO1 = rounded1.toISOString().slice(0, 16);
                  input1.min = minISO1;
                  input1.value = '';

                  for (let fieldData of commercePlatformFieldsData3) {
                    if (fieldData.id === 'support-commerce-platform-disable-email-renable-date') {
                      delete fieldData.value;
                    }
                  }
                }
                if (field.id === 'support-commerce-platform-up-size-from-date') {
                  const container2 = appShadowRoot?.getElementById('support-commerce-platform-up-size-to-date');
                  if (!container2) return;
                  const input2 = container2.querySelector('input');
                  const nowUTC2 = new Date(field.value);
                  const rounded2 = new Date(nowUTC2.getTime() - (nowUTC2.getSeconds() * 1000 + nowUTC2.getMilliseconds()));
                  const minISO2 = rounded2.toISOString().slice(0, 16);
                  input2.min = minISO2;
                  input2.value = '';

                  for (let fieldData of commercePlatformFieldsData5) {
                    if (fieldData.id === 'support-commerce-platform-up-size-to-date') {
                      delete fieldData.value;
                    }
                  }
                }
              } else {
                if (!input.value.trim()) delete field.value;
                else field.value = input.value.trim();
              }
            }
          }
          scheduleCommerceStep2Revalidate();
          if (stepCount === 2) {
            const val = (input.value || '').trim();
            void trackSupportFormFieldInteracted(label, val, val.length ? 'yes' : 'no');
          }
        });

      }

      const syncCommerceFieldTextLike = () => {
        const fields = commerceFieldsForType();
        for (let field of fields) {

          if (field.id === idValue) {
            const nowUTC = new Date();

            if (field.id === 'support-commerce-platform-upgrade-scheduled-at') {
              if (!input.value.trim()) {
                delete field.value;
                break;
              }
              const diffMs = new Date(input.value.trim() + ':00Z') - nowUTC;
              const diffHours = diffMs / (1000 * 60 * 60);
              if (diffHours > 48) {
                field.value = new Date(input.value.trim() + ':00Z').toUTCString();
              } else {
                notice('Selected date and time should be greater than 48 hours from the current UTC time', true, 3e3, 'negative', 0, true);
                delete field.value;
                break;
              }
            }
            if (input.type === 'datetime-local') {
              if (!input.value.trim()) {
                delete field.value;
                break;
              }
              field.value = new Date(input.value.trim() + ':00Z').toUTCString();
              if (field.id === 'support-commerce-platform-disable-email-disable-date') {
                const container1 = appShadowRoot?.getElementById('support-commerce-platform-disable-email-renable-date');
                if (!container1) return;
                const input1 = container1.querySelector('input');
                const nowUTC1 = new Date(field.value);
                const rounded1 = new Date(nowUTC1.getTime() - (nowUTC1.getSeconds() * 1000 + nowUTC1.getMilliseconds()));
                const minISO1 = rounded1.toISOString().slice(0, 16);
                input1.min = minISO1;
                input1.value = '';

                for (let fieldData of commercePlatformFieldsData3) {
                  if (fieldData.id === 'support-commerce-platform-disable-email-renable-date') {
                    delete fieldData.value;
                  }
                }
              }
              if (field.id === 'support-commerce-platform-up-size-from-date') {
                const container2 = appShadowRoot?.getElementById('support-commerce-platform-up-size-to-date');
                if (!container2) return;
                const input2 = container2.querySelector('input');
                const nowUTC2 = new Date(field.value);
                const rounded2 = new Date(nowUTC2.getTime() - (nowUTC2.getSeconds() * 1000 + nowUTC2.getMilliseconds()));
                const minISO2 = rounded2.toISOString().slice(0, 16);
                input2.min = minISO2;
                input2.value = '';

                for (let fieldData of commercePlatformFieldsData5) {
                  if (fieldData.id === 'support-commerce-platform-up-size-to-date') {
                    delete fieldData.value;
                  }
                }
              }
            } else {
              if (!input.value.trim()) delete field.value;
              else field.value = input.value.trim();
            }
          }
        }
        scheduleCommerceStep2Revalidate();
      };

      input.addEventListener('keyup', syncCommerceFieldTextLike);
      input.addEventListener('input', syncCommerceFieldTextLike);

      input.addEventListener('blur', () => {
        const pValue = input.value.trim();
        if (stepCount === 2 && input.type !== 'date' && input.type !== 'datetime-local') {
          void trackSupportFormFieldInteracted(label, pValue, pValue.length ? 'yes' : 'no');
        }
        if (!pValue.length) {
          notice(getLabelV2(label), true, void 0, 'negative', 0);
        }
        scheduleCommerceStep2Revalidate();
      });
    }


    const upgradeFields = [
      { idValue: 'support-commerce-platform-upgrade-rabbit-required', label: 'Enter valid Rabbit URL', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-upgrade-redis-required', label: 'Enter valid Redis URL', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-upgrade-maria-required', label: 'Enter valid MariaDB URL', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-upgrade-open-required', label: 'Enter valid Open Required value', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-upgrade-scheduled-at', label: 'Enter valid Scheduled Time', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-database-snapshot-retrieval', label: 'Enter valid Snapshot Retrieval value', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-ssh-logs-time-period-from', label: 'Enter valid SSH Logs Start Time', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-ssh-logs-time-period-to', label: 'Enter valid SSH Logs End Time', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-add-storage-size', label: 'Enter valid Storage Size', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-disable-email-disable-date', label: 'Enter valid Disable Email Date', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-disable-email-renable-date', label: 'Enter valid Re-enable Email Date', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-update-domain-list-domain', label: 'Enter valid Domain', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-update-domain-fastly-service-id', label: 'Enter valid Case Migration Info', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-update-domain-prefered-time', label: 'Enter valid Preferred Time', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-update-domain-source-destination', label: 'Enter valid Source/Destination', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-custom-lograte-full-path', label: 'Enter valid Log Path', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-custom-lograte-retention-period', label: 'Enter valid Retention Period', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-cloud-type', label: 'Enter valid Cloud Type', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-aws-account', label: 'Enter valid AWS Account', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-environment', label: 'Enter valid Environment', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-setup', label: 'Enter valid Setup Info', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-connection-type', label: 'Enter valid Connection Type', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-communication-port', label: 'Enter valid Communication Port', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-service-endpoint', label: 'Enter valid Service Endpoint', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-private-link-staging-server-name', label: 'Enter valid Staging Server Name', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-send-grid-email', label: 'Enter valid SendGrid Email', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-split-architecture-core-sizing', label: 'Enter valid Core Sizing', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-split-architecture-web-cores', label: 'Enter valid Web Cores', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-split-architecture-web-node-count', label: 'Enter valid Web Node Count', fieldsType: 'commercePlatformFieldsData3' },
      { idValue: 'support-commerce-platform-up-size-custom', label: 'Enter valid Custom Size', fieldsType: 'commercePlatformFieldsData5' },
      { idValue: 'support-commerce-platform-up-size-from-date', label: 'Enter valid From Date', fieldsType: 'commercePlatformFieldsData5' },
      { idValue: 'support-commerce-platform-up-size-to-date', label: 'Enter valid To Date', fieldsType: 'commercePlatformFieldsData5' },
      { idValue: 'support-commerce-platform-up-size-web-node', label: 'Enter valid Web Node Size', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-up-size-service-node', label: 'Enter valid Service Node Size', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-up-size-from-date', label: 'Enter valid From Date', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-up-size-to-date', label: 'Enter valid To Date', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-user-creation-directory', label: 'Enter valid Directory', fieldsType: 'commercePlatformFieldsData4' },
      { idValue: 'support-commerce-platform-user-creation-user-name', label: 'Enter valid Username', fieldsType: 'commercePlatformFieldsData4' }
    ];



    function isStep2FieldContainer(containerId) {
      const step2 = appShadowRoot?.querySelector('#step-2');
      const container = appShadowRoot?.getElementById(containerId);
      return !!(step2 && container && step2.contains(container));
    }

    function getStep2FieldTitle(containerEl) {
      if (!containerEl) return '';
      const label = containerEl.querySelector('.field-labels, .spectrum-FieldLabel, .spectrum-Form-itemLabel');
      if (label) {
        return label.textContent.replace(/\*/g, '').trim();
      }
      const parentLabel = containerEl.closest('.spectrum-Form-item')?.querySelector('label');
      return parentLabel ? parentLabel.textContent.replace(/\*/g, '').trim() : (containerEl.id || '');
    }

    async function trackSupportFormFieldInteracted(supportFieldTitle, supportFieldValue, supportFieldEntered) {
      if (stepCount !== 2) return;

      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
      if (isWorkFront()) {
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
      }
      const caseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
      const caseDescription = (caseDescriptionInput?.value || miloCaseCreateObject.description || '')
        .trim()
        .slice(0, 200);
      const companyEntitlements = await getEntitlementsString();
      const companysupportEntitlements = await getSupportEntitlements();
      const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
      const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
      const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
      const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';

      adobeDataLayerTrack({
        event: 'supportFormInteracted',
        eventType: 'web.webinteraction.supportform-supportFormInteracted',
        companyLoginDetails: {
          companyLoginName: selectedOrg.name,
          companyLoginID: selectedOrg.id,
          companyEntitlements,
          companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
        },
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle: miloCaseCreateObject.title || '',
          caseDescription,
          step: stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          hasAttachment,
          watchersAdded,
          supportField: {
            supportFieldTitle:supportFieldTitle,
            supportFieldValue,
            supportFieldEntered,
          },
        },
      });
    }

    function bindStep2FieldInteractionTracking(containerId) {
      if (!isStep2FieldContainer(containerId)) return;
      const container = appShadowRoot.getElementById(containerId);
      if (!container) return;

      container.querySelectorAll('input[type="text"], input[type="date"], input[type="datetime-local"], textarea:not(.radio-suggestion-input)').forEach((input) => {
        if (input.__supportFormStep2InputBound) return;
        if (input.closest('#commerce-project-url, #commerce-affected-url, #commerce-paypal-merchant-id, [id^="support-commerce-platform-"]')) return;
        input.__supportFormStep2InputBound = true;
        const isDateInput = input.type === 'date' || input.type === 'datetime-local';
        const trackFieldInteraction = () => {
          if (stepCount !== 2) return;
          const val = (input.value || '').trim();
          const fieldTitle = getStep2FieldTitle(input.parentElement);
          void trackSupportFormFieldInteracted(fieldTitle, val, val.length ? 'yes' : 'no');
        };
        if (isDateInput) {
          input.addEventListener('change', trackFieldInteraction);
        } else {
          input.addEventListener('blur', trackFieldInteraction);
        }
      });
    }

    async function trackSupportFormRecentChangesEvent(eventName, eventType) {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
      if (isWorkFront()) {
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
      }
      const caseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
      const caseDescription = (caseDescriptionInput?.value || miloCaseCreateObject.description || '')
        .trim()
        .slice(0, 200);
      const recentChangesVal = newDescriptionObject.environmentChanges;
      const recentChanges = recentChangesVal === 'yes' ? 'true' : recentChangesVal === 'no' ? 'false' : '';
      const recentChangesDescription = newDescriptionObject['env-description-fieldSuggestion'] || '';
      const companyEntitlements = await getEntitlementsString();
      const companysupportEntitlements = await getSupportEntitlements();
      adobeDataLayerTrack({
        event: eventName,
        eventType,
        companyLoginDetails: {
          companyLoginName: selectedOrg.name,
          companyLoginID: selectedOrg.id,
          companyEntitlements,
          companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
        },
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle: miloCaseCreateObject.title || '',
          caseDescription,
          step: stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          recentChanges,
          recentChangesDescription,
        },
      });
    }

    async function trackSupportFormIssueReproducibleEvent(eventName, eventType, { reproSteps } = {}) {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
      if (isWorkFront()) {
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
      }
      const caseDescriptionInput = appShadowRoot.querySelector('#support-openticket-casedescription-input');
      const caseDescription = (caseDescriptionInput?.value || miloCaseCreateObject.description || '')
        .trim()
        .slice(0, 200);
      const companyEntitlements = await getEntitlementsString();
      const companysupportEntitlements = await getSupportEntitlements();
      const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
      const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
      const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
      const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';
      const issueReproducable = reproSteps !== undefined
        ? 'yes'
        : (newDescriptionObject.stepsToReproduce || '');

      const supportForm = {
        formStep: '',
        formType: 'support',
        productSelection: selectedNewProductName,
        productSelectionOrder: productSelectionCount.toString(),
        caseTitle: miloCaseCreateObject.title || '',
        caseDescription,
        step: stepCount.toString(),
        companyName: selectedOrg.name ? selectedOrg.name : '',
        useCasePriority: analyticCasePriority || '',
        hasAttachment,
        watchersAdded,
        issueReproducable,
      };

      if (reproSteps !== undefined) {
        supportForm.reproSteps = reproSteps;
      }

      adobeDataLayerTrack({
        event: eventName,
        eventType,
        companyLoginDetails: {
          companyLoginName: selectedOrg.name,
          companyLoginID: selectedOrg.id,
          companyEntitlements,
          companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
        },
        supportForm,
      });
    }

    function renderFieldsPicker(elementId, productFields, fieldsType, instanceUrl = false) {
      const renderedFieldIds = new Set();
      delete commerceProjectURL.value;
      
      
      typeOfProduct = fieldsType;
      const fields = document.createElement('div');
      appShadowRoot.getElementById(elementId).innerHTML = '';
      const chevronDown = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
        <defs>
          <style>
            .fill {
              fill: #464646;
            }
          </style>
        </defs>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z" />
      </svg>`;
      const prepareFieldsArray = [];
      productFields?.forEach((field) => {
        console.log('field', field);
        if (renderedFieldIds.has(field.id)) {
          return;
        }
        renderedFieldIds.add(field.id);

        let fieldPara = '';
        let fieldPlaceholder = '';
        let textAreaId = '';
        if (field.para) {
          fieldPara = field.para;
        }
        if (field.placeholder) {
          fieldPlaceholder = field.placeholder;
        }
        if(field.textAreaId){
          textAreaId = field.textAreaId
        }
        if (field?.type && field.type === 'DATE_TIME_TEXT') {
          appShadowRoot.getElementById(elementId).innerHTML += `<div class="spectrum-Form-item is-margin-bottom-big-big">
            <div id="${field.id}" class="">
              <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-0 is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
              ${getLabelV2(field.label)}
              </label>
              <p class='break-word'>${getLabelV2(fieldPara)}</p>
              <input placeholder="${getLabelV2(fieldPlaceholder)}" selected-value="" type="datetime-local" step="60" id="" maxlength="200" class="field-input is-padded-bottom is-padded-top spectrum-Textfield-input w-100 border is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6" data-cs-mask/>
            </div>
          </div>`;
        } else if (field?.type && field.type === 'DATE_TEXT') {
          appShadowRoot.getElementById(elementId).innerHTML += `<div class="spectrum-Form-item is-margin-bottom-big-big">
            <div id="${field.id}" class="">
              <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-0 is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
              ${getLabelV2(field.label)}
              </label>
              <p class='break-word'>${getLabelV2(fieldPara)}</p>
              <input placeholder="${getLabelV2(fieldPlaceholder)}" selected-value="" type="date" id="" maxlength="200" class="field-input is-padded-bottom is-padded-top spectrum-Textfield-input w-100 border is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6" data-cs-mask/>
            </div>
          </div>`;
        } else if (field?.type && field.type === 'SHORT_TEXT') {
          appShadowRoot.getElementById(elementId).innerHTML +=
            `<div class="spectrum-Form-item is-margin-bottom-big-big">
            <div id="${field.id}" class="">
              <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-0 is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
              ${getLabelV2(field.label)}
              </label>
              <label class="set-index is-block field-sub-labels is-margin-bottom-0 is-size-8-tablet spectrum-FieldLabel">
              ${getLabelV2(field.sublabel)?getLabelV2(field.sublabel):''}
              </label>
              <p class='break-word'>${getLabelV2(fieldPara)}</p>
              <input placeholder="${getLabelV2(
              fieldPlaceholder
            )}" id = "${textAreaId}" selected-value="" type="text" id="" maxlength="200" class="field-input is-padded-bottom is-padded-top spectrum-Textfield-input w-100 border is-padded-bottom-small is-padded-top-small is-padded-left-big is-padded-right-big is-size-6" data-cs-mask/>
            </div>
          </div>`;
        } else if (field?.type && field.type === 'LONG_TEXT') {
          // Set maxlength to 5000 for case description field, 7000 for other LONG_TEXT fields
          const maxLength = textAreaId === 'support-openticket-casedescription-input' ? '4000' : '1000';
          const isCaseDescription = textAreaId === 'support-openticket-casedescription-input';
          appShadowRoot.getElementById(elementId).innerHTML +=
            `<div class="spectrum-Form-item is-margin-bottom-big-big">
            <div id="${field.id}" class="">
              <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-0 is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
              ${getLabelV2(field.label)}
              </label>
              <label class="set-index is-block field-sub-labels is-margin-bottom-0 is-size-8-tablet spectrum-FieldLabel ">
              ${getLabelV2(field.sublabel)?getLabelV2(field.sublabel):''}
              </label>
              <p class='break-word'>${getLabelV2(fieldPara)}</p>
              <textarea id="${textAreaId}" maxlength="${maxLength}" selected-value=""
                  placeholder="${getLabelV2(fieldPlaceholder)}"
                  class="field-textarea spectrum-Textfield-input w-100 border  is-padded-bottom-big is-padded-top-big is-padded-left-big is-padded-right-big is-size-6" data-cs-mask></textarea>
              ${isCaseDescription ? `<p class="char-remaining description-char-count spectrum-Body--secondary is-size-8 is-margin-top-small" id="description-char-count" aria-live="polite"></p>` : ''}
            </div>
          </div>`;
        } else if (field?.type && field.type === 'RADIO') {
          const radioName = field.id;
          const radioOptions = field.options || [];
          const isRadioRequired = field.required === true;
          const showSuggestionForOption = field.showSuggestionForOption != null ? String(field.showSuggestionForOption) : '';
          const hasSuggestion = showSuggestionForOption !== '';
          const suggestionRequired = hasSuggestion && field.suggestionRequired === true;
          const suggestionLabel = field.suggestionLabel ? getLabelV2(field.suggestionLabel) : 'Suggestion';
          const suggestionTextAreaId = field.suggestionTextAreaId || `${field.id}-suggestion-input`;
          const suggestionPlaceholder = field.suggestionPlaceholder || '';
          const suggestionKey = field.suggestionKey || field.id + 'Suggestion';
          const suggestionMaxLength = field.suggestionMaxLength || 1000;
          const optionsHtml = radioOptions.map((option, idx) => {
            const optId = `${radioName}-opt-${idx}`;
            const optValue = option.value ?? '';
            const desc = option.description ? `<p class="break-word is-size-8 is-margin-top-small">${getLabelV2(option.description)}</p>` : '';
            return `<div class="spectrum-Radio spectrum-Radio--labelBelow is-margin-bottom-small">
              <input type="radio" id="${optId}" name="${radioName}" value="${optValue}" class="spectrum-Radio-input" data-field-key="${field.key || ''}"/>
              <span class="spectrum-Radio-button"></span>
              <label class="spectrum-Radio-label" for="${optId}">${getLabelV2(option.label)}</label>
              ${desc}
            </div>`;
          }).join('');
          const suggestionHtml = hasSuggestion
            ? `<div class="radio-suggestion-wrapper is-hidden is-margin-top-big" data-suggestion-trigger-value="${showSuggestionForOption}" data-suggestion-required="${suggestionRequired}" data-suggestion-key="${suggestionKey}">
                <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-small is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
                  ${suggestionLabel}${suggestionRequired ? ' <span class="required-asterisk">*</span>' : ''}
                </label>
                <textarea id="${suggestionTextAreaId}" maxlength="${suggestionMaxLength}" class="field-textarea spectrum-Textfield-input w-100 border is-padded-bottom-big is-padded-top-big is-padded-left-big is-padded-right-big is-size-6 radio-suggestion-input ${suggestionRequired ? 'suggestion-field-required' : ''}" placeholder="${getLabelV2(suggestionPlaceholder)}" data-cs-mask></textarea>
              </div>`
            : '';
          appShadowRoot.getElementById(elementId).innerHTML +=
            `<div class="spectrum-Form-item is-margin-bottom-big-big">
            <div id="${field.id}" class="" data-field-type="radio" data-field-key="${field.key || ''}" data-radio-required="${isRadioRequired}">
              <label class="set-index is-inline-block field-labels has-text-weight-bold is-margin-bottom-small is-size-5-tablet spectrum-FieldLabel spectrum-Form-itemLabel">
                ${getLabelV2(field.label)}${isRadioRequired ? ' <span class="required-asterisk">*</span>' : ''}
              </label>
              ${fieldPara ? `<p class='break-word'>${getLabelV2(fieldPara)}</p>` : ''}
              <div class="radio-group is-margin-top-small" role="radiogroup" aria-label="${getLabelV2(field.label)}" ${isRadioRequired ? 'aria-required="true"' : ''}>
                ${optionsHtml}
              </div>
              ${suggestionHtml}
            </div>
          </div>`;
        } else {
          let fieldWrapper;
          let fieldWrapperLabel;
          let dropdownWrapper;
          let listWrapper;
          let listButton;
          let ul;
          let fieldWrapperPara;
          prepareFieldsArray.push(field.id);

          fieldWrapper = document.createElement('div');
          fieldWrapper.className = 'spectrum-Form-item is-margin-bottom-big w-100 is-inline-block';
          fieldWrapperLabel = document.createElement('label');
          fieldWrapperLabel.className =
            'spectrum-FieldLabel spectrum-Form-itemLabel  is-inline-block  has-text-weight-bold is-size-5';
          fieldWrapperLabel.appendChild(document.createTextNode(getLabelV2(field.label)));
          fieldWrapper.appendChild(fieldWrapperLabel);

          fieldWrapperPara = document.createElement('p');
          fieldWrapperPara.className = 'break-word is-margin-bottom-small';
          fieldWrapperPara.appendChild(document.createTextNode(getLabelV2(fieldPara)));
          fieldWrapper.appendChild(fieldWrapperPara);

          dropdownWrapper = document.createElement('div');
          dropdownWrapper.className =
            'is-relative spectrumpicker-outer-box  transparent-box support-sidebar-orgpicker-wrap';
          dropdownWrapper.id = field.id;
          listButton = document.createElement('button');
          listButton.className = 'support-form-priority spectrum-Picker spectrum-Picker--sizeM adobe-exl-picker';
          listButton.setAttribute('aria-haspopup', 'listbox');
          listButton.setAttribute('selected-value', '');
          listButton.innerHTML = `<span class="spectrum-Picker-label is-placeholder adobe-exl-pickerSelectedOption">${getLabelV2(field.title) || getLabelV2(field.label)
            }</span>${chevronDown}`;
          dropdownWrapper.appendChild(listButton);
          listWrapper = document.createElement('div');
          listWrapper.className =
            'spectrum-Popover spectrum-Popover--bottom spectrum-Picker-popover adobe-exl-pickerOptions';
          ul = document.createElement('ul');
          ul.className = 'spectrum-Menu supportSidebarOrgPickerListWrap';
          ul.setAttribute('role', 'listbox');
          field?.options.forEach((option) => {
            let li;
            let h5;
            let p;
            li = document.createElement('li');
            li.className = 'spectrum-Menu-item';
            li.setAttribute('data-id', option.value);
            li.setAttribute('data-label', getLabelV2(option.label));
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'true');
            li.setAttribute('tabindex', '0');
            h5 = document.createElement('h5');
            h5.appendChild(document.createTextNode(getLabelV2(option.label)));
            li.appendChild(h5);
            if (option.description) {
              p = document.createElement('p');
              p.appendChild(document.createTextNode(getLabelV2(option.description) || ''));
              li.appendChild(p);
            }
            li.innerHTML += views.get('support-fieldpicker-item')();
            ul.appendChild(li);
          });
          listWrapper.appendChild(ul);
          dropdownWrapper.appendChild(listWrapper);
          fieldWrapper.appendChild(dropdownWrapper);
          fields.appendChild(fieldWrapper);
        }
      });

      let inputIdArray = []
      function createTextAreaIdKeyMap(descriptionFields) {
        return Object.values(descriptionFields)
          .flat()
          .reduce((acc, field) => {
            if (field.textAreaId && field.key) {
              // acc[field.textAreaId] = field.key;
              inputIdArray.push(field.textAreaId);
            }
            return acc;
          }, {});
      }

      createTextAreaIdKeyMap(DESCRIPTION_FIELDS);

      inputIdArray.push('steps-to-reproduce-input');

      for(let inputId of inputIdArray){

        let inputField = appShadowRoot?.getElementById(inputId);
        if (inputField) {
          inputField.addEventListener('keyup', () => {

            
            if(DESCRIPTION_FIELDS[selectedNewProductCode]?.length){

              DESCRIPTION_FIELDS[selectedNewProductCode]?.forEach((element)=>{
                
                if(element.textAreaId === inputId){
                  newDescriptionObject[element.label] = inputField.value.trim();
                }
              })
            }
            
            if(inputId === 'steps-to-reproduce-input'){
              newDescriptionObject['Steps to Reproduce'] = inputField.value.trim();

            }

          });
        }
      }
      
      


      appShadowRoot.getElementById(elementId).innerHTML += fields.innerHTML;

      // RADIO fields: store selected value, show/hide suggestion textarea by option, re-run validation
      appShadowRoot.querySelectorAll('[data-field-type="radio"]').forEach((container) => {
        if (container.__supportFormRadioBound) return;
        container.__supportFormRadioBound = true;
        const key = container.getAttribute('data-field-key');
        if (!key) return;
        const containerId = container.id || '';
        const isEnvField = containerId === 'env-description-field';
        const isStepsToReproduceField = containerId === 'steps-to-reproduce' || key === 'stepsToReproduce';
        const suggestionWrapper = container.querySelector('.radio-suggestion-wrapper');
        const triggerValue = suggestionWrapper ? suggestionWrapper.getAttribute('data-suggestion-trigger-value') : '';
        const suggestionKey = suggestionWrapper ? suggestionWrapper.getAttribute('data-suggestion-key') : '';
        const suggestionTa = suggestionWrapper ? suggestionWrapper.querySelector('.radio-suggestion-input') : null;

        const updateSuggestionVisibility = (selectedValue) => {
          if (!suggestionWrapper) return;
          if (selectedValue === triggerValue) {
            removeClass(suggestionWrapper, 'is-hidden');
            if (suggestionTa) suggestionTa.setAttribute('aria-required', suggestionWrapper.getAttribute('data-suggestion-required') === 'true');
          } else {
            addClass(suggestionWrapper, 'is-hidden');
            if (suggestionTa) {
              suggestionTa.value = '';
              if (suggestionKey) newDescriptionObject[suggestionKey] = '';
            }
            suggestionTa?.removeAttribute('aria-required');
          }
          try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
        };

        const syncEnvObjectIfNeeded = () => {
          if (!isEnvField) return;
          const checkedRadio = container.querySelector('input[type="radio"]:checked');
          if (!checkedRadio) {
            newDescriptionEnvObject.environment = '';
            return;
          }
          const labelEl = checkedRadio.closest('.spectrum-Radio')?.querySelector('.spectrum-Radio-label');
          const label = labelEl ? labelEl.textContent.trim() : checkedRadio.value;
          newDescriptionEnvObject.environment = label;
        };

        container.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', function () {
            const val = this.value;
            newDescriptionObject[key] = val;
            syncEnvObjectIfNeeded();
            updateSuggestionVisibility(val);
            if (stepCount === 2) {
              const fieldTitle = getStep2FieldTitle(container);
              const labelEl = this.closest('.spectrum-Radio')?.querySelector('.spectrum-Radio-label');
              const selectedLabel = labelEl ? labelEl.textContent.trim() : val;
              void trackSupportFormFieldInteracted(fieldTitle, selectedLabel, 'yes');
            }
            if (isEnvField) {
              trackSupportFormRecentChangesEvent(
                'supportFormRecentChangesToggle',
                'web.webInteraction.supportform-recentChangesToggle',
              );
            }
            if (isStepsToReproduceField) {
              trackSupportFormIssueReproducibleEvent(
                'supportFormIssueReproducable',
                'web.webinteraction.supportform-issueReproducable',
              );
            }
          });
        });

        if (suggestionTa && suggestionKey) {
          suggestionTa.addEventListener('input', () => {
            newDescriptionObject[suggestionKey] = suggestionTa.value.trim();
            syncEnvObjectIfNeeded();
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          });
          if (isEnvField) {
            suggestionTa.addEventListener('blur', () => {
              newDescriptionObject[suggestionKey] = suggestionTa.value.trim();
              if (suggestionTa.value.trim()) {
                trackSupportFormRecentChangesEvent(
                  'supportFormRecentChangesDescription',
                  'web.webInteraction.supportform-recentChangesDescription',
                );
              }
            });
          }
          if (isStepsToReproduceField) {
            suggestionTa.addEventListener('blur', () => {
              newDescriptionObject[suggestionKey] = suggestionTa.value.trim();
              if (suggestionTa.value.trim()) {
                trackSupportFormIssueReproducibleEvent(
                  'supportFormReproSteps',
                  'web.webinteraction.supportform-reproSteps',
                  { reproSteps: suggestionTa.value.trim() },
                );
              }
            });
          }
        }

        const checked = container.querySelector('input[type="radio"]:checked');
        if (suggestionWrapper && checked) updateSuggestionVisibility(checked.value);
        if (isEnvField) syncEnvObjectIfNeeded();
      });

      if (fieldsType === 'ECC') {
        miloCaseCreateObject.productMetadata = [];
        let accountId = appShadowRoot?.getElementById('ecc-support-product-accountId');
        if (accountId) {
          let accountIdInput = accountId.getElementsByTagName('input');
          accountIdInput = accountIdInput[0];
          accountIdInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.accountId = accountIdInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'Account ID');
            newMetaData.push(
              {
                displayName: 'Account ID',
                code: '5047',
                value: accountIdInput.value.trim()
              }
            );
            
          });
        }

      }
      if (fieldsType === 'IMS-COMMERCE') {
        miloCaseCreateObject.productMetadata = [];
        

        let commerceInstanceId = appShadowRoot?.getElementById('support-product-v2-commerceInstanceId');
        if (commerceInstanceId) {
          let commerceInstanceIdInput = commerceInstanceId.getElementsByTagName('input');
          commerceInstanceIdInput = commerceInstanceIdInput[0];
          commerceInstanceIdInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.commerceInstanceId = commerceInstanceIdInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'Commerce Instance ID');
            newMetaData.push(
              {
                displayName: 'Commerce Instance ID',
                code: '5231',
                value: commerceInstanceIdInput.value.trim()
              }
            );
            
          });
        }


        let apiEndpointUrl = appShadowRoot?.getElementById('support-product-v2-apiEndpointUrl');
        if (apiEndpointUrl) {
          let apiEndpointUrlInput = apiEndpointUrl.getElementsByTagName('input');
          apiEndpointUrlInput = apiEndpointUrlInput[0];
          apiEndpointUrlInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.apiEndpointUrl = apiEndpointUrlInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'API Endpoint URL');
            newMetaData.push(
              {
                displayName: 'API Endpoint URL',
                code: '5232',
                value: apiEndpointUrlInput.value.trim()
              }
            );
            
          });
        }
        let storefrontEndpointUrl = appShadowRoot?.getElementById('support-product-v2-storefrontEndpointUrl');
        if (storefrontEndpointUrl) {
          let storefrontEndpointUrlInput = storefrontEndpointUrl.getElementsByTagName('input');
          storefrontEndpointUrlInput = storefrontEndpointUrlInput[0];
          storefrontEndpointUrlInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.storefrontEndpointUrl = storefrontEndpointUrlInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'Storefront Endpoint URL');
            newMetaData.push(
              {
                displayName: 'Storefront Endpoint URL',
                code: '5233',
                value: storefrontEndpointUrlInput.value.trim()
              }
            );
            
          });
        }

      }
      if (fieldsType === 'IMS-COMMERCE') {
        miloCaseCreateObject.productMetadata = [];
        

        let commerceInstanceId = appShadowRoot?.getElementById('support-product-v2-commerceInstanceId');
        if (commerceInstanceId) {
          let commerceInstanceIdInput = commerceInstanceId.getElementsByTagName('input');
          commerceInstanceIdInput = commerceInstanceIdInput[0];
          commerceInstanceIdInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.commerceInstanceId = commerceInstanceIdInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'Commerce Instance ID');
            newMetaData.push(
              {
                displayName: 'Commerce Instance ID',
                code: '5231',
                value: commerceInstanceIdInput.value.trim()
              }
            );
          });
        }


        let apiEndpointUrl = appShadowRoot?.getElementById('support-product-v2-apiEndpointUrl');
        if (apiEndpointUrl) {
          let apiEndpointUrlInput = apiEndpointUrl.getElementsByTagName('input');
          apiEndpointUrlInput = apiEndpointUrlInput[0];
          apiEndpointUrlInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.apiEndpointUrl = apiEndpointUrlInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'API Endpoint URL');
            newMetaData.push(
              {
                displayName: 'API Endpoint URL',
                code: '5232',
                value: apiEndpointUrlInput.value.trim()
              }
            );
          });
        }
        let storefrontEndpointUrl = appShadowRoot?.getElementById('support-product-v2-storefrontEndpointUrl');
        if (storefrontEndpointUrl) {
          let storefrontEndpointUrlInput = storefrontEndpointUrl.getElementsByTagName('input');
          storefrontEndpointUrlInput = storefrontEndpointUrlInput[0];
          storefrontEndpointUrlInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.storefrontEndpointUrl = storefrontEndpointUrlInput.value.trim();
            newMetaData = newMetaData.filter(obj => obj.displayName !== 'Storefront Endpoint URL');
            newMetaData.push(
              {
                displayName: 'Storefront Endpoint URL',
                code: '5233',
                value: storefrontEndpointUrlInput.value.trim()
              }
            );
          });
        }

      }
      if (fieldsType === 'COMMERCE') {
        miloCaseCreateObject.productMetadata = [];
        const phoneNumberInput = appShadowRoot.querySelector('#support-openticket-phone-input');
        if (phoneNumberInput && !phoneNumberInput.__supportFormStep2InputBound) {
          phoneNumberInput.__supportFormStep2InputBound = true;
          phoneNumberInput.addEventListener('keyup', () => {
            const rawPhoneValue = phoneNumberInput.value.trim();
            if (OPEN_TICKET_PHONE_ALLOWED_CHARS.test(rawPhoneValue)) {
              formatPhoneNumber(phoneNumberFormat[lang]);
            }
            updateOpenTicketPhone();
            if (
              Number.isInteger(miloCaseCreateObject.timezone) &&
              miloCaseCreateObject.phone &&
              isOpenTicketStep4PhoneValid()
            ) {
              removeClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = false;
            } else {
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          });
          phoneNumberInput.addEventListener('blur', () => {
            updateOpenTicketPhone();
            const rawPhoneValue = phoneNumberInput.value.trim();
            const pValue = rawPhoneValue.replace(/\D/g, '');
            if (!pValue.length || !OPEN_TICKET_PHONE_ALLOWED_CHARS.test(rawPhoneValue) || !isOpenTicketStep4PhoneValid()) {
              notice(getLabelV2('Enter valid phone number'), true, void 0, 'negative', 0);
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          });
        }

        const affectedUrl = appShadowRoot?.getElementById('commerce-affected-url');
        if (affectedUrl && renderedFieldIds.has('commerce-affected-url')) {
          let affectedUrlInput = affectedUrl.getElementsByTagName('input');
          affectedUrlInput = affectedUrlInput[0];
          if (affectedUrlInput && !affectedUrlInput.__supportFormStep2InputBound) {
          affectedUrlInput.__supportFormStep2InputBound = true;
          const updateAffectedUrlAndStepValidation = () => {
            miloCaseCreateObject.productMetadata.affectedUrl = affectedUrlInput.value.trim();
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Affected URL');
            newMetaData.push({
              displayName: 'Affected URL',
              code: '1002',
              value: affectedUrlInput.value.trim(),
              required: false,
            });
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          };
          affectedUrlInput.addEventListener('keyup', updateAffectedUrlAndStepValidation);
          affectedUrlInput.addEventListener('input', updateAffectedUrlAndStepValidation);
          affectedUrlInput.addEventListener('blur', () => {
            
            const pValue = affectedUrlInput.value.trim();
            let affectedErrorEl = appShadowRoot.querySelector('#affected-url-error');
            if (pValue.length && !AFFECTED_URL_REGEX.test(pValue)) {
              newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Affected URL');
              notice(getLabelV2('Enter valid Affected URL'), true, void 0, 'negative', 0);
              if (!affectedErrorEl) {
                affectedErrorEl = document.createElement('div');
                affectedErrorEl.id = 'affected-url-error';
                affectedErrorEl.className = 'spectrum-Form-errorText';
                affectedErrorEl.innerText = getLabelV2('Enter valid Affected URL');
                affectedErrorEl.style.cssText = 'color:red'

                affectedUrlInput.parentElement.appendChild(affectedErrorEl);
              }else{
                affectedErrorEl.innerText = getLabelV2('Enter valid Affected URL');
              }
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }else if(!pValue.length){
              if (affectedErrorEl) affectedErrorEl.innerText = '';
              try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            }
            else{

              let hasEnvironmentValue = true;
              let validStep2 = true;
              if (!miloCaseCreateObject.issueReasonCode) {
                validStep2 = false;
              }
              if(newMetaData.length){
                for (let newMeta of newMetaData){
                  
                  // Skip Project URL and Project ID from "must have value" check
                  if(newMeta?.displayName === 'Project URL' || newMeta?.displayName === 'Project ID'){
                    continue;
                  }
                  
                  if (isStep2MetaEntryValueMissing(newMeta)) {
                    validStep2 = false;
                  }
                }
              }
          
              // If Environment field is not in newMetaData, check newDescriptionEnvObject
              // (This handles the case when Environment is rendered as a separate field)
              if(!hasEnvironmentField){
                if(!newDescriptionEnvObject?.environment){
                  hasEnvironmentValue = false;
                }
              }
              if(validStep2 && hasEnvironmentValue){
                removeClass($llel.nextStep, 'disabled');
                $llel.nextStep.disabled = false;
              }
              if (affectedErrorEl) affectedErrorEl.innerText = '';
            }
            if (stepCount === 2) {
              const entered = pValue.length && AFFECTED_URL_REGEX.test(pValue) ? 'yes' : 'no';
              void trackSupportFormFieldInteracted('Affected URL', pValue, entered);
            }
          });
          }
        }

        const projectUrl = appShadowRoot?.getElementById('commerce-project-url');
        if (projectUrl && renderedFieldIds.has('commerce-project-url')) {
          // Show support insights section
          appShadowRoot.querySelector('.support-insights-section').classList.remove('is-hidden');

          commerceProjectURL.value = '';
          const projectId = appShadowRoot?.getElementById('commerce-project-id');
          let projectIdInput = projectId.getElementsByTagName('input');
          projectIdInput = projectIdInput[0];
          let projectUrlInput = projectUrl.getElementsByTagName('input');
          projectUrlInput = projectUrlInput[0];
          if (projectUrlInput && !projectUrlInput.__supportFormStep2InputBound) {
          projectUrlInput.__supportFormStep2InputBound = true;
          const updateProjectUrlAndStepValidation = () => {
            commerceProjectURL.value = projectUrlInput.value.trim();
            miloCaseCreateObject.productMetadata.projectUrl = projectUrlInput.value.trim();
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Project URL');
            newMetaData.push({
              displayName: 'Project URL',
              code: '1003',
              value: projectUrlInput.value.trim(),
            });
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          };
          projectUrlInput.addEventListener('keyup', updateProjectUrlAndStepValidation);
          projectUrlInput.addEventListener('input', updateProjectUrlAndStepValidation);
          projectUrlInput.addEventListener('blur', () => {
            const pValue = projectUrlInput.value.trim();
            let errorEl = appShadowRoot.querySelector('#project-url-error');
            if (pValue.length && !PROJECT_URL_REGEX.test(pValue)) {
              projectIdInput.value = '';
              newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Project URL');
              notice(getLabelV2('Enter valid project URL'), true, void 0, 'negative', 0);
              if (!errorEl) {
                errorEl = document.createElement('div');
                errorEl.id = 'project-url-error';
                errorEl.className = 'spectrum-Form-errorText';
                errorEl.innerText = 'Enter valid Project URL';
                errorEl.style.cssText = 'color:red'

                projectUrlInput.parentElement.appendChild(errorEl);
              }else{
                errorEl.innerText = 'Enter valid Project URL';
              }
              // Disable Next button when Project URL is invalid
              addClass($llel.nextStep, 'disabled');
              $llel.nextStep.disabled = true;
            }
            
            if (PROJECT_URL_REGEX.test(pValue)) {
              if (!pValue.includes('demo.magento')) {
                if (errorEl) {
                  errorEl.innerText = '';
                }
                const urlArray = pValue.split('/');
                projectIdInput.value = urlArray[4];
                loadSwatData(urlArray[4]);
              } else {
                projectIdInput.value = '';
              }
            }
            
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Project ID');
            newMetaData.push({
              displayName: 'Project ID',
              code: '1004',
              value: projectIdInput.value.trim(),
            });

            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
            if(isWorkFront()){
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
            }
            adobeDataLayerTrack({
              event: 'support-form-commerce-url',
              supportForm: {
                formStep: '',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle:miloCaseCreateObject.title,
                caseDescription:miloCaseCreateObject.description,
                step:stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCasePriority,
              },
              supportFormCommerce:{
                commerceProjectUrl:pValue
              }
            });
            if (stepCount === 2) {
              const entered = pValue.length && PROJECT_URL_REGEX.test(pValue) ? 'yes' : 'no';
              void trackSupportFormFieldInteracted('Project URL', pValue, entered);
            }
            // Update Next button state after validation
            try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
          });
          }
        }else{
          // Hide support insights section
          appShadowRoot.querySelector('.support-insights-section').classList.add('is-hidden');
        }

        const paypalMerchantId = appShadowRoot?.getElementById('commerce-paypal-merchant-id');
        if (paypalMerchantId && renderedFieldIds.has('commerce-paypal-merchant-id')) {
          let paypalMerchantIdInput = paypalMerchantId.getElementsByTagName('input');
          paypalMerchantIdInput = paypalMerchantIdInput[0];
          if (paypalMerchantIdInput && !paypalMerchantIdInput.__supportFormStep2InputBound) {
          paypalMerchantIdInput.__supportFormStep2InputBound = true;
          paypalMerchantIdInput.addEventListener('keyup', () => {
            miloCaseCreateObject.productMetadata.paypalMerchantId = paypalMerchantIdInput.value.trim();
            newMetaData = newMetaData.filter((obj) => obj.displayName !== 'Paypal Merchant ID');
            newMetaData.push({
              displayName: 'Paypal Merchant ID',
              code: '1001',
              value: paypalMerchantIdInput.value.trim(),
            });
            
          });
          }
        }
      }

      if (fieldsType === 'COMMERCE-ADDITONAL-PLATFORM_FIELDS') {
        upgradeFields.forEach(fieldConfig => {
          setupCommercePlatformUpgradeField({
            idValue: fieldConfig.idValue,
            label: fieldConfig.label,
            fieldsType: fieldConfig.fieldsType
          });
        });
      }
      prepareFieldsArray.forEach((fieldId) => {
        prepareFormPicker(fieldId, fieldId);
      });
      bindStep2FieldInteractionTracking(elementId);
      if (appShadowRoot.getElementById('commerce-project-id')) {
        appShadowRoot.getElementById('commerce-project-id').getElementsByTagName('input')[0].disabled = true;
      }
    }

    async function getProductMetadata() {
      if (isECC()) return;
      if (selectedProduct !== 'WORKFRONT') {
        let productMetaStart = 0;
        try {
          if (!$llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
            $llel.additionalMiloHelpSection.classList.add('is-hidden');
          }
          miloCaseCreateObject.productMetadata = {};
          const productMetaUrl = miloProductMetadataUrl.replace('#PRODUCT_CODE', selectedProduct);
          let orgSource = 'IMS';
          productMetaStart = performance.now();
          const res = await request(productMetaUrl, {
            headers: {
              'x-api-key': ClientId,
              Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            },
            params: {
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().userId,
              orgSource
            },
            key: 'milo-product-meta',
          });
          const data = await res.json();
          const productMetaDuration = Number((performance.now() - productMetaStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: productMetaUrl,
              duration: productMetaDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            if (data.family) {
              // Project
              if (data.project && Array.isArray(data.project)) {
                const newField = {};
                newField.id = 'support-product-project';
                newField.label = 'Project';
                newField.title = 'Select a project';
                newField.key = 'projectId';
                newField.options = [];
                data.project.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }
              // Environment
              if (data.environment && Array.isArray(data.environment)) {
                const newField = {};
                newField.id = 'support-product-environment';
                newField.label = 'Environment';
                newField.title = 'Select a environment';
                newField.key = 'environmentId';
                newField.options = [];
                data.environment.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }
              // Product version
              if (data.version && Array.isArray(data.version)) {
                const newField = {};
                newField.id = 'support-product-version';
                newField.label = 'Product Version';
                newField.title = 'Select a product version';
                newField.key = 'versionId';
                newField.options = [];
                data.version.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }
              // Server build
              if (data.serverBuild && Array.isArray(data.serverBuild)) {
                const newField = {};
                newField.id = 'support-product-server-build';
                newField.label = 'Server build';
                newField.title = 'Select a server build';
                newField.key = 'serverBuildId';
                newField.options = [];
                data.serverBuild.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }
              // Console build
              if (data.consoleBuild && Array.isArray(data.consoleBuild)) {
                const newField = {};
                newField.id = 'support-product-console-build';
                newField.label = 'Console build';
                newField.title = 'Select a product console build';
                newField.key = 'consoleBuildId';
                newField.options = [];
                data.consoleBuild.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }
              // Product offering
              if (data.component && Array.isArray(data.component)) {
                const newField = {};
                newField.id = 'support-product-offering';
                newField.label = 'Product offering';
                newField.title = 'Select a product offering';
                newField.key = 'componentId';
                newField.options = [];
                data.component.forEach((opt) => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.id,
                    description: '',
                  });
                });
                mileAdditionalFieldsData.push(newField);
              }

              if (mileAdditionalFieldsData.length) {
                if ($llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
                  $llel.additionalMiloHelpSection.classList.remove('is-hidden');
                }
                renderFieldsPicker(
                  'render-additinal-fields',
                  mileAdditionalFieldsData,
                  selectedProduct,
                  data.instanceUrl,
                );
              }
            } else {
              mileAdditionalFieldsData = [];
              if (!$llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
                $llel.additionalMiloHelpSection.classList.add('is-hidden');
              }
            }
            
          } else {
            relicApiFail({
              status:data.status,
              endpoint: productMetaUrl,
              duration: productMetaDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve Products list: ${JSON.stringify(data.error)}`);
          }
        } catch (err) {
          const productMetaDuration = productMetaStart
            ? Number((performance.now() - productMetaStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: miloProductMetadataUrl.replace('#PRODUCT_CODE', selectedProduct),
            duration: productMetaDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve Products list: ${JSON.stringify(err.message)}`);
        }
      }
      if (typeOfProduct === 'COMMERCE') {
        miloCaseCreateObject.productMetadata = {};
        AMCFIELDS.forEach((data) => {
          if (data.productId === selectedProduct) {
            data.field.forEach((field) => {
              mileAdditionalFieldsData.push({
                label: field.label,
                value: field.id,
                description: '',
                key: field.key,
              });
            });
          }
        });
      }
      if (typeOfProduct === 'ECC') {
        miloCaseCreateObject.productMetadata = {};
        let metaProductFields = await getEccProductMetaData(); // eslint-disable-line no-use-before-define
        metaProductFields.forEach(data => {
          mileAdditionalFieldsData.push({
            label: data.label,
            value: data.id,
            description: '',
            key: data.key
          });
        });
      }
    }

    async function getCommerceProductMetadata() {
      if (selectedProduct !== 'WORKFRONT') {
        let commerceProductMetaStart = 0;
        try {
          if (!$llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
            $llel.additionalMiloHelpSection.classList.add('is-hidden');
          }
          miloCaseCreateObject.productMetadata = {};
          let profileData = await adobeIMS.getProfile();
          commerceProductMetaStart = performance.now();
          const res = await request(exlMiloProductMetadataUrl.replaceAll('PRODUCT_CODE', selectedNewProductCode), {
            credentials: 'include',
            headers: {
              Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              [headerKeys.accept]: headerValues.json,
            },
            params: {
              auth_id: profileData.authId,
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().rengaId,
              productCode: selectedNewProductCode,
              orgSource: 'AMC',
              date: new Date()
            },
            key: 'milo-product-meta',
          });
          const resData = await res.json();
          const commerceProductMetaDuration = Number((performance.now() - commerceProductMetaStart) );

          const data = resData.result;
          let metadataFields = [];
          if (resData.status === 200) {
            relicApiSuccess({
              endpoint: exlMiloProductMetadataUrl.replaceAll('PRODUCT_CODE', selectedNewProductCode),
              duration: commerceProductMetaDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            if (data.length) {
              // Project

              metadataFields = data.map(item => {
                const isOptionSet = item.displayDataType === 'Option Set';
                if (isOptionSet) {
                  const metaId = item.displayName.toLowerCase()
                    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());

                  const options = isOptionSet ?
                    item.metadataValues?.map(option => ({
                      label: option.value,
                      value: String(option.integerCode)
                    })) :
                    undefined;

                  const value = !isOptionSet ? item.metadataValues?.[0]?.code : undefined;

                  return {
                    id: `commerce-support-product-${metaId}`,
                    key: metaId,
                    label: item.displayName,
                    type: isOptionSet ? 'DROPDOWN' : 'SHORT_TEXT',
                    options,
                    value
                  };
                }
              }).filter(Boolean);
              console.log('qwerty metadataFields', metadataFields);
              
              
              miloCaseCreateObject.productMetadata = {};
              AMCFIELDS.forEach((data) => {
                if (data.productId === selectedNewProductCode) {
                  data.field.forEach((field) => {

                    if(field.id === 'commerce-project-url'){
                      hasCommerceProjectUrl = true;
                      hasCommerceProjectUrlArray.push(
                        {
                        label: field.label,
                        sublabel: field.sublabel,
                        placeholder:field.placeholder,
                        value: field.id,
                        id: field.id,
                        description: '',
                        key: field.key,
                        type: 'SHORT_TEXT'
                      }

                      )


                    } else{

                      metadataFields.push({
                        label: field.label,
                        value: field.id,
                        id: field.id,
                        description: '',
                        key: field.key,
                        type: 'SHORT_TEXT'
                      });
                    }
                  });
                }
              });

              console.log('qwerty 8256 metadataFields', metadataFields);
              
              metadataFields.forEach(data => {
                
                if(data.label.toLocaleLowerCase() === 'environment'){
                  hasEnvironmentField = true;
                }
                newMetaData.push(
                  {
                    displayName: data.label,
                    code: data?.value,
                    id: data.id
                  }
                );
              });

              if(!hasEnvironmentField){
                renderFieldsPicker('env-description-fields', ENVIRONMENT_FIELD, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
              }

              renderFieldsPicker('metadata-fields', metadataFields, 'COMMERCE');

              if(hasCommerceProjectUrl){
                if(hasCommerceProjectUrlArray && hasCommerceProjectUrlArray.length){
                  renderFieldsPicker('project-url-field', hasCommerceProjectUrlArray, 'COMMERCE'); // eslint-disable-line no-use-before-define
                }
              }
      

            } else {
              if(!hasEnvironmentField){
                renderFieldsPicker('env-description-fields', ENVIRONMENT_FIELD, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
              }
              mileAdditionalFieldsData = [];
              if (!$llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
                $llel.additionalMiloHelpSection.classList.add('is-hidden');
              }
            }
            
          } else {
            relicApiFail({
              status:resData.status,
              endpoint: exlMiloProductMetadataUrl.replaceAll('PRODUCT_CODE', selectedNewProductCode),
              duration: commerceProductMetaDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve Products list: ${JSON.stringify(data.error)}`);
          }
        } catch (err) {
          const commerceProductMetaDuration = commerceProductMetaStart
            ? Number((performance.now() - commerceProductMetaStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: exlMiloProductMetadataUrl.replaceAll('PRODUCT_CODE', selectedNewProductCode),
            duration: commerceProductMetaDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          console.error('error', err);
        
          log(`Failed to retrieve Products list: ${JSON.stringify(err.message)}`);
        }
      }
      if (typeOfProduct === 'COMMERCE') {
        miloCaseCreateObject.productMetadata = {};
        AMCFIELDS.forEach((data) => {
          if (data.productId === selectedProduct) {
            data.field.forEach((field) => {
              mileAdditionalFieldsData.push({
                label: field.label,
                value: field.id,
                description: '',
                key: field.key,
              });
            });
          }
        });
      }
      if (typeOfProduct === 'ECC') {
        miloCaseCreateObject.productMetadata = {};
        let metaProductFields = await getEccProductMetaData(); // eslint-disable-line no-use-before-define
        metaProductFields.forEach(data => {
          mileAdditionalFieldsData.push({
            label: data.label,
            value: data.id,
            description: '',
            key: data.key
          });
        });
      }
    }

    async function getIssueReasonField(productCode) {
      let issueReasonStart = 0;
      try {
        let orgSource = 'IMS';
        if (isECC()) {
          orgSource = 'ECC';
        }
        issueReasonRequired = false;
        issueReasonStart = performance.now();
        const res = await request(miloIssueReasonUrl, {
          headers: {
            'x-api-key': ClientId,
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            orgId: getSelectedOrg().id,
            contactRengaId: getSelectedOrg().userId,
            categoryCode: 1,
            locale: miloLocales.get(lang),
            productCode,
            typeCode: 2,
            orgSource
          },
        });
        const data = await res.json();
        const issueReasonDuration = Number((performance.now() - issueReasonStart) );
        issueReasonMetaData = [];
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloIssueReasonUrl,
            duration: issueReasonDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (data.metadata) {
            if (data.metadata.items[0].item && Array.isArray(data.metadata.items[0].item.values)) {
              if (data.metadata.items[0].item.name === 'issueReason') {
                issueReasonRequired = true;
                let newField = {};
                newField.id = 'support-issue-reason';
                newField.label = 'Issue Reason';
                newField.title = 'Select a Issue Reason';
                newField.key = 'issueReasonCode';
                newField.options = [];
                data.metadata.items[0].item.values.forEach(opt => {
                  newField.options.push({
                    label: opt.value,
                    value: opt.code,
                    description: ''
                  });
                });
                issueReasonMetaData.push(newField);
              }
            }
          }
        } else {
          relicApiFail({
            status:data.status,
            endpoint: miloIssueReasonUrl,
            duration: issueReasonDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }

        if(issueReasonMetaData && issueReasonMetaData.length){
          hasIssueReason = true;
          renderFieldsPicker('issue-reson-field', issueReasonMetaData, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
        }
      } catch (error) {
        const issueReasonDuration = issueReasonStart
          ? Number((performance.now() - issueReasonStart) )
          : 0;
        relicApiFail({
          status:error.status,
          endpoint: miloIssueReasonUrl,
          duration: issueReasonDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`error in getIssueReasonField: ${error}`);
      }
    }

    async function getCommerceIssueReasonField(productCode) {
      let commerceIssueReasonStart = 0;
      try {
        let profileData = await adobeIMS.getProfile();
        commerceIssueReasonStart = performance.now();
        const res = await request(exlMiloIssueReasonUrl, {
          credentials: 'include',
          headers: {
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            [headerKeys.accept]: headerValues.json,
          },
          params: {
            auth_id: profileData.authId,
            orgId: getSelectedOrg().id,
            contactRengaId: getSelectedOrg().rengaId,
            categoryCode: 1,
            locale: miloLocales.get(lang),
            productCode,
            typeCode: 2,
            orgSource: 'AMC',
            date: new Date()
          },
        });
        const resData = await res.json();
        const commerceIssueReasonDuration = Number((performance.now() - commerceIssueReasonStart) );
        const data = resData.result;

        issueReasonMetaData = [];
        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloIssueReasonUrl,
            duration: commerceIssueReasonDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (data.metadata) {
            if (data.metadata.items[0].item && Array.isArray(data.metadata.items[0].item.values)) {
              const newField = {};
              newField.id = 'support-issue-reason';
              newField.label = 'Issue Reason';
              newField.title = 'Select a Issue Reason';
              newField.key = 'issueReasonCode';
              newField.options = [];
              data.metadata.items[0].item.values.forEach((opt) => {
                newField.options.push({
                  label: opt.value,
                  value: opt.code,
                  description: '',
                });
              });
              issueReasonMetaData.push(newField);
            }
          }
        } else {
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloIssueReasonUrl,
            duration: commerceIssueReasonDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }
        if(issueReasonMetaData && issueReasonMetaData.length){
          hasIssueReason = true;
          renderFieldsPicker('issue-reson-field', issueReasonMetaData, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
        }
      } catch (error) {
        const commerceIssueReasonDuration = commerceIssueReasonStart
          ? Number((performance.now() - commerceIssueReasonStart) )
          : 0;
        relicApiFail({
          status:error.status,
          endpoint: exlMiloIssueReasonUrl,
          duration: commerceIssueReasonDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`error in getIssueReasonField: ${error}`);
      }
    }

    async function getWorkFrontFormFields(product) {
      if (product === 'WORKFRONT') {
        if (!workFrontFormFields) {
          let workfrontFieldsStart = 0;
          try {
            workfrontFieldsStart = performance.now();
            const res = await request(workfrontFieldsListUrl, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              },
            });
            const data = await res.json();
            const workfrontFieldsDuration = Number((performance.now() - workfrontFieldsStart) );
            if (res.ok) {
              relicApiSuccess({
                endpoint: workfrontFieldsListUrl,
                duration: workfrontFieldsDuration,
                ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
              });
            } else {
              relicApiFail({
                status:data.status,
                endpoint: workfrontFieldsListUrl,
                duration: workfrontFieldsDuration,
                ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
              });
            }
            workFrontFormFields = data?.data?.response[0]?.fields;
          } catch (err) {
            const workfrontFieldsDuration = workfrontFieldsStart
              ? Number((performance.now() - workfrontFieldsStart) )
              : 0;
            relicApiFail({
              status:err.status,
              endpoint: workfrontFieldsListUrl,
              duration: workfrontFieldsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            throw err;
          }
          workFrontFormFields[2]?.options?.sort((a, b) => a?.label.localeCompare(b?.label));
          workFrontFormFields[2]?.selectForm?.sort((a, b) => a?.label.localeCompare(b?.label));
        }


        let step2fields = [];
        let step3fields = [];
        let step4fields = [];
        for(let field of workFrontFormFields){

          if(field.sfApi === 'Priority'){
            step3fields.push(field);
          }
          else if(field.sfApi === 'Customer_Region__c'){
            step4fields.push(field);
          } else{
            step2fields.push(field)
          }
        }

        
        
        renderFieldsPicker('env-description-fields', step2fields, 'IMS-COMMERCE', false);
        renderFieldsPicker('step-3-fields', step3fields, 'IMS-COMMERCE', false);
        renderFieldsPicker('step-4-fields', step4fields,'IMS-COMMERCE', false);



        // renderFieldsPicker('render-product-fields', workFrontFormFields, product, false);
      } else {
        renderFieldsPicker('render-product-fields', miloFieldsData, product, false);
      }
    }

    async function getCommerceField(productId) {
      appShadowRoot.getElementById('commerce-additional-field').innerHTML = '';
      AMCFIELDS.forEach((data) => {
        if (productId === data.productId) {
          renderFieldsPicker('commerce-additional-field', data.field, 'COMMERCE');
          data.field.forEach((field) => {
            newMetaData.push({
              displayName: field.label,
            });
          });
        }
      });
    }

    

    async function getProductMetadataV2() {
      let productMetadataV2Start = 0;
      try {
        appShadowRoot.getElementById('ims-commerce-additional-field').innerHTML = '';
        if(appShadowRoot.getElementById('support-openticket-additionalMilohelp').classList.contains('is-hidden')){
          appShadowRoot.getElementById('support-openticket-additionalMilohelp').classList.remove('is-hidden')
        }

        let orgSourceValue = 'IMS'
        if(isECC()){
          orgSourceValue = 'ECC' 
        }
        miloCaseCreateObject.productMetadata = {};
        const productMetadataV2Endpoint = miloProductMetadataV2Url.replace('#PRODUCT_CODE', selectedNewProductCode);
        productMetadataV2Start = performance.now();
        const res = await request(productMetadataV2Endpoint, {
          method: 'GET',
          headers: {
            'x-api-key': ClientId,
            Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
          },
          params: {
            orgId: getSelectedOrg().id,
            contactRengaId: getSelectedOrg().userId,
            orgSource: orgSourceValue
          },
          key: 'milo-product-meta'
        });

        let data = await res.json();
        const productMetadataV2Duration = Number((performance.now() - productMetadataV2Start) );

        if (res.ok) {
          relicApiSuccess({
            endpoint: productMetadataV2Endpoint,
            duration: productMetadataV2Duration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        } else {
          relicApiFail({
            status:data.status,
            endpoint: productMetadataV2Endpoint,
            duration: productMetadataV2Duration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }

        
        if (data && data?.length) {
          const metadataFields = data.filter(item => item.displayName !== 'LogmeinAs').map(item => {
            const isOptionSet = item.displayDataType === 'Option Set';
            const metaId = item.displayName.toLowerCase()
              .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());

              
            const options = isOptionSet ?
              item.metadataValues?.map(option => ({
                label: option.value,
                value: String(option.integerCode)
              })) :
              undefined;
            const value = !isOptionSet ? item.metadataValues?.[0]?.code : undefined;
            const required = resolveProductMetadataV2ItemRequired(item);

            console.log('product metadata', data);
            
            let obj =  {
              id: `support-product-v2-${metaId}`,
              key: metaId,
              label: item.displayName,
              type: isOptionSet ? 'DROPDOWN' : 'SHORT_TEXT',
              options,
              value,
              title: isOptionSet ? `${getLabelV2('Select')} ${item.displayName}`: item.displayName,
              required,
            };

            return obj

          });
          // renderFieldsPicker('render-additinal-fields', mileAdditionalFieldsData, 'IMS-COMMERCE');
          renderFieldsPicker('metadata-fields', metadataFields, 'IMS-COMMERCE');
          
          appShadowRoot.querySelector('#metadata-fields').querySelectorAll('input').forEach((element)=>{

            element.addEventListener('keyup', (event) => {

              
              const inputEl = event.target;

              newMetaData.forEach((metadata)=>{
                if(metadata.id === inputEl.parentElement?.id){
                  metadata.value = inputEl.value
                }
              })

              //check form field validation on metafield keyup event
              if(stepCount === 2){
                  let validStep2 = true
                  let hasEnvironmentValue = false
                  if(newMetaData.length){
                    for (let newMeta of newMetaData){
                      
                      if (newMeta.displayName === 'Environment' && newMeta?.value) {
                        hasEnvironmentValue = true;
                      }
                      if (isStep2MetaEntryValueMissing(newMeta)) {
                        validStep2 = false;
                      }
                    }
                  }
                  
                  if(hasIssueReason){
                    if(!miloCaseCreateObject.issueReasonCode){
                      validStep2 = false
                    }
                  }

                  if(!hasEnvironmentValue){
                    if(newDescriptionEnvObject?.environment){
                        hasEnvironmentValue = true;
                    }
                  }
                      
                  // Environment field is required - Next button should be disabled if it doesn't have a value
                  if(!hasEnvironmentValue){
                    validStep2 = false;
                  }  

                  
                  if(validStep2){
                    removeClass($llel.nextStep, 'disabled');
                    $llel.nextStep.disabled = false;
                  } else{
                    addClass($llel.nextStep, 'disabled');
                    $llel.nextStep.disabled = true;
                  }
              }
              try { handleNextPreviousBtn(); } catch (e) { /* ignore */ }
            })
          })
          newMetaData= [];
          
          metadataFields.forEach(data => {
            
            if(data.label.toLocaleLowerCase() === 'environment'){
              
              hasEnvironmentField = true;
            }
            newMetaData.push(
              {
                displayName: data.label,
                code: data?.value,
                id: data.id,
                required: !!data.required,
              }
            );
          });
          
          
          if(!metadataFields.length){
            hasEnvironmentField = false;
          }


          if(!hasEnvironmentField){
            renderFieldsPicker('env-description-fields', ENVIRONMENT_FIELD, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          }

          return metadataFields;
        } else{
          hasEnvironmentField = false;

          if(!hasEnvironmentField){
            renderFieldsPicker('env-description-fields', ENVIRONMENT_FIELD, 'IMS-COMMERCE'); // eslint-disable-line no-use-before-define
          }

          return [];
        }

        

      
      } catch (error) {
        const productMetadataV2Duration = productMetadataV2Start
          ? Number((performance.now() - productMetadataV2Start) )
          : 0;
        relicApiFail({
          status:error.status,
          endpoint: miloProductMetadataV2Url.replace('#PRODUCT_CODE', selectedNewProductCode),
          duration: productMetadataV2Duration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`error in getProductMetadataV2: ${error}`);

        return [];
      }
    }
    async function getEccProductMetaData() {
      let eccProductMetaStart = 0;
      try {
        const productMetadataV2EccEndpoint = miloProductMetadataV2Url.replace('#PRODUCT_CODE', selectedProduct);
        eccProductMetaStart = performance.now();
        const res = await request(productMetadataV2EccEndpoint, {
          method: 'GET',
          headers: {
            'x-api-key': ClientId,
            Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
          },
          params: {
            orgId: getSelectedOrg().id,
            contactRengaId: getSelectedOrg().userId,
            orgSource: 'ECC'
          },
          key: 'milo-product-meta'
        });

        let data = await res.json();
        const eccProductMetaDuration = Number((performance.now() - eccProductMetaStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: productMetadataV2EccEndpoint,
            duration: eccProductMetaDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        } else {
          relicApiFail({
            status:data.status,
            endpoint: productMetadataV2EccEndpoint,
            duration: eccProductMetaDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
        }
        if (data && data?.length) {
          const metadataFields = data.map(item => {
            if (item.displayName === 'Account ID' || item.displayName === 'Role' || item.displayName === 'Project') {
              const isOptionSet = item.displayDataType === 'Option Set';
              const metaId = item.displayName.toLowerCase()
                .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());

              const options = isOptionSet ?
                item.metadataValues?.map(option => ({
                  label: option.value,
                  value: String(option.integerCode)
                })) :
                undefined;

              const value = !isOptionSet ? item.metadataValues?.[0]?.code : undefined;

              return {
                id: `ecc-support-product-${metaId}`,
                key: metaId,
                label: item.displayName,
                type: isOptionSet ? 'DROPDOWN' : 'SHORT_TEXT',
                options,
                value
              };
            } else {
              return {};
            }
          });

          return metadataFields;
        }

        return [];
      } catch (error) {
        const eccProductMetaDuration = eccProductMetaStart
          ? Number((performance.now() - eccProductMetaStart) )
          : 0;
        relicApiFail({
          status:error.status,
          endpoint: miloProductMetadataV2Url.replace('#PRODUCT_CODE', selectedProduct),
          duration: eccProductMetaDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`error in getEccProductMetaData: ${error}`);

        return [];
      }
    }

    async function getEccField() {
      if (isECC()) {
        appShadowRoot.getElementById('ecc-additional-field').innerHTML = '';
        let metaProductFields = await getEccProductMetaData();
        renderFieldsPicker('ecc-additional-field', metaProductFields, 'ECC');
        metaProductFields.forEach(data => {
          newMetaData.push(
            {
              displayName: data.label,
              value: data?.value,
            }
          );
        });
        if (mileAdditionalFieldsData.length) {
          if ($llel.additionalMiloHelpSection.classList.contains('is-hidden')) {
            $llel.additionalMiloHelpSection.classList.remove('is-hidden');
          }
          renderFieldsPicker('render-additinal-fields', mileAdditionalFieldsData, selectedProduct);
        }
      }
    }



    async function createMarkdown(elementId, text) {
      try {
        const markdownText = text.replace(/\\n/g, '\n');
        const md = window.markdownit({
          html: true,
          linkify: true,
          typographer: true
        });

        const result = md.render(markdownText);
        appShadowRoot.getElementById(elementId).innerHTML = result;

        return true;
      } catch (error) {
        console.error('error in creating markdown', error);

        return [];

      }

    }

    async function getZeonAiAgentFeedback(helpfullValue) {
      let requestBody = {
        customerEmailId: userprofile.email,
        helpful: helpfullValue,
        orgId: selectedOrg.id || '',
        contactRengaId: selectedOrg.userId || '', 
      };

      try {
        let xApiKey = 'ExperienceLeague';
        const res = await request(zeonAiAgentFeedbackUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': xApiKey,
            Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
          },
          body: JSON.stringify(requestBody)
        });
        let data = await res;

        if (data.status === 200) {

          let beforeFeedback = appShadowRoot.querySelector('#feedback-before-submit');
          if (!beforeFeedback.classList.contains('is-hidden')) {
            beforeFeedback.classList.add('is-hidden');
          }

          let afterFeedback = appShadowRoot.querySelector('#feedback-after-submit');
          if (afterFeedback.classList.contains('is-hidden')) {
            afterFeedback.classList.remove('is-hidden');
          }
        }

        return data;
      } catch (error) {
        console.error('error in AI Agent', error);

        return [];
      }
    }

    function generateRequestId() {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
      const seg1 = Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
      const seg2 = Array.from({ length: 7 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
      return `${seg1}-${seg2}`;
    }

    async function getCasePrepareTitle(descriptionText) {
      console.log('selectedOrg',selectedOrg);
      removeClass(appShadowRoot.querySelector('#support-openticket-casetitle'),'is-hidden');
      try {
        const xApiKey = 'ExperienceLeague';
        const payload = {
          userInput: descriptionText,
          orgId: selectedOrg.id || '',
          contactRengaId: selectedOrg.userId || '',
          requestId: generateRequestId(),
          productCode: selectedNewProductCode || '',
          productName: selectedNewProductName || '',
          locale: lang
        };
        console.log('[CasePrepare] Calling API with payload:', payload);
        const res = await request(zeonCasePrepareUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': xApiKey,
            Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
          },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        console.log('[CasePrepare] API response:', data);
        if (data.status === 'success' && data.data?.case_title) {
          return {
            case_title: data.data.case_title || null,
            impact_code: data.data.impact_code ?? null
          };
        }
        return null;
      } catch (error) {
        console.error('[CasePrepare] Error in case prepare API', error);
        return null;
      }
    }

    async function getZeonAiAgent(aiApiObjectData) {
      const myGeneration = ++zeonGenAiRequestGeneration;
      const genAiProductDisplayName = aiApiObjectData.product || selectedNewProductName;
      let readyToHelp = appShadowRoot.querySelector('.ready-to-help');
      let lookingIntoIt = appShadowRoot.querySelector('.looking-into-it');
      let aiAgentResponseContainer = appShadowRoot.querySelector('#ai-agent-response-container')
      let coveoSearch = appShadowRoot.querySelector('#support-openticket-relatedarticles');
      let coveoHeading = appShadowRoot.querySelector('#support-openticket-relatedarticles-heading-span');
      let coveoAricles = appShadowRoot.querySelector('#support-openticket-relatedarticleslist').querySelectorAll('li')
      let beforeFeedback = appShadowRoot.querySelector('#feedback-before-submit');
      console.log('beforeFeedback', beforeFeedback);
      let afterFeedback = appShadowRoot.querySelector('#feedback-after-submit');
      let noResultDiv = appShadowRoot.querySelector('#support-openticket-noresult')
      const recReadyToHelp = appShadowRoot.querySelector('.recomend-container .ready-to-help');
      const recLookingIntoIt = appShadowRoot.querySelector('.recomend-container .looking-into-it');
      const recommendationsWrapper = appShadowRoot.querySelector('.recomend-container-wrapper');
      const projectUrlInput = appShadowRoot?.querySelector('#commerce-project-url input');


      addClass(aiAgentResponseContainer, 'is-hidden');
      addClass(noResultDiv, 'is-hidden')
      addClass(beforeFeedback, 'is-hidden');
      aiApiObjectData.customerEmailId = userprofile.email;
      aiApiObjectData.orgId = selectedOrg.id || '';
      aiApiObjectData.contactRengaId = selectedOrg.userId || '';
      const productIdForInsights = selectedProduct || miloCaseCreateObject?.productCode || selectedNewProductCode || '';
      const useGlobalOverlay = !recommendationColumnGlobalOverlayUsed && isInsightsSupportedForProduct(productIdForInsights);
      if (useGlobalOverlay) {
        showGlobalLoader(true);
      }
      try {

      if(projectUrlInput){
        recommendationsWrapper?.classList.add('insights-supported');
        recommendationsWrapper?.classList.remove('insights-not-supported');
      }else{
        recommendationsWrapper?.classList.add('insights-not-supported');
        recommendationsWrapper?.classList.remove('insights-supported');
      }
      if (miloCaseCreateObject.description.length < 50) {
        recommendationsWrapper?.classList.remove('recommendations-loaded');
        addClass(recReadyToHelp, 'is-hidden');
        addClass(coveoSearch, 'is-hidden');
        removeClass(recLookingIntoIt, 'is-hidden');
        await setCaseAssistView();
        coveoHeading.innerText = getLabelV2('Helpful resources for {{product}}.').replace(
          '{{product}}',
          genAiProductDisplayName
        );
        addClass(aiAgentResponseContainer, 'is-hidden');
        addClass(appShadowRoot.querySelector('.ready-to-help'), 'is-hidden')
        addClass(recLookingIntoIt, 'is-hidden');
        addClass(recReadyToHelp, 'is-hidden');
        if (useGlobalOverlay) {
          dismissGlobalLoader();
          recommendationColumnGlobalOverlayUsed = true;
        }
        //removeClass(beforeFeedback, 'is-hidden');
        return [];
      }
      try {
        let xApiKey ='ExperienceLeague'; 
        recommendationsWrapper?.classList.remove('recommendations-loaded');
        addClass(coveoSearch, 'is-hidden')
        addClass(afterFeedback, 'is-hidden')
        addClass(recReadyToHelp, 'is-hidden');
        removeClass(recLookingIntoIt, 'is-hidden');
        
        const res = await request(zeonAiAgentUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': xApiKey,
            Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`

          },
          body: JSON.stringify(aiApiObjectData)
        });
        let data = await res.json();
        if (myGeneration !== zeonGenAiRequestGeneration) {
          return [];
        }
        if (miloCaseCreateObject.description.length < 50) {
          recommendationsWrapper?.classList.remove('recommendations-loaded');
          addClass(recReadyToHelp, 'is-hidden');
          addClass(coveoSearch, 'is-hidden');
          removeClass(recLookingIntoIt, 'is-hidden');
          await setCaseAssistView();
          coveoHeading.innerText = getLabelV2('Helpful resources for {{product}}.').replace(
            '{{product}}',
            genAiProductDisplayName
          );
          addClass(aiAgentResponseContainer, 'is-hidden');
          addClass(appShadowRoot.querySelector('.ready-to-help'), 'is-hidden');
          addClass(recLookingIntoIt, 'is-hidden');
          addClass(recReadyToHelp, 'is-hidden');
          //removeClass(beforeFeedback, 'is-hidden');
          return [];
        }
        if (data.status === 'success') {
          if (data.requestId) {
            zeonAiAgentRequestId = data.requestId;
          }
          if (data.adobeSource) {
            const companyEntitlements = await getEntitlementsString();
            const companysupportEntitlements = await getSupportEntitlements();
            const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
            const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
            const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
            const hasAttachment = caseAttachmentsFiles.length > 0 ? 'true' : 'false';
            let analyticCase = priorityKeys[miloCaseCreateObject.priorityCode];
            if (isWorkFront()) {
              analyticCase = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
            }
            adobeDataLayerTrack({
              event: 'ai-recommendation-generated',
              eventType: 'web.webinteraction.supportform-aiRecommendationGenerated',
              companyLoginDetails: {
                companyLoginName: selectedOrg.name,
                companyLoginID: selectedOrg.id,
                companyEntitlements,
                companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
              },
              supportForm: {
                formStep: 'Form Case Description Entered',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle: miloCaseCreateObject.title || '',
                caseDescription: miloCaseCreateObject.description,
                step: stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCase,
                hasAttachment,
                watchersAdded,
                aiRecommendationContentId:data.requestId
              },
            });

            // Set data on recommendation modal manager
            recommendationModalManager.setData({
              adobeSource: data.adobeSource,
              publicSource: data.publicSource,
              adobeReferences: data.adobeReferences,
              publicReferences: data.publicReferences
            });

            // let adobeDocContainer = appShadowRoot.querySelector('#adobe-doc-container');

            coveoSearch = appShadowRoot.querySelector('#support-openticket-relatedarticles');
            if (!coveoSearch.classList.contains('is-hidden')) {
              coveoSearch.classList.add('is-hidden');
            }


            removeClass(aiAgentResponseContainer, 'is-hidden');
            removeClass(beforeFeedback, 'is-hidden');
            addClass(recLookingIntoIt, 'is-hidden');

            let aiAgentResponse = appShadowRoot.querySelector('#ai-agent-response');
            if (aiAgentResponse.classList.contains('is-hidden')) {
              aiAgentResponse.classList.remove('is-hidden');
            }

            // await createMarkdown('adobe-doc', data.adobeSource);
            // await createMarkdown('public-doc', data.publicSource);

            await createMarkdown('adobe-doc-text', data.adobeSource);
            await createMarkdown('public-doc-text', data.publicSource);
            if (data.adobeReferences) {
              let linkList = '';
              for (let link of data.adobeReferences) {
                linkList += `<li>
                          <a href="${link}" target="_blank" class="spectrum-Link spectrum-Link--quiet adobe-ref-link">
                            ${link}
                          </a>
                        </li>`;
              }
              appShadowRoot.querySelector('.adobe-based-on-list').innerHTML = linkList;
              appShadowRoot.querySelectorAll('.adobe-ref-link').forEach((el, index) => {
                el.addEventListener('click', (event) => {
                  const clickedLink = event.currentTarget.href;
                  let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
                  if(isWorkFront()){
                    analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
                  }
                  adobeDataLayerTrack({
                    event: 'clickSupportGenAILink',
                    supportForm: {
                      formStep: '',
                      formType: 'support',
                      productSelection: selectedNewProductName,
                      productSelectionOrder: productSelectionCount.toString(),
                      caseTitle:miloCaseCreateObject.title,
                      caseDescription:miloCaseCreateObject.description,
                      step:stepCount.toString(),
                      companyName: selectedOrg.name ? selectedOrg.name : '',
                      useCasePriority: analyticCasePriority,
                      aiLink:{
                        section:"Adobe Documentation",
                        url:clickedLink
                      }
                    },
                  });
                });
              });
            } else {
              appShadowRoot.querySelector('#adobe-doc-link-container').classList.add('is-hidden');

            }

            if (data.publicReferences) {
              let linkList = '';
              for (let link of data.publicReferences) {
                linkList += `<li>
                          <a href="${link}" target="_blank" class="spectrum-Link spectrum-Link--quiet public-ref-link">
                            ${link}
                          </a>
                        </li>`;
              }
              appShadowRoot.querySelector('.public-based-on-list').innerHTML = linkList;
              appShadowRoot.querySelectorAll('.public-ref-link').forEach((el, index) => {
                el.addEventListener('click', (event) => {
                  const clickedLink = event.currentTarget.href;
                  let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
                  if(isWorkFront()){
                    analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
                  }
                  adobeDataLayerTrack({
                    event: 'clickSupportGenAILink',
                    supportForm: {
                      formStep: '',
                      formType: 'support',
                      productSelection: selectedNewProductName,
                      productSelectionOrder: productSelectionCount.toString(),
                      caseTitle:miloCaseCreateObject.title,
                      caseDescription:miloCaseCreateObject.description,
                      step:stepCount.toString(),
                      companyName: selectedOrg.name ? selectedOrg.name : '',
                      useCasePriority: analyticCasePriority,
                      aiLink:{
                        section:"Public Documentation",
                        url:clickedLink
                      }
                    },
                  });
                });
              });
            } else {
              appShadowRoot.querySelector('#public-doc-link-container').classList.add('is-hidden');
            }

            let adobeDocContainer = appShadowRoot.querySelector('#adobe-doc-container');
            let publicDocContainer = appShadowRoot.querySelector('#public-doc-container');
            
            let adobeResultBtns = appShadowRoot.querySelectorAll('.adobe-results');
            let publicResultBtns = appShadowRoot.querySelectorAll('.public-results');

            
            adobeResultBtns.forEach(btn => {
              btn.addEventListener('click', async(e) => {
                e.preventDefault();
                e.stopPropagation();
                
                addClass(publicDocContainer, 'is-hidden');
                removeClass(adobeDocContainer, 'is-hidden');
                
                // Update all adobe buttons
                adobeResultBtns.forEach(aBtn => addClass(aBtn, 'is-active'));
                // Update all public buttons
                publicResultBtns.forEach(pBtn => removeClass(pBtn, 'is-active'));
                const paginationTab = appShadowRoot.getElementById('active-ai-pagenation-tab');
                if (paginationTab) {
                  paginationTab.textContent = 1;
                }
                let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
                if(isWorkFront()){
                  analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
                }
                const companyEntitlements = await getEntitlementsString();
                const companysupportEntitlements = await getSupportEntitlements();

                adobeDataLayerTrack({
                  event: 'supportFormCarouselSwitch',
                  supportForm: {
                    formStep: '',
                    formType: 'support',
                    productSelection: selectedNewProductName,
                    productSelectionOrder: productSelectionCount.toString(),
                    caseTitle:miloCaseCreateObject.title,
                    caseDescription:miloCaseCreateObject.description,
                    step:stepCount.toString(),
                    companyName: selectedOrg.name ? selectedOrg.name : '',
                    useCasePriority: analyticCasePriority,
                    carouselSection:'Adobe Documentation',
                    aiRecommendationContentId: zeonAiAgentRequestId
                  }
                });

                // adobeDataLayerTrack({
                //   event: 'clickSupportGenAILink',
                //   eventType: 'web.webinteraction.supportform-genAiClick',
                //   companyLoginDetails: {
                //     companyLoginName: selectedOrg.name,
                //     companyLoginID: selectedOrg.id,
                //     companyEntitlements,
                //     companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
                //   },
                //   supportForm: {
                //     formStep: '',
                //     formType: 'support',
                //     productSelection: selectedNewProductName,
                //     productSelectionOrder: productSelectionCount.toString(),
                //     caseTitle: miloCaseCreateObject.title || '',
                //     caseDescription: miloCaseCreateObject.description,
                //     step: stepCount.toString(),
                //     companyName: selectedOrg.name ? selectedOrg.name : '',
                //     useCasePriority: analyticCasePriority,
                //     hasAttachment: 'true',
                //     aiLink:{
                //       section:"Adobe Documentation"
                //     }
                //   },
                // });
              });
            });

            publicResultBtns.forEach(btn => {
              btn.addEventListener('click', async(e) => {
                e.preventDefault();
                e.stopPropagation();
                
                addClass(adobeDocContainer, 'is-hidden');
                removeClass(publicDocContainer, 'is-hidden');
                
                // Update all public buttons
                publicResultBtns.forEach(pBtn => addClass(pBtn, 'is-active'));
                // Update all adobe buttons
                adobeResultBtns.forEach(aBtn => removeClass(aBtn, 'is-active'));
                
                const paginationTab = appShadowRoot.getElementById('active-ai-pagenation-tab');
                if (paginationTab) {
                  paginationTab.textContent = 2;
                }
                let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
                if(isWorkFront()){
                  analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
                }
                const companyEntitlements = await getEntitlementsString();

                adobeDataLayerTrack({
                  event: 'supportFormCarouselSwitch',
                  supportForm: {
                    formStep: '',
                    formType: 'support',
                    productSelection: selectedNewProductName,
                    productSelectionOrder: productSelectionCount.toString(),
                    caseTitle:miloCaseCreateObject.title,
                    caseDescription:miloCaseCreateObject.description,
                    step:stepCount.toString(),
                    companyName: selectedOrg.name ? selectedOrg.name : '',
                    useCasePriority: analyticCasePriority,
                    carouselSection:'Public Documentation',
                    aiRecommendationContentId: zeonAiAgentRequestId
                  }
                });

                //  adobeDataLayerTrack({
                //   event: 'clickSupportGenAILink',
                //   eventType: 'web.webinteraction.supportform-genAiClick',
                //   companyLoginDetails: {
                //     companyLoginName: selectedOrg.name,
                //     companyLoginID: selectedOrg.id,
                //     companyEntitlements,
                //   },
                //   supportForm: {
                //     formStep: '',
                //     formType: 'support',
                //     productSelection: selectedNewProductName,
                //     productSelectionOrder: productSelectionCount.toString(),
                //     caseTitle: miloCaseCreateObject.title || '',
                //     caseDescription: miloCaseCreateObject.description,
                //     step: stepCount.toString(),
                //     companyName: selectedOrg.name ? selectedOrg.name : '',
                //     useCasePriority: analyticCasePriority,
                //     hasAttachment: 'true',
                //     aiLink:{
                //       section:"Adobe Documentation"
                //     }
                //   },
                // });
              });
            });

            function trackScrollOnce(el, supportFormData) {
            if (!el || el.__supportFormRecommendationsScrollBound) return;
            el.__supportFormRecommendationsScrollBound = true;
            let hit75 = false;
            let hit100 = false;

            el.addEventListener('scroll', () => {
              const { scrollTop, scrollHeight, clientHeight } = el;
              if (el.scrollHeight <= el.clientHeight) return;
              const scrollPercent =
                ((scrollTop + clientHeight) / scrollHeight) * 100;

              if (!hit75 && scrollPercent >= 75) {
                hit75 = true;
                adobeDataLayerTrack({
                  event: 'supportFormRecommendationsScroll',
                  supportForm: {
                    ...supportFormData,
                    percentageScrolled: 75,
                  },
                });
              }

              if (!hit100 && scrollPercent >= 100) {
                hit100 = true;
                adobeDataLayerTrack({
                  event: 'supportFormRecommendationsScroll',
                  supportForm: {
                    ...supportFormData,
                    percentageScrolled: 100,
                  },
                });
              }
            });
          }

          function trackMouseEnterOnce(el, eventName, supportFormData) {

            el.addEventListener('mouseenter', () => {

              adobeDataLayerTrack({
                event: eventName,
                supportForm: supportFormData,
              });
            });
          }


          const adobeScrollEl = appShadowRoot.getElementById('adobe-doc-text'); 
          const publicScrollEl = appShadowRoot.getElementById('public-doc-text');
          let adobeDoc = appShadowRoot.querySelector('#adobe-doc');
          let publicDoc = appShadowRoot.querySelector('#public-doc');

          if (adobeScrollEl) {  
            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
            if(isWorkFront()){
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
            }
            trackMouseEnterOnce(adobeScrollEl, 'hoverSupportGenAI_Adobe', {
              formStep: '',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title,
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name || '',
              useCasePriority: analyticCasePriority,
            });
            trackScrollOnce(adobeDoc, {
              formStep: '',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title,
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name || '',
              useCasePriority: analyticCasePriority,
              section:'Adobe Documentation',
            });
          }

          let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
          if(isWorkFront()){
            analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
          }
          if (publicScrollEl) {
            trackMouseEnterOnce(publicScrollEl, 'hoverSupportGenAI_Public', {
              formStep: '',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title,
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name || '',
              useCasePriority: analyticCasePriority,
            });
            trackScrollOnce(publicDoc, {
              formStep: '',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title,
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name || '',
              useCasePriority: analyticCasePriority,
              section:'Public Documentation',
            });
          }

          const genAiRecommendationsContainer = appShadowRoot.querySelector(
            '.genai-recommendations .recomend-container'
          );
          if (genAiRecommendationsContainer) {
            let analyticCasePriorityGenAi = priorityKeys[miloCaseCreateObject.priorityCode];
            if (isWorkFront()) {
              analyticCasePriorityGenAi = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
            }
            trackScrollOnce(genAiRecommendationsContainer, {
              formStep: '',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title,
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name || '',
              useCasePriority: analyticCasePriorityGenAi,
              section: 'Gen AI recommendations',
            });
          }

          recommendationsWrapper?.classList.add('recommendations-loaded');

          } else {
            recommendationsWrapper?.classList.remove('recommendations-loaded');
            await setCaseAssistView();
            addClass(aiAgentResponseContainer, 'is-hidden');
            addClass(recLookingIntoIt, 'is-hidden');
            addClass(recReadyToHelp, 'is-hidden');
          }

        } else {
          console.log('got null data');
          recommendationsWrapper?.classList.remove('recommendations-loaded');
          await setCaseAssistView();
          coveoHeading.innerText=`We couldn't find specific recommendations. Here are the most relevant articles for ${genAiProductDisplayName}.`
          // removeClass(coveoSearch, 'is-hidden')
          addClass(beforeFeedback, 'is-hidden');
          addClass(aiAgentResponseContainer, 'is-hidden')
          addClass(recLookingIntoIt, 'is-hidden');
          // Keep intro hidden so Coveo articles or #support-openticket-noresult show alone (not stacked with "Recommendations will appear here")
          addClass(recReadyToHelp, 'is-hidden');
        }
        return data;
      } catch (error) {
        console.error('error in AI Agent', error);
        if (myGeneration === zeonGenAiRequestGeneration) {
          recommendationsWrapper?.classList.remove('recommendations-loaded');
          await setCaseAssistView();
          coveoHeading.innerText=`We couldn't find specific recommendations. Here are the most relevant articles for ${genAiProductDisplayName}.`
          // removeClass(coveoSearch, 'is-hidden');
          addClass(aiAgentResponseContainer, 'is-hidden');
          addClass(beforeFeedback, 'is-hidden');
          addClass(recLookingIntoIt, 'is-hidden');
          addClass(recReadyToHelp, 'is-hidden');
        }
        return [];
      }
      } finally {
        if (useGlobalOverlay) {
          dismissGlobalLoader();
          recommendationColumnGlobalOverlayUsed = true;
        }
      }
    }
 
    syncAiApiObjectProductForGenAi();

    const positiveFeedbackBtn = appShadowRoot.getElementById('positive-feedback-btn');
    positiveFeedbackBtn.addEventListener('click', async () => {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
      if(isWorkFront()){
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
      }
      adobeDataLayerTrack({
        event: 'clickSupportGenAIPositiveFeedback',
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle:miloCaseCreateObject.title,
          caseDescription:miloCaseCreateObject.description,
          step:stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          aiRecommendationContentId:zeonAiAgentRequestId
        }
      });
      await getZeonAiAgentFeedback(true);
      
    });
    const negativeFeedbackBtn = appShadowRoot.getElementById('negative-feedback-btn');
    negativeFeedbackBtn.addEventListener('click', async () => {
      let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
      if(isWorkFront()){
        analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
      }
      adobeDataLayerTrack({
        event: 'clickSupportGenAINegativeFeedback',
        supportForm: {
          formStep: '',
          formType: 'support',
          productSelection: selectedNewProductName,
          productSelectionOrder: productSelectionCount.toString(),
          caseTitle:miloCaseCreateObject.title,
          caseDescription:miloCaseCreateObject.description,
          step:stepCount.toString(),
          companyName: selectedOrg.name ? selectedOrg.name : '',
          useCasePriority: analyticCasePriority,
          aiRecommendationContentId:zeonAiAgentRequestId
        }
      });
      await getZeonAiAgentFeedback(false);
    });






    async function createMiloSupportCase(caseBody) {
      console.log(caseBody);
      
      let miloCaseCreateStart = 0;
      try {
        log('Creating Support CASE');
        caseBody.orgSource = 'IMS';
        if (isECC()) {
          caseBody.orgSource = 'ECC';
        }
        if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
          caseBody.optInCountryCode = '';
          caseBody.smsOptIn = false;
          caseBody.whatsappOptIn = false;
        }
        const caseCreateOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': ClientId,
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            orgSource: 'IMS'
          },
          body: JSON.stringify(caseBody),
        };
        miloCaseCreateStart = performance.now();
        const res = await request(miloCaseUrl, { ...caseCreateOptions });
        const getMiloXRequestID = (res) => res?.headers?.get?.('x-request-id') || '';
        const data = await res.json();
        const miloCaseCreateDuration = Number((performance.now() - miloCaseCreateStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseUrl,
            duration: miloCaseCreateDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          relicCaseCreationResult({
            flow: caseBody.orgSource,
            success: true,
            httpStatus: res.status,
            durationMs: miloCaseCreateDuration,
            orgId: getSelectedOrg()?.id,
            orgSource: caseBody.orgSource,
            token: window.adobeIMS.getAccessToken(),
            xRequestID: getMiloXRequestID,
            payload: miloCaseCreateObject,
            res,
          });
          coveoAnalyticsSubmitCase(caseBody.title, caseBody.description, data.caseId);

          
          return {
            data,
            msg: 'Your case has been submitted successfully.',
            status: true,
          };
        }
        relicApiFail({
          status:data.status,
          endpoint: miloCaseUrl,
          duration: miloCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: caseBody.orgSource,
          success: false,
          httpStatus: res.status,
          errorMessage: data?.error?.[0]?.message || data?.message || res?.statusText,
          durationMs: miloCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: caseBody.orgSource,
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
          res,
        });
        log(`Failed to create the case: ${data.message}`);
        
        if (!$llel.caseLoaderBlock.classList.contains('is-hidden')) {
          $llel.caseLoaderBlock.classList.add('is-hidden');
        }

        return {
          data: {},
          msg: data?.error?.[0]?.message || data?.message || res?.statusText,
          status: false,
          statusCode: res?.status ? res?.status : 400,
          apiMessage: res?.statusText ? res?.statusText : ''
        };
      } catch (err) {
        const miloCaseCreateDuration = miloCaseCreateStart
          ? Number((performance.now() - miloCaseCreateStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: miloCaseUrl,
          duration: miloCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: caseBody.orgSource,
          success: false,
          httpStatus: 0,
          errorMessage: err.message,
          errorClass: err.name,
          durationMs: miloCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: caseBody.orgSource,
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
        });
        log(`There was some error while creating the case: ${err.message}`);

        if (!$llel.caseLoaderBlock.classList.contains('is-hidden')) {
          $llel.caseLoaderBlock.classList.add('is-hidden');
        }

        return {
          data: {},
          msg: err.message,
          status: false,
        };
      }
    }

    async function createCommerceMiloSupportCase(caseBody) {
      console.log(caseBody);

      let commerceCaseCreateStart = 0;
      let btnLoader = appShadowRoot.querySelector('#submit-button').querySelector('.btn-loader');
      try {
        log('Creating Support CASE');

        caseBody.contactRengaId = getSelectedOrg().rengaId;
        caseBody.orgSource = 'AMC';
        if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
          caseBody.optInCountryCode = '';
          caseBody.smsOptIn = false;
          caseBody.whatsappOptIn = false;
        }
        let profileData = await adobeIMS.getProfile();
        const caseCreateOptions = {
          method: 'POST',
          credentials: 'include',
          headers: {
            [headerKeys.accept]: headerValues.json,
            accept: 'application/json',
            'content-type': 'application/json',
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`
          },
          params: {
            orgSource: 'AMC',
            auth_id: profileData.authId
          },
          body: JSON.stringify(caseBody),
        };

        commerceCaseCreateStart = performance.now();
        const res = await request(exlMiloCaseUrl, { ...caseCreateOptions });
        const resData = await res.json();
        const getMiloXRequestID = (res) => res?.headers?.get?.('x-request-id') || '';
        const commerceCaseCreateDuration = Number((performance.now() - commerceCaseCreateStart) );

        const data = resData.result;

        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseUrl,
            duration: commerceCaseCreateDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          relicCaseCreationResult({
            flow: 'AMC',
            success: true,
            httpStatus: resData.status,
            durationMs: commerceCaseCreateDuration,
            orgId: getSelectedOrg()?.id,
            orgSource: 'AMC',
            token: window.adobeIMS.getAccessToken(),
            xRequestID: getMiloXRequestID,
            payload: miloCaseCreateObject,
            res,
          });
          coveoAnalyticsSubmitCase(caseBody.title, caseBody.description, data.caseId);

          return {
            data,
            msg: 'Your case has been submitted successfully.',
            status: true,
          };
        }
        log(`Failed to create the case: ${resData?.error?.[0]?.message || resData?.message || res?.statusTexT}`);
        if (!btnLoader.classList.contains('is-hidden')) {
          btnLoader.classList.add('is-hidden');
        }
        if (!$llel.caseLoaderBlock.classList.contains('is-hidden')) {
          $llel.caseLoaderBlock.classList.add('is-hidden');
        }

        relicApiFail({
          status:resData.status,
          endpoint: exlMiloCaseUrl,
          duration: commerceCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: 'AMC',
          success: false,
          httpStatus: resData.status || 0,
          errorMessage: resData?.error?.[0]?.message || resData?.message || res?.statusText,
          durationMs: commerceCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: 'AMC',
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
          res,
        });
        return {
          data: {},
          msg:  resData?.error?.[0]?.message || resData?.message || res?.statusText,
          status: false,
        };
      } catch (err) {
        const commerceCaseCreateDuration = commerceCaseCreateStart
          ? Number((performance.now() - commerceCaseCreateStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseUrl,
          duration: commerceCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: 'AMC',
          success: false,
          httpStatus: 0,
          errorMessage: err.message,
          errorClass: err.name,
          durationMs: commerceCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: 'AMC',
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
        });
        log(`There was some error while creating the case: ${err.message}`);

        if (!btnLoader.classList.contains('is-hidden')) {
          btnLoader.classList.add('is-hidden');
        }
        if (!$llel.caseLoaderBlock.classList.contains('is-hidden')) {
          $llel.caseLoaderBlock.classList.add('is-hidden');
        }

        return {
          data: {},
          msg: err.message,
          status: false,
        };
      }
    }

    async function createWorkfrontSupportCase(caseBody) {
      let workfrontCaseCreateStart = 0;
      try {
        const caseCreateOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            contactRengaId: userprofile.email,
          },
          body: JSON.stringify(caseBody),
        };
        $lel.progressBar.style.width = '100%';
        workfrontCaseCreateStart = performance.now();
        const res = await request(workfrontCaseCreateUrl, {
          ...caseCreateOptions,
        });
        const data = await res.json();
        const getMiloXRequestID = (res) => res?.headers?.get?.('x-request-id') || '';

        const workfrontCaseCreateDuration = Number((performance.now() - workfrontCaseCreateStart) );
        if (res.ok && data.status === 200) {
          relicApiSuccess({
            endpoint: workfrontCaseCreateUrl,
            duration: workfrontCaseCreateDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          relicCaseCreationResult({
            flow: 'Workfront',
            success: true,
            httpStatus: res.status,
            durationMs: workfrontCaseCreateDuration,
            orgId: getSelectedOrg()?.id,
            orgSource: 'Workfront',
            token: window.adobeIMS.getAccessToken(),
            xRequestID: getMiloXRequestID,
            payload: miloCaseCreateObject,
            res,
          });
          coveoAnalyticsSubmitCase(caseBody.title, caseBody.description, data.caseId);

          
          return {
            data: data.data,
            msg: 'Your case has been submitted successfully.',
            status: !data.hasError,
          };
        }
        relicApiFail({
          status:data.status,
          endpoint: workfrontCaseCreateUrl,
          duration: workfrontCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: 'Workfront',
          success: false,
          httpStatus: res.status,
          errorMessage: data.message,
          durationMs: workfrontCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: 'Workfront',
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
          res,
        });
        return {
          data: {},
          msg: data.message,
          status: false,
        };
      } catch (err) {
        const workfrontCaseCreateDuration = workfrontCaseCreateStart
          ? Number((performance.now() - workfrontCaseCreateStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: workfrontCaseCreateUrl,
          duration: workfrontCaseCreateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        relicCaseCreationResult({
          flow: 'Workfront',
          success: false,
          httpStatus: 0,
          errorMessage: err.message,
          errorClass: err.name,
          durationMs: workfrontCaseCreateDuration,
          orgId: getSelectedOrg()?.id,
          orgSource: 'Workfront',
          token: window.adobeIMS.getAccessToken(),
          xRequestID: getMiloXRequestID,
          payload: miloCaseCreateObject,
        });
        return {
          data: {},
          msg: err.message,
          status: false,
        };
      }
    }

    function goToCaseDetailPage(caseId) {

      queryString('case-id', caseId);
      queryString('org-id', getSelectedOrg().id);
      
      supportProcess(SUPPORT_TABS.MY_CASES);
      window.scrollTo(0, 0);
      notice(getLabelV2('Your case has been submitted successfully.'), true, 3e3, 'positive', 0, true);
    }

    function formatFileSize(bytes) {
      if (bytes == null || bytes === 0) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function renderAttachments(selector) {
      let imagesHTML = '';
      caseAttachments.forEach((el, idx) => {
        const file = caseAttachmentsFiles[idx];
        const fileInfo = file
          ? {
              fileName: file.name,
              fileType: file.type || (file.name ? file.name.split('.').pop() : ''),
              fileSize: formatFileSize(file.size)
            }
          : { fileName: '', fileType: el.value || '', fileSize: '' };
        const viewData = { el, idx, ...fileInfo };
        if (el.type === 'IMAGE') {
          imagesHTML += views.get('support-attachments-item')(viewData);
        }
        if (el.type === 'FILE') {
          imagesHTML += views.get('support-attachments-file')(viewData);
        }
      });
      selector.innerHTML = imagesHTML;
      // remove attachment event
      const imageElementIcon = $el.support
        .querySelector('#step-4')
        .querySelector('.support-openticket-dropzone-imageswrapper')
        .querySelectorAll('.support-openticket-form-image-removeicon');
      imageElementIcon.forEach((idx) => {
        idx.addEventListener('click', async() => {
          const attachementID = idx.getAttribute('data-id');
          caseAttachments.splice(attachementID, 1);
          caseAttachmentsFiles.splice(attachementID, 1);
          const companyEntitlements = await getEntitlementsString();
          const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
          const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
          const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
          const companysupportEntitlements = await getSupportEntitlements();
          adobeDataLayerTrack({
            event: 'supportFormAttachmentRemoved',
            eventType: 'web.webInteraction.supportform-attachmentRemoved',
            companyLoginDetails: {
              companyLoginName: selectedOrg.name,
              companyLoginID: selectedOrg.id,
              companyEntitlements,
              companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',
            },
            supportForm: {
              formStep: 'Form Complete',
              formType: 'support',
              productSelection: selectedNewProductName,
              productSelectionOrder: productSelectionCount.toString(),
              caseTitle: miloCaseCreateObject.title || '',
              caseDescription: miloCaseCreateObject.description,
              step: stepCount.toString(),
              companyName: selectedOrg.name ? selectedOrg.name : '',
              useCasePriority: analyticCasePriority,
              hasAttachment: caseAttachmentsFiles.length ? 'true' : 'false',
              watchersAdded,
            },
          });

          const imagesWrapper = appShadowRoot.querySelector('.upload-image-sec');
          if (imagesWrapper && caseAttachmentsFiles.length > 4) {
            imagesWrapper.classList.add('support-openticket-dropzone-has5');
          } else if (imagesWrapper) {
            imagesWrapper.classList.remove('support-openticket-dropzone-has5');
          }
          if (caseAttachmentsFiles.length < 5) {
            appShadowRoot
              .querySelector('#support-openticket-dropzone .upload-image-sec')
              .classList.remove('support-openticket-dropzone-has5');
          }
          renderAttachments($el.support.querySelector('.support-openticket-dropzone-imageswrapper'));
        });
      });
    }

    // $llel.formAddAttachment.addEventListener('click', () => {
    //   $llel.formDropzone.classList.remove('is-hidden');
    //   $llel.formUploadAttachmentInput.click();
    // });

    $llel.formUploadAttachmentInput.addEventListener('change', async (event) => {
      if (event.target.files && event.target.files.length) {
        const file = event.target.files[0];
        if (file.size < ALLOWED_FILE_SIZE) {
          const fileExtension = file.name.split('.').pop();

          if (fileExtension && fileExtension !== 'dll' && fileExtension !== 'exe') {
            caseAttachmentsFiles.push(file);
            const imagesWrapper = appShadowRoot.querySelector('.upload-image-sec');
            if (imagesWrapper && caseAttachmentsFiles.length > 4) {
              imagesWrapper.classList.add('support-openticket-dropzone-has5');
            } else if (imagesWrapper) {
              imagesWrapper.classList.remove('support-openticket-dropzone-has5');
            }
            if (imageAllowed.includes(fileExtension.toLowerCase())) {
              const fileBase64 = await convertFileToBase64(file);
              caseAttachments.push({ value: fileBase64, type: 'IMAGE' });
              if (caseAttachments.length === 5) {
                if (
                  $llel.formUploadAttachmentWrapSec.classList.contains('support-openticket-dropzone-has5') === false
                ) {
                  $llel.formUploadAttachmentWrapSec.classList.add('support-openticket-dropzone-has5');
                }
              }
            } else {
              caseAttachments.push({ value: fileExtension, type: 'FILE' });
            }
            renderAttachments($el.support.querySelector('.support-openticket-dropzone-imageswrapper'));

            let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode];
            if (isWorkFront()) {
              analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority];
            }
            const companyEntitlements = await getEntitlementsString();
            const tagsWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
            const emailTags = tagsWrapper?.querySelectorAll('.tag') || [];
            const watchersAdded = emailTags.length > 0 ? 'true' : 'false';
            const companysupportEntitlements = await getSupportEntitlements();
            adobeDataLayerTrack({
              event: 'supportFormAttachmentUploaded',
              eventType: 'web.webInteraction.supportform-attachmentUploaded',
              companyLoginDetails: {
                companyLoginName: selectedOrg.name,
                companyLoginID: selectedOrg.id,
                companyEntitlements,
                companysupportEntitlements:companysupportEntitlements?'Ultimate':'Expert',

              },
              supportForm: {
                formStep: 'Form Complete',
                formType: 'support',
                productSelection: selectedNewProductName,
                productSelectionOrder: productSelectionCount.toString(),
                caseTitle: miloCaseCreateObject.title || '',
                caseDescription: miloCaseCreateObject.description,
                step: stepCount.toString(),
                companyName: selectedOrg.name ? selectedOrg.name : '',
                useCasePriority: analyticCasePriority,
                hasAttachment: 'true',
                watchersAdded,
              },
            });
          } else {
            notice(getLabelV2('Invalid file format'), true, void 0, 'negative', 0);
          }
        } else {
          notice(getLabelV2('File size must be less than 20MB.'), true, void 0, 'negative', 0);
        }
      }
      $llel.formUploadAttachmentInput.value = null;
    });

    // form-notice data tracker
    let analyticCasePriority = priorityKeys[miloCaseCreateObject.priorityCode]
    if(isWorkFront()){
      analyticCasePriority = workfrontPriorityKeys[workfrontCaseCreateObject?.Priority]
    }
    adobeDataLayerTrack({
      event: 'form-notice',
      supportForm: {
        formStep: "Form Start",
        formType: 'support',
        productSelection: '',
        productSelectionOrder: '',
        caseTitle:'',
        caseDescription:'',
        step:'',
        companyName: selectedOrg.name ? selectedOrg.name : '',
        useCasePriority: analyticCasePriority,
      },
    });


  }


  /*
   * My Case detail
   */
  async function supportCaseDetail(supportProcess = null) {
    window.scrollTo(0, 0);
    // await initWebcall('EXL-Case Detail-2', {});
    lurl = new URL(`${location.href}`);
    const caseNumber = lurl.searchParams.get('case-id');
    const isWorkFrontCase = !caseNumber.startsWith('E-');
    if (isWorkFrontCase) {
      let workfrontCommentInput = appShadowRoot.getElementById('comment-area-1');
      let commentInputContainer = appShadowRoot.getElementById('comment-area-container');
      if (workfrontCommentInput.classList.contains('is-hidden')) {
        workfrontCommentInput.classList.remove('is-hidden');
      }
      if (!commentInputContainer.classList.contains('is-hidden')) {
        commentInputContainer.classList.add('is-hidden');
      }

    } else {
      let workfrontCommentInput = appShadowRoot.getElementById('comment-area-1');
      let commentInputContainer = appShadowRoot.getElementById('comment-area-container');
      if (commentInputContainer.classList.contains('is-hidden')) {
        commentInputContainer.classList.remove('is-hidden');
      }
      if (!workfrontCommentInput.classList.contains('is-hidden')) {
        workfrontCommentInput.classList.add('is-hidden');
      }

    }

    if (lurl.searchParams.get('org-id')) {
      selectedOrgObj = organizations.find((org) => org.orgId === lurl.searchParams.get('org-id'));
      deleteCookie(SelectedOrg);
      cookie(
        'set',
        SelectedOrg,
        JSON.stringify({
          id: selectedOrgObj.orgId,
          name: selectedOrgObj.orgName,
          type: selectedOrgObj.type,
          orgType: selectedOrgObj.orgType,
          userId: selectedOrgObj.userId,
          contactId: selectedOrgObj.contactId,
          rengaId: selectedOrgObj?.rengaId ? selectedOrgObj?.rengaId : null,
          rengaIdType: selectedOrgObj?.rengaIdType ? selectedOrgObj?.rengaIdType : null,
        }),
      );
    } else {
      selectedOrgObj = getSelectedOrg();
    }

    const $llel = {
      caseHead: appShadowRoot.querySelector('#case-head'),
      caseDescriptionSec: appShadowRoot.querySelector('#case-description'),
      caseDescription: appShadowRoot.querySelector('#case-description p'),
      caseLastUpdate: appShadowRoot.querySelector('#updatedDate'),
      contactName: appShadowRoot.querySelector('#contact-name'),
      productName: appShadowRoot.querySelector('#product'),
      caseTitle: appShadowRoot.querySelector('#case-title'),
      caseNumber: appShadowRoot.querySelector('#case-number'),
      adobeSupportAgent: appShadowRoot.querySelector('#adobe-agent'),
      caseId: appShadowRoot.querySelector('#case-Id'),
      breadCrumbMyCase: appShadowRoot.querySelector('#link-mycase'),
      watcherViewSection: appShadowRoot.querySelector('#case-watcher-section'),
      watcherView: appShadowRoot.querySelector('#case-watcher'),
      watcherEditBtn: appShadowRoot.querySelector('#watcher-edit'),
      caseOptInSection: appShadowRoot.querySelector('#case-opt-in-section'),
      smsOptInCheckbox: appShadowRoot.querySelector('#case-detail-sms-opt-in'),
      whatsappOptInCheckbox: appShadowRoot.querySelector('#case-detail-whatsapp-opt-in'),
      casePriority: appShadowRoot.querySelector('#priority'),
      caseBusinessImpact: appShadowRoot.querySelector('#impactCode'),
      caseDetailSec: appShadowRoot.querySelector('#case-detail-sec'),
      modalTitle: appShadowRoot.querySelector('#modal-title'),
      // escalateCaseBtn: appShadowRoot.querySelector('#escalate-case-btn'), 
      closeCaseBtn: appShadowRoot.querySelector('#close-case-btn'),
      caseDetailAttachment: appShadowRoot.querySelector('#case-detail-attachment'),
      caseCommentArea: appShadowRoot.querySelector('#comment-area-new'),
      workfrontCaseCommentArea: appShadowRoot.querySelector('#comment-area-1'),
      caseCommentInputContainer: appShadowRoot.querySelector('#comment-area-container'),
      caseCommentsLoader: appShadowRoot.querySelector('#support_case_comment_loader'),
      caseCommentsSubmit: appShadowRoot.querySelector('#comment-submit'),
      caseComments: appShadowRoot.querySelector('#support_case_comment'),
      attachmentsList: appShadowRoot.querySelector('#attachments-list'),
      caseAttachment: appShadowRoot.querySelector('.case-attachment .custom-input-sec'),
      myCaseSurveyBtn: appShadowRoot.querySelector('#case-detail-survey'),
      reopenCaseBtn: appShadowRoot.querySelector('#reopen-case-btn'),
      reopenTooltip: appShadowRoot.querySelector('#reopen-tooltip'),
      needAdditinalHelpBtn: appShadowRoot.querySelector('#need-additional-help-btn'),
      // requestcallbackBtn: appShadowRoot.querySelector('#request-callback-btn'),
    };
    $llel.caseDescriptionSec.querySelector('a').innerText = getLabelV2('Show more');
    $llel.caseCommentArea.placeholder = getLabelV2('Comments');
    $llel.workfrontCaseCommentArea.placeholder = getLabelV2('Comments');

    function resolveCaseDetailProductName(details) {
      if (!details || typeof details !== 'object') return '';
      const candidates = [
        details.productName,
        details.productLabel,
        details.product?.name,
        details.product?.label,
        details.product?.displayName,
        details.elProductName,
        details.el_product,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const v = candidates[i];
        if (v != null && String(v).trim() !== '') {
          return String(v).trim();
        }
      }
      if (details.typeCode === 1) {
        return 'Admin Console';
      }
      const code = details.productCode;
      if (code != null && String(code).trim() !== '') {
        const codeStr = String(code).trim();
        const match = productsList.find(
          (p) =>
            String(p.id) === codeStr ||
            String(p.productId) === codeStr ||
            (p.product && p.product.toLowerCase() === codeStr.toLowerCase()),
        );
        if (match?.product) {
          return match.product;
        }
      }
      return '';
    }

    let caseDetails;
    caseAttachments = [];
    let commentsList = [];
    let attachmentsList = [];
    const commentRequest = {
      orgId: getSelectedOrg().id,
      id: caseNumber,
      contactRengaId: getSelectedOrg().userId,
      customerNote: {
        description: '',
        descriptionHtml: '',

      },
      regarding: 'incident',
    };

    let escalateReasonOptionsHtml = '';
    let closeCaseReasonOptionsHtml = '';
    let reopenCaseReasonOptionsHtml = '';

    const caseActionData = {
      orgId: '',
      type: '',
      contactRengaId: '',
      caseId: '',
      reasonCode: '',
      reasonSummary: '',
    };

    $llel.breadCrumbMyCase.addEventListener('click', () => {
      queryString('case-id', '');
      supportProcess(SUPPORT_TABS.MY_CASES);
    });


    const editor = appShadowRoot.querySelector('#comment-area-new');
    appShadowRoot.querySelectorAll('[data-cmd]').forEach(btn => {
      btn.addEventListener('click', () => {
        const cmd = btn.dataset.cmd;
        document.execCommand(cmd, false, null);
        editor.focus();
        updateToolbar();
      });
    });

    // Heading select
    appShadowRoot.getElementById('headingSelect').addEventListener('change', (e) => {
      document.execCommand('formatBlock', false, e.target.value);
      editor.focus();
      updateToolbar();
    });

    // Color picker
    appShadowRoot.getElementById('colorPicker').addEventListener('input', (e) => {
      // document.execCommand('foreColor', false, e.target.value);
      // editor.focus();
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('foreColor', false, e.target.value);
      editor.focus();
    });

    function updateToolbar() {
      appShadowRoot.querySelectorAll('[data-cmd]').forEach(btn => {
        const cmd = btn.dataset.cmd;
        if (document.queryCommandState(cmd)) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

    }

    // Update toolbar on selection change
    editor.addEventListener('input', updateToolbar);
    editor.addEventListener('mouseup', updateToolbar);

    /**
     * get Milo case detail
     */
    async function getMiloCaseData(searchParams) {
      const caseDetailsPage = appShadowRoot.querySelector('#case-detail #case-detail-page');
      const caseDetailsError = appShadowRoot.querySelector('#case-detail #error-sec');
      let miloCaseDetailStart = 0;
      caseDetailsError.querySelector('a').addEventListener('click', () => {
        queryString('case-id', '');
        supportProcess(SUPPORT_TABS.MY_CASES);
      });
      try {
        const requestHeaders = {};
        requestHeaders['Content-Type'] = 'application/json';
        requestHeaders['x-api-key'] = ClientId;
        requestHeaders.Authorization = `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`;
        searchParams.orgSource = 'IMS';
        if (isECC()) {
          searchParams.orgSource = 'ECC';
        }
        miloCaseDetailStart = performance.now();
        const res = await request(miloCaseUrl, {
          headers: { ...requestHeaders },
          params: { ...searchParams },
          key: 'milo-case-details',
        });
        const data = await res.json();
        const miloCaseDetailDuration = Number((performance.now() - miloCaseDetailStart) );
        console.log(data);
        
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseUrl,
            duration: miloCaseDetailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (caseDetailsPage.classList.contains('is-hidden')) {
            caseDetailsPage.classList.remove('is-hidden');
          }
          if (!caseDetailsError.classList.contains('is-hidden')) {
            caseDetailsError.classList.add('is-hidden');
          }

          return data;
        }
        relicApiFail({
          status:data.status,
          endpoint: miloCaseUrl,
          duration: miloCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${data.error.message}`);
        caseDetailsError.querySelector('p span').innerText = data.error[0].message;
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }

        return false;
      } catch (err) {
        const miloCaseDetailDuration = miloCaseDetailStart
          ? Number((performance.now() - miloCaseDetailStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: miloCaseUrl,
          duration: miloCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${err.message}`);
        caseDetailsError.querySelector('p span').innerText = getLabelV2(
          'Something went wrong, not able retrieve case detail',
        );
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }

        return false;
      }
    }

    /**
     * get Milo case detail
     */
    async function getCommerceCaseData(searchParams) {
      const caseDetailsPage = appShadowRoot.querySelector('#case-detail #case-detail-page');
      const caseDetailsError = appShadowRoot.querySelector('#case-detail #error-sec');
      let commerceCaseDetailStart = 0;
      caseDetailsError.querySelector('a').addEventListener('click', () => {
        queryString('case-id', '');
        supportProcess(SUPPORT_TABS.MY_CASES);
      });
      try {
        searchParams.contactRengaId = getSelectedOrg().rengaId;
        searchParams.orgSource = 'AMC';
        searchParams.date = new Date();
        let profileData = await adobeIMS.getProfile();
        commerceCaseDetailStart = performance.now();
        const res = await request(exlMiloCaseUrl, {
          headers: {
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            [headerKeys.accept]: headerValues.json,
            accept: 'application/json',
            'content-type': 'application/json',
          },
          params: { ...searchParams, auth_id: profileData.authId},
          key: 'milo-case-details',
        });
        const resData = await res.json();
        const commerceCaseDetailDuration = Number((performance.now() - commerceCaseDetailStart) );
        const data = resData.result;
        console.log('data', data);
        

        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseUrl,
            duration: commerceCaseDetailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (caseDetailsPage.classList.contains('is-hidden')) {
            caseDetailsPage.classList.remove('is-hidden');
          }
          if (!caseDetailsError.classList.contains('is-hidden')) {
            caseDetailsError.classList.add('is-hidden');
          }

          return data;
        }
        relicApiFail({
          status:resData.status,
          endpoint: exlMiloCaseUrl,
          duration: commerceCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${data.error.message}`);
        caseDetailsError.querySelector('p span').innerText = data.error[0].message;
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }

        return false;
      } catch (err) {
        const commerceCaseDetailDuration = commerceCaseDetailStart
          ? Number((performance.now() - commerceCaseDetailStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseUrl,
          duration: commerceCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${err.message}`);
        caseDetailsError.querySelector('p span').innerText = getLabelV2(
          'Something went wrong, not able retrieve case detail',
        );
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }

        return false;
      }
    }

    /**
     * get Milo case Attachment List
     */
    async function getMiloAttachmentList() {
      let orgSource = 'IMS';
      let miloAttachmentStart = 0;
      if (isECC()) {
        orgSource = 'ECC';
      }
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          orgId: getSelectedOrg().id,
          id: caseDetails.caseId,
          contactRengaId: getSelectedOrg().userId,
          regarding: 'incident',
          orgSource
        },
      };
      try {
        miloAttachmentStart = performance.now();
        const res = await request(miloCaseAttachmentsUrl, options);
        const data = await res.json();
        const miloAttachmentDuration = Number((performance.now() - miloAttachmentStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseAttachmentsUrl,
            duration: miloAttachmentDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseAttachments = [];
          attachmentsList = data.attachments;
        } else {
          relicApiFail({
            status:data.status,
            endpoint: miloCaseAttachmentsUrl,
            duration: miloAttachmentDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          log(`There was an error retrieving attachments: ${error.message}`);
          notice(`${error.message}`, true, void 0, 'negative', 0);
        }
      } catch (err) {
        const miloAttachmentDuration = miloAttachmentStart
          ? Number((performance.now() - miloAttachmentStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: miloCaseAttachmentsUrl,
          duration: miloAttachmentDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was an error retrieving attachments: ${err.message}`);
        notice(getLabelV2('There was an error retrieving attachments'), true, void 0, 'negative', 0);
      }
    }

    /**
     * get Commerce case Attachment List
     */
    async function getCommerceAttachmentList(caseId) {
      let profileData = await adobeIMS.getProfile();
      let commerceAttachmentStart = 0;
      const options = {
        credentials: 'include',
        headers: {
          Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
          accept: 'application/json',
          'content-type': 'application/json',
        },
        params: {
          auth_id: profileData.authId,
          orgId: getSelectedOrg().id,
          id: caseId,
          contactRengaId: getSelectedOrg().rengaId,
          regarding: 'incident',
          of: 'incident,email',
          orgSource: 'AMC',
          date: new Date()
        },
      };

      try {
        commerceAttachmentStart = performance.now();
        const res = await request(exlMiloCaseAttachmentsUrl, options);
        const resData = await res.json();
        const commerceAttachmentDuration = Number((performance.now() - commerceAttachmentStart) );
        const data = resData.result;
        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseAttachmentsUrl,
            duration: commerceAttachmentDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseAttachments = [];
          attachmentsList = data.attachments;
        } else {
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloCaseAttachmentsUrl,
            duration: commerceAttachmentDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          log(`There was an error retrieving attachments: ${error.message}`);
          notice(`${error.message}`, true, void 0, 'negative', 0);
        }
      } catch (err) {
        const commerceAttachmentDuration = commerceAttachmentStart
          ? Number((performance.now() - commerceAttachmentStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseAttachmentsUrl,
          duration: commerceAttachmentDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was an error retrieving attachments: ${err.message}`);
        notice(getLabelV2('There was an error retrieving attachments'), true, void 0, 'negative', 0);
      }
    }

    /**
     * download Milo case Attachment to preview
     */
    async function downloadMiloAttachmentById(attachment, isDownload = false) {
      const downloadEndpoint = miloCaseDownloadAttachmentUrl.replace('FILEIDENTIFIER', attachment.attachmentId);
      let downloadMiloStart = 0;
      let orgSource = 'IMS';
      if (isECC()) {
        orgSource = 'ECC';
      }
      if (isCommerce()) {
        orgSource = 'AMC';
      }
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          orgId: getSelectedOrg().id,
          contactRengaId: getSelectedOrg().userId,
          id: caseDetails.caseId,
          regarding: 'incident',
          key: 'milo-case-details',
          orgSource
        },
      };
      try {
        downloadMiloStart = performance.now();
        const res = await request(downloadEndpoint, options);
        let blobFile = await res.blob();
        const downloadMiloDuration = Number((performance.now() - downloadMiloStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: downloadEndpoint,
            duration: downloadMiloDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (isDownload === false) {
            const extension = attachment.fileName.split('.').pop();
            blobFile = blobFile.slice(0, blobFile.size, `image/${extension}`);
            const imagebase64 = await convertFileToBase64(blobFile);
            caseAttachments.push({
              attachmentId: attachment.attachmentId,
              fileName: attachment.fileName,
              fileExt: extension,
              base64Url: imagebase64,
            });
          } else {
            blobFile = blobFile.slice(0, blobFile.size, `image/${attachment.ext}`);
            const fileUrl = URL.createObjectURL(blobFile);
            const a = document.createElement('a');
            a.href = fileUrl;
            a.style = 'display: none';
            a.target = '_blank';
            a.download = attachment.fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
        } else {
          relicApiFail({
            status:res.status,
            endpoint: downloadEndpoint,
            duration: downloadMiloDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          // const error = blobFile.error[0];
          removeImageLoader();
          log('There was some error while download attachment');
          notice(getLabelV2('There was an error while downloading attachment'), true, void 0, 'negative', 0);
        }
      } catch (err) {
        const downloadMiloDuration = downloadMiloStart
          ? Number((performance.now() - downloadMiloStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: downloadEndpoint,
          duration: downloadMiloDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        removeImageLoader();
        log(`There was some error retriving attachments: ${err.message}`);
        notice(getLabelV2('There was an error while downloading attachment'), true, void 0, 'negative', 0);
      }
    }

    /**
     * get Milo case Comments List
     */
    async function getMiloCaseComments(caseId, loader) {
      if (authenticated) {
        let miloCommentsStart = 0;
        try {
          showHideLoader(loader, true);
          let orgSource = 'IMS';
          if (isECC()) {
            orgSource = 'ECC';
          }

          miloCommentsStart = performance.now();
          const res = await request(miloCaseCommentListUrl, {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            },
            params: {
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().userId,
              id: caseId,
              regarding: 'incident',
              activityType: 'customernote',
              orgSource
            },
            key: 'milo-case-details',
          });
          const data = await res.json();
          const miloCommentsDuration = Number((performance.now() - miloCommentsStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: miloCaseCommentListUrl,
              duration: miloCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            const activityArray = [...data.customerNotes];
            if (data?.externalTickets?.customerNotes && data?.externalTickets?.customerNotes.length) {
              activityArray.push(...data.externalTickets.customerNotes);
            }

            return activityArray;
          }
          relicApiFail({
            status:data.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${data.error}`);
          showHideLoader(loader, false);

          return false;
        } catch (err) {
          const miloCommentsDuration = miloCommentsStart
            ? Number((performance.now() - miloCommentsStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * get commerce case Comments List
     */
    async function getCommerceCaseComments(caseId, loader) {
      if (authenticated) {
        let commerceCommentsStart = 0;
        try {
          showHideLoader(loader, true);
          let profileData = await adobeIMS.getProfile();
          commerceCommentsStart = performance.now();
          const res = await request(exlMiloCaseCommentListUrl, {
            credentials: 'include',
            headers: {
              Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              [headerKeys.accept]: headerValues.json,
            },
            params: {
              auth_id: profileData.authId,
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().rengaId,
              id: caseId,
              regarding: 'incident',
              activityType: 'customernote',
              date: new Date(),
              orgSource: 'AMC',
              date: new Date()
            },
            key: 'milo-case-details',
          });
          const resData = await res.json();
          const commerceCommentsDuration = Number((performance.now() - commerceCommentsStart) );

          const data = resData.result;

          if (resData.status === 200) {
            relicApiSuccess({
              endpoint: exlMiloCaseCommentListUrl,
              duration: commerceCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            const activityArray = [...data.customerNotes];
            if (data?.externalTickets?.customerNotes && data?.externalTickets?.customerNotes.length) {
              activityArray.push(...data.externalTickets.customerNotes);
            }

            return activityArray;
          }
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commerceCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${data.error}`);
          showHideLoader(loader, false);

          return false;
        } catch (err) {
          const commerceCommentsDuration = commerceCommentsStart
            ? Number((performance.now() - commerceCommentsStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commerceCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * get Milo external email List
     */
    async function getMiloExternalEmail(caseId, loader) {
      if (authenticated) {
        let miloExternalEmailStart = 0;
        try {
          showHideLoader(loader, true);
          miloExternalEmailStart = performance.now();
          let orgSource = 'IMS';
          if (isECC()) {
            orgSource = 'ECC';
          }

          const res = await request(miloCaseCommentListUrl, {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            },
            params: {
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().userId,
              id: caseId,
              regarding: 'incident',
              activityType: 'email',
              orgSource
            },
            key: 'milo-case-details',
          });
          const data = await res.json();
          const miloExternalEmailDuration = Number((performance.now() - miloExternalEmailStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: miloCaseCommentListUrl,
              duration: miloExternalEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            const activityArray = [];
            if (data?.emails && data?.emails.length) {
              activityArray.push(...data.emails);
            }
            if (data?.externalTickets?.emails && data?.externalTickets?.emails.length) {
              activityArray.push(...data.externalTickets.emails);
            }

            return activityArray;
          }
          relicApiFail({
            status:data.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloExternalEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${data.error}`);
          showHideLoader(loader, false);

          return false;
        } catch (err) {
          relicApiFail({
            status:err.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloExternalEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * get Milo external email List
     */
    async function getCommerceExternalEmail(caseId, loader) {
      if (authenticated) {
        let commerceExternalEmailStart = 0;
        try {
          showHideLoader(loader, true);
          let profileData = await adobeIMS.getProfile();
          commerceExternalEmailStart = performance.now();
          const res = await request(exlMiloCaseCommentListUrl, {
            credentials: 'include',
            headers: {
              Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              [headerKeys.accept]: headerValues.json,
            },
            params: {
              auth_id: profileData.authId,
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().rengaId,
              id: caseId,
              regarding: 'incident',
              activityType: 'email',
              orgSource: 'AMC',
              date: new Date()
            },
            key: 'milo-case-details',
          });
          const resData = await res.json();
          const commerceExternalEmailDuration = Number((performance.now() - commerceExternalEmailStart) );
          const data = resData.result;

          if (resData.status === 200) {
            relicApiSuccess({
              endpoint: exlMiloCaseCommentListUrl,
              duration: commerceExternalEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            const activityArray = [];
            if (data?.emails && data?.emails.length) {
              activityArray.push(...data.emails);
            }
            if (data?.externalTickets?.emails && data?.externalTickets?.emails.length) {
              activityArray.push(...data.externalTickets.emails);
            }

            return activityArray;
          }
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commerceExternalEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${data.error}`);
          showHideLoader(loader, false);

          return false;
        } catch (err) {
          const commerceExternalEmailDuration = commerceExternalEmailStart
            ? Number((performance.now() - commerceExternalEmailStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commerceExternalEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }


    /**
   * get commerce case Platform.sh Comments List
   */
    async function getCommercePlatformShComments(caseId, loader) {
      if (authenticated) {
        let commercePlatformShCommentsStart = 0;
        try {
          showHideLoader(loader, true);
          let profileData = await adobeIMS.getProfile();
          commercePlatformShCommentsStart = performance.now();
          const res = await request(exlMiloCaseCommentListUrl, {
            credentials: 'include',
            headers: {
              Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              [headerKeys.accept]: headerValues.json,
            },
            params: {
              auth_id: profileData.authId,
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().rengaId,
              id: caseId,
              regarding: 'incident',
              activityType: 'customernote',
              date: new Date(),
              orgSource: 'AMC',
              type: 'platform.sh'
            },
            key: 'milo-case-details'
          }),
            resData = await res.json();
          const commercePlatformShCommentsDuration = Number((performance.now() - commercePlatformShCommentsStart) );

          let data = resData.result;


          if (resData.status === 200) {
            relicApiSuccess({
              endpoint: exlMiloCaseCommentListUrl,
              duration: commercePlatformShCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            let activityArray = [...data.customerNotes];
            if (data?.externalTickets?.customerNotes && data?.externalTickets?.customerNotes.length) {
              activityArray.push(...data.externalTickets.customerNotes);
            }

            return activityArray;
          } else {
            relicApiFail({
              status:resData.status,
              endpoint: exlMiloCaseCommentListUrl,
              duration: commercePlatformShCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve case data1: ${data.error}`);
            showHideLoader(loader, false);

            return false;
          }
        } catch (err) {
          const commercePlatformShCommentsDuration = commercePlatformShCommentsStart
            ? Number((performance.now() - commercePlatformShCommentsStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commercePlatformShCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }
    /**
     * get Milo external email List
     */
    async function getMiloPlatformShComments(caseId, loader) {
      if (authenticated) {
        let miloPlatformShCommentsStart = 0;
        try {
          showHideLoader(loader, true);
          let orgSource = 'IMS';
          if (isECC()) {
            orgSource = 'ECC';
          }

          miloPlatformShCommentsStart = performance.now();
          const res = await request(miloCaseCommentListUrl, {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
            },
            params: {
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().userId,
              id: caseId,
              regarding: 'incident',
              activityType: 'customernote',
              orgSource,
              type: 'platform.sh'
            },
            key: 'milo-case-details'
          }),
            data = await res.json();
          const miloPlatformShCommentsDuration = Number((performance.now() - miloPlatformShCommentsStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: miloCaseCommentListUrl,
              duration: miloPlatformShCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            let activityArray = [];
            if (data?.emails && data?.emails.length) {
              activityArray.push(...data.emails);
            }
            if (data?.externalTickets?.emails && data?.externalTickets?.emails.length) {
              activityArray.push(...data.externalTickets.emails);
            }

            return activityArray;
          } else {
            relicApiFail({
              status:data.status,
              endpoint: miloCaseCommentListUrl,
              duration: miloPlatformShCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve case emails: ${data.error}`);
            showHideLoader(loader, false);

            return false;
          }
        } catch (err) {
          const miloPlatformShCommentsDuration = miloPlatformShCommentsStart
            ? Number((performance.now() - miloPlatformShCommentsStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloPlatformShCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
    * get Milo platform.sh email List
    */
    async function getMiloPlatformShEmail(caseId, loader) {
      if (authenticated) {
        let miloPlatformShEmailStart = 0;
        try {
          showHideLoader(loader, true);
          let orgSource = 'IMS';
          if (isECC()) {
            orgSource = 'ECC';
          }

          miloPlatformShEmailStart = performance.now();
          const res = await request(miloCaseCommentListUrl, {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`
            },
            params: {
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().userId,
              id: caseId,
              regarding: 'incident',
              activityType: 'email',
              orgSource,
              type: 'platform.sh'
            },
            key: 'milo-case-details'
          }),
            data = await res.json();
          const miloPlatformShEmailDuration = Number((performance.now() - miloPlatformShEmailStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: miloCaseCommentListUrl,
              duration: miloPlatformShEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            let activityArray = [];
            if (data?.emails && data?.emails.length) {
              activityArray.push(...data.emails);
            }
            if (data?.externalTickets?.emails && data?.externalTickets?.emails.length) {
              activityArray.push(...data.externalTickets.emails);
            }

            return activityArray;
          } else {
            relicApiFail({
              status:data.status,
              endpoint: miloCaseCommentListUrl,
              duration: miloPlatformShEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve case emails: ${data.error}`);
            showHideLoader(loader, false);

            return false;
          }
        } catch (err) {
          const miloPlatformShEmailDuration = miloPlatformShEmailStart
            ? Number((performance.now() - miloPlatformShEmailStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: miloCaseCommentListUrl,
            duration: miloPlatformShEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * get Milo external email List
     */
    async function getCommercePlatformShEmail(caseId, loader) {
      if (authenticated) {
        let commercePlatformShEmailStart = 0;
        try {
          showHideLoader(loader, true);
          let profileData = await adobeIMS.getProfile();
          commercePlatformShEmailStart = performance.now();
          const res = await request(exlMiloCaseCommentListUrl, {
            credentials: 'include',
            headers: {
              Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              [headerKeys.accept]: headerValues.json,
            },
            params: {
              auth_id: profileData.authId,
              orgId: getSelectedOrg().id,
              contactRengaId: getSelectedOrg().rengaId,
              id: caseId,
              regarding: 'incident',
              activityType: 'email',
              orgSource: 'AMC',
              date: new Date(),
              type: 'platform.sh'
            },
            key: 'milo-case-details'
          }),
            resData = await res.json();
          const commercePlatformShEmailDuration = Number((performance.now() - commercePlatformShEmailStart) );
          let data = resData.result;

          if (resData.status === 200) {
            relicApiSuccess({
              endpoint: exlMiloCaseCommentListUrl,
              duration: commercePlatformShEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            showHideLoader(loader, false);
            let activityArray = [];
            if (data?.emails && data?.emails.length) {
              activityArray.push(...data.emails);
            }
            if (data?.externalTickets?.emails && data?.externalTickets?.emails.length) {
              activityArray.push(...data.externalTickets.emails);
            }

            return activityArray;
          } else {
            relicApiFail({
              status:resData.status,
              endpoint: exlMiloCaseCommentListUrl,
              duration: commercePlatformShEmailDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`Failed to retrieve case emails: ${data.error}`);
            showHideLoader(loader, false);

            return false;
          }
        } catch (err) {
          const commercePlatformShEmailDuration = commercePlatformShEmailStart
            ? Number((performance.now() - commercePlatformShEmailStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: exlMiloCaseCommentListUrl,
            duration: commercePlatformShEmailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case emails: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }
    /**
     * get Workfront case detail
     */
    async function getWorkfrontCaseData(searchParams, loader) {
      const caseDetailsPage = appShadowRoot.querySelector('#case-detail #case-detail-page');
      const caseDetailsError = appShadowRoot.querySelector('#case-detail #error-sec');
      let workfrontCaseDetailStart = 0;
      caseDetailsError.querySelector('a').addEventListener('click', () => {
        queryString('case-id', '');
        supportProcess(SUPPORT_TABS.MY_CASES);
      });
      try {
        const requestHeaders = {};
        requestHeaders['Content-Type'] = 'application/json';
        requestHeaders['x-api-key'] = ClientId;
        requestHeaders.Authorization = `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`;
        showHideLoader(loader, true);
        workfrontCaseDetailStart = performance.now();
        const res = await request(workfrontCaseDetailUrl, {
          headers: { ...requestHeaders },
          params: { ...searchParams },
          key: 'workfront-case-details',
        });
        const data = await res.json();
        const workfrontCaseDetailDuration = Number((performance.now() - workfrontCaseDetailStart) );

        if (res.ok && data.data) {
          relicApiSuccess({
            endpoint: workfrontCaseDetailUrl,
            duration: workfrontCaseDetailDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (caseDetailsPage.classList.contains('is-hidden')) {
            caseDetailsPage.classList.remove('is-hidden');
          }
          if (!caseDetailsError.classList.contains('is-hidden')) {
            caseDetailsError.classList.add('is-hidden');
          }

          showHideLoader(loader, false);

          return data.data;
        }
        relicApiFail({
          status:data.status,
          endpoint: workfrontCaseDetailUrl,
          duration: workfrontCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${data.error}`);
        caseDetailsError.querySelector('p span').innerText = 'Something went wrong, not able retrieve case detail';
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }
        showHideLoader(loader, false);

        return false;
      } catch (err) {
        const workfrontCaseDetailDuration = workfrontCaseDetailStart
          ? Number((performance.now() - workfrontCaseDetailStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: workfrontCaseDetailUrl,
          duration: workfrontCaseDetailDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve case data1: ${err.message}`);
        caseDetailsError.querySelector('p span').innerText = 'Something went wrong, not able retrieve case detail';
        if (!caseDetailsPage.classList.contains('is-hidden')) {
          caseDetailsPage.classList.add('is-hidden');
        }
        if (caseDetailsError.classList.contains('is-hidden')) {
          caseDetailsError.classList.remove('is-hidden');
        }
        showHideLoader(loader, false);

        return false;
      }
    }

    /**
     * get Workfront case Comments list
     */
    async function getWorkfrontCaseComments(caseId, loader) {
      if (authenticated) {
        let workfrontCaseCommentsStart = 0;
        try {
          showHideLoader(loader, true);
          workfrontCaseCommentsStart = performance.now();
          const res = await request(workfrontCaseCommentListUrl, {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            },
            params: {
              contactRengaId: userprofile.email,
              caseId,
            },
            key: 'milo-case-details',
          });
          const data = await res.json();
          const workfrontCaseCommentsDuration = Number((performance.now() - workfrontCaseCommentsStart) );

          if (res.ok) {
            relicApiSuccess({
              endpoint: workfrontCaseCommentListUrl,
              duration: workfrontCaseCommentsDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            const comments = [];
            if (data.data && Array.isArray(data.data.records)) {
              data.data.records.forEach((comment) => {
                const commentObj = {
                  createdBy: {
                    firstName: comment.CreatedBy?.Name,
                    lastName: '',
                    rengaId: '',
                  },
                  createdOn: comment.CreatedDate,
                  description: comment.CommentBody,
                  direction: '',
                  type: comment.Channel,
                };
                comments.push(commentObj);
              });
            }
            showHideLoader(loader, false);

            return comments;
          }
          relicApiFail({
            status:data.status,
            endpoint: workfrontCaseCommentListUrl,
            duration: workfrontCaseCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${data.error}`);
          showHideLoader(loader, false);

          return false;
        } catch (err) {
          const workfrontCaseCommentsDuration = workfrontCaseCommentsStart
            ? Number((performance.now() - workfrontCaseCommentsStart) )
            : 0;
          relicApiFail({
            status:err.status,
            endpoint: workfrontCaseCommentListUrl,
            duration: workfrontCaseCommentsDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve case data1: ${err.message}`);
          showHideLoader(loader, false);

          return false;
        }
      } else {
        return false;
      }
    }

    /**
     * download Workfront case Attachment to preview
     */
    async function downloadWorkfrontAttachmentById(attachment, isDownload = false) {
      const downloadEndpoint = workfrontCaseAttachmentsDownloadUrl;
      let downloadWorkfrontStart = 0;
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          attachmentId: attachment.attachmentId,
          contactRengaId: userprofile.email,
        },
      };
      try {
        downloadWorkfrontStart = performance.now();
        const res = await request(downloadEndpoint, options);
        let blobFile = await res.blob();
        const downloadWorkfrontDuration = Number((performance.now() - downloadWorkfrontStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: downloadEndpoint,
            duration: downloadWorkfrontDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (isDownload === false) {
            const extension = attachment.fileName.split('.').pop();
            blobFile = blobFile.slice(0, blobFile.size, `image/${extension}`);
            const imagebase64 = await convertFileToBase64(blobFile);
            caseAttachments.push({
              attachmentId: attachment.attachmentId,
              fileName: attachment.fileName,
              fileExt: extension,
              base64Url: imagebase64,
            });
          } else {
            blobFile = blobFile.slice(0, blobFile.size, `image/${attachment.ext}`);
            const fileUrl = URL.createObjectURL(blobFile);
            const a = document.createElement('a');
            a.href = fileUrl;
            a.style = 'display: none';
            a.target = '_blank';
            a.download = attachment.fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
          }
        } else {
          relicApiFail({
            status:res.status,
            endpoint: downloadEndpoint,
            duration: downloadWorkfrontDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = blobFile.error[0];
          removeImageLoader();
          log(`There was some error while download attachment: ${error.message}`);
          notice(`${error.message}`, true, void 0, 'negative', 0);
        }
      } catch (err) {
        const downloadWorkfrontDuration = downloadWorkfrontStart
          ? Number((performance.now() - downloadWorkfrontStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: downloadEndpoint,
          duration: downloadWorkfrontDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        removeImageLoader();
        log(`There was some error retriving attachments: ${err.message}`);
        notice(getLabelV2('There was an error while downloading attachment'), true, void 0, 'negative', 0);
      }
    }

    /**
     * create comments view
     */
    async function setCommentsView() {
      let commentsHtml = '';

      commentsList = [
        ...new Map(
          commentsList
            .filter(item => item.guid)
            .map(item => [item.guid, item])
        ).values(),
        ...commentsList.filter(item => !item.guid)
      ];
      if (commentsList.length > 0) {
        commentsList.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
        // let lastDate = getFormattedDate(commentsList[0].createdOn).substring(0, 10);
        for (const [i, comment] of commentsList.entries()) {
          // const commentData = getFormattedDate(comment.createdOn).substring(0, 10);
          // const commentDataTime = getFormattedDate(comment.createdOn);
          const commentDataTime = getFormattedDate(comment.createdOn);

          let description = '';
          if (isWorkFrontCase) {
            if (comment.type === 'case') {
              description = getSafeHtml(comment.description)
                .replace(URL_PATTERN_HTTP, '<a href="$1" target="_blank">$1</a>')
                .replace(URL_PATTERN_WWW, '$1<a href="//$2" target="_blank">$2</a>')
                .replace(EMAIL_PATTERN, '<a href="mailto:$1">$1</a>');
            } else {
              description = comment.description;
            }
          } else {
            description = getSafeHtml(comment.descriptionHtml)
              .replace(URL_PATTERN_HTTP, '<a href="$1" target="_blank">$1</a>')
              .replace(URL_PATTERN_WWW, '$1<a href="//$2" target="_blank">$2</a>')
              .replace(EMAIL_PATTERN, '<a href="mailto:$1">$1</a>');
          }
          // commentsHtml += views.get('support-comments-item')({
          //   comment,
          //   commentDataTime,
          //   description,
          //   klass: i !== 0 && i !== 0 && lastDate !== commentData ? 'break' : '',
          //   last: i === commentsList.length - 1,
          // });
          // lastDate = getFormattedDate(commentsList[0].createdOn).substring(0, 10);

          let descriptionHtml = '';
          if (comment?.descriptionHtml) {
            
            const decodedHtml = description
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&quot;/g, '"')
              .replace(/&#39;/g, "'")
              .replace(/&amp;/g, '&') // This should be last
              .replaceAll(/\n/g, '<br/>'); // Convert newlines to line breaks
            descriptionHtml = decodedHtml;
          } else {
            descriptionHtml = comment?.description ? comment?.description : " ";
            descriptionHtml = descriptionHtml
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&quot;/g, '"')
              .replace(/&#39;/g, "'")
              .replace(/&amp;/g, '&') // This should be last
              .replaceAll(/\n/g, '<br/>'); // Convert newlines to line breaks
          }
          const last = i === commentsList.length - 1;
            commentsHtml += `
            <li class="">
              <div class=" border radius-5 has-background-white is-padded-small">
                <div class="is-flex is-vcentered is-justify-content-space-between is-margin-bottom-big resp-flex-wrap">
                  <div class="is-flex is-vcentered">
                    <span class="support_user_img" data-cs-mask>
                      <img src="/assets/img/support/user-placeholder.svg" alt="Use">
                    </span>
                    <span class="is-padded-left font-14" data-cs-mask>${comment.createdBy.firstName} ${comment.createdBy.lastName ? comment.createdBy.lastName : ''}</span>
                  </div>
                  <span class="font-14">${commentDataTime}</span>
                </div>
                <div class="comment-content" data-cs-mask>${descriptionHtml}</div>
              </div>
              <div class="is-margin-top-big ${last ? '' : 'is-hidden'}">
                <span class="end-msg is-size-7 is-uppercase">End</span>
              </div>
            </li>`;
        }
      }
      $llel.caseComments.innerHTML = commentsHtml;
    }

    /**
     * create reason Code picker
     */
    function prepareMiloCaseActionPicker(elementSelector) {
      const pickerMainEl = appShadowRoot.querySelector(`#${elementSelector}`);
      const pickerElement = pickerMainEl.querySelector('.adobe-exl-picker');
      const pickerTextElement = pickerElement.querySelector('.spectrum-Picker-label');
      const pickerIconElement = pickerElement.querySelector('.spectrum-Icon');
      const pickerElementOptions = pickerMainEl.querySelector('.adobe-exl-pickerOptions');
      const pickerButton = pickerMainEl.querySelector('.spectrum-Picker');
      const chevronDown = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
        <defs>
          <style>
            .fill {
              fill: #464646;
            }
          </style>
        </defs>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z" />
      </svg>`;
      // picker button click event to open an close picker
      pickerElement.addEventListener('click', (event) => {
        log('Action picker clicked');
        event.stopPropagation();
        event.preventDefault();
        if (pickerElementOptions.classList.contains('is-open')) {
          pickerElementOptions.classList.remove('is-open');
          pickerButton.lastElementChild.outerHTML = chevronDown;
          log(`Action picker closed (#${elementSelector})`);
        } else {
          pickerElementOptions.classList.add('is-open');
          pickerButton.lastElementChild.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
            <defs>
              <style>
                .fill {
                  fill: #464646;
                }
              </style>
            </defs>
            <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z" />
          </svg>`;
          log(`Action picker opend (#${elementSelector})`);
        }
      });

      // add clicked event to picker options
      for (const listItem of pickerElementOptions.querySelectorAll('li')) {
        listItem.addEventListener('click', (event) => {
          log('Action picker option clicked');
          const selectedValue = listItem.getAttribute('data-id');
          const selectedLabel = listItem.getAttribute('data-label');
          event.stopPropagation();
          pickerTextElement.innerText = `${selectedLabel}`;
          pickerButton.lastElementChild.outerHTML = chevronDown;
          const selectedElement = pickerElementOptions.querySelector('li.is-selected');
          if (selectedElement) {
            selectedElement.classList.remove('is-selected');
          }
          listItem.classList.add('is-selected');
          pickerElementOptions.classList.remove('is-open');

          caseActionData.reasonCode = +selectedValue;
        });
        log(`Action picker ready for (#${elementSelector})`);
      }
    }

    /**
     * milo case action (escalate / close) case
     */

    async function miloCaseAction(actionType, btnLoader) {
      let orgSource = 'IMS';
      let miloCaseActionStart = 0;
      if (isECC()) {
        orgSource = 'ECC';
      }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          orgSource
        },
        body: {},
      };
      const requestPayload = { ...caseActionData };
      requestPayload.type = actionType;
      const reasonSummary = appShadowRoot.querySelector('#case-reason-summary').value.trim();
      const searchParams = {
        caseId: caseNumber,
        orgId: getSelectedOrg().id,
        contactRengaId: getSelectedOrg().userId,
        orgSource
      };
      if (requestPayload.reasonCode === '') {
        log('Please select reason');
        notice(getLabelV2('Please select reason'), true, void 0, 'negative', 0);

        return;
      }
      if (reasonSummary.length >= 250) {
        log('Reason summary should not exceed 250 characters');
        notice(getLabelV2('Reason summary should not exceed 250 characters'), true, void 0, 'negative', 0);

        return;
      }
      if (reasonSummary === '') {
        log('Please enter reason summary');
        notice(getLabelV2('Please enter reason summary'), true, void 0, 'negative', 0);

        return;
      }
      requestPayload.reasonSummary = reasonSummary;
      requestPayload.orgSource = orgSource;


      options.body = JSON.stringify({ ...requestPayload });
      try {
        showHideLoader(btnLoader, true);
        miloCaseActionStart = performance.now();
        const res = await request(miloCaseActionUrl, options);
        const data = await res.json();
        const miloCaseActionDuration = Number((performance.now() - miloCaseActionStart) );
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseActionUrl,
            duration: miloCaseActionDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails = await getMiloCaseData(searchParams);
          let classAppend;
          const classesToRemove = ['status_neutral_tag', 'status_positive_tag', 'status_notice_tag', 'status_info_tag'];
          for (const key in supportTicketUIStatus) {
            const normalizedKey = key.replace('_', ' ').toLowerCase();
            let normalizedStatusReasonText = caseDetails.statusReasonText.toLowerCase();
            if (caseDetails.statusReasonText === 'Cancel/Misroute') {
              normalizedStatusReasonText = normalizedStatusReasonText.replace('/', ' ');
              classAppend = `status_${supportTicketUIStatus[key].variant}_tag`;
            }
            if (normalizedKey === normalizedStatusReasonText) {
              classAppend = `status_${supportTicketUIStatus[key].variant}_tag`;
            }
          }

          console.log('actionType', actionType);
          
          if (actionType === 'REOPEN') {
            if (!$llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
              $llel.myCaseSurveyBtn.classList.add('is-hidden');
            }
            notice(getLabelV2('Your case has been successfully reopened.'), true, void 0, 'positive', 0);
            $llel.reopenCaseBtn.classList.add('is-hidden');
            // $llel.requestcallbackBtn.classList.remove('is-hidden');
            $llel.reopenTooltip.classList.add('is-hidden');
            // $llel.escalateCaseBtn.classList.remove('is-hidden');
            $llel.closeCaseBtn.classList.remove('is-hidden');
            // $llel.escalateCaseBtn.disabled = true;
            $llel.closeCaseBtn.disabled = false;
            classesToRemove.forEach((className) => {
              if ($llel.caseHead.querySelector('a').classList.contains(className)) {
                $llel.caseHead.querySelector('a').classList.remove(className);
              }
            });
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            $llel.caseHead.querySelector('a span').innerHTML = getLabelV2(caseDetails.statusReasonText);
            caseDetails.status = 0;
            $llel.caseCommentArea.classList.remove('is-hidden');
            $llel.caseCommentInputContainer.classList.remove('is-hidden');
            if ($llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.remove('is-hidden');
            }
            if ($llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.remove('is-not-allow');
            }

            let editor = appShadowRoot.querySelector('#comment-area-new');
            editor.addEventListener('input', () => {
              
              if (editor.innerHTML && editor.innerHTML.trim().length && caseDetails.status === 0) {
                $llel.caseCommentsSubmit.disabled = false;
                commentRequest.customerNote.descriptionHtml = editor.innerHTML;
                commentRequest.customerNote.description = editor.innerText;
              } else {
                $llel.caseCommentsSubmit.disabled = true;
                commentRequest.customerNote.description = '';
                commentRequest.customerNote.descriptionHtml = '';
              }
            })



            const companyEntitlements = await getEntitlementsString();
            adobeDataLayerTrack({
              "event": "linkClicked",
              "eventType": "web.webInteraction.linkclicks",
              "companyLoginDetails": {
                "companyLoginName": selectedOrg.name,
                "companyLoginID": selectedOrg.id,
                "companyEntitlements": companyEntitlements,
              },
              "caseDetails":{
                "Title": caseDetails.title,
                "Product": caseDetails.productName,
                "caseNumber": caseDetails.caseId,
                "Priority": caseDetails.priorityText
              },
              "link": {
                "linkTitle": "Reopen case",
                "linkLocation": "casePage:reopenCase",
                "linkType": "button",
              }
            });
            $llel.reopenCaseBtn.addEventListener('click', async () => {
              // eslint-disable-next-line no-use-before-define
              openConfirmationModal('REOPEN', 'MILO');
            });
            // to enable comment area
          } else if (actionType === 'ESCALATE') {
            notice(getLabelV2('Your case has been successfully escalated to management.'), true, void 0, 'positive', 0);
            // $llel.escalateCaseBtn.setAttribute('disabled', true);
          } else {
            console.log('test comment');
            // let surveyURL = `https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails.email)}&Device_Type=EXL`;
            let surveyURL = `https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails?.agentAssigned?.emailId)}&Device_Type=EXL`;
            if (caseDetails?.surveyUrl) {
              surveyURL = caseDetails?.surveyUrl;
              surveyURL = surveyURL + '&Device_Type=EXL';
            }
            window._qsie = window._qsie || [];
            window._qsie.push('set', 'ownerEmail', 'gra61007@adobe.com');
            window._qsie.push('ClosedCase');
            if (window.QSI && window.QSI.API) {
              window.QSI.API.unload();
              window.QSI.API.load().then(function() {
                window.QSI.API.run();
              });
            }
            notice(getLabelV2('Your case has been closed successfully.'), true, void 0, 'positive', 0);
            if (await checkSurveyDate(caseDetails.lastModified) && caseDetails.statusText === 'Closed' && caseDetails.admin.rengaId === searchParams.contactRengaId && !userprofile.email.includes('@adobe.com')) {
              if ($llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
                $llel.myCaseSurveyBtn.classList.remove('is-hidden');
              }
              $llel.myCaseSurveyBtn.addEventListener('click', () => {
                // window.open(`https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?idx=SV_5b6RcUGkMMNp3V4&SIC=0136193c223baf4bc08426c16e193a56&CID=${caseDetails.caseId}=Z2xvNTg4NThAYWRvYmUuY29t&Device_Type=EXL`, '_blank');
                //  window.open(`https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails.email)}&Device_Type=EXL`, '_blank');
                window.open(surveyURL, '_blank');
                // window.open(`${caseDetails.surveyUrl}&Device_Type=EXL`, '_blank');
              });
            } else if (!$llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
              $llel.myCaseSurveyBtn.classList.add('is-hidden');
            }
            $llel.closeCaseBtn.setAttribute('disabled', true);
            $llel.reopenCaseBtn.classList.remove('is-hidden');
            $llel.needAdditinalHelpBtn.classList.add('is-hidden');
            // $llel.requestcallbackBtn.classList.add('is-hidden');
            // $llel.escalateCaseBtn.classList.add('is-hidden');
            $llel.closeCaseBtn.classList.add('is-hidden');
            classesToRemove.forEach((className) => {
              if ($llel.caseHead.querySelector('a').classList.contains(className)) {
                $llel.caseHead.querySelector('a').classList.remove(className);
              }
            });
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            $llel.caseHead.querySelector('a span').innerHTML = getLabelV2(caseDetails.statusReasonText);
            caseDetails.statusCode = 1;
            if (!$llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.add('is-hidden');
            }
            if (!$llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.add('is-not-allow');
            }

            const companyEntitlements = await getEntitlementsString();
            adobeDataLayerTrack({
              "event": "linkClicked",
              "eventType": "web.webInteraction.linkclicks",
              "companyLoginDetails": {
                "companyLoginName": selectedOrg.name,
                "companyLoginID": selectedOrg.id,
                "companyEntitlements": companyEntitlements,
              },
              "caseDetails":{
                "Title": caseDetails.title,
                "Product": caseDetails.productName,
                "caseNumber": caseDetails.caseId,
                "Priority": caseDetails.priorityText
              },
              "link": {
                "linkTitle": "Close case",
                "linkLocation": "casePage:closeCase",
                "linkType": "button clicked",
              }
            });
              $llel.closeCaseBtn.addEventListener('click', async () => {
              // eslint-disable-next-line no-use-before-define
              openConfirmationModal('CLOSE', 'MILO');
            });
          }
          showHideLoader(btnLoader, false);
          close();
        } else {
          relicApiFail({
            status:data.status,
            endpoint: miloCaseActionUrl,
            duration: miloCaseActionDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          showHideLoader(btnLoader, false);
          log(`There was some error while ${actionType.toLowerCase()}ing the case: ${error.message}`);
          notice(error.message, true, void 0, 'negative', 0);
        }
        let openFormOptions = {
          caseId: caseDetails.caseId,
          caseTitle: caseDetails.title,
          host_surface_name: 'EXL-Case Detail',
          productCode: caseDetails.productCode,
          supportPortalType: 'legacy support portal',
          oncloseCallbackDialogFn
        };
        // await initWebcall('EXL-Case Detail-2', openFormOptions);
        initWebcall('EXL-Case Detail-2', openFormOptions)
          .then(() => {
            return ZeonCallbackClient.canRequestAdditionalHelp(caseDetails.caseId);
          })
          .then((showAdditionalHelp) => {
            console.log('showAdditionalHelp', showAdditionalHelp);
            if (showAdditionalHelp) {
              removeClass($llel.needAdditinalHelpBtn, 'is-hidden');
            } else {
              addClass($llel.needAdditinalHelpBtn, 'is-hidden');
            }
          })
          .catch(() => {
            addClass($llel.needAdditinalHelpBtn, 'is-hidden');
        });
      } catch (err) {
        const miloCaseActionDuration = miloCaseActionStart
          ? Number((performance.now() - miloCaseActionStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: miloCaseActionUrl,
          duration: miloCaseActionDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while ${actionType.toLowerCase()}ing the case: ${err.message}`);
        showHideLoader(btnLoader, false);
        notice(
          getLabelV2('There was some error while processing this request. Please try later'),
          true,
          void 0,
          'negative',
          0,
        );
      }
    }

    /**
     * commerce case action (escalate / close) case
     */
    async function commerceCaseAction(actionType, btnLoader) {
      let profileData = await adobeIMS.getProfile();
      let commerceCaseActionStart = 0;
      
      const options = {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
          accept: 'application/json',
          'content-type': 'application/json',
        },
        params: {orgSource: 'AMC',auth_id: profileData.authId},
        body: {},
      };
      const requestPayload = { ...caseActionData };
      requestPayload.type = actionType;
      const reasonSummary = appShadowRoot.querySelector('#case-reason-summary').value.trim();
      const searchParams = {
        caseId: caseNumber,
        orgId: getSelectedOrg().id,
        contactRengaId: getSelectedOrg().userId,
        orgSource: 'AMC'
      };
      if (requestPayload.reasonCode === '') {
        log('Please select reason');
        notice(getLabelV2('Please select reason'), true, void 0, 'negative', 0);

        return;
      }
      if (reasonSummary.length >= 250) {
        log('Reason summary should not exceed 250 characters');
        notice(getLabelV2('Reason summary should not exceed 250 characters'), true, void 0, 'negative', 0);

        return;
      }
      if (reasonSummary === '') {
        log('Please enter reason summary');
        notice(getLabelV2('Please enter reason summary'), true, void 0, 'negative', 0);

        return;
      }
      requestPayload.reasonSummary = reasonSummary;

      requestPayload.contactRengaId = getSelectedOrg().rengaId;
      requestPayload.orgSource = 'AMC';

      options.body = JSON.stringify({ ...requestPayload });
      try {
        showHideLoader(btnLoader, true);
        commerceCaseActionStart = performance.now();
        const res = await request(exlMiloCaseActionUrl, options);
        const resData = await res.json();
        const commerceCaseActionDuration = Number((performance.now() - commerceCaseActionStart) );
        const data = resData.result;
        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseActionUrl,
            duration: commerceCaseActionDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails = await getCommerceCaseData(searchParams);
          console.log('caseDetails', caseDetails);
          
          let classAppend;
          const classesToRemove = ['status_neutral_tag', 'status_positive_tag', 'status_notice_tag', 'status_info_tag'];
          for (const key in supportTicketUIStatus) {
            const normalizedKey = key.replace('_', ' ').toLowerCase();
            let normalizedStatusReasonText = caseDetails.statusReasonText.toLowerCase();
            if (caseDetails.statusReasonText === 'Cancel/Misroute') {
              normalizedStatusReasonText = normalizedStatusReasonText.replace('/', ' ');
              classAppend = `status_${supportTicketUIStatus[key].variant}_tag`;
            }
            if (normalizedKey === normalizedStatusReasonText) {
              classAppend = `status_${supportTicketUIStatus[key].variant}_tag`;
            }
          }
          if (actionType === 'REOPEN') {
            notice(getLabelV2('Your case has been successfully reopened.'), true, void 0, 'positive', 0);
            $llel.reopenCaseBtn.classList.add('is-hidden');
            // $llel.requestcallbackBtn.classList.remove('is-hidden');
            $llel.reopenTooltip.classList.add('is-hidden');
            // $llel.escalateCaseBtn.classList.remove('is-hidden');
            $llel.closeCaseBtn.classList.remove('is-hidden');
            // $llel.escalateCaseBtn.disabled = true;
            $llel.closeCaseBtn.disabled = false;
            classesToRemove.forEach((className) => {
              if ($llel.caseHead.querySelector('a').classList.contains(className)) {
                $llel.caseHead.querySelector('a').classList.remove(className);
              }
            });
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            $llel.caseHead.querySelector('a span').innerHTML = getLabelV2(caseDetails.statusReasonText);
            caseDetails.status = 0;
            $llel.caseCommentArea.classList.remove('is-hidden');
            $llel.caseCommentInputContainer.classList.remove('is-hidden');

            if ($llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.remove('is-hidden');
            }
            if ($llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.remove('is-not-allow');
            }

            let editor = appShadowRoot.querySelector('#comment-area-new');
            editor.addEventListener('input', () => {
              if (editor.innerHTML && editor.innerHTML.trim().length && caseDetails.status === 0) {
                $llel.caseCommentsSubmit.disabled = false;
                commentRequest.customerNote.descriptionHtml = editor.innerHTML;
                commentRequest.customerNote.description = editor.innerText;
              } else {
                $llel.caseCommentsSubmit.disabled = true;
                commentRequest.customerNote.description = '';
                commentRequest.customerNote.descriptionHtml = '';
              }
            })


            $llel.closeCaseBtn.addEventListener('click', async () => {
              const companyEntitlements = await getEntitlementsString();
              adobeDataLayerTrack({
                "event": "linkClicked",
                "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                  "companyLoginName": selectedOrg.name,
                  "companyLoginID": selectedOrg.id,
                  "companyEntitlements": companyEntitlements,
                },
                "link": {
                  "linkTitle": "Close case",
                  "linkLocation": "casePage:closeCase",
                  "linkType": "button clicked",
                }
              });
              // eslint-disable-next-line no-use-before-define
              openConfirmationModal('CLOSE', 'MILO');
            });
          } else if (actionType === 'ESCALATE') {
            notice(getLabelV2('Your case has been successfully escalated to management.'), true, void 0, 'positive', 0);
            // $llel.escalateCaseBtn.setAttribute('disabled', true);
          } else {
            notice(getLabelV2('Your case has been closed successfully.'), true, void 0, 'positive', 0);
            window._qsie = window._qsie || [];
            window._qsie.push('set', 'ownerEmail', 'gra61007@adobe.com');
            window._qsie.push('ClosedCase');

            if (window.QSI && window.QSI.API) {
              window.QSI.API.unload();
              window.QSI.API.load().then(function() {
                window.QSI.API.run();
              });
            }
            $llel.closeCaseBtn.setAttribute('disabled', true);
            $llel.reopenCaseBtn.classList.remove('is-hidden');
            $llel.needAdditinalHelpBtn.classList.add('is-hidden');
            // $llel.requestcallbackBtn.classList.add('is-hidden');
            // $llel.escalateCaseBtn.classList.add('is-hidden');
            $llel.closeCaseBtn.classList.add('is-hidden');
            classesToRemove.forEach((className) => {
              if ($llel.caseHead.querySelector('a').classList.contains(className)) {
                $llel.caseHead.querySelector('a').classList.remove(className);
              }
            });
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            $llel.caseHead.querySelector('a span').innerHTML = getLabelV2(caseDetails.statusReasonText);
            caseDetails.statusCode = 1;
            if (!$llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.add('is-hidden');
            }
            if (!$llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.add('is-not-allow');
            }
            $llel.reopenCaseBtn.addEventListener('click', async () => {
              const companyEntitlements = await getEntitlementsString();
              adobeDataLayerTrack({
                "event": "linkClicked",
                "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                  "companyLoginName": selectedOrg.name,
                  "companyLoginID": selectedOrg.id,
                  "companyEntitlements": companyEntitlements,
                },
                "link": {
                  "linkTitle": "Reopen case",
                  "linkLocation": "caseDetail:reopenCase",
                  "linkType": "button clicked",
                }
              });
              // eslint-disable-next-line no-use-before-define
              openConfirmationModal('REOPEN', 'MILO');
            });
          }
          showHideLoader(btnLoader, false);
          close();
        } else {
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloCaseActionUrl,
            duration: commerceCaseActionDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          showHideLoader(btnLoader, false);
          log(`There was some error while ${actionType.toLowerCase()}ing the case: ${error.message}`);
          notice(error.message, true, void 0, 'negative', 0);
        }
        let openFormOptions = {
          caseId: caseDetails.caseId,
          caseTitle: caseDetails.title,
          host_surface_name: 'EXL-Case Detail',
          productCode: caseDetails.productCode,
          supportPortalType: 'legacy support portal',
          oncloseCallbackDialogFn
        };
        // await initWebcall('EXL-Case Detail-2', openFormOptions);
        initWebcall('EXL-Case Detail-2', openFormOptions)
          .then(() => {
            return ZeonCallbackClient.canRequestAdditionalHelp(caseDetails.caseId);
          })
          .then((showAdditionalHelp) => {
            console.log('showAdditionalHelp', showAdditionalHelp);
            if (showAdditionalHelp) {
              removeClass($llel.needAdditinalHelpBtn, 'is-hidden');
            } else {
              addClass($llel.needAdditinalHelpBtn, 'is-hidden');
            }
          })
          .catch(() => {
            addClass($llel.needAdditinalHelpBtn, 'is-hidden');
        });
      } catch (err) {
        const commerceCaseActionDuration = commerceCaseActionStart
          ? Number((performance.now() - commerceCaseActionStart) )
          : 0;
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseActionUrl,
          duration: commerceCaseActionDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while ${actionType.toLowerCase()}ing the case: ${err.message}`);
        showHideLoader(btnLoader, false);
        notice(
          getLabelV2('There was some error while processing this request. Please try later'),
          true,
          void 0,
          'negative',
          0,
        );
      }
    }

    /**
     * workfront case escalate
     */
    async function workfrontCaseEscalate(btnLoader) {
      let workfrontCaseEscalateStart = 0;
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          caseId: caseNumber,
          contactRengaId: userprofile.email,
        },
        body: JSON.stringify({
          Escalation_Reason__c: appShadowRoot.querySelector('#case-reason-summary').value.trim() || '',
        }),
      };
      workfrontCaseEscalateStart = performance.now();
      const workfrontCaseEscalateDuration = Number((performance.now() - workfrontCaseEscalateStart) );
      try {
        showHideLoader(btnLoader, true);
        const res = await request(workfrontCaseEscalateUrl, options);
        const data = await res.json();
        if (res.ok) {
          relicApiSuccess({
            endpoint: workfrontCaseEscalateUrl,
            duration: workfrontCaseEscalateDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          notice(getLabelV2('Case escalated successfully'), true, void 0, 'positive', 0);
          // $llel.escalateCaseBtn.setAttribute('disabled', true);
          showHideLoader(btnLoader, false);
          close();
        } else {
          relicApiFail({
            status:data.status,
            endpoint: workfrontCaseEscalateUrl,
            duration: workfrontCaseEscalateDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          showHideLoader(btnLoader, false);
          log(`There was some error while escalating the case: ${error.message}`);
          notice(`${error.message}`, true, void 0, 'negative', 0);
        }
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: workfrontCaseEscalateUrl,
          duration: workfrontCaseEscalateDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        showHideLoader(btnLoader, false);
        log(`There was some error while escalating the case: ${err.message}`);
        notice(getLabelV2('There was an error while escalating the case'), true, void 0, 'negative', 0);
      }
    }

    /**
     * workfront case close
     */
    async function workfrontCaseClose(btnLoader) {
      let workfrontCaseCloseStart = 0;
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          caseId: caseNumber,
          contactRengaId: userprofile.email,
        },
        body: {},
      };
      const requestPayload = {
        status: 'Closed',
      };

      options.body = JSON.stringify({ ...requestPayload });
      workfrontCaseCloseStart = performance.now();
      const workfrontCaseCloseDuration = Number((performance.now() - workfrontCaseCloseStart) );
      try {
        showHideLoader(btnLoader, true);
        const res = await request(workfrontCaseCloseUrl, options);
        const data = await res.json();
        if (res.ok) {
          relicApiSuccess({
            endpoint: workfrontCaseCloseUrl,
            duration: workfrontCaseCloseDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          notice(getLabelV2('Closed'), true, void 0, 'positive', 0);
          showHideLoader(btnLoader, false);
          $llel.closeCaseBtn.setAttribute('disabled', true);
          // $llel.escalateCaseBtn.setAttribute('disabled', true);
          $llel.caseHead.querySelector('a').classList.remove('status_open_tag');
          $llel.caseHead.querySelector('a').classList.add('status_closed_tag');
          $llel.caseHead.querySelector('a span').innerHTML = getLabelV2('Closed');
          caseDetails.statusCode = 1;
          if (!$llel.caseDetailAttachment.classList.contains('is-hidden')) {
            $llel.caseDetailAttachment.classList.add('is-hidden');
          }
          if (!$llel.caseAttachment.classList.contains('is-not-allow')) {
            $llel.caseAttachment.classList.add('is-not-allow');
          }
          close();
        } else {
          relicApiFail({
            status:data.status,
            endpoint: workfrontCaseCloseUrl,
            duration: workfrontCaseCloseDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          const error = data.error[0];
          showHideLoader(btnLoader, false);
          log(`There was some error while escalating the case: ${error.message}`);
          notice(`${error.message}`, true, void 0, 'negative', 0);
        }
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: workfrontCaseCloseUrl,
          duration: workfrontCaseCloseDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        showHideLoader(btnLoader, false);
        log(`There was some error while escalating the case: ${err.message}`);
        notice(getLabelV2('There was an error while escalating the case'), true, void 0, 'negative', 0);
      }
    }

    /**
     * Check SMS / WhatsApp notification eligibility for case detail opt-ins
     */
    async function checkCaseDetailNotificationEligibility() {
      if (!ENABLE_PHONE_NOTIFICATION_OPT_IN) {
        const section = $llel.caseOptInSection;
        if (section) addClass(section, 'is-hidden');
        return;
      }

      const smsWrap = appShadowRoot?.querySelector('#case-detail-sms-opt-in-wrap');
      const waWrap = appShadowRoot?.querySelector('#case-detail-whatsapp-opt-in-wrap');
      const smsCheckbox = $llel.smsOptInCheckbox;
      const waCheckbox = $llel.whatsappOptInCheckbox;
      const section = $llel.caseOptInSection;
      const hideOptIns = () => {
        if (smsCheckbox) smsCheckbox.checked = false;
        if (waCheckbox) waCheckbox.checked = false;
        if (smsWrap) addClass(smsWrap, 'is-hidden');
        if (waWrap) addClass(waWrap, 'is-hidden');
        if (section) addClass(section, 'is-hidden');
      };

      const countryCode = caseDetails?.optInCountryCode || '';
      const phoneNumber = caseDetails?.phone || '';
      if (!countryCode || !getSelectedOrg()?.id) {
        hideOptIns();
        return;
      }

      try {
        const org = getSelectedOrg();
        const isUltimate = await getSupportEntitlements();
        const profile = await window.adobeIMS.getProfile();
        const res = await request(whatsappNotifEligibilityUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': ClientId,
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          body: JSON.stringify({
            countryCode,
            phoneNumber,
            level: isUltimate ? 'Ultimate' : 'Expert',
            customerName: profile?.displayName || userprofile?.email || '',
            customerEmail: userprofile?.email || profile?.email || '',
            orgId: org.id,
            rengaId: org.rengaId || org.userId || '',
          }),
        });
        const data = await res.json();
        if (!res.ok || data?.status !== 'success' || (!data?.data?.sms && !data?.data?.whatsapp)) {
          hideOptIns();
          return;
        }

        removeClass(section, 'is-hidden');
        if (smsWrap) {
          if (data.data.sms) {
            removeClass(smsWrap, 'is-hidden');
            if (smsCheckbox) {
              smsCheckbox.checked = !!caseDetails.smsOptIn;
              smsCheckbox.disabled = caseDetails.status === 1;
            }
          } else {
            addClass(smsWrap, 'is-hidden');
            if (smsCheckbox) smsCheckbox.checked = false;
          }
        }
        if (waWrap) {
          if (data.data.whatsapp) {
            removeClass(waWrap, 'is-hidden');
            if (waCheckbox) {
              waCheckbox.checked = !!caseDetails.whatsappOptIn;
              waCheckbox.disabled = caseDetails.status === 1;
            }
          } else {
            addClass(waWrap, 'is-hidden');
            if (waCheckbox) waCheckbox.checked = false;
          }
        }
      } catch (e) {
        hideOptIns();
      }
    }

    /**
     * milo case SMS / WhatsApp opt-in update
     */
    async function updateCaseOptIn(smsOptIn, whatsappOptIn) {
      let orgSource = 'IMS';
      if (isECC()) {
        orgSource = 'ECC';
      }
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          orgSource
        },
        body: JSON.stringify({
          caseId: caseNumber,
          contactRengaId: getSelectedOrg().userId,
          orgId: getSelectedOrg().id,
          smsOptIn: !!smsOptIn,
          whatsappOptIn: !!whatsappOptIn,
          orgSource
        }),
      };

      const updateCaseOptInStart = performance.now();
      try {
        const res = await request(miloCaseUpdateUrl, options);
        const data = await res.json();
        const updateCaseOptInDuration = Number(performance.now() - updateCaseOptInStart);
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseUpdateUrl,
            duration: updateCaseOptInDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails.smsOptIn = !!smsOptIn;
          caseDetails.whatsappOptIn = !!whatsappOptIn;
          notice(getLabelV2('Case has been successfully updated'), true, void 0, 'positive', 0);
          return true;
        }
        relicApiFail({
          status: data.status,
          endpoint: miloCaseUpdateUrl,
          duration: updateCaseOptInDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        const error = data.error?.[0];
        log(`There was some error while updating case opt-in: ${error?.message || ''}`);
        notice(error?.message || getLabelV2('There was an error while updating the case'), true, void 0, 'negative', 0);
        return false;
      } catch (err) {
        relicApiFail({
          status: err.status,
          endpoint: miloCaseUpdateUrl,
          duration: Number(performance.now() - updateCaseOptInStart),
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while updating case opt-in: ${err.message}`);
        notice(getLabelV2('There was an error while updating the case'), true, void 0, 'negative', 0);
        return false;
      }
    }

    /**
     * commerce case SMS / WhatsApp opt-in update
     */
    async function updateCommerceCaseOptIn(smsOptIn, whatsappOptIn) {
      let profileData = await adobeIMS.getProfile();
      const options = {
        method: 'PUT',
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
          accept: 'application/json',
          'content-type': 'application/json',
        },
        params: {
          orgSource: 'AMC',
          auth_id: profileData.authId
        },
        body: JSON.stringify({
          caseId: caseNumber,
          contactRengaId: getSelectedOrg().rengaId,
          orgId: getSelectedOrg().id,
          smsOptIn: !!smsOptIn,
          whatsappOptIn: !!whatsappOptIn,
          orgSource: 'AMC'
        }),
      };

      const updateCommerceCaseOptInStart = performance.now();
      try {
        const res = await request(exlMiloCaseUpdateUrl, options);
        const resData = await res.json();
        const data = resData.result;
        const updateCommerceCaseOptInDuration = Number(performance.now() - updateCommerceCaseOptInStart);
        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseUpdateUrl,
            duration: updateCommerceCaseOptInDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails.smsOptIn = !!smsOptIn;
          caseDetails.whatsappOptIn = !!whatsappOptIn;
          notice(getLabelV2('Case has been successfully updated'), true, void 0, 'positive', 0);
          return true;
        }
        relicApiFail({
          status: resData.status,
          endpoint: exlMiloCaseUpdateUrl,
          duration: updateCommerceCaseOptInDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        const error = data?.error?.[0];
        log(`There was some error while updating case opt-in: ${error?.message || ''}`);
        notice(error?.message || getLabelV2('There was an error while updating the case'), true, void 0, 'negative', 0);
        return false;
      } catch (err) {
        relicApiFail({
          status: err.status,
          endpoint: exlMiloCaseUpdateUrl,
          duration: Number(performance.now() - updateCommerceCaseOptInStart),
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while updating case opt-in: ${err.message}`);
        notice(getLabelV2('There was an error while updating the case'), true, void 0, 'negative', 0);
        return false;
      }
    }

    /**
     * milo case watcher list update
     */
    async function updateCCEmailList(emailList, btnLoader) {
      let orgSource = 'IMS';
      let updateCCEmailListStart = 0;
      if (isECC()) {
        orgSource = 'ECC';
      }
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
        },
        params: {
          orgSource
        },
        body: JSON.stringify({
          caseId: caseNumber,
          contactRengaId: getSelectedOrg().userId,
          orgId: getSelectedOrg().id,
          ccEmailList: emailList,
          orgSource
        }),
      };

      updateCCEmailListStart = performance.now();
      const updateCCEmailListDuration = Number((performance.now() - updateCCEmailListStart) );

      try {
        showHideLoader(btnLoader, true);
        const res = await request(miloCaseUpdateUrl, options);
        const data = await res.json();
        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseUpdateUrl,
            duration: updateCCEmailListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails.ccEmailList = JSON.parse(JSON.stringify(emailList));
          notice(getLabelV2('Case has been successfully updated'), true, void 0, 'positive', 0);
          showHideLoader(btnLoader, false);

          return true;
        }
        relicApiFail({
          status:data.status,
          endpoint: miloCaseUpdateUrl,
          duration: updateCCEmailListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        const error = data.error[0];
        log(`There was some error while updating case watchers: ${error.message}`);
        notice(error.message, true, void 0, 'negative', 0);
        showHideLoader(btnLoader, false);

        return false;
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: miloCaseUpdateUrl,
          duration: updateCCEmailListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while updating case watchers: ${err.message}`);
        notice(getLabelV2('There was an error while updating case watchers'), true, void 0, 'negative', 0);
        showHideLoader(btnLoader, false);

        return false;
      }
    }

    /**
     * commerce case watcher list update
     */
    async function updateCommerceCCEmailList(emailList, btnLoader) {
      let profileData = await adobeIMS.getProfile();
      let updateCommerceCCEmailListStart = 0;
      const options = {
        method: 'PUT',
        credentials: 'include',
        headers: {
          Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          [headerKeys.accept]: headerValues.json,
          accept: 'application/json',
          'content-type': 'application/json',
        },
        params: {
          orgSource: 'AMC',
          auth_id: profileData.authId
        },
        body: JSON.stringify({
          caseId: caseNumber,
          contactRengaId: getSelectedOrg().rengaId,
          orgId: getSelectedOrg().id,
          ccEmailList: emailList,
          orgSource: 'AMC'
        }),
      };

      try {
        showHideLoader(btnLoader, true);
        updateCommerceCCEmailListStart = performance.now();
        const res = await request(exlMiloCaseUpdateUrl, options);
        const resData = await res.json();
        const data = resData.result;
        const updateCommerceCCEmailListDuration = Number((performance.now() - updateCommerceCCEmailListStart) );

        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseUpdateUrl,
            duration: updateCommerceCCEmailListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          caseDetails.ccEmailList = JSON.parse(JSON.stringify(emailList));
          notice(getLabelV2('Case has been successfully updated'), true, void 0, 'positive', 0);
          showHideLoader(btnLoader, false);

          return true;
        }
        relicApiFail({
          status:resData.status,
          endpoint: exlMiloCaseUpdateUrl,
          duration: updateCommerceCCEmailListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        const error = data.error[0];
        log(`There was some error while updating case watchers: ${error.message}`);
        notice(error.message, true, void 0, 'negative', 0);
        showHideLoader(btnLoader, false);

        return false;
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseUpdateUrl,
          duration: updateCommerceCCEmailListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`There was some error while updating case watchers: ${err.message}`);
        notice(getLabelV2('There was an error while updating case watchers'), true, void 0, 'negative', 0);
        showHideLoader(btnLoader, false);

        return false;
      }
    }

    function openConfirmationModal(modalId, platform) {
      let zeonChatBtn = document?.querySelector('.adbMsgClientWrapper');
      if (!zeonChatBtn?.classList.contains('is-hidden')) {
        zeonChatBtn?.classList.add('is-hidden');
      }
      if (platform === 'MILO') {
        switch (modalId) {
          case 'ESCALATE': {
            modal(
              'support-case-action',
              {
                modalType: 'escalate',
                actionBtn: 'Escalate Case',
              },
              'case-action',
              true,
            );
            setTimeout(() => {
              const $lllel = {
                pickerOptionList: appShadowRoot.querySelector('#support-case-escalate-picker #option-list'),
                escalatePicker: appShadowRoot.querySelector('#support-case-escalate-picker'),
                escalatePickerSec: appShadowRoot.querySelector('#action-picker-sec'),
                caseReasonSection: appShadowRoot.querySelector('#case-reason-sec'),
                modalActionBtn: appShadowRoot.querySelector('#case-modal-body #modal-action'),
                modalActionBtnLoader: appShadowRoot.querySelector('#case-modal-body #modal-action .btn-loader'),
                cancelBtn: appShadowRoot.querySelector('#case-modal-body #modal-cancel'),
              };
              $lllel.pickerOptionList.innerHTML = escalateReasonOptionsHtml;
              if ($lllel.escalatePicker.classList.contains('is-hidden')) {
                $lllel.escalatePicker.classList.remove('is-hidden');
              }
              if ($lllel.escalatePickerSec.classList.contains('is-hidden')) {
                $lllel.escalatePickerSec.classList.remove('is-hidden');
              }

              if ($lllel.caseReasonSection.classList.contains('is-hidden')) {
                $lllel.caseReasonSection.classList.remove('is-hidden');
                $lllel.caseReasonSection.placeholder = 'Please tell more about your reason to escalate';
              }
              caseActionData.caseId = caseDetails.caseId;
              caseActionData.orgId = getSelectedOrg().id;
              caseActionData.contactRengaId = getSelectedOrg().userId; // userprofile.userId;
              caseActionData.reasonSummary = '';
              caseActionData.reasonCode = '';
              $lllel.escalatePicker.querySelector('.spectrum-Picker-label').innerText = getLabelV2(
                'Why are you escalating this case?',
              );
              $lllel.modalActionBtn.setAttribute('action-type', 'ESCALATE');
              $lllel.modalActionBtn.addEventListener('click', () => {
                if (isCommerce()) {
                  commerceCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                } else {
                  miloCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                }
              });
              prepareMiloCaseActionPicker('support-case-escalate-picker');

              $lllel.cancelBtn.addEventListener('click', () => {
                zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });
            }, 100);
            break;
          }
          case 'REOPEN': {
            modal(
              'support-case-action',
              {
                modalType: getLabelV2('reopen'),
                actionBtn: getLabelV2('Submit'),
              },
              'case-action',
              true,
            );
            setTimeout(() => {
              const $lllel = {
                pickerOptionList: appShadowRoot.querySelector('#support-case-reopen-picker #option-list'),
                reopenPicker: appShadowRoot.querySelector('#support-case-reopen-picker'),
                reopenPickerSec: appShadowRoot.querySelector('#action-picker-sec'),
                caseReasonSection: appShadowRoot.querySelector('#case-reason-sec'),
                modalActionBtn: appShadowRoot.querySelector('#case-modal-body #modal-action'), // Reopen button
                modalActionBtnLoader: appShadowRoot.querySelector('#case-modal-body #modal-action .btn-loader'),
                cancelBtn: appShadowRoot.querySelector('#case-modal-body #modal-cancel'),
                caseReasonSummary: appShadowRoot.querySelector('#case-reason-summary')
              };

              $lllel.caseReasonSummary.placeholder = 'Please tell more about your reason to reopen';
              $lllel.pickerOptionList.innerHTML = reopenCaseReasonOptionsHtml;
              if ($lllel.reopenPicker.classList.contains('is-hidden')) {
                $lllel.reopenPicker.classList.remove('is-hidden');
              }
              if ($lllel.reopenPickerSec.classList.contains('is-hidden')) {
                $lllel.reopenPickerSec.classList.remove('is-hidden');
              }
              if ($lllel.caseReasonSection.classList.contains('is-hidden')) {
                $lllel.caseReasonSection.classList.remove('is-hidden');
                $lllel.caseReasonSection.placeholder = 'Please tell more about your reason to reopen';
              }
              caseActionData.caseId = caseDetails.caseId;
              caseActionData.orgId = getSelectedOrg().id;
              caseActionData.contactRengaId = getSelectedOrg().userId; // userprofile.userId;
              caseActionData.reasonSummary = '';
              caseActionData.reasonCode = '';
              $lllel.reopenPicker.querySelector('.spectrum-Picker-label').innerText = getLabelV2(
                'Why are you reopening this case?',
              );
              $lllel.modalActionBtn.setAttribute('action-type', 'REOPEN');

              $lllel.modalActionBtn.addEventListener('click', () => {
                if (isCommerce()) {
                  commerceCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                } else {
                  miloCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                }
              });
              prepareMiloCaseActionPicker('support-case-reopen-picker');

              $lllel.cancelBtn.addEventListener('click', () => {
                zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });
            }, 100);
            break;
          }
          case 'CLOSE': {
            modal(
              'support-case-action',
              {
                modalType: getLabelV2('close'),
                actionBtn: getLabelV2('Close Case'),
              },
              'case-action',
              true,
            );
            setTimeout(() => {
              const $lllel = {
                pickerOptionList: appShadowRoot.querySelector('#support-case-close-picker #option-list'),
                closePicker: appShadowRoot.querySelector('#support-case-close-picker'),
                escalatePickerSec: appShadowRoot.querySelector('#action-picker-sec'),
                caseReasonSection: appShadowRoot.querySelector('#case-reason-sec'),
                modalActionBtn: appShadowRoot.querySelector('#case-modal-body #modal-action'),
                modalActionBtnLoader: appShadowRoot.querySelector('#case-modal-body #modal-action .btn-loader'),
                cancelBtn: appShadowRoot.querySelector('#case-modal-body #modal-cancel'),
                caseReasonSummary: appShadowRoot.querySelector('#case-reason-summary')
              };
              $lllel.caseReasonSummary.placeholder = getLabelV2('Please tell more about your reason to close');
              $lllel.pickerOptionList.innerHTML = closeCaseReasonOptionsHtml;
              if ($lllel.closePicker.classList.contains('is-hidden')) {
                $lllel.closePicker.classList.remove('is-hidden');
              }
              if ($lllel.escalatePickerSec.classList.contains('is-hidden')) {
                $lllel.escalatePickerSec.classList.remove('is-hidden');
              }
              if ($lllel.caseReasonSection.classList.contains('is-hidden')) {
                $lllel.caseReasonSection.classList.remove('is-hidden');
                $lllel.caseReasonSection.placeholder = getLabelV2('Please tell more about your reason to close');
              }
              caseActionData.caseId = caseDetails.caseId;
              caseActionData.orgId = getSelectedOrg().id;
              caseActionData.contactRengaId = getSelectedOrg().userId; // userprofile.userId;
              caseActionData.reasonSummary = '';
              caseActionData.reasonCode = '';
              $lllel.closePicker.querySelector('.spectrum-Picker-label').innerText = getLabelV2(
                'Why are you closing this case?',
              );
              $lllel.modalActionBtn.setAttribute('action-type', 'CLOSE');

              $lllel.modalActionBtn.addEventListener('click', () => {
                if (isCommerce()) {
                  commerceCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                } else {
                  miloCaseAction($lllel.modalActionBtn.getAttribute('action-type'), $lllel.modalActionBtnLoader);
                }
              });

              $lllel.cancelBtn.addEventListener('click', () => {
                zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });

              prepareMiloCaseActionPicker('support-case-close-picker');
            }, 100);
            break;
          }

          default: {
            log('Call default');
          }
        }
      } else {
        switch (modalId) {
          case 'ESCALATE': {
            modal(
              'support-case-action',
              {
                modalType: 'escalate',
                actionBtn: getLabelV2('Escalate Case'),
              },
              'case-action',
              true,
            );
            setTimeout(() => {
              const $lllel = {
                pickerSec: appShadowRoot.querySelector('#action-picker-sec'),
                caseReasonSection: appShadowRoot.querySelector('#case-reason-sec'),
                modalActionBtn: appShadowRoot.querySelector('#case-modal-body #modal-action'),
                modalActionBtnLoader: appShadowRoot.querySelector('#case-modal-body #modal-action .btn-loader'),
                cancelBtn: appShadowRoot.querySelector('#case-modal-body #modal-cancel'),
              };

              if (!$lllel.pickerSec.classList.contains('is-hidden')) {
                $lllel.pickerSec.classList.add('is-hidden');
              }
              if ($lllel.caseReasonSection.classList.contains('is-hidden')) {
                $lllel.caseReasonSection.classList.remove('is-hidden');
                $lllel.caseReasonSection.placeholder = 'Please tell more about your reason to escalate';
              }
              $lllel.modalActionBtn.addEventListener('click', () => {
                workfrontCaseEscalate($lllel.modalActionBtnLoader);
              });
              $lllel.cancelBtn.addEventListener('click', () => {
                zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });
            }, 100);
            break;
          }
          case 'CLOSE': {
            modal(
              'support-case-action',
              {
                modalType: getLabelV2('close'),
                actionBtn: getLabelV2('Close Case'),
              },
              'case-action',
              true,
            );
            setTimeout(() => {
              const $lllel = {
                pickerSec: appShadowRoot.querySelector('#action-picker-sec'),
                caseReasonSection: appShadowRoot.querySelector('#case-reason-sec'),
                modalActionBtn: appShadowRoot.querySelector('#case-modal-body #modal-action'),
                modalActionBtnLoader: appShadowRoot.querySelector('#case-modal-body #modal-action .btn-loader'),
                cancelBtn: appShadowRoot.querySelector('#case-modal-body #modal-cancel'),
              };
              if (!$lllel.pickerSec.classList.contains('is-hidden')) {
                $lllel.pickerSec.classList.add('is-hidden');
              }
              $lllel.modalActionBtn.addEventListener('click', () => {
                workfrontCaseClose($lllel.modalActionBtnLoader);
              });
              $lllel.cancelBtn.addEventListener('click', () => {
                zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });
            }, 100);
            break;
          }
          default: {
            log('Call default');
          }
        }
      }
    }

    function addFileEvent(caseId) {
      const elSelector = `.attachment-link[data-attachmentid="${caseId}"`;
      const attachmentEl = appShadowRoot.querySelector(elSelector);
      attachmentEl.addEventListener('click', async () => {
        const attachmentObj = {
          attachmentId: attachmentEl.getAttribute('data-attachmentId'),
          ext: attachmentEl.getAttribute('data-ext'),
          fileName: attachmentEl.getAttribute('download'),
        };
        await downloadWorkfrontAttachmentById(attachmentObj, true);
      });
    }

    /**
     * create watchers list view
     */
    function setWatchersView() {
      caseDetails.watchersHtml = '';
      for (const watcher of caseDetails.ccEmailList) {
        caseDetails.watchersHtml += views.get('support-watcher-list')({
          watcher,
        });
      }
      $llel.watcherView.innerHTML = caseDetails.watchersHtml;
    }

    const searchParams = {
      caseId: caseNumber,
    };

    // check for case
    if (isWorkFrontCase) {
      searchParams.contactRengaId = userprofile.email;
      searchParams.accountId = getSelectedOrg().id;
      const workfrontConfiguration = await getWorkfrontConfiguration();
      commentsList = [];
      $llel.caseBusinessImpact.classList.add('is-hidden');
      caseDetails = await getWorkfrontCaseData(searchParams, $llel.caseCommentsLoader);

      if (showNotification) {
        if (caseDetails.Survey_URL__c && (caseDetails.Survey_Status__c === 'Success' || caseDetails.Survey_Status__c === 'SurveyStarted') && await checkSurveyDate(caseDetails.LastModifiedDate)) {
          if ($llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
            $llel.myCaseSurveyBtn.classList.remove('is-hidden');
          }
          $llel.myCaseSurveyBtn.addEventListener('click', () => {
            window.open(`${caseDetails.Survey_URL__c}&Device_Type=EXL`, '_blank');
          });
        } else if (!$llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
          $llel.myCaseSurveyBtn.classList.add('is-hidden');
        }
      }

      // let openFormOptions = {
      //   caseId: caseDetails.CaseNumber,
      //   caseTitle: caseDetails.Subject,
      //   host_surface_name: 'EXL-Case Detail',
      //   productCode: 'WORKFRONT',
      //   oncloseCallbackDialogFn
      // };
      // await initWebcall('EXL-Case Detail', {});
      $llel.needAdditinalHelpBtn.addEventListener('click', async () => {
        
        ZeonCallbackClient.openNeedAdditionalHelpModal({
          caseId: caseDetails.CaseNumber,
          caseTitle: caseDetails.CaseNumber,
          productCode: "WORKFRONT",
        })
      });
      let abc = await ZeonCallbackClient.canRequestAdditionalHelp(caseDetails.CaseNumber); 
      console.log('abc', abc);
      
      if(await ZeonCallbackClient.canRequestAdditionalHelp(caseDetails.CaseNumber)){
        removeClass($llel.needAdditinalHelpBtn, 'is-hidden')
      } else{
        addClass($llel.needAdditinalHelpBtn, 'is-hidden')
      }
      $llel.caseHead.querySelector('h2').innerText = caseDetails.Subject;
      caseDetails.statusCode = openStatusWorkfront.includes(caseDetails.Status) ? 0 : 1;

      if (caseDetails.IsEscalated === true) {
        caseDetails.isEscalationAllowed = false;
      } else {
        const hours = Math.abs(new Date(caseDetails.CreatedDate) - new Date()) / 36e5;
        caseDetails.isEscalationAllowed = hours > +workfrontConfiguration.escalateTime;
      }

      if (caseDetails.statusCode === 0) {
        $llel.caseHead.querySelector('a').classList.add('status_open_tag');
        $llel.caseHead.querySelector('a span').innerHTML = getLabelV2('Open');
        if ($llel.caseDetailAttachment.classList.contains('is-hidden')) {
          $llel.caseDetailAttachment.classList.remove('is-hidden');
        }
        if ($llel.caseAttachment.classList.contains('is-not-allow')) {
          $llel.caseAttachment.classList.remove('is-not-allow');
        }
      } else {
        $llel.caseHead.querySelector('a').classList.add('status_closed_tag');
        $llel.caseHead.querySelector('a span').innerHTML = getLabelV2('Closed');
        if (!$llel.caseDetailAttachment.classList.contains('is-hidden')) {
          $llel.caseDetailAttachment.classList.add('is-hidden');
        }
        if (!$llel.caseAttachment.classList.contains('is-not-allow')) {
          $llel.caseAttachment.classList.add('is-not-allow');
        }
      }

      $llel.caseLastUpdate.innerText = getFormattedDate(caseDetails.LastModifiedDate);
      $llel.contactName.querySelector('p').innerText = `${caseDetails.Contact?.FirstName
        } ${caseDetails.Contact?.LastName ? caseDetails.Contact?.LastName : ''}`;
      $llel.productName.querySelector('p').innerText = 'Workfront';
      $llel.caseTitle.querySelector('p').innerText = caseDetails.Subject;
      $llel.caseDescription.innerText = caseDetails.Description ? caseDetails.Description : '';
      if ($llel.caseDescription.scrollHeight > 100) {
        $llel.caseDescription.classList.add('show-less');
        $llel.caseDescriptionSec.querySelector('a').classList.remove('is-hidden');
        $llel.caseDescriptionSec.querySelector('a').addEventListener('click', () => {
          if ($llel.caseDescription.classList.contains('show-less')) {
            $llel.caseDescription.classList.remove('show-less');
            $llel.caseDescription.classList.add('show-more');
            $llel.caseDescriptionSec.querySelector('a').innerText = getLabelV2('Show less');
          } else {
            $llel.caseDescription.classList.remove('show-more');
            $llel.caseDescription.classList.add('show-less');
            $llel.caseDescriptionSec.querySelector('a').innerText = getLabelV2('Show more');
          }
        });
      }
      $llel.caseNumber.querySelector('p').innerText = caseDetails.CaseNumber;
      $llel.caseId.innerText = getLabelV2('Case #{{number}}').replace('{{number}}', caseDetails.CaseNumber);
      $llel.casePriority.querySelector('p').innerText = caseDetails.Priority;
      const workfrontPriorityTooltipLabel = $llel.casePriority.querySelector('.spectrum-Tooltip-label');
      if (workfrontPriorityTooltipLabel) {
        workfrontPriorityTooltipLabel.innerHTML = `
                          P4- Low, Minimal or no interruptions to normal operations.
                          <br>
                          P3- Medium, Interruptions to normal operations.
                          <br>
                          P2- High, Serious interruptions to normal operations.
                          <br>
                          P1- Critical, Outage or extremely serious interruptions to operation
                          <br>
                       `;
      }

      // comments section
      $llel.caseCommentsSubmit.disabled = true;

      commentsList = await getWorkfrontCaseComments(caseNumber);

      setCommentsView();

      $llel.workfrontCaseCommentArea.addEventListener(
        'keyup',
        (ev) =>
          debounce('comment-area-1', () => {
            const commentText = $llel.workfrontCaseCommentArea.value.replace(/ +/g, ' ').trim();
            if (commentText && commentText.trim().length && caseDetails.statusCode === 0) {
              $llel.caseCommentsSubmit.disabled = false;
              commentRequest.customerNote.description = commentText;
            } else {
              $llel.caseCommentsSubmit.disabled = true;
              commentRequest.customerNote.description = '';
            }
          }),
        false,
      );

      // case add comment event
      $llel.caseCommentsSubmit.addEventListener(
        'click',
        async () => {
          commentsList.push({
            createdBy: {
              firstName: userprofile.first_name,
              lastName: userprofile.last_name,
            },
            createdOn: getFormattedDate(new Date().toString()),
            description: commentRequest.customerNote.description,
            direction: 'Inbound',
            type: 'Comment',
          });

          $llel.caseCommentArea.value = '';
          $llel.caseCommentsSubmit.disabled = true;
          setCommentsView();

          const options = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ClientId,
              Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            },
            params: {
              caseId: caseNumber,
              contactRengaId: userprofile.email,
            },
            body: JSON.stringify({
              comment: commentRequest.customerNote.description,
            }),
          };

          $llel.caseCommentsSubmit.disabled = true;
          $llel.workfrontCaseCommentArea.value = '';

          const workfrontCaseCreateCommentStart = performance.now();
          const workfrontCaseCreateCommentDuration = Number((performance.now() - workfrontCaseCreateCommentStart) );
          try {
            const res = await request(workfrontCaseCreateCommentUrl, options);
            const data = await res.json();
            if (res.ok) {
              relicApiSuccess({
                endpoint: workfrontCaseCreateCommentUrl,
                duration: workfrontCaseCreateCommentDuration,
                ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
              });
              log('Comment added Successfully');
              // notice('Comment added Successfully', true, void 0, 'positive', 0);
            } else {
              relicApiFail({
                status:data.status,
                endpoint: workfrontCaseCreateCommentUrl,
                duration: workfrontCaseCreateCommentDuration,
                ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
              });
              const error = data.error[0];
              log(`There was some error while adding the comment: ${error.message}`);
              notice(error.message, true, void 0, 'negative', 0);
            }
          } catch (err) {
            relicApiFail({
              status:err.status,
              endpoint: workfrontCaseCreateCommentUrl,
              duration: workfrontCaseCreateCommentDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`There was some error while adding the comment: ${err.message}`);
            notice(getLabelV2('There was some error while adding the comment'), true, void 0, 'negative', 0);
          }
        },
        false,
      );

      const workFrontAttachments = [];
      if (caseDetails.Attachments !== null) {
        caseDetails.Attachments.records.forEach((attachment) => {
          const extension = attachment.Name.split('.').pop();
          const attachmentObj = {
            attachmentId: attachment.Id,
            fileName: attachment.Name,
            fileExt: extension,
            size: attachment.BodyLength,
          };
          workFrontAttachments.push(attachmentObj);
        });
      }

      // if (caseDetails.isEscalationAllowed === false || (openStatusWorkfront.includes(caseDetails.Status) ? 0 : 1)) {
      //   // if (!$llel.escalateCaseBtn.hasAttribute('disabled')) {
      //   //   $llel.escalateCaseBtn.setAttribute('disabled', true);
      //   // }
      // } else {
      //   if ($llel.escalateCaseBtn.hasAttribute('disabled')) {
      //     $llel.escalateCaseBtn.removeAttribute('disabled');
      //   }
      //   $llel.escalateCaseBtn.addEventListener('click', async () => {
      //     const companyEntitlements = await getEntitlementsString();
      //     adobeDataLayerTrack({
      //       "event": "linkClicked",
      //       "eventType": "web.webInteraction.linkclicks",
      //       "companyLoginDetails": {
      //         "companyLoginName": selectedOrg.name,
      //         "companyLoginID": selectedOrg.id,
      //         "companyEntitlements": companyEntitlements,
      //       },
      //       "link": {
      //         "linkTitle": "Escalate to management",
      //         "linkLocation": "casePage:escalateToManagement",
      //         "linkType": "button",
      //       }
      //     });
      //     openConfirmationModal('ESCALATE', 'WORKFRONT');
      //   });
      // }
      if (openStatusWorkfront.includes(caseDetails.Status) ? 0 : 1) {
        if (!$llel.closeCaseBtn.hasAttribute('disabled')) {
          $llel.closeCaseBtn.setAttribute('disabled', true);
        }
      } else {
        if ($llel.closeCaseBtn.hasAttribute('disabled')) {
          $llel.closeCaseBtn.removeAttribute('disabled');
        }
        $llel.closeCaseBtn.addEventListener('click', async () => {
          const companyEntitlements = await getEntitlementsString();
          adobeDataLayerTrack({
            "event": "linkClicked",
            "eventType": "web.webInteraction.linkclicks",
            "companyLoginDetails": {
              "companyLoginName": selectedOrg.name,
              "companyLoginID": selectedOrg.id,
              "companyEntitlements": companyEntitlements,
            },
            "link": {
              "linkTitle": "Close case",
              "linkLocation": "casePage:closeCase",
              "linkType": "button clicked",
            }
          });
          openConfirmationModal('CLOSE', 'WORKFRONT');
        });
      }

      caseAttachments = [];
      if (workFrontAttachments && workFrontAttachments.length) {
        const attachmentLoaderHtml = views.get('support-attachment-loader')({});
        $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentLoaderHtml);
        for (const attached of workFrontAttachments) {
          await downloadWorkfrontAttachmentById(attached);
        }
        removeImageLoader();
      }

      if (caseAttachments.length) {
        caseAttachments.forEach((attachment) => {
          if (imageAllowed.includes(attachment.fileExt.toLowerCase())) {
            const attachmentHtml = views.get('support-attachment-image-item')(attachment);
            $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
          } else {
            const attachmentHtml = views.get('support-attachment-link-item')(attachment);
            $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
          }
        });

        appShadowRoot.querySelectorAll('.attachment-link').forEach((attachmentEl) => {
          attachmentEl.addEventListener('click', async () => {
            const attachment = {
              attachmentId: attachmentEl.getAttribute('data-attachmentId'),
              ext: attachmentEl.getAttribute('data-ext'),
              fileName: attachmentEl.getAttribute('download'),
            };
            await downloadWorkfrontAttachmentById(attachment, true);
          });
        });
      }

      appShadowRoot.querySelector('#case-detail-attachment').addEventListener('click', async () => {
        const companyEntitlements = await getEntitlementsString();
        adobeDataLayerTrack({
          "event": "linkClicked",
          "eventType": "web.webInteraction.linkclicks",
          "companyLoginDetails": {
            "companyLoginName": selectedOrg.name,
            "companyLoginID": selectedOrg.id,
            "companyEntitlements": companyEntitlements,
          },
          "link": {
            "linkTitle": "Add Case Attachments",
            "linkLocation": "casePage:addAttachments",
            "linkType": "button",
          }
        });
      });
      appShadowRoot.querySelector('#case-detail-attachment').addEventListener('change', async (event) => {
        const attachmentLoaderHtml = views.get('support-attachment-loader')({});
        if (event.target.files && event.target.files.length) {
          const file = event.target.files[0];
          if (file.size < ALLOWED_FILE_SIZE) {
            const fileExtension = file.name.split('.').pop();
            if (fileExtension !== 'dll' && fileExtension !== 'exe') {
              $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentLoaderHtml);
              const results = await uploadWorkfrontCaseAttachments(caseDetails.Id, event.target.files, userprofile);
              caseAttachments = [];
              if (results && results.length) {
                for (const attached of results) {
                  attached.attachmentId = attached.Id;
                  attached.fileName = attached.Name;
                  await downloadWorkfrontAttachmentById(attached);
                  removeImageLoader();
                }
              }

              caseAttachments.forEach((attachment) => {
                if (imageAllowed.includes(attachment.fileExt.toLowerCase())) {
                  const attachmentHtml = views.get('support-attachment-image-item')(attachment);
                  $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
                  addFileEvent(attachment.attachmentId);
                } else {
                  const attachmentHtml = views.get('support-attachment-link-item')(attachment);
                  $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
                  addFileEvent(attachment.attachmentId);
                }
              });
            } else {
              notice(getLabelV2('Invalid file format'), true, void 0, 'negative', 0);
            }
          } else {
            notice(getLabelV2('File size must be less than 20MB.'), true, void 0, 'negative', 0);
          }
        }
        appShadowRoot.querySelector('#case-detail-attachment').value = null;
      });
    } else {
      searchParams.orgId = getSelectedOrg().id;
      searchParams.contactRengaId = getSelectedOrg().userId; // userprofile.userId;
      commentsList = [];
      if (isCommerce()) {
        caseDetails = await getCommerceCaseData(searchParams);
        console.log('caseDetails', caseDetails);
        
      } else {
        caseDetails = await getMiloCaseData(searchParams);
      }
      if(caseDetails?.isEscalated){
        removeClass(appShadowRoot.querySelector('.escation-btn'), 'is-hidden');        
      } else{
        addClass(appShadowRoot.querySelector('.escation-btn'), 'is-hidden');        
      }
      
      cookie('set', 'COE', caseDetails?.agentAssigned?.emailId ? caseDetails?.agentAssigned?.emailId : '');
      cookie('set', 'loggedInUser', userprofile?.email ? userprofile?.email : '');
      
      let openFormOptions = {
        caseId: caseDetails.caseId,
        caseTitle: caseDetails.title,
        host_surface_name: 'EXL-Case Detail',
        productCode: caseDetails.productCode,
        supportPortalType: 'legacy support portal',
        oncloseCallbackDialogFn
      };
      // await initWebcall('EXL-Case Detail-2', openFormOptions);
      initWebcall('EXL-Case Detail-2', openFormOptions)
        .then(() => {
          return ZeonCallbackClient.canRequestAdditionalHelp(caseDetails.caseId);
        })
        .then((showAdditionalHelp) => {
          console.log('showAdditionalHelp', showAdditionalHelp);
          if (showAdditionalHelp) {
            removeClass($llel.needAdditinalHelpBtn, 'is-hidden');
          } else {
            addClass($llel.needAdditinalHelpBtn, 'is-hidden');
          }
        })
        .catch(() => {
          addClass($llel.needAdditinalHelpBtn, 'is-hidden');
      });
      // appShadowRoot.getElementById('request-callback-btn').addEventListener('click', async () => {
      //   const companyEntitlements = await getEntitlementsString();
      //   adobeDataLayerTrack({
      //     "event": "linkClicked",
      //     "eventType": "web.webInteraction.linkclicks",
      //     "companyLoginDetails": {
      //       "companyLoginName": selectedOrg.name,
      //       "companyLoginID": selectedOrg.id,
      //       "companyEntitlements": companyEntitlements,
      //     },
      //     "link": {
      //       "linkTitle": "Request a callback",
      //       "linkLocation": "casePage:requestCallback",
      //       "linkType": "button",
      //     }
      //   });
      //   // eslint-disable-next-line no-undef
      //   await ZeonCallbackClient.openForm(openFormOptions);
      // });
      // let openFormOptions = {
      //   caseId: caseDetails.caseId,
      //   caseTitle: caseDetails.title,
      //   host_surface_name: 'EXL-Case Detail',
      //   productCode: caseDetails.productCode,
      //   oncloseCallbackDialogFn
      // };
      


      $llel.needAdditinalHelpBtn.addEventListener('click', async () => {
        
        ZeonCallbackClient.openNeedAdditionalHelpModal({
          caseId: caseDetails.caseId,
          caseTitle: caseDetails.title,
          productCode: caseDetails.productCode,
        })
      });

      
      // if (await checkSurveyDate(caseDetails.lastModified) && !userprofile.email.includes('@adobe.com')) {
      // let surveyURL = `https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails.email)}&Device_Type=EXL`;
      let surveyURL = `https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails?.agentAssigned?.emailId)}&Device_Type=EXL`;
      if (caseDetails?.surveyUrl) {
        surveyURL = caseDetails?.surveyUrl;
        surveyURL = surveyURL + '&Device_Type=EXL';
      }
      if (await checkSurveyDate(caseDetails.lastModified) && caseDetails.statusText === 'Closed' && caseDetails.admin.rengaId === searchParams.contactRengaId && !userprofile.email.includes('@adobe.com')) {
        if ($llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
          $llel.myCaseSurveyBtn.classList.remove('is-hidden');
        }
        $llel.myCaseSurveyBtn.addEventListener('click', () => {
          // window.open(`https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?idx=SV_5b6RcUGkMMNp3V4&SIC=0136193c223baf4bc08426c16e193a56&CID=${caseDetails.caseId}=Z2xvNTg4NThAYWRvYmUuY29t&Device_Type=EXL`, '_blank');
          // window.open(`https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?SIC=16542ac56465cdf5a64f65abdf65456d&CID=${caseDetails.caseId}&COE=${toBase64(caseDetails.email)}&Device_Type=EXL`, '_blank');
          window.open(surveyURL, '_blank');

        });
      } else if (!$llel.myCaseSurveyBtn.classList.contains('is-hidden')) {
        $llel.myCaseSurveyBtn.classList.add('is-hidden');
      }
      $llel.caseHead.querySelector('h2').innerText = caseDetails.title;
      let classAppend;
      for (const key in supportTicketUIStatus) {
        const normalizedKey = key.replace('_', ' ').toLowerCase();
        let normalizedStatusReasonText = caseDetails.statusReasonText.toLowerCase();
        if (caseDetails.statusReasonText === 'Cancel/Misroute') {
          normalizedStatusReasonText = normalizedStatusReasonText.replace('/', ' ');
        }
        if (normalizedKey === normalizedStatusReasonText) {
          classAppend = `status_${supportTicketUIStatus[key].variant}_tag`;
          if (caseDetails.status === 0) {
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            if ($llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.remove('is-hidden');
            }
            if ($llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.remove('is-not-allow');
            }
          } else {
            $llel.caseHead.querySelector('a').classList.add(classAppend);
            if (!$llel.caseDetailAttachment.classList.contains('is-hidden')) {
              $llel.caseDetailAttachment.classList.add('is-hidden');
            }
            if (!$llel.caseAttachment.classList.contains('is-not-allow')) {
              $llel.caseAttachment.classList.add('is-not-allow');
            }
          }
        }
      }
      $llel.caseHead.querySelector('a span').innerHTML = caseDetails.statusReasonText
        ? caseDetails.statusReasonText
        : '';
      $llel.caseLastUpdate.innerText = caseDetails.lastModified ? getFormattedDate(caseDetails.lastModified) : '';
      $llel.contactName.querySelector('p').innerText = `${caseDetails.admin?.firstName ? caseDetails.admin?.firstName : ''
        } ${caseDetails.admin?.lastName ? caseDetails.admin?.lastName : ''}`;
      const productNameParagraph = $llel.productName.querySelector('p');
      const previousProductLabel = (productNameParagraph.innerText || '').trim();
      const resolvedProductName =
        resolveCaseDetailProductName(caseDetails) || previousProductLabel;
      caseDetails.productName = resolvedProductName;
      productNameParagraph.innerText = resolvedProductName;
      $llel.caseTitle.querySelector('p').innerText = caseDetails.title ? caseDetails.title : '';
      $llel.caseDescriptionSec.querySelector('p').innerText = caseDetails.description ? caseDetails.description : '';
      if ($llel.caseDescription.scrollHeight > 100) {
        $llel.caseDescription.classList.add('show-less');
        $llel.caseDescriptionSec.querySelector('a').classList.remove('is-hidden');
        $llel.caseDescriptionSec.querySelector('a').addEventListener('click', () => {
          if ($llel.caseDescription.classList.contains('show-less')) {
            $llel.caseDescription.classList.remove('show-less');
            $llel.caseDescription.classList.add('show-more');
            $llel.caseDescriptionSec.querySelector('a').innerText = getLabelV2('Show less');
          } else {
            $llel.caseDescription.classList.remove('show-more');
            $llel.caseDescription.classList.add('show-less');
            $llel.caseDescriptionSec.querySelector('a').innerText = getLabelV2('Show more');
          }
        });
      }
      if ($llel.adobeSupportAgent.classList.contains('is-hidden')) {
        $llel.adobeSupportAgent.classList.remove('is-hidden');
      }
      $llel.caseNumber.querySelector('p').innerText = caseDetails.caseId ? caseDetails.caseId : '';
      $llel.adobeSupportAgent.querySelector('p').innerText = caseDetails.agentAssigned ? caseDetails.agentAssigned.fullName : '';
      $llel.caseId.innerText = `Case #${caseDetails.caseId ? caseDetails.caseId : ''}`;
      $llel.casePriority.querySelector('p').innerText = caseDetails.priorityText
        ? getLabelV2(caseDetails.priorityText)
        : '';
      $llel.caseBusinessImpact.querySelector('p').innerText = caseDetails.impactCodeText
        ? getLabelV2(caseDetails.impactCodeText)
        : '';

      if (caseDetails.status !== 0) {
        $llel.caseCommentArea.classList.add('is-hidden');
        $llel.caseCommentInputContainer.classList.add('is-hidden');
      }

      if ($llel.watcherViewSection.classList.contains('is-hidden')) {
        $llel.watcherViewSection.classList.remove('is-hidden');
      }

      if (caseDetails.ccEmailList && caseDetails.ccEmailList.length) {
        setWatchersView();
      }

      await checkCaseDetailNotificationEligibility();
      if (ENABLE_PHONE_NOTIFICATION_OPT_IN) {
        const handleCaseOptInChange = async () => {
          const smsOptIn = !!$llel.smsOptInCheckbox?.checked;
          const whatsappOptIn = !!$llel.whatsappOptInCheckbox?.checked;
          const previousSmsOptIn = !!caseDetails.smsOptIn;
          const previousWhatsappOptIn = !!caseDetails.whatsappOptIn;
          let result = false;
          if (isCommerce()) {
            result = await updateCommerceCaseOptIn(smsOptIn, whatsappOptIn);
          } else {
            result = await updateCaseOptIn(smsOptIn, whatsappOptIn);
          }
          if (!result) {
            if ($llel.smsOptInCheckbox) $llel.smsOptInCheckbox.checked = previousSmsOptIn;
            if ($llel.whatsappOptInCheckbox) $llel.whatsappOptInCheckbox.checked = previousWhatsappOptIn;
          }
        };
        $llel.smsOptInCheckbox?.addEventListener('change', handleCaseOptInChange);
        $llel.whatsappOptInCheckbox?.addEventListener('change', handleCaseOptInChange);
      }
      const attachmentError = appShadowRoot.querySelector('#case-detail-commerce-error-sec');
      const attachmentList = appShadowRoot.querySelector('#attachment-list');
      if (isCommerce()) {
        if (getSelectedOrg().rengaIdType === 'type2e') {
          if (caseDetails.status === 0) {
            attachmentError.querySelector('p span').innerHTML = `
            <p>We are currently experiencing an issue regarding case attachment uploads and downloads within Experience League.</p>
            <ul>
              <li>To provide us with an attachment, please respond to one of the system generated case emails with the attachments to ensure they are available to our support teams.</li>
              <li>Please request an attachment be provided by email if you are experiencing errors downloading attachments from a case in Experience League.</li>
            </ul>`;
            if (attachmentError.classList.contains('is-hidden')) {
              attachmentError.classList.remove('is-hidden');
            }
            if (!attachmentList.classList.contains('is-hidden')) {
              attachmentList.classList.add('is-hidden');
            }
          }
        }
      }

      if (caseDetails.status !== 1) {
        $llel.watcherEditBtn.classList.remove('is-hidden');
        $llel.watcherEditBtn.addEventListener('click', async () => {
          const companyEntitlements = await getEntitlementsString();
          adobeDataLayerTrack({
            "event": "linkClicked",
            "eventType": "web.webInteraction.linkclicks",
            "companyLoginDetails": {
              "companyLoginName": selectedOrg.name,
              "companyLoginID": selectedOrg.id,
              "companyEntitlements": companyEntitlements,
            },
            "link": {
              "linkTitle": "Add Watchers",
              "linkLocation": "casePage:addWatchers",
              "linkType": "button",
            }
          });
          modal('support-case-watchers', {}, 'case-watcher', true);
          let watcherEmailListHtml = '';
          if (caseDetails.ccEmailList && caseDetails.ccEmailList.length) {
            for (const watcher of caseDetails.ccEmailList) {
              watcherEmailListHtml += views.get('support-watcher-item')({
                remove: getLabelV2('Remove'),
                watcher,
              });
            }
          }
          setTimeout(async () => {
            const $lllel = {
              listView: appShadowRoot.querySelector('.case-watcher #list-view'),
              addView: appShadowRoot.querySelector('.case-watcher #add-view'),
              watcherList: appShadowRoot.querySelector('.case-watcher #list-view ul'),
              modalCancelBtns: appShadowRoot.querySelectorAll('.modal-cancel-btn'),
              addUsersBtn: appShadowRoot.querySelector('.case-watcher #submit-users'),
              modalActionBtnLoader: appShadowRoot.querySelector('.case-watcher #submit-users .btn-loader'),
              tagInput: appShadowRoot.querySelector('#tag-input2'),
            };
            if (!caseDetails.ccEmailList || !caseDetails.ccEmailList.length) {
              $lllel.listView.classList.add('is-hidden');
              $lllel.addView.classList.remove('is-hidden');
              instantiateTagsInput('tag-input2');
              if (!isCommerce() && !isWorkFront() && !isECC()) {
                await findWatchersMembers('.tags-input-wrapper input', '.edituserListModal', '.edituserListMembers');
              }
            }
            appShadowRoot.querySelector('.case-watcher #add-user').addEventListener('click', async () => {
              $lllel.listView.classList.add('is-hidden');
              $lllel.addView.classList.remove('is-hidden');
              instantiateTagsInput('tag-input2');
              if (!isCommerce() && !isWorkFront() && !isECC()) {
                await findWatchersMembers('.tags-input-wrapper input', '.edituserListModal', '.edituserListMembers');
              }
            });
            $lllel.watcherList.innerHTML = watcherEmailListHtml;
            appShadowRoot.querySelectorAll('.case-watcher #list-view .remove-watcher').forEach((watcher) => {
              watcher.addEventListener('click', async () => {
                const loaderEl = document.createElement('span');
                loaderEl.classList.add('loader', 'btn-loader', 'is-margin-left-small');
                watcher.appendChild(loaderEl);
                const selectedEmail = watcher.getAttribute('data-email');
                // let emailList = caseDetails.ccEmailList;
                const foudindex = caseDetails.ccEmailList.findIndex((email) => email === selectedEmail);

                if (foudindex >= 0) {
                  caseDetails.ccEmailList.splice(foudindex, 1);
                  watcher.setAttribute('disabled', true);
                  let result;
                  if (isCommerce()) {
                    result = await updateCommerceCCEmailList(caseDetails.ccEmailList, $lllel.modalActionBtnLoader);
                  } else {
                    result = await updateCCEmailList(caseDetails.ccEmailList, $lllel.modalActionBtnLoader);
                  }
                  if (result) {
                    const elementList = appShadowRoot.querySelectorAll('.case-watcher #list-view ul .watcher-item');
                    elementList.forEach((node) => {
                      if (node.getAttribute('data-email') === selectedEmail) {
                        node.remove();
                      }
                    });
                    setWatchersView();
                  } else {
                    watcher.setAttribute('disabled', false);
                  }
                }
              });
            });
            $lllel.modalCancelBtns.forEach((btn) => {
              btn.addEventListener('click', () => {
                let zeonChatBtn = appShadowRoot?.querySelector('.adbMsgClientWrapper');
                if (zeonChatBtn?.classList.contains('is-hidden')) {
                  zeonChatBtn?.classList.remove('is-hidden');
                }
                close();
              });
            });
            $lllel.addUsersBtn.addEventListener('click', async () => {
              const tags = appShadowRoot.querySelector('.tags-input-wrapper');
              const emailTags = tags.querySelectorAll('.tag');
              const listNewUsers = [];
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              emailTags.forEach(tag => {
                const email = tag.textContent.trim();
                if (email.length && emailRegex.test(email)) {
                  listNewUsers.push(email);
                } else if (email.length) {
                  console.warn(`${email} is not a valid email address.`);
                }
              });
              if (listNewUsers.toString().length > 2000) {
                notice(getLabelV2('Email list can not exceed more than 2000 characters'), true, void 0, 'negative', 0);
              } else if (listNewUsers.length) {
                let emailList = [];
                if (caseDetails.ccEmailList && Array.isArray(caseDetails.ccEmailList)) {
                  emailList = [...new Set([...caseDetails.ccEmailList, ...listNewUsers])];
                } else {
                  emailList = [...new Set([...listNewUsers])];
                }
                let result;
                if (isCommerce()) {
                  result = await updateCommerceCCEmailList(emailList, $lllel.modalActionBtnLoader);
                } else {
                  result = await updateCCEmailList(emailList, $lllel.modalActionBtnLoader);
                }

                if (result) {
                  setWatchersView();
                  close();
                }
              } else {
                notice(getLabelV2('Add valid email address to add watcher.'), true, void 0, 'negative', 0);
              }
            });
          }, 100);
        });
      }

      // Re-Open the case
      const today = new Date();
      const fourteenDaysAgo = new Date(today);
      fourteenDaysAgo.setDate(today.getDate() - 14);
      const closedDate = new Date(caseDetails.closedDate);

      if (caseDetails.canReopen === true || caseDetails.status === 1) {
        if (closedDate < fourteenDaysAgo) {
          console.log('The case was closed more than 14 days ago.');
          $llel.reopenCaseBtn.classList.remove('is-hidden');
          $llel.needAdditinalHelpBtn.classList.add('is-hidden');
          // $llel.requestcallbackBtn.classList.add('is-hidden');
          $llel.reopenCaseBtn.disabled = true;
          $llel.reopenTooltip.classList.remove('is-hidden');
          $llel.reopenTooltip.disabled = false;
          // $llel.escalateCaseBtn.classList.add('is-hidden');
          $llel.closeCaseBtn.classList.add('is-hidden');
        } else {
          console.log('The case was closed within the last 14 days.');
          if (!isWorkFront()) {
            $llel.reopenCaseBtn.classList.remove('is-hidden');
            $llel.needAdditinalHelpBtn.classList.add('is-hidden');
            // $llel.requestcallbackBtn.classList.add('is-hidden');
            $llel.reopenTooltip.classList.add('is-hidden');
            // $llel.escalateCaseBtn.classList.add('is-hidden');
            $llel.closeCaseBtn.classList.add('is-hidden');
            reopenCaseReasonOptionsHtml = '';
            for (const code of REOPEN_CASE_REASON_CODES) {
              const template = views.get('support-reasons-item')({
                code,
                caseActionData,
              });
              reopenCaseReasonOptionsHtml += template;
            }
            $llel.reopenCaseBtn.addEventListener('click', async () => {
              const companyEntitlements = await getEntitlementsString();
              adobeDataLayerTrack({
                "event": "linkClicked",
                "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                  "companyLoginName": selectedOrg.name,
                  "companyLoginID": selectedOrg.id,
                  "companyEntitlements": companyEntitlements,
                },
                "link": {
                  "linkTitle": "Reopen case",
                  "linkLocation": "casePage:reopenCase",
                  "linkType": "button clicked",
                }
              });
              openConfirmationModal('REOPEN', 'MILO');
            });
          }
        }
      }

      // if (caseDetails.isEscalationAllowed === false || caseDetails.status === 1) {
      //   $llel.escalateCaseBtn.setAttribute('disabled', true);
      // } else {
      //   $llel.escalateCaseBtn.removeAttribute('disabled');
      //   escalateReasonOptionsHtml = '';
      //   for (const code of ESCALATE_CASE_REASON_CODES) {
      //     escalateReasonOptionsHtml += views.get('support-reasons-item')({
      //       code,
      //       caseActionData,
      //     });
      //   }
      //   $llel.escalateCaseBtn.addEventListener('click', async () => {
      //     const companyEntitlements = await getEntitlementsString();
      //     adobeDataLayerTrack({
      //       "event": "linkClicked",
      //       "eventType": "web.webInteraction.linkclicks",
      //       "companyLoginDetails": {
      //         "companyLoginName": selectedOrg.name,
      //         "companyLoginID": selectedOrg.id,
      //         "companyEntitlements": companyEntitlements,
      //       },
      //       "link": {
      //         "linkTitle": "Escalate to management",
      //         "linkLocation": "casePage:escalateToManagement",
      //         "linkType": "button clicked",
      //       }
      //     });
      //     openConfirmationModal('ESCALATE', 'MILO');
      //   });
      // }

      if (caseDetails.status > 0) {
        $llel.closeCaseBtn.setAttribute('disabled', true);
      } else {
        $llel.closeCaseBtn.removeAttribute('disabled');
        closeCaseReasonOptionsHtml = '';
        for (const code of CLOSE_CASE_REASON_CODES) {
          const template = views.get('support-reasons-item')({
            code:{
              id: code.id,
              label:getLabelV2(code.label)
            },
            caseActionData,
          });
          closeCaseReasonOptionsHtml += template;
        }
        $llel.closeCaseBtn.addEventListener('click', () => {
          openConfirmationModal('CLOSE', 'MILO');
        });
      }
      let emailList = [];
      let platformShEmailList = [];
      let platformShCommentList = [];

      // comments section start
      $llel.caseCommentsSubmit.disabled = true;
      if (isCommerce()) {
        commentsList = await getCommerceCaseComments(caseNumber, $llel.caseCommentsLoader);
        emailList = await getCommerceExternalEmail(caseNumber, $llel.caseCommentsLoader);
        platformShEmailList = await getCommercePlatformShEmail(caseNumber, $llel.caseCommentsLoader);
        platformShCommentList = await getCommercePlatformShComments(caseNumber, $llel.caseCommentsLoader);
      } else {
        commentsList = await getMiloCaseComments(caseNumber, $llel.caseCommentsLoader);
        emailList = await getMiloExternalEmail(caseNumber, $llel.caseCommentsLoader);
        platformShEmailList = await getMiloPlatformShEmail(caseNumber, $llel.caseCommentsLoader);
        platformShCommentList = await getMiloPlatformShComments(caseNumber, $llel.caseCommentsLoader);
      }

      if (emailList && emailList.length) {
        commentsList.push(...emailList);
      }
      if (platformShEmailList && platformShEmailList.length) {
        commentsList.push(...platformShEmailList);
      }
      if (platformShCommentList && platformShCommentList.length) {
        commentsList.push(...platformShCommentList);
      }

      if (caseDetails.status !== 0) {
        $llel.caseCommentArea.classList.add('is-hidden');
      }
      setCommentsView();

      let editor = appShadowRoot.querySelector('#comment-area-new');
      editor.addEventListener('input', () => {
        if (editor.innerHTML && editor.innerHTML.trim().length && caseDetails.status === 0) {
          $llel.caseCommentsSubmit.disabled = false;
          commentRequest.customerNote.descriptionHtml = editor.innerHTML;
          commentRequest.customerNote.description = editor.innerText;
        } else {
          $llel.caseCommentsSubmit.disabled = true;
          commentRequest.customerNote.description = '';
          commentRequest.customerNote.descriptionHtml = '';
        }
      })


      // case add comment event
      $llel.caseCommentsSubmit.addEventListener(
        'click',
        async () => {
          commentsList.push({
            createdBy: {
              firstName: userprofile.first_name,
              lastName: userprofile.last_name,
            },
            createdOn: new Date().toString(),
            descriptionHtml: commentRequest.customerNote.descriptionHtml,
            direction: getLabelV2('Inbound'),
            type: getLabelV2('Comment'),
          });

          $llel.caseCommentArea.value = '';
          $llel.caseCommentsSubmit.disabled = true;
          let options;
          let res;
          let data;
          $llel.caseCommentsSubmit?.querySelector('.btn-loader')?.classList.remove('is-hidden');
          let profileData = await adobeIMS.getProfile();
          if (isCommerce()) {
            commentRequest.contactRengaId = getSelectedOrg().rengaId;
            commentRequest.orgSource = 'AMC';
            options = {
              method: 'POST',
              credentials: 'include',
              headers: {
                Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
                [headerKeys.accept]: headerValues.json,
                accept: 'application/json',
                'content-type': 'application/json',
              },
              params: {auth_id: profileData.authId},
              body: JSON.stringify({ ...commentRequest }),
            };
          } else {
            commentRequest.orgSource = 'IMS';
            if (isECC()) {
              commentRequest.orgSource = 'ECC';
            }
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-api-key': ClientId,
                Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
              },
              params: {},
              body: JSON.stringify({ ...commentRequest }),
            };
          }

          let editor = appShadowRoot.querySelector('#comment-area-new');
          editor.innerHTML = '';
          $llel.caseCommentsSubmit.disabled = true;
          const commerceCommentsStart = performance.now();
          const miloCaseCommentAdditionDuration = Number((performance.now() - commerceCommentsStart) );
          try {
            if (isCommerce()) {
              res = await request(exlMiloCaseCommentAdditionUrl, options);
              
              const resData = await res.json();
              const commerceCommentsDuration = Number((performance.now() - commerceCommentsStart) );
              data = resData.result;
              if ( resData.status === 200) {
                relicApiSuccess({
                  endpoint: exlMiloCaseCommentAdditionUrl,
                  duration: commerceCommentsDuration,
                  ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
                });
                log('Comment added Successfully');
                setCommentsView();
                // notice('Comment added Successfully', true, void 0, 'positive', 0);
              } else {
                relicApiFail({
                  status:resData.status,
                  endpoint: exlMiloCaseCommentAdditionUrl,
                  duration: commerceCommentsDuration,
                  ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
                });
                const error = data.error[0];
                log(`There was some error while adding the comment: ${error.message}`);
                notice(error.message, true, void 0, 'negative', 0);
              }
            } else {
              res = await request(miloCaseCommentAdditionUrl, options);
              data = await res.json();
              if (res.ok) {
                relicApiSuccess({
                  endpoint: miloCaseCommentAdditionUrl,
                  duration: miloCaseCommentAdditionDuration,
                  ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
                });
                log('Comment added Successfully');
                setCommentsView();
                // notice('Comment added Successfully', true, void 0, 'positive', 0);
              } else {
                relicApiFail({
                  status:data.status,
                  endpoint: miloCaseCommentAdditionUrl,
                  duration: miloCaseCommentAdditionDuration,
                  ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
                });
                const error = data.error[0];
                log(`There was some error while adding the comment: ${error.message}`);
                notice(error.message, true, void 0, 'negative', 0);
              }
            }
          } catch (err) {
            relicApiFail({
              status:err.status,
              endpoint: isCommerce() ? exlMiloCaseCommentAdditionUrl : miloCaseCommentAdditionUrl,
              duration: miloCaseCommentAdditionDuration,
              ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
            });
            log(`There was some error while adding the comment: ${err.message}`);
            notice(getLabelV2('There was some error while adding the comment'), true, void 0, 'negative', 0);
          }
          $llel.caseCommentsSubmit?.querySelector('.btn-loader')?.classList.add('is-hidden');
        },
        false,
      );

      if (isCommerce()) {
        await getCommerceAttachmentList(caseNumber);
      } else {
        await getMiloAttachmentList();
      }
      caseAttachments = [];
      if (attachmentsList && attachmentsList.length) {
        const attachmentLoaderHtml = views.get('support-attachment-loader')({});
        $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentLoaderHtml);
        for (const attached of attachmentsList) {
          await downloadMiloAttachmentById(attached);
        }
        removeImageLoader();
      }

      if (caseAttachments.length) {
        caseAttachments.forEach((attachment) => {
          let attachmentHtml = '';
          const extension = attachment.fileName.split('.').pop();
          if (imageAllowed.includes(extension.toLowerCase())) {
            attachmentHtml = views.get('support-attachment-image-item')(attachment);
          } else {
            attachmentHtml = views.get('support-attachment-link-item')(attachment);
          }
          $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
        });
        appShadowRoot.querySelectorAll('.attachment-link').forEach((attachmentEl) => {
          attachmentEl.addEventListener('click', async () => {
            const attachment = {
              attachmentId: attachmentEl.getAttribute('data-attachmentId'),
              ext: attachmentEl.getAttribute('data-ext'),
              fileName: attachmentEl.getAttribute('download'),
            };
            await downloadMiloAttachmentById(attachment, true);
          });
        });
      }

      appShadowRoot.querySelector('#case-detail-attachment').addEventListener('click', async () => {
        const companyEntitlements = await getEntitlementsString();
        adobeDataLayerTrack({
          "event": "linkClicked",
          "eventType": "web.webInteraction.linkclicks",
          "companyLoginDetails": {
            "companyLoginName": selectedOrg.name,
            "companyLoginID": selectedOrg.id,
            "companyEntitlements": companyEntitlements,
          },
          "link": {
            "linkTitle": "Add Case attachments",
            "linkLocation": "casePage:addAttachments",
            "linkType": "button",
          }
        });
      });
      appShadowRoot.querySelector('#case-detail-attachment').addEventListener('change', async (event) => {
        const attachmentLoaderHtml = views.get('support-attachment-loader')({});
        if (event.target.files && event.target.files.length) {
          const file = event.target.files[0];
          if (file.size < ALLOWED_FILE_SIZE) {
            const fileExtension = file.name.split('.').pop();
            if (fileExtension !== 'dll' && fileExtension !== 'exe') {
              $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentLoaderHtml);
              // let results;
              // if (isCommerce()) {
              //   results = await uploadCommerceCaseAttachments(caseDetails.caseId, event.target.files);
              // } else {
              //   results = await uploadMiloCaseAttachments(caseDetails.caseId, event.target.files);
              // }
              const results = await uploadMiloCaseAttachments(caseDetails.caseId, event.target.files);
              removeImageLoader();
              if (imageAllowed.includes(fileExtension.toLowerCase())) {
                const filebase64 = await convertFileToBase64(file);
                if (results.length) {
                  results[0].base64Url = filebase64;
                  results[0].fileExt = fileExtension;
                  results.forEach((attachment) => {
                    const attachmentHtml = views.get('support-attachment-image-item')(attachment);
                    $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
                    const elSelector = `.attachment-link[data-attachmentid="${attachment.attachmentId}"`;
                    const attachmentEl = appShadowRoot.querySelector(elSelector);
                    attachmentEl.addEventListener('click', async () => {
                      const attachmentObj = {
                        attachmentId: attachmentEl.getAttribute('data-attachmentId'),
                        ext: attachmentEl.getAttribute('data-ext'),
                        fileName: attachmentEl.getAttribute('download'),
                      };
                      await downloadMiloAttachmentById(attachmentObj, true);
                    });
                  });
                }
              } else if (results.length) {
                results.forEach((attachment) => {
                  attachment.fileExt = fileExtension;
                  const attachmentHtml = views.get('support-attachment-link-item')(attachment);
                  $llel.attachmentsList.insertAdjacentHTML('afterbegin', attachmentHtml);
                  const elSelector = `.attachment-link[data-attachmentid="${attachment.attachmentId}"`;
                  const attachmentEl = appShadowRoot.querySelector(elSelector);
                  attachmentEl.addEventListener('click', async () => {
                    const attachmentObj = {
                      attachmentId: attachmentEl.getAttribute('data-attachmentId'),
                      ext: attachmentEl.getAttribute('data-ext'),
                      fileName: attachmentEl.getAttribute('download'),
                    };
                    await downloadMiloAttachmentById(attachmentObj, true);
                  });
                });
              }
            } else {
              notice(getLabelV2('Invalid file format'), true, void 0, 'negative', 0);
            }
          } else {
            notice(getLabelV2('File size must be less than 20MB.'), true, void 0, 'negative', 0);
          }
        }
        appShadowRoot.querySelector('#case-detail-attachment').value = null;
      });
    }
  }

  /**
   * Support My Cases
   */
  async function supportMyCases(supportProcess = null) {
    const $llel = {
      caseTable: appShadowRoot.querySelectorAll('.support-my-cases-tablecases'),
      casesTableBoady: appShadowRoot.querySelector('#my-case-table-body'),
      feedbackColumn: appShadowRoot.querySelector('#col-case-feedback'),
      recordLimit: appShadowRoot.querySelectorAll('#my-cases .results-per-page-list li'),
      paginationSec: appShadowRoot.querySelector('.pagination-outer'),
      paginationController: appShadowRoot.querySelector('#case-list-pagination'),
      supportMyCaseViewFilterButton: appShadowRoot.querySelector(
        '#my-cases #support-case-view-picker .spectrum-Picker',
      ),
      supportMyCaseViewFilterList: appShadowRoot.querySelector('#my-cases #support-case-view-picker .spectrum-Menu'),
      supportMyCaseProductFilterButton: appShadowRoot.querySelector(
        '#my-cases #support-case-product-picker .spectrum-Picker',
      ),
      supportMyCaseProductFilterList: appShadowRoot.querySelector(
        '#my-cases #support-case-product-picker .spectrum-Menu',
      ),
      supportMyCaseSearchInput: appShadowRoot.querySelector('#my-cases #search-case-input'),
      supportMyCaseTableHeadColumns: appShadowRoot.querySelectorAll('#my-case-table-head tr th'),
      productFilterPicker: appShadowRoot.querySelector('#support-case-product-picker'),
      productFilterLoader: appShadowRoot.querySelector('#product-filter-loader'),
      caseSearchBar: appShadowRoot.getElementById('search-case-input'),
    };
    // await initWebcall('EXL-My-Cases', {});
    $llel.caseSearchBar.placeholder = getLabelV2('Search in cases');
    if (showNotification) {
      if ($llel.feedbackColumn.classList.contains('is-hidden')) {
        $llel.feedbackColumn.classList.remove('is-hidden');
      }
    } else if (!$llel.feedbackColumn.classList.contains('is-hidden')) {
      $llel.feedbackColumn.classList.add('is-hidden');
    }
    // Case Summary and Get Help are disabled for Workfront orgs
    const disableCaseSummaryAndHelp = isWorkFront();
    let isWorkfront = false;
    let miloCaseList = [];
    let workfrontCaseList = [];
    let filteredCaseList = [];
    const productResult = await getProductList(productOrg, 'my-case', onlyPSA);
    const uniqueLabels = {};
    const modifiedProductList = {
      id: 'allProducts',
      label: 'All Products',
      type: 'SUPPORT',
    };
    productResult.productList.splice(0, 0, modifiedProductList);
    products = productResult.productList.filter((obj) => !uniqueLabels[obj.id] && (uniqueLabels[obj.id] = true));
    productOrg = productResult.orgId;
    const filters = {
      product: { id: '', label: '' },
      viewCase: { id: 1, label: getLabelV2('My cases (Open)') },
      search: '',
    };
    const caseFilterMap = {
      'my-open': {
        id: 1,
        label: 'My cases (Open)',
      },
      'my-close': {
        id: 2,
        label: 'My cases (Closed)',
      },
      'my-all': {
        id: 3,
        label: 'My cases (All)',
      },
      'org-open': {
        id: 4,
        label: "My organization's cases (Open)",
      },
      'org-close': {
        id: 5,
        label: "My organization's cases (Closed)",
      },
      'org-all': {
        id: 6,
        label: "My organization's cases (All)",
      },
    };

    const caseFilter = lurl.searchParams.get('my-case-filter');

    if (caseFilter && caseFilterMap[caseFilter]) {
      const { id, label } = caseFilterMap[caseFilter];

      filters.viewCase.id = id;
      filters.viewCase.label = getLabelV2(label);
    }

    const caseSort = {
      key: 'caseId',
      order: 'ascending', // ACS / DCS
    };

    pagination.createPageElement = () => {
      pagination.pages = [];
      pagination.pagination.maxDisplayPages = +pagination.pagination.maxDisplayPages;
      const totalPages = Math.max(
        Math.ceil(pagination.pagination.totalRecords / pagination.pagination.recordsPerPage),
        1,
      );
      const halfWay = Math.ceil(pagination.pagination.maxDisplayPages / 2);
      const isStart = pagination.pagination.currentPage <= halfWay;
      const isEnd = totalPages - halfWay < pagination.pagination.currentPage;
      const isMiddle = !isStart && !isEnd;

      const ellipsesNeeded = pagination.pagination.maxDisplayPages < totalPages;
      let i = 1;
      while (i <= totalPages && i <= pagination.pagination.maxDisplayPages) {
        let label;
        const pageNumber = pagination.calculatePageNumber(
          i,
          pagination.pagination.currentPage,
          pagination.pagination.maxDisplayPages,
          totalPages,
        );
        const openingEllipsesNeeded = i === 2 && (isMiddle || isEnd);
        const closingEllipsesNeeded = i === pagination.pagination.maxDisplayPages - 1 && (isMiddle || isStart);
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          // label = '...';
          label = pageNumber;
        } else {
          label = pageNumber;
        }
        pagination.pages.push({
          label,
          value: pageNumber,
        });
        i++;
      }

      if ($llel.paginationSec.classList.contains('is-hidden')) {
        $llel.paginationSec.classList.remove('is-hidden');
      }

      if (totalPages < 2) {
        if (!$llel.paginationController.classList.contains('is-hidden')) {
          $llel.paginationController.classList.add('is-hidden');
        }
      } else if ($llel.paginationController.classList.contains('is-hidden')) {
        $llel.paginationController.classList.remove('is-hidden');
      }
      const paginationHtml = views.get('support-pagination')({
        first: pagination.isFirstPage(),
        last: pagination.isLastPage(),
        items: pagination.pages
          .map((p) =>
            views.get('support-pagination-item')({
              page: p,
              current: pagination.getCurrentPage(),
            }),
          )
          .join('\n'),
      });

      appShadowRoot.getElementById(pagination.pagination.elementId).innerHTML = paginationHtml;
      // on page change — use currentTarget so clicks on inner label spans still read data from the .page-btn anchor
      const pageBtns = $llel.paginationController.querySelectorAll('.page-btn');

      pageBtns.forEach((pageBtn) => {
        pageBtn.addEventListener('click', async (event) => {
          event.preventDefault();
          // Read synchronously (closure + getAttribute): async handlers clear event.currentTarget; getAttribute
          // avoids browser differences for data-* attribute names (e.g. data-pageNumber vs data-pagenumber).
          const pageNumber =
            pageBtn.getAttribute('data-pagenumber') ??
            pageBtn.getAttribute('data-pageNumber') ??
            pageBtn.dataset.pageNumber ??
            pageBtn.dataset.pagenumber;
          if (pageNumber == null || pageNumber === '') {
            return;
          }
          let limitCase = pagination.getRecordsPerPage();
          let skipCase = 0;
          if (isNaN(pageNumber)) {
            if (pageNumber === 'next') {
              pagination.next();
              skipCase = (pagination.getCurrentPage() - 1) * pagination.getRecordsPerPage();
            }

            if (pageNumber === 'pre') {
              pagination.previous();
              skipCase = (pagination.getCurrentPage() - 1) * pagination.getRecordsPerPage();
            }
          } else {
            pagination.setCurrentPage(+pageNumber);
            skipCase = (pagination.getCurrentPage() - 1) * pagination.getRecordsPerPage();
          }
          limitCase += skipCase;
          // eslint-disable-next-line no-use-before-define
          saveAppliedFilters();
          // eslint-disable-next-line no-use-before-define
          processMyCasesTableDataRows(filteredCaseList.slice(skipCase, limitCase));

          
        });
      });
    };

    if (!$llel.paginationSec.classList.contains('is-hidden')) {
      $llel.paginationSec.classList.add('is-hidden');
    }

    const caseListFilters = sessionStorage.getItem(CaseListFilters);

    if (!lurl.searchParams.get('my-case-filter')) {
      if (caseListFilters) {
        const filterObj = JSON.parse(caseListFilters);
        if (filterObj) {
          if (filterObj.viewCase && filterObj.viewCase.id) {
            filters.viewCase = viewCaseFilterList.find((view) => view.id === filterObj.viewCase.id);
          }

          if (filterObj.search) {
            $llel.supportMyCaseSearchInput.value = filterObj.search;
            filters.search = filterObj.search;
          }

          if (filterObj.caseSort && filterObj.caseSort.key && filterObj.caseSort.order) {
            caseSort.key = filterObj.caseSort.key;
            caseSort.order = filterObj.caseSort.order;
          }

          if (filterObj.pagination && filterObj.pagination.currentPage) {
            pagination.pagination.currentPage = filterObj.pagination.currentPage;
          }
          if (filterObj.pagination && filterObj.pagination.totalRecords) {
            pagination.pagination.totalRecords = filterObj.pagination.totalRecords;
          }
          if (filterObj.pagination && filterObj.pagination.recordsPerPage) {
            pagination.pagination.recordsPerPage = filterObj.pagination.recordsPerPage;
          }
          if (filterObj.pagination && filterObj.pagination.totalNumberOfPages) {
            pagination.pagination.totalNumberOfPages = filterObj.pagination.totalNumberOfPages;
          }
          if (filterObj.pagination && filterObj.pagination.maxDisplayPages) {
            pagination.pagination.maxDisplayPages = filterObj.pagination.maxDisplayPages;
          }
        }
      }
    }

    for (const btn of $llel.recordLimit) {
      const btnValue = parseInt(btn.innerText);
      if (btnValue === pagination.pagination.recordsPerPage && !btn.classList.contains('active')) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    }

    appShadowRoot.querySelectorAll('#my-cases th').forEach((column) => {
      if (column.getAttribute('data-sortKey') === caseSort.key) {
        if (caseSort.order === 'ascending') {
          column.setAttribute('aria-sort', caseSort.order);
          column.classList.remove('is-sorted-desc');
          column.classList.add('is-sorted-asc');
        } else {
          column.setAttribute('aria-sort', caseSort.order);
          column.classList.remove('is-sorted-asc');
          column.classList.add('is-sorted-desc');
        }
      }
    });

    function saveAppliedFilters() {
      const filterObj = {
        viewCase: { id: '', label: '' },
        search: '',
        caseSort: { key: '', order: '' },
        pagination: {
          currentPage: 1,
          totalRecords: 0,
          recordsPerPage: 10,
          totalNumberOfPages: 0,
          maxDisplayPages: 5,
          elementId: '',
        },
      };
      if (filters.viewCase && filters.viewCase.id && filters.viewCase.label) {
        filterObj.viewCase.id = filters.viewCase.id;
        filterObj.viewCase.label = filters.viewCase.label;
      }

      if (filters.search) {
        filterObj.search = filters.search;
      }

      if (caseSort && caseSort.key && caseSort.order) {
        filterObj.caseSort.key = caseSort.key;
        filterObj.caseSort.order = caseSort.order;
      }

      if (pagination && pagination.pagination && pagination.pagination.currentPage) {
        filterObj.pagination.currentPage = pagination.pagination.currentPage;
      }
      if (pagination && pagination.pagination && pagination.pagination.totalRecords) {
        filterObj.pagination.totalRecords = pagination.pagination.totalRecords;
      }
      if (pagination && pagination.pagination && pagination.pagination.recordsPerPage) {
        filterObj.pagination.recordsPerPage = pagination.pagination.recordsPerPage;
      }
      if (pagination && pagination.pagination && pagination.pagination.totalNumberOfPages) {
        filterObj.pagination.totalNumberOfPages = pagination.pagination.totalNumberOfPages;
      }
      if (pagination && pagination.pagination && pagination.pagination.maxDisplayPages) {
        filterObj.pagination.maxDisplayPages = pagination.pagination.maxDisplayPages;
      }

      const resultPerPageDiv = appShadowRoot.getElementById('resultsPerPage');

      if (filterObj.pagination.totalRecords > 10) {
        if (resultPerPageDiv.classList.contains('is-hidden')) {
          resultPerPageDiv.classList.remove('is-hidden');
        }
      } else if (!resultPerPageDiv.classList.contains('is-hidden')) {
        resultPerPageDiv.classList.add('is-hidden');
      }

      sessionStorage.setItem(CaseListFilters, JSON.stringify(filterObj));
    }

    function showTableLoader() {
      let tableLoaderHtml = '';
      for (let i = 0; i < 10; i++) {
        tableLoaderHtml += views.get('support-table-row')();
      }
      $llel.casesTableBoady.innerHTML = tableLoaderHtml;
    }

    /**
     * Get Cases from Milo
     */
    async function getMiloCaseList(viewId) {
      miloCaseList = [];
      const miloCaseListStart = performance.now();;
      const miloCaseListDuration = Number((performance.now() - miloCaseListStart) );
      try {
        let orgSource = 'IMS';
        if (isECC()) {
          orgSource = 'ECC';
        }
        showTableLoader();
        const searchParams = {
          orgId: getSelectedOrg().id,
          contactRengaId: getSelectedOrg().userId,
          orgSource
        };

        if (viewId === 1 || viewId === 4) {
          searchParams.status = 'Active';
        }

        if (viewId === 2 || viewId === 5) {
          searchParams.status = 'Inactive';
        }

        const res = await request(miloCaseListUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': ClientId,
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            ...searchParams,
          },
          key: 'miloCaseList',
        });
        const data = await res.json();
        

        if (res.ok) {
          relicApiSuccess({
            endpoint: miloCaseListUrl,
            duration: miloCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (Array.isArray(data)) {
            miloCaseList = data.filter(function (caseResult) {
              return caseResult;
            });

            miloCaseList.map((caseData) => {
              switch (caseData.status) {
                case 1: {
                  caseData.displayDate = getFormattedDate(caseData.lastModified);
                  caseData.caseDate = caseData.lastModified;
                  break;
                }
                case 2: {
                  caseData.displayDate = getFormattedDate(caseData.lastModified);
                  caseData.caseDate = caseData.lastModified;
                  break;
                }
                default: {
                  caseData.displayDate = getFormattedDate(caseData.createdOn);
                  caseData.caseDate = caseData.createdOn;
                }
              }

              return caseData;
            });


          }
        } else {
          relicApiFail({
            status:data.status,
            endpoint: miloCaseListUrl,
            duration: miloCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve Milo case list: ${data.error}`);
        }
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: miloCaseListUrl,
          duration: miloCaseListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve Milo case list: ${err.message}`);
      }
    }

    /**
     * Get Cases for Commerce from milo
     */
    async function getCommerceCaseList(viewId) {
      miloCaseList = [];
      const commerceCaseListStart = performance.now();
      const commerceCaseListDuration = Number((performance.now() - commerceCaseListStart) );
      try {
        showTableLoader();
        const searchParams = {
          orgId: getSelectedOrg().id,
          contactRengaId: getSelectedOrg().rengaId,
          orgSource: 'AMC'
        };

        if (viewId === 1 || viewId === 4) {
          searchParams.status = 'Active';
        }

        if (viewId === 2 || viewId === 5) {
          searchParams.status = 'Inactive';
        }

        let profileData = await adobeIMS.getProfile();
        console.log('profileData', profileData);
        
        const res = await request(exlMiloCaseListUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
            Authorization : `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
            [headerKeys.accept]: headerValues.json,
            
          },
          params: {
            ...searchParams,
            auth_id: profileData.authId,
            date: new Date()
          },
          key: 'miloCaseList',
        });
        const resData = await res.json();
        const data = resData.result;

        if (resData.status === 200) {
          relicApiSuccess({
            endpoint: exlMiloCaseListUrl,
            duration: commerceCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (Array.isArray(data)) {
            miloCaseList = data.filter(function (caseResult) {
              return caseResult;
            });


            miloCaseList.map((caseData) => {
              switch (caseData.status) {
                case 1: {
                  caseData.displayDate = getFormattedDate(caseData.lastModified);
                  caseData.caseDate = caseData.lastModified;
                  break;
                }
                case 2: {
                  caseData.displayDate = getFormattedDate(caseData.lastModified);
                  caseData.caseDate = caseData.lastModified;
                  break;
                }
                default: {
                  caseData.displayDate = getFormattedDate(caseData.createdOn);
                  caseData.caseDate = caseData.createdOn;
                }
              }

              return caseData;
            });


          }
        } else {
          relicApiFail({
            status:resData.status,
            endpoint: exlMiloCaseListUrl,
            duration: commerceCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve Milo case list: ${data.error}`);
        }
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: exlMiloCaseListUrl,
          duration: commerceCaseListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve Milo case list: ${err.message}`);
      }
    }

    /**
     * Get Cases from Workfront
     */
    async function getWorkFrontCaseList() {
      const workfrontCaseListStart = performance.now();
      const workfrontCaseListDuration = Number((performance.now() - workfrontCaseListStart) );
      try {
        showTableLoader();
        const res = await request(workfrontCaseListUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.adobeIMS.getAccessToken()?.token || ''}`,
          },
          params: {
            accountId: getSelectedOrg().id,
            contactRengaId: userprofile.email,
          },
          key: 'workfrontCaseList',
        });
        const data = await res.json();

        if (res.ok) {
          relicApiSuccess({
            endpoint: workfrontCaseListUrl,
            duration: workfrontCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          if (Array.isArray(data.data)) {
            workfrontCaseList = data.data;
            workfrontCaseList.map((casedata) => {
              casedata.status = openStatusWorkfront.includes(casedata.Status) ? 0 : 1;
              casedata.statusText = casedata.status === 0 ? getLabelV2('Open') : getLabelV2('Closed');
              casedata.caseId = casedata.CaseNumber;
              casedata.productName = 'Workfront';
              casedata.productCode = 'WORKFRONT';
              casedata.title = getSafeHtml(casedata.Subject);
              casedata.contactId = casedata.ContactId;
              casedata.admin = {
                firstName: casedata.Contact_First_Name__c,
                lastName: casedata.Contact_Last_Name__c,
                rengaId: casedata.Contact
                  ? casedata.Contact.IMS_ID__c !== null
                    ? casedata.Contact.IMS_ID__c
                    : ''
                  : '',
              };

              switch (casedata.status) {
                case 1: {
                  casedata.displayDate = getFormattedDate(casedata.LastModifiedDate);
                  casedata.caseDate = casedata.LastModifiedDate;
                  break;
                }
                default: {
                  casedata.displayDate = getFormattedDate(casedata.CreatedDate);
                  casedata.caseDate = casedata.CreatedDate;
                }
              }

              return casedata;
            });
          }
        } else {
          relicApiFail({
            status:data.status,
            endpoint: workfrontCaseListUrl,
            duration: workfrontCaseListDuration,
            ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
          });
          log(`Failed to retrieve Workfront case list: ${data.error}`);
        }
      } catch (err) {
        relicApiFail({
          status:err.status,
          endpoint: workfrontCaseListUrl,
          duration: workfrontCaseListDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
        log(`Failed to retrieve Workfront case list: ${err.message}`);
      }
    }

    async function getCSVData(statusValue) {
      let orgSource = 'IMS';
      let getCSVDataStart = 0;
      if (isECC()) {
        orgSource = 'ECC';
      }
      let searchParams = {
        orgId: getSelectedOrg().id,
        contactRengaId: getSelectedOrg().userId,
        orgSource
      };
      if (statusValue === 1 || statusValue === 4) {
        searchParams.status = 'Active';
      } else if (statusValue === 2 || statusValue === 5) {
        searchParams.status = 'Inactive';
      } else {
        searchParams = searchParams;
      }
      getCSVDataStart = performance.now();
      const res = await request(miloCaseListUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ClientId,
          Authorization: `Bearer ${adobeIMS.getAccessToken()?.token || ''}`,
          'Accept': 'text/csv'
        },
        params: {
          ...searchParams
        },
        key: 'miloCaseList'
      }),
        data = await res.text();
        const getCSVDataDuration = Number((performance.now() - getCSVDataStart) );

      if (res.ok) {
        relicApiSuccess({
          endpoint: miloCaseListUrl,
          duration: getCSVDataDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
      } else {
        relicApiFail({
          status:data.status,
          endpoint: miloCaseListUrl,
          duration: getCSVDataDuration,
          ...RELIC_CASE_CREATION_AVAILABILITY_TRACKING,
        });
      }

      return data;
    }

    let displayedCaseList = [];

    async function processMyCasesTableDataRows(caseDataArray) {
      let tableBodyRowHtml = '';
      let userId = getSelectedOrg().userId;
      if (caseDataArray.length > 0) {
        displayedCaseList = caseDataArray;
        let showSurvey = false;
        for (const caseData of caseDataArray) {
          if (isWorkFront() && (caseData.Survey_Status__c === 'Success' || caseData.Survey_Status__c === 'SurveyStarted') && (await checkSurveyDate(caseData.LastModifiedDate))) {
            showSurvey = true;
            break;
          }
          if (!isWorkFront() && caseData.statusText === 'Closed' && caseData.admin.rengaId === userId && await checkSurveyDate(caseData.lastModified) && !userprofile.email.includes('@adobe.com')) {
            showSurvey = true;
            break;
          }
        }
        // if (showSurvey) {
        //   if ($llel.feedbackColumn.classList.contains('is-hidden')) {
        //     $llel.feedbackColumn.classList.remove('is-hidden');
        //   }
        // } else {
        //   $llel.feedbackColumn.classList.add('is-hidden');
        // }
        $llel.feedbackColumn.classList.add('is-hidden');
        for (const caseData of caseDataArray) {
          let showSurveyBtn = false;
          if (
            isWorkFront() &&
            (caseData.Survey_Status__c === 'Success' || caseData.Survey_Status__c === 'SurveyStarted') &&
            (await checkSurveyDate(caseData.LastModifiedDate))
          ) {
            showSurveyBtn = true;
          }
          if (!isWorkFront() && caseData.statusText === 'Closed' && caseData.admin.rengaId === userId && await checkSurveyDate(caseData.lastModified) && !userprofile.email.includes('@adobe.com')) {
            showSurveyBtn = true;
          }
          let classAppendAll = '';
          if (!isWorkFront()) {
            let normalizedStatusReasonText = caseData.statusReasonText.toLowerCase().trim();
            let foundMatch = false;
            if (normalizedStatusReasonText === 'cancel/misroute') {
              normalizedStatusReasonText = normalizedStatusReasonText.replace('/', ' ');
            }
            for (let key in supportTicketUIStatus) {
              let normalizedKey = supportTicketUIStatus[key].stringKey.replace('_', ' ').toLowerCase().trim();
              if (normalizedKey === normalizedStatusReasonText) {
                classAppendAll = `status_${supportTicketUIStatus[key].variant}`;
                foundMatch = true;
                break;
              }
            }
            if (!foundMatch) {
              classAppendAll = 'status_info';
            }
          }
          if (isWorkFront()) {
            if (caseData.Status === 'Closed') {
              classAppendAll = `status_${caseData.Status.toLowerCase()}`;
            } else {
              classAppendAll = 'status_view';
            }
          }
          let productNameDisplay;
          if (caseData.productName && caseData.productName.trim() !== '') {
            productNameDisplay = caseData.productName;
          } else if (caseData.typeCode === 1) {
            productNameDisplay = 'Admin Console';
          } else {
            productNameDisplay = '--';
          }
          tableBodyRowHtml += `
            <tr class="spectrum-Table-row">
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="0">
                <a class="case-id-link" data-caseId="${isWorkfront ? caseData.Id : caseData.caseId}" data-cs-mask>${caseData.caseId}</a>
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="1" title="${getSafeHtml(caseData.title)}">
                <span class="case-title" data-cs-mask>${getSafeHtml(caseData.title)}</span>
                <div class="spectrum-Tooltip spectrum-Tooltip--top" data-cs-mask>
                  <span class="spectrum-Tooltip-label">${getSafeHtml(caseData.title)}</span>
                  <span class="spectrum-Tooltip-tip"></span>
                </div>
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="2">
                <span class="${classAppendAll} radius-50 is-inline-block is-margin-right-small u-tooltip-showOnHover"></span>
                ${caseData.statusReasonText ? getLabelV2(caseData.statusReasonText) : caseData.Status === 'Closed' ? caseData.Status : 'Open'}
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="3" title="${productNameDisplay}">
                <span class="case-product">${productNameDisplay}</span>
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="4" title="${isWorkFront() ? caseData.Priority : caseData.priorityText ? caseData.priorityText : '--'}">
                <span class="case-priority">${isWorkFront() ? caseData.Priority : caseData.priorityText ? getLabelV2(caseData.priorityText) : '--'}</span>
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="5" title="${isWorkFront() ? (caseData?.Contact_First_Name__c || '') + ' ' + (caseData?.Contact_Last_Name__c || '') : caseData.admin ? (caseData.admin.firstName || '') + ' ' + (caseData.admin.lastName || '') : '--'}">
                <span class="case-adminName" data-cs-mask>${caseData.admin && (caseData.admin.firstName || caseData.admin.lastName) ? (caseData.admin.firstName || '') + ' ' + (caseData.admin.lastName || '') : '--'}</span>
              </td>
              <td class="spectrum-Table-cell spectrum-Table-cell-1" tabindex="6">${caseData.displayDate}</td>
              <td class="spectrum-Table-cell pl-3" tabindex="7">
                <div class="case-summary-btn ${disableCaseSummaryAndHelp ? 'disabled' : ''}" ${disableCaseSummaryAndHelp ? '' : `onclick='ZeonCallbackClient.openCaseSummaryModal(${JSON.stringify({
                  caseId: caseData.caseId,
                  orgId: selectedOrg.id,
                  contactRengaId: selectedOrg.userId,
                  imsAccessToken: (await adobeIMS.getAccessToken())?.token || ''
                })})'`}>
                  <span>${getLabelV2('Case Summary')}</span>
                </div>
              </td>
              <td class="spectrum-Table-cell pl-3" tabindex="8">
                <div class="additional-help-btn spectrum-Button spectrum-Button--sizeM ${(disableCaseSummaryAndHelp || !(await ZeonCallbackClient.canRequestAdditionalHelp(caseData.caseId))) ? 'disabled' : ''}" data-case-id="${caseData.caseId}">
                  <span>${getLabelV2('Get Help')}</span>
                </div>
              </td>
              
              <td class="spectrum-Table-cell  pl-3 is-hidden" tabindex="9">
                <button class="survey-btn spectrum-Button spectrum-Button--sizeM ${showSurveyBtn ? '' : 'is-hidden'}" id="my-case-feedback-btn">
                  <a>Take the survey</a>
                </button>
              </td>
            </tr>`;
        }


                        // <button class=" spectrum-Button spectrum-Button--sizeM" id="my-case-feedback-btn" onclick='ZeonCallbackClient.openNeedAdditionalHelpModal(${JSON.stringify({


                        // <button class="survey-btn spectrum-Button spectrum-Button--sizeM" id="my-case-feedback-btn" onclick='ZeonCallbackClient.openCaseSummaryModal(${JSON.stringify({

                // <button class="survey-btn spectrum-Button spectrum-Button--sizeM ${await ZeonCallbackClient.canRequestAdditionalHelp(caseData.caseId) ? '' : 'is-hidden'}" id="my-case-feedback-btn" onclick='ZeonCallbackClient.openNeedAdditionalHelpModal(${JSON.stringify({
        // <a class="spectrum-Button-label is-flex" href="https://survey.adobe.com/jfe/form/SV_5b6RcUGkMMNp3V4?idx=SV_5b6RcUGkMMNp3V4&SIC=0136193c223baf4bc08426c16e193a56&CID=${caseData.caseId}=Z2xvNTg4NThAYWRvYmUuY29t&Device_Type=EXL" target="_blank">  
        $llel.casesTableBoady.innerHTML = tableBodyRowHtml;

        $llel.casesTableBoady.querySelectorAll('.additional-help-btn').forEach((additionalHelpBtn) => {
          if (disableCaseSummaryAndHelp || additionalHelpBtn.classList.contains('disabled')) {
            return;
          }
          additionalHelpBtn.addEventListener('click', () => {
            const caseId = additionalHelpBtn.dataset.caseId;
            const rowCase = displayedCaseList.find((d) => d.caseId === caseId);
            if (!rowCase) {
              return;
            }
            ZeonCallbackClient.openNeedAdditionalHelpModal({
              caseId: rowCase.caseId,
              caseTitle: rowCase.title,
              productCode: rowCase.productCode,
              onCasePriorityUpgraded: (info) => {
                let nextText = info.newPriorityText;
                console.log('infopriority', info);
                
                if (nextText === undefined || nextText === null || nextText === '') {
                  return;
                }
                let map = {
                  2: "P2- Urgent",
                  3: "P3- Important",
                  4: "P4- Minor",
                }
                nextText = map[info.newPriority];
                console.log('nextText', nextText);
                
                const row = additionalHelpBtn.closest('tr');
                const priorityEl = row?.querySelector('.case-priority');
                const priorityCell = priorityEl?.closest('td');
                if (priorityEl) {
                  priorityEl.textContent = nextText;
                }
                if (priorityCell) {
                  priorityCell.setAttribute('title', nextText);
                }
                if (isWorkFront()) {
                  rowCase.Priority = nextText;
                } else {
                  rowCase.priorityText = nextText;
                }
              },
            });
          });
        });

        if (!isWorkFront() && !isCommerce()) {
          const exportMyCasesBtn = appShadowRoot.getElementById('export-mycases');
          exportMyCasesBtn.classList.remove('is-hidden');
          exportMyCasesBtn.removeAttribute('disabled');
          exportMyCasesBtn.onclick = async () => {
            try {
              let exportBtn = appShadowRoot.getElementById('export-mycases').querySelector('.btn-loader');
              appShadowRoot.getElementById('export-mycases').setAttribute('disabled', true);
              if (!appShadowRoot.getElementById('export-mycases').classList.contains('disable-btn')) {
                appShadowRoot.getElementById('export-mycases').classList.add('disable-btn');
              }
              if (exportBtn.classList.contains('is-hidden')) {
                exportBtn.classList.remove('is-hidden');
              }
              const companyEntitlements = await getEntitlementsString();
              adobeDataLayerTrack({
                 "event": "linkClicked",
                 "eventType": "web.webInteraction.linkclicks",
                "companyLoginDetails": {
                            "companyLoginName": selectedOrg.name,
                            "companyLoginID": selectedOrg.id,
                            "companyEntitlements": companyEntitlements,
                          },
                 "link": {
                    "linkTitle": "Export to CSV",
                    "linkLocation": "myCases:export",
                    "linkType": "button",
                 },
                });
              const rawCsv = await getCSVData(filters.viewCase.id);
              const caseIds = filteredCaseList.map((c) => String(c.caseId));
              const lines = rawCsv.trim().split(/\r?\n/);
              const header = lines[0];
              const filteredLines = lines.slice(1).filter((line) =>
                caseIds.some((id) => line.includes(id)),
              );
              const csvData = [header, ...filteredLines].join('\r\n');
              const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              const timestamp = new Date().getTime();
              link.download = `my_cases_${timestamp}.csv`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(URL.createObjectURL(blob));
              if (!exportBtn.classList.contains('is-hidden')) {
                exportBtn.classList.add('is-hidden');
              }
              if (appShadowRoot.getElementById('export-mycases').classList.contains('disable-btn')) {
                appShadowRoot.getElementById('export-mycases').classList.remove('disable-btn');
              }
              appShadowRoot.getElementById('export-mycases').removeAttribute('disabled');
            } catch (error) {
              console.error('Failed to export CSV:', error);
            }
          };

        }

        // add listener for case detail
        appShadowRoot.querySelectorAll('.case-id-link').forEach((caseLink) => {
          caseLink.addEventListener('click', async () => {
            queryString('case-id', caseLink.dataset.caseid);
            queryString('org-id', getSelectedOrg().id);
            let caseData;
            if (isWorkfront) {
              caseData = displayedCaseList.find((data) => data.Id === caseLink.dataset.caseid);
            } else {
              caseData = displayedCaseList.find((data) => data.caseId === caseLink.dataset.caseid);
            }
            caseData.lastUpdated = '';
            caseData.impactCodeText = '';
            caseData.title = getSafeHtml(caseData.title);
            caseData.title = getSafeHtml(caseData.title);

            $lel.tabsContent.innerHTML = views.get('support-case-detail')({
              ...caseData,
            });
            const pageName = 'xl:learn:homemy-cases';
            const previousPageName = window.adobeDataLayer
              .filter((i) => 'event' in i && i.event === 'page loaded' && i.web.webPageDetails.pageName !== pageName)
              .reduce((a, v) => v.web.webPageDetails.pageName, '');
            const feature =
              appShadowRoot.querySelector('meta[name="feature"]') !== null
                ? appShadowRoot.querySelector('meta[name="feature"]').content
                : '';
                    // page loaded data tracker
            adobeDataLayerTrack({
              event: 'page loaded',
              web: {
                webPageDetails: {
                  name: pageName,
                  pageName,
                  prevPage: previousPageName,
                  previousPageName,
                  pageType: 'webpage',
                  URL: location.href,
                  domain: location.hostname,
                  server: location.hostname,
                  feature: feature.toLowerCase(),
                  siteSection: 'support',
                  siteSubSection1: 'support',
                  siteSubSection2: 'my-cases',
                  siteSubSection3: '',
                  siteSubSection4: '',
                  siteSubSection5: '',
                  solution: '',
                  supportPortalType: 'legacy support portal',
                },
              },
            });
            supportCaseDetail(supportProcess);
          });
        });
      } else {
        if (!$llel.paginationSec.classList.contains('is-hidden')) {
          $llel.paginationSec.classList.add('is-hidden');
        }
        tableBodyRowHtml = `<tr class="spectrum-Table-row"> <td class="no-case is-padded-small" align="center" colspan="12">${getLabelV2(
          'No cases for the selected product or filter at this time. Please select another product or filter',
        )}</td> </tr>`;
        $llel.casesTableBoady.innerHTML = tableBodyRowHtml;
        if (!appShadowRoot.getElementById('export-mycases').classList.contains('is-hidden')) {
          appShadowRoot.getElementById('export-mycases').classList.add('is-hidden');
        } else {
          appShadowRoot.getElementById('export-mycases').classList.add('is-hidden');
        }
        appShadowRoot.getElementById('export-mycases').setAttribute('disabled', true);
      }
    }

    async function processCaseList(skipCase, limitCase) {
      let filteredRecords = [];
      if (isWorkfront) {
        filteredCaseList = workfrontCaseList;
      } else {
        filteredCaseList = miloCaseList;
      }
      filteredRecords = filteredCaseList;
      filteredCaseList = JSON.parse(JSON.stringify(filteredRecords));
      // filter by View
      filteredRecords = [];
      if (filters.viewCase?.id) {
        switch (filters.viewCase.id) {
          case 1: {
            // My cases (Open)
            if (isWorkFront()) {
              filteredRecords = filteredCaseList.filter(
                (record) => record.contactId === getSelectedOrg().contactId && record.status === 0,
              );
            } else {
              let userId;
              if (isCommerce()) {
                userId = getSelectedOrg().rengaId; // userprofile.userId;
              } else {
                userId = getSelectedOrg().userId; // userprofile.userId;
              }
              filteredRecords = filteredCaseList.filter(
                (record) => 'admin' in record && record.admin.rengaId === userId && record.status === 0,
              );
            }
            break;
          }
          case 2: {
            // My cases (Closed)
            if (isWorkFront()) {
              filteredRecords = filteredCaseList.filter(
                (record) => record.contactId === getSelectedOrg().contactId && record.status === 1,
              );
            } else {
              let userId;
              if (isCommerce()) {
                userId = getSelectedOrg().rengaId; // userprofile.userId;
              } else {
                userId = getSelectedOrg().userId; // userprofile.userId;
              }
              filteredRecords = filteredCaseList.filter(
                (record) => 'admin' in record && record.admin.rengaId === userId && record.status === 1,
              );
            }
            break;
          }
          case 3: {
            // My cases (All)
            if (isWorkFront()) {
              filteredRecords = filteredCaseList.filter((record) => record.contactId === getSelectedOrg().contactId);
            } else {
              let userId;
              if (isCommerce()) {
                userId = getSelectedOrg().rengaId; // userprofile.userId;
              } else {
                userId = getSelectedOrg().userId; // userprofile.userId;
              }
              filteredRecords = filteredCaseList.filter(
                (record) => 'admin' in record && record.admin.rengaId === userId,
              );
            }
            break;
          }
          case 4: {
            // My organization’s cases (Open)
            filteredRecords = filteredCaseList.filter((record) => record.status === 0);
            break;
          }
          case 5: {
            // My organization’s cases (Closed)
            filteredRecords = filteredCaseList.filter((record) => record.status === 1);
            break;
          }
          default: {
            // My organization’s cases (All)
            filteredRecords = filteredCaseList;
          }
        }
      } else {
        filteredRecords = filteredCaseList;
      }
      filteredCaseList = JSON.parse(JSON.stringify(filteredRecords));

      // sort records
      filteredCaseList = await sortCaseData(filteredCaseList, caseSort);

      // search cases
      if (filters.search.length) {
        const caseList = filteredCaseList;
        filteredRecords = [];
        filteredRecords = caseList.filter((record) => {
          if (isWorkFront()) {
            return record.caseId?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.productName?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.title.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.statusText.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.Priority?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.Contact_First_Name__c?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.Contact_Last_Name__c?.toLowerCase().includes(filters.search.toLowerCase()) ||
              ((record.Contact_First_Name__c || '') + ' ' + (record.Contact_Last_Name__c || '')).toLowerCase().includes(filters.search.toLowerCase());
          } else {
            return record.caseId?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.productName?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.title.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.priorityText?.toLowerCase().includes(filters.search.toLowerCase()) ||
              record.statusReasonText.toLowerCase().includes(filters.search.toLowerCase()) ||
              ((record.admin?.firstName || '') + ' ' + (record.admin?.lastName || '')).toLowerCase().includes(filters.search.toLowerCase()); // Search full name
          }
        });
        filteredCaseList = JSON.parse(JSON.stringify(filteredRecords));
      }

      pagination.setTotalRecords(filteredCaseList.length, pagination.getCurrentPage());
      pagination.createPageElement();
      saveAppliedFilters();
      await processMyCasesTableDataRows(filteredCaseList.slice(skipCase, limitCase));
    }

    $llel.recordLimit.forEach((limtBtn) => {
      limtBtn.addEventListener('click', async () => {
        for (const btn of $llel.recordLimit) {
          btn.classList.remove('active');
        }
        limtBtn.classList.add('active');
        pagination.setRecordsPerPage(+limtBtn.dataset.perpage);
        saveAppliedFilters();
        await processMyCasesTableDataRows(filteredCaseList.slice(0, +limtBtn.dataset.perpage));
        const companyEntitlements = await getEntitlementsString();
        adobeDataLayerTrack({
          event: 'linkClicked',
          eventType: 'web.webInteraction.linkclicks',
          companyLoginDetails: {
            companyLoginName: selectedOrg.name,
            companyLoginID: selectedOrg.id,
            companyEntitlements: companyEntitlements,
          },
          link: {
            linkTitle: limtBtn.dataset.perpage,
            linkLocation: 'myCases:resultPerPage',
            linkType: 'results number clicked',
          },
        });
      });
    });

    function prepareFilterPicker(elementSelector) {
      const pickerMainEl = appShadowRoot.querySelector(elementSelector);
      const pickerElement = pickerMainEl.querySelector('.adobe-exl-picker');
      const pickerTextElement = pickerElement.querySelector('.spectrum-Picker-label');
      const pickerElementOptions = pickerMainEl.querySelector('.adobe-exl-pickerOptions');
      const pickerButton = pickerMainEl.querySelector('.spectrum-Picker');

      // picker button click event to open an close picker
      pickerElement.addEventListener('click', (event) => {
        log('Filter picker clicked');
        event.stopPropagation();
        event.preventDefault();
        const allDropdown = appShadowRoot.querySelectorAll('.adobe-exl-pickerOptions');
        // Filter out the clicked element
        const fieldDropdowns = Array.from(allDropdown).filter((el) => el !== pickerElementOptions);
        fieldDropdowns.forEach((fieldDropdown) => {
          // close extra drop down
          if (fieldDropdown.classList.contains('is-open')) {
            fieldDropdown.classList.remove('is-open');
          }
        });
        if (pickerElementOptions.classList.contains('is-open')) {
          pickerElementOptions.classList.remove('is-open');
          pickerButton.lastElementChild.outerHTML = chevronDown;
          log(`Filter picker closed (${elementSelector})`);
        } else {
          pickerElementOptions.classList.add('is-open');
          pickerButton.lastElementChild.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
            <defs>
              <style>
                .fill {
                  fill: #464646;
                }
              </style>
            </defs>
            <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z" />
          </svg>`;
          log(`Filter picker opened (${elementSelector})`);
        }
      });

      // add clicked event to picker options
      pickerElementOptions.querySelectorAll('li').forEach((listItem) => {
        listItem.addEventListener('click', async (event) => {
          log('Filter picker option clicked');
          $llel.supportMyCaseSearchInput.value = '';
          filters.search = '';
          saveAppliedFilters();
          const selectedValue = listItem.getAttribute('data-id');
          const selectedLabel = listItem.getAttribute('data-label');
          const picker = listItem.getAttribute('data-picker');
          event.stopPropagation();
          pickerTextElement.innerText = `${selectedLabel}`;
          pickerButton.lastElementChild.outerHTML = chevronDown;
          const selectedElement = pickerElementOptions.querySelector('li.is-selected');
          if (selectedElement) {
            selectedElement.classList.remove('is-selected');
          }
          listItem.classList.add('is-selected');

          pickerElementOptions.classList.remove('is-open');
          switch (picker) {
            case 'view': {
              if (filters.viewCase.id !== +selectedValue) {
                filters.viewCase.id = +selectedValue;
                filters.viewCase.label = selectedLabel;
                if (!isWorkfront) {
                  if (isCommerce()) {
                    await getCommerceCaseList(filters.viewCase.id);
                  } else {
                    await getMiloCaseList(filters.viewCase.id);
                  }
                }
                await processCaseList(0, pagination.getRecordsPerPage());
              }

              break;
            }
            default: {
              log('Default call');
            }
          }
        });
      });
      log(`Form picker ready (${elementSelector})`);
    }

    function processMyCasesTableHeader(clickedColumn) {
      caseSort.key = clickedColumn.getAttribute('data-sortkey');
      for (const column of $llel.supportMyCaseTableHeadColumns) {
        if (clickedColumn.getAttribute('data-sortkey') !== column.getAttribute('data-sortkey')) {
          column.setAttribute('aria-sort', 'none');
          column.classList.remove('is-sorted-desc');
          column.classList.remove('is-sorted-asc');
        }
      }
      if (clickedColumn.getAttribute('aria-sort') === 'ascending') {
        caseSort.order = 'descending';
        clickedColumn.setAttribute('aria-sort', caseSort.order);
        clickedColumn.classList.remove('is-sorted-asc');
        clickedColumn.classList.add('is-sorted-desc');
        clickedColumn.lastElementChild.outerHTML = `<span class="arrow_down"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
          <g id="ArrowSize100">
            <rect id="Frame" width="10" height="10" fill="red" opacity="0"/>
            <path d="M9.94952,4.99652a.87815.87815,0,0,0-.02966-.15259.854.854,0,0,0-.03522-.17315L9.882,4.66217A.86384.86384,0,0,0,9.7464,4.459a.819.819,0,0,0-.04718-.07226l-.00488-.005-.00086-.00079L6.62354,1.26172A.87459.87459,0,1,0,5.37646,2.48828L6.98682,4.125H.9248a.875.875,0,0,0,0,1.75h6.062L5.37646,7.51172A.87459.87459,0,1,0,6.62354,8.73828l3.06994-3.1192.00086-.00079.00488-.005A.819.819,0,0,0,9.7464,5.541.86384.86384,0,0,0,9.882,5.33783l.00262-.00861a.854.854,0,0,0,.03522-.17315.87815.87815,0,0,0,.02966-.15259L9.9502,5Z"/>
          </g>
        </svg></span>`;
      } else {
        caseSort.order = 'ascending';
        clickedColumn.setAttribute('aria-sort', caseSort.order);
        clickedColumn.classList.remove('is-sorted-desc');
        clickedColumn.classList.add('is-sorted-asc');
        clickedColumn.lastElementChild.outerHTML = `<span class="arrow_up"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
          <g id="ArrowSize100">
            <rect id="Frame" width="10" height="10" fill="red" opacity="0"/>
            <path d="M9.94952,4.99652a.87815.87815,0,0,0-.02966-.15259.854.854,0,0,0-.03522-.17315L9.882,4.66217A.86384.86384,0,0,0,9.7464,4.459a.819.819,0,0,0-.04718-.07226l-.00488-.005-.00086-.00079L6.62354,1.26172A.87459.87459,0,1,0,5.37646,2.48828L6.98682,4.125H.9248a.875.875,0,0,0,0,1.75h6.062L5.37646,7.51172A.87459.87459,0,1,0,6.62354,8.73828l3.06994-3.1192.00086-.00079.00488-.005A.819.819,0,0,0,9.7464,5.541.86384.86384,0,0,0,9.882,5.33783l.00262-.00861a.854.854,0,0,0,.03522-.17315.87815.87815,0,0,0,.02966-.15259L9.9502,5Z"/>
          </g>
        </svg></span>`;
      }
      saveAppliedFilters();
    }

    $llel.supportMyCaseSearchInput.addEventListener(
      'input',
      (ev) =>
        debounce('search-case-input', async () => {
          filters.search = $llel.supportMyCaseSearchInput.value.toLowerCase();
          const companyEntitlements = await getEntitlementsString();
          adobeDataLayerTrack({
            "event": "linkClicked",
            "eventType": "web.webInteraction.linkclicks",
            "companyLoginDetails": {
              "companyLoginName": selectedOrg.name,
              "companyLoginID": selectedOrg.id,
              "companyEntitlements": companyEntitlements,
            },
            "link": {
              "linkTitle": "Search Bar" ,
              "linkLocation": "myCases:searchBar",
              "linkType": "search input",
            }
          });
          processCaseList(0, +pagination.getRecordsPerPage());
        }),
      false,
    );

    // Process My Cases
    let optionViewListHtml = '';
    const chevronDown = `<svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
        <defs>
          <style>
            .fill {
              fill: #464646;
            }
          </style>
        </defs>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z" />
      </svg>`;
    for (const view of viewCaseFilterList) {
      optionViewListHtml += `<li data-id="${view.id}" data-label="${view.label
        }" data-picker="view" class="spectrum-Menu-item ${filters.viewCase.id === view.id ? 'is-selected' : ''
        }" role="option" aria-selected="true" tabindex="0"><span class="spectrum-Menu-itemLabel">${view.label}</span>
        <svg class="spectrum-Icon spectrum-UIIcon-Checkmark100 spectrum-Menu-checkmark spectrum-Menu-itemIcon" focusable="false" aria-hidden="true">
          <use xlink:href="#spectrum-css-icon-Checkmark100" />
        </svg></li>`;

      if (filters.viewCase?.id === view.id) {
        $llel.supportMyCaseViewFilterButton.innerHTML = `
          <span class="spectrum-Picker-label adobe-exl-pickerSelectedOption">${view.label}</span>
          ${chevronDown}`;
      }
    }
    $llel.supportMyCaseViewFilterList.innerHTML = optionViewListHtml;
    // prepareFilterPicker('#support-case-product-picker');
    prepareFilterPicker('#support-case-view-picker');

    // Table Header for sorting

    $llel.supportMyCaseTableHeadColumns.forEach((headColumn) => {
      if (headColumn.getAttribute('data-sortKey')) {
        headColumn.addEventListener('click', async () => {
          // eslint-disable-next-line no-use-before-define
          processMyCasesTableHeader(headColumn);
          if (isWorkFront()) {
            if (caseSort.key === 'adminName') {
              caseSort.key = 'Contact_First_Name__c';
            } else if (caseSort.key === 'priorityText') {
              caseSort.key = 'Priority';
            }
          }
          if (!isWorkFront() && caseSort.key === 'statusText') {
            caseSort.key = 'statusReasonText';
          }
          filteredCaseList = await sortCaseData(filteredCaseList, caseSort);
          let skipCase = 0;
          skipCase = (pagination.getCurrentPage() - 1) * pagination.getRecordsPerPage();
          let limitCase = pagination.getRecordsPerPage();
          limitCase += skipCase;
          await processMyCasesTableDataRows(filteredCaseList.slice(skipCase, limitCase));
        });
      }
    });
    isWorkfront = isWorkFront();
    if (isWorkfront) {
      await getWorkFrontCaseList();
    } else if (isCommerce()) {
      await getCommerceCaseList(filters.viewCase.id);
    } else {
      await getMiloCaseList(filters.viewCase.id);
    }
    pagination.pagination.elementId = 'case-list-pagination';
    pagination.reset(pagination.getCurrentPage());
    let skipCase = 0;
    skipCase = (pagination.getCurrentPage() - 1) * pagination.getRecordsPerPage();
    let limitCase = pagination.getRecordsPerPage();
    limitCase += skipCase;
    await initWebcall('EXL-My-Cases', {});

    await processCaseList(skipCase, limitCase);
  }


  render(async () => {
    const resumeRedeemUrl = sessionStorage.getItem(PremiumRedeemResumeUrl);
    if (authenticated && resumeRedeemUrl) {
      try {
        const resume = new URL(resumeRedeemUrl);
        const cur = new URL(`${window.location.href}`);
        if (
          resume.searchParams.get('support-tab') === SUPPORT_TABS.REDEEM_CODE &&
          cur.searchParams.get('support-tab') !== SUPPORT_TABS.REDEEM_CODE
        ) {
          sessionStorage.removeItem(PremiumRedeemResumeUrl);
          window.location.replace(resumeRedeemUrl);
          return;
        }
      } catch {
        sessionStorage.removeItem(PremiumRedeemResumeUrl);
      }
      sessionStorage.removeItem(PremiumRedeemResumeUrl);
    }

    let redeemDocumentTitleBackup = null;

    $lel.orgPickerWrap.setAttribute('id', `support-sidebar-orgpicker-${orgPickerCounter}`);

    /**
     * Process Support View
     */
    async function supportProcess(arg = '') {
      if (
        getCurrentSupportTab() === SUPPORT_TABS.OPEN_TICKET &&
        arg !== SUPPORT_TABS.OPEN_TICKET
      ) {
        if (isOpenTicketAiChatActive() && trackOpenTicketAiChatDuration) {
          await trackOpenTicketAiChatDuration();
        }
        trackOpenTicketAiChatDuration = null;
        isOpenTicketAiChatActive = () => false;
      }
      if (arg === SUPPORT_TABS.OPEN_TICKET) {
        if (authenticated === false || (await verifyRole()) === false) {
          arg = SUPPORT_TABS.HOME;
        }
      } else if (arg === SUPPORT_TABS.REQUEST_A_SESSION) {
        if (authenticated === false || (await verifyRole()) === false) {
          arg = SUPPORT_TABS.HOME;
        }
      } else if (arg === SUPPORT_TABS.MY_CASES) {
        lurl = new URL(`${location.href}`);
        if (lurl.searchParams.has('case-id')) {
          if (authenticated === false) {
            signin();
          } else if ((await verifyRole()) === false) {
            arg = SUPPORT_TABS.HOME;
          }
        } else if (authenticated === false || (await verifyRole()) === false) {
          arg = SUPPORT_TABS.HOME;
        }
      } else if (arg === SUPPORT_TABS.REDEEM_CODE && authenticated === false) {
        if (!loggedOutRedeemSignInActive) {
          await startLoggedOutRedeemSignIn();
        }
        return;
      } else if (arg === SUPPORT_TABS.MOBILE){
        if (authenticated === false) {
          arg = SUPPORT_TABS.HOME;
        } else{
          let current_org = getSelectedOrg();
          console.log('current_org', current_org);

          organizations = userprofile.orgs ? userprofile.orgs : [];
          console.log('organizations', organizations);

          let orgSelected = organizations.find((org) => org.orgId === current_org.id);
          console.log('orgSelected', orgSelected);
            
          let tMobileOrgs = ['1358406C534BC94D0A490D4D@AdobeOrg', '1B4F13AF61F3458F0A49413C@AdobeOrg', '011D515E6799153A0A49412F@AdobeOrg']
          if (orgSelected) {
            const roles = orgSelected.roles ? (orgSelected.roles.length > 0 ? orgSelected.roles : []) : [];
            const lowerCaseRoles = roles.map(role => role.toLowerCase());
            if(tMobileOrgs.includes(orgSelected.orgId)){
              if(lowerCaseRoles.includes('support_admin') || lowerCaseRoles.includes('org_admin')){
              } else{
                arg = SUPPORT_TABS.HOME;
              }
            } else{
              arg = SUPPORT_TABS.HOME;
            }  
          }
        }
      } else if (arg === SUPPORT_TABS.ADMIN_FORM){
        if (authenticated === false) {
          arg = SUPPORT_TABS.HOME;
        }
      } else if (arg === SUPPORT_TABS.OFFLINE_FORM){
      }
      await ensureViewsLoaded(getViewsRequiredForTab(arg, { authenticated }));
      appShadowRoot.querySelectorAll('a.support_tab_button').forEach((idx) => {
        idx.classList.remove('active');
      });

      sessionStorage.setItem(SupportTab, arg);
      queryString('support-tab', arg);
      relicSetView(arg);
      updateToggleVisibility();
      portalPageMapping({ toggleContainer });
      const pageName = `${window.adobeDataLayerMap[location.hash]}${arg}`;
      const previousPageName = window.adobeDataLayer
        .filter((i) => 'event' in i && i.event === 'page loaded' && i.web.webPageDetails.pageName !== pageName)
        .reduce((a, v) => v.web.webPageDetails.pageName, '');
      const feature =
        appShadowRoot.querySelector('meta[name="feature"]') !== null
          ? appShadowRoot.querySelector('meta[name="feature"]').content
          : '';

      await new Promise((resolve) => {
        render(async () => {
        if (loggedOutRedeemSignInActive) {
          resolve();
          return;
        }
        if (arg !== SUPPORT_TABS.REDEEM_CODE && redeemDocumentTitleBackup !== null) {
          document.title = redeemDocumentTitleBackup;
          redeemDocumentTitleBackup = null;
        }
        switch (arg) {
          case SUPPORT_TABS.OPEN_TICKET: {
            const username = userprofile ? userprofile.first_name : 'there';
            appShadowRoot.querySelectorAll('a.support_tab_button[data-id="open-ticket"]').forEach((idx) => {
              idx.classList.add('active');
            });

            // Initialize Widget Experiment (A/B test for recommendation widget visibility)
            const widgetExperiment = isCommerce()
              ? createSupportWidgetExperiment(appShadowRoot)
              : null;
            
            console.log({ widgetExperiment });
            
            $lel.tabsContent.innerHTML = views.get('support-open-ticket')({
              username,
              greetingMessage: '',
            });

            // Reset insights manager when tab content is recreated
            supportInsightsManager.reset();

            // Apply experiment visibility after view is rendered
            widgetExperiment?.updateWidgetVisibility?.();

            // exp.setupTargetEventListener();
            supportOpenTicket(supportProcess, widgetExperiment);

            break;
          }
          case SUPPORT_TABS.MY_CASES: {
            if (!$lel.progressBar.classList.contains('is-hidden')) {
              $lel.progressBar.classList.add('is-hidden');
            }
            lurl = new URL(`${location.href}`);
            appShadowRoot.querySelectorAll('a.support_tab_button[data-id="my-cases"]').forEach((idx) => {
              idx.classList.add('active');
            });
            if (lurl.searchParams.has('case-id')) {
              const caseDetails = {
                admin: {
                  firstName: '',
                  lastName: '',
                },
                caseId: '',
                productName: '',
                priorityText: '',
                title: '',
                lastUpdated: '',
                impactCodeText: '',
                statusText: '',
              };
              $lel.tabsContent.innerHTML = views.get('support-case-detail')({
                ...caseDetails,
              });
              await supportCaseDetail(supportProcess);
            } else {
              $lel.tabsContent.innerHTML = views.get('support-my-cases')({});
              await supportMyCases(supportProcess);
            }
            break;
          }
          case SUPPORT_TABS.REDEEM_CODE: {
            if (!$lel.progressBar.classList.contains('is-hidden')) {
              $lel.progressBar.classList.add('is-hidden');
            }
            if (document.title !== 'Activate Premium Learning | Adobe') {
              redeemDocumentTitleBackup = document.title;
            }
            document.title = 'Activate Premium Learning | Adobe';
            appShadowRoot.querySelectorAll('a.support_tab_button[data-id="redeem-code"]').forEach((idx) => {
              idx.classList.add('active');
            });
            const username = userprofile ? userprofile.first_name : 'there';
            const backToHomeUrl = new URL(window.location.href);
            backToHomeUrl.searchParams.set('support-tab', 'home');
            $lel.tabsContent.innerHTML = views.get('support-redeem-code')({
              username,
              backToHomeUrl: backToHomeUrl.toString(),
            });
            // eslint-disable-next-line no-new
            new SupportRedeemCode(appShadowRoot);
            break;
          }
          case 'cxi-case-form': {
            const username = userprofile ? userprofile?.first_name : 'there';
            $lel.tabsContent.innerHTML = views.get('cxi-case-form')({
              username,
            });
            break;
          }
          case 'offline-form': {
            $lel.tabsContent.innerHTML = views.get('offline-form')();
            break;
          }
          case 'admin-form': {
            $lel.tabsContent.innerHTML = views.get('admin-form')();
            break;
          }
          default: {
            if (!$lel.progressBar.classList.contains('is-hidden')) {
              $lel.progressBar.classList.add('is-hidden');
            }

            appShadowRoot.querySelectorAll('a.support_tab_button[data-id="home"]').forEach((idx) => {
              idx.classList.add('active');
            });
            const username = userprofile ? userprofile?.first_name : 'there';
            const renderHome = views.get('support-home');
            if (!renderHome) {
              if ($lel.tabsContent) {
                $lel.tabsContent.innerHTML =
                  '<div class="spectrum-Body spectrum-Body--sizeM" style="padding:2rem;text-align:center">Loading…</div>';
              }
              break;
            }
            $lel.tabsContent.innerHTML = renderHome({
              username,
            });
            await processSupportHome(supportProcess);
            try {
              if (appShadowRoot.querySelector('#CoveoSearchBox')) {
                window.Coveo.initSearchbox(appShadowRoot.querySelector('#CoveoSearchBox'), window.fullSearchPagePath);
                log('Initialized support search');
              }
            } catch (err) {
              log(`Something went wrong initializing the support search: ${err.stack}`);
            }
            // $el.navbar.querySelectorAll('[data-id="search"]').forEach(i => i.addEventListener('click', () => render(() => {
            //   window.scrollTo(0, 0);
            //   $el.navbar.classList.add('is-hidden');
            //   $el.siteSearch.classList.remove('is-hidden');
            //   EnableSearch(); // Coveo global
            //   log('Enabled site search');
            // }), false));
            // log('Set Coveo interop event handlers');
          }
        }

        // page loaded data tracker
        adobeDataLayerTrack({
          event: 'page loaded',
          web: {
            webPageDetails: {
              name: pageName,
              pageName,
              prevPage: previousPageName,
              previousPageName,
              pageType: 'webpage',
              URL: location.href,
              domain: location.hostname,
              server: location.hostname,
              feature: feature.toLowerCase(),
              siteSection: 'support',
              siteSubSection1: 'support',
              siteSubSection2: arg,
              siteSubSection3: '',
              siteSubSection4: '',
              siteSubSection5: '',
              solution: '',
              supportPortalType: 'legacy support portal',
            },
          },
        });

        if (authenticated === true) {
          const idx = userprofile.interactions.map((i) => i.event).indexOf(SupportVisit);

          if (idx === -1) {
            userprofile.interactions.push({
              event: SupportVisit,
              origin: 'learning',
              timestamps: [new Date().toISOString()],
            });
          } else {
            userprofile.interactions[idx].timestamps.push(new Date().toISOString());
          }

          void updateProfile('interactions', userprofile.interactions, true);
        } else {
          localStorage.setItem(SupportVisit, Number(localStorage.getItem(SupportVisit) || 0) + 1);
        }
        resolve();
      });
      });
    }
    appShadowRoot.querySelector('.redirect-to-cxi-case-form').addEventListener('click', () => {
      supportProcess('cxi-case-form');
    })


    function prepareOrgPicker() {
      const pickerMainEl = appShadowRoot.querySelector(`#support-sidebar-orgpicker-${orgPickerCounter}`);
      const pickerElement = pickerMainEl.querySelector('.adobe-exl-picker');
      const pickerElementOptions = pickerMainEl.querySelector('.adobe-exl-pickerOptions');
      const pickerButton = pickerMainEl.querySelector('.spectrum-Picker');
      const pickerElementSelectedOption = pickerMainEl.querySelector('.adobe-exl-pickerSelectedOption');
      const checronDown = `<svg xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 5px; right: 5px;" height="18" viewBox="0 0 18 18" width="18">
            <defs>
              <style>
                .fill {
                  fill: #464646;
                }
              </style>
            </defs>
            <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M4,7.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,11.7075a1,1,0,0,1-1.4125,0L4.293,7.716A.9945.9945,0,0,1,4,7.01Z" />
          </svg>`

      pickerButton.lastElementChild.outerHTML = checronDown

      pickerElement.addEventListener('click', (event) => {
        if (orgSwitchInFlight) {
          event.stopPropagation();
          return;
        }
        log('Org picker clicked');
        event.stopPropagation();
        if (pickerElementOptions.classList.contains('is-open')) {
          pickerElementOptions.classList.remove('is-open');
          pickerButton.lastElementChild.outerHTML = checronDown
          log('Org picker closed');
        } else {
          pickerElementOptions.classList.add('is-open');
          pickerButton.lastElementChild.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 5px; right: 5px;" height="18" viewBox="0 0 18 18" width="18">
            <defs>
              <style>
                .fill {
                  fill: #464646;
                }
              </style>
            </defs>
            <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path class="fill" d="M14,10.99a1,1,0,0,1-1.7055.7055l-3.289-3.286-3.289,3.286a1,1,0,0,1-1.437-1.3865l.0245-.0245L8.3,6.2925a1,1,0,0,1,1.4125,0L13.707,10.284A.9945.9945,0,0,1,14,10.99Z" />
          </svg>`
          log('Org picker open');
        }
      });

      pickerElementOptions.querySelectorAll('li').forEach((idx) => {
        idx.addEventListener('click', async (event) => {
          if (orgSwitchInFlight) {
            event.stopPropagation();
            return;
          }
          event.stopPropagation();
          const selectedOrgId = idx.getAttribute('orgId');
          if (selectedOrgId === getSelectedOrg()?.id) {
            pickerElementOptions.classList.remove('is-open');
            return;
          }
          setOrgPickerSwitching(true);
          $lel.horizontalLine.classList.add('is-hidden');
          $lel.statBar.classList.add('is-hidden');
          $lel.ticketStatusUL.innerHTML = '';
          log('Org picker option clicked');
          try {
          const selectedOrgName = idx.getAttribute('orgName');
          pickerElementSelectedOption.innerHTML = selectedOrgName;
          selectedOrg.name = selectedOrgName;
          const foundOrg = organizations.find((org) => org.orgId === selectedOrgId);
          selectedOrg.id = foundOrg.orgId;
          selectedOrg.name = foundOrg.orgName;
          selectedOrg.type = foundOrg.type;
          selectedOrg.userId = foundOrg.userId;
          selectedOrg.contactId = foundOrg.contactId ? foundOrg.contactId : null;
          selectedOrg.rengaId = foundOrg?.rengaId ? foundOrg?.rengaId : null;
          selectedOrg.rengaIdType = foundOrg?.rengaIdType ? foundOrg?.rengaIdType : null;
          deleteCookie(SelectedOrg);
          cookie('set', SelectedOrg, JSON.stringify(selectedOrg));
          void getEntitlementsString().then((companyEntitlements) => {
            adobeDataLayerTrack({
             "event": "linkClicked",
             "eventType": "web.webInteraction.linkclicks",
             "companyLoginDetails": {
                  "companyLoginName": selectedOrg.name,
                  "companyLoginID": selectedOrg.id,
                  "companyEntitlements": companyEntitlements,
                },
            "link": {
              "linkTitle": "Org Selector",
              "linkLocation": "body",
              "linkType": "button",
             }
            });
          });
          pickerElementOptions.classList.remove('is-open');
          const selectedElement = pickerElementOptions.querySelectorAll('li.is-selected')[0];
          if (selectedElement) {
            selectedElement.classList.remove('is-selected');
          }
          pickerElementOptions.querySelectorAll('svg').forEach((idx1) => {
            idx1.classList.add('is-hidden');
          })
          idx.classList.add('is-selected');
          idx.querySelectorAll('svg')[0].classList.remove('is-hidden');
          lurl = new URL(`${location.href}`);
          sessionStorage.removeItem(SelectedProduct);
          sessionStorage.removeItem(CaseListFilters);
          const hasUserRole = await verifyRole();
          const tabAfterOrgChange = lurl.searchParams.get('support-tab') === SUPPORT_TABS.MY_CASES
            && lurl.searchParams.has('case-id')
            ? SUPPORT_TABS.HOME
            : (hasUserRole ? lurl.searchParams.get('support-tab') : SUPPORT_TABS.HOME) || SUPPORT_TABS.HOME;
          if (lurl.searchParams.get('support-tab') === SUPPORT_TABS.MY_CASES && lurl.searchParams.has('case-id')) {
            queryString('case-id', '');
            queryString('org-id', '');
          }
          await Promise.all([
            helperSideNav(hasUserRole),
            supportProcess(tabAfterOrgChange),
          ]);
          } finally {
            setOrgPickerSwitching(false);
          }
        });
      });
      log('Org picker ready');
    }

    /**
     * process support left bar UI
     */
    async function prepareSideNav() {
      const tab = getCurrentSupportTab();
      if (authenticated && tabUsesOrgPicker(tab) && organizations.length) {
        await ensureViewsLoaded(['support-orglist-item']);
        const currentOrg = getSelectedOrg();
        if (!currentOrg) {
          const org = {
            id: organizations[0].orgId,
            name: organizations[0].orgName,
            type: organizations[0].type,
            userId: organizations[0].userId,
            contactId: organizations[0].contactId ? organizations[0].contactId : null,
            rengaId: organizations[0]?.rengaId ? organizations[0]?.rengaId : null,
            rengaIdType: organizations[0]?.rengaIdType ? organizations[0]?.rengaIdType : null,
          };
          deleteCookie(SelectedOrg);
          cookie('set', SelectedOrg, JSON.stringify(org));
        }
        prepareOrgList();
        prepareOrgPicker();
      }
      await helperSideNav();
    }

    $lel.tabs.forEach((tab) =>
      tab.addEventListener(
        'click',
         async () => {
          if (orgSwitchInFlight) {
            return;
          }
          if (!tab.classList.contains('disable-btn')) {
            const selectedTab = tab.dataset.id;
            const currentUrl = new URL(`${location.href}`);
            if (selectedTab === SUPPORT_TABS.HOME && currentUrl.searchParams.get('redirect-to') === 'modern') {
              if (isOpenTicketAiChatActive() && trackOpenTicketAiChatDuration) {
                await trackOpenTicketAiChatDuration();
                trackOpenTicketAiChatDuration = null;
                isOpenTicketAiChatActive = () => false;
              }
              window.location.href = modernSupportV2Href(SUPPORT_TABS.HOME);
              return;
            }
            if (currentUrl.searchParams.get('support-tab') !== selectedTab || currentUrl.searchParams.get('case-id')) {
              if (selectedTab !== SUPPORT_TABS.MY_CASES) {
                sessionStorage.removeItem(CaseListFilters);
              }
              queryString('case-id', '');
              queryString('org-id', '');
              supportProcess(selectedTab);
            }
            const selectedTabCamelCase = selectedTab
            .split('-')
            .map((part, index) =>
              index === 0
                ? part.toLowerCase()
                : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
            )
            .join('');            const companyEntitlements = await getEntitlementsString();
            adobeDataLayerTrack({
              "event": "linkClicked",
              "eventType": "web.webInteraction.linkclicks",
              "companyLoginDetails": {
                        "companyLoginName": selectedOrg.name,
                        "companyLoginID": selectedOrg.id,
                        "companyEntitlements": companyEntitlements,
                   },
             "link": {
               "linkTitle": selectedTabCamelCase,
               "linkLocation": `sideNav:${selectedTabCamelCase}`,
               "linkType": "button",
              },
             })
          }
        },
        false,
      ),
    );

    const initialTab = loggedOutRedeem
      ? SUPPORT_TABS.REDEEM_CODE
      : getInitialSupportTab(supportTabs);
    await supportProcess(initialTab);
    if (tabUsesSidebarSetup(initialTab)) {
      void prepareSideNav();
    }
    $el.support.addEventListener('click', () => {
      const pickersList = appShadowRoot.querySelectorAll('.adobe-exl-pickerOptions');
      const pickersListIcon = appShadowRoot.querySelectorAll('.spectrum-Icon');
      if (pickersList !== null) {
        for (const pickerBtn of pickersList) {
          if (pickerBtn.classList.contains('is-open')) {
            pickerBtn.classList.remove('is-open');
          }
        }
      }

      if (pickersListIcon !== null) {
        for (const pickerIcon of pickersListIcon) {
          if (pickerIcon.classList.contains('spectrum-UIIcon-ChevronUp100')) {
            pickerIcon.classList.remove('spectrum-UIIcon-ChevronUp100');
            pickerIcon.classList.add('spectrum-UIIcon-ChevronDown100');
          }
        }
      }
    });
  });

  log(`Rendered ${id}`);
}
